import {createConsultationFeeSave} from './consultation-fee-save';
import { readDoctorQueueClinicView } from './doctor-home-view';
import { DoctorOrdinaryPriceEditor, useDoctorOrdinaryPricing, withInvestigationPricePreviews, investigationQuotedAmount, type OrdinaryPricePreview } from './DoctorOrdinaryPricing';
import {formatIstDate} from '@/lib/datetime-ist';
import {useFinalizedClinicalAdditions} from './useFinalizedClinicalAdditions';
import {ADDITION_NOTE_FIELDS,additionContentFromForm,formWithAdditions,prescriptionWithAdditions,finalizedQuestionnairePanel,stageFinalizedQuestionnaire} from './clinical-finalized-additions-view';
import SavedClinicalAdditions from './SavedClinicalAdditions';
import {fetchClinicalFinalizedAdditions,type ClinicalFinalizedAddition,type ClinicalFinalizedAdditionContent} from '@/dashboard/api';
import { ClinicalTodayWork } from './ClinicalTodayWork';
import {useDoctorPending} from './DoctorPendingContext';
import { fetchClinicalTodayWork, type ClinicalTodayWorkView } from '@/dashboard/api';
import { latestTodayFacts } from './clinical-today-work-view';
import { todayWithInvestigations, type InvestigationWorkspace } from './ClinicalInvestigations';
import { fetchClinicalInvestigations, type ClinicalInvestigationsView } from '@/dashboard/api';
import {DoctorVisitPending} from './DoctorPendingPage';
import ClinicalFinishReview, {derivedFinishOutcome,savedTodayWorkReview,savedInvestigationReview,clinicalPlanReviewLabel,clinicalFinishOutcomeLabel} from './ClinicalFinishReview';
import { createPortal } from 'react-dom';
import { Table, TableHeader, TableHead, TableBody, TableRow, TableCell } from '@/components/ui/table';
import { consultationAmountFromDiscount, wholePlanListPrice, planQuoteFromDiscount, PLAN_DISCOUNT_UNITS, consultPlanEstimate, clinicalEstimateDiscounts } from './doctor-consult-view';
import { consentPrintPath, consentStateLabel } from './consult-consent-view';
import ClinicalPrescriptionPanel from './ClinicalPrescriptionPanel';
import { prescriptionFields, prescriptionProblems } from './clinical-prescription-view';
import RoleHomeSearchPortal from '@/dashboard/ui/RoleHomeSearchPortal';
import GlobalPatientSearchModal from '@/dashboard/patients/GlobalPatientSearchModal';
import ConsultExamination, { type ExaminationTreatmentRequest } from './ConsultExamination';
import { examinationEqual, examinationSummary, examinationTreatmentReview, recordFindingNoTreatmentNeeded } from './clinical-examination-view';
import ConsultStages, {type ConsultStage, type ConsultStageStatuses} from './ConsultStages';
import {ensureConsultationFee, setConsultationFeeAmount, type ConsultationFeeAmountInput, getCaseSheet, getIntakeQuestionnaire, type DoctorPreconsultView} from '@/dashboard/api';
import ConsultationPrintView, {CONSULTATION_PRINT_TITLES, savedVisitDoctorLabels, type SavedVisitDoctorLabels, type ConsultationPrintKind} from './ConsultationPrintView';
import PreviousToothPlans, {EarlierEstimates,usePreviousClinicalPlans,type PreviousClinicalPlansRead} from './PreviousToothPlans';
import { PrintSheetHostContext } from '@/dashboard/ui/PrintSheet';
import { DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { ConsultationDialog as Dialog, ConsultationPresentationContext, useConsultationWithheld } from './ConsultationPresentation';
import { ConsultationAttribution, type ConsultationActivityDisplay } from '@/dashboard/billing/consultation-display';
import ConsultationActions, { type ConsultationActionsProps } from '@/dashboard/billing/ConsultationActions';
import FieldGrid from '@/dashboard/ui/FieldGrid';
import { useConsultationIdentity } from '@/dashboard/billing/use-consultation-identity';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { usePlanControlDraft, type PlanControlDraft, type PlanDraftOwner } from './consult-autosave';
import { authBearer, PortalApiError } from '@/lib/portal-api';
import { clinicLabelOf } from '@/dashboard/clinic-context';
import { Link, useBlocker, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRegisterRoleNavigationGuard } from '@/layout/AppLayout';
import { TreatmentJourneyPanel } from '@/dashboard/doctor/TreatmentJourneyPanel';
import { proposedFollowUpDate } from '@/walkin/schedule-book-view';
import {
  advanceLeadStageBackHalf,
  completePlanItem,
  createCaseSheet,
  createPlanItem,
  fetchDoctorCaseHistory,
  bookConsultNextVisit,
  fetchConsultReturnBooking, createConsultReturnBooking, changeConsultReturnBooking, cancelConsultReturnBooking,
  fetchConsultNextVisitSlots,
  fetchDoctorConsultContext,
  fetchDoctorPatientLens,
  fetchTreatmentCatalog,
  fetchTreatmentCourseJourney, acceptEarlierClinicalPlan, listClinicalPlanAcceptances,
  type ClinicalPlanAcceptanceInput, type ClinicalPlanAcceptanceFact,
  markAppointmentFulfilled,
  markAppointmentNotConverted,
  markConsultStarted,
  markLeadConverted,
  markTreatmentAccepted,
  markTreatmentAdvised,
  markTreatmentDeclined,
  updateCaseSheet,
  updatePlanItem, removePlanItem, type PlanItemRemovalInput,
  type PlanItemUpdateInput,
  fetchCaseSheetConsents,
  type CaseSheetClinicalView,
  type CaseSheetConsentsWire,
  type TreatmentConsentView,
  type CaseSheetFollowUpOptionView,
  type CourseJourneyResponse,
  type ClinicalPlanItemView,
  type DoctorConsultContext,
  type PatientClinicalProfileView,
  type PlanItemStatusView,
  type TreatmentCatalogItemView,
  type TreatmentCatalogResult,
} from '@/dashboard/api';
import {
  OUTCOME_REASON_OPTIONS,
  outcomeReasonLabel,
} from '@/dashboard/owner/Lead360Panel';
import {
  recordOutcome,
  type OutcomeRecordDeps,
  type WorkbenchFeedback,
} from '@/dashboard/clinical-workbench/clinical-workbench-view';
import {
  CASE_SHEET_LABELS,
  caseSheetStatusLabel,
  planItemStatusLabel,
} from '@/dashboard/clinical-workbench/case-sheet-labels';
import {
  buildPlanItemCreatePayload,
  estimateInputDisplayOnBlur,
  parseWholeInr,
  suggestVisitOutcome,
  syncItemEdits,
  treatmentFloorViolationMessage,
  type PlanItemEdit,
} from '@/dashboard/clinical-workbench/case-sheet-cockpit-view';
import { AcInput } from '@/dashboard/ui/FormControl';
import { dayStatusChip } from '@/dashboard/appointments/ClinicDayBoard';
import {
  AcBadge,
  AcButton,
  acButtonClass,
  ConfirmDialog,
  EmptyState,
  ErrorState,
  LoadingState,
  SectionShell,
  RelatedHistory,
} from '@/dashboard/ui';
import {
  CONSULT_CLOSED_PAID_LINE,
  CONSULT_OPEN_NEXT_ACTION_LABEL,
} from '@/dashboard/appointments/workflow-handoff';
import {
  consultLiveRequiredAnswered,
  consultNextActionLabel,
  CONSULT_NEXT_RECORD_DECISIONS_LABEL,
} from '@/dashboard/doctor/consult-next-band';
import { consultDoorVerdict } from '@/dashboard/doctor/consult-eligibility';
import { doctorLensHref } from '@/dashboard/doctor/doctor-patient-lens-view';
import { owedKindsSummary } from '@/dashboard/doctor/clinical-evidence-view';
// DOCTOR-CONSULT-TRUTH-AND-GATE-CORRECTIVE-V1 (C2/C6): THE accepted-state
// truth owner -- the line chip, the journey header counters, the Estimation
// ACCEPTED cell, and the fee-missing guard all read THIS one derivation over
// the live plan items (never a stale wire, never a second sum).
import {
  acceptedCellDisplay,
  acceptedPlannedChipLabel,
  closeFeeMissingLine,
  deriveAcceptedTruth,
  NO_FEE_RECORDED_LABEL,
  planLineFeeMissing,
} from '@/dashboard/doctor/consult-accepted-truth';
// DOCTOR-JOURNEY-COMPOSE-V1: the doctor-v2 Cockpit tree's decision grammar,
// consumed BY REFERENCE (the mount) -- the inline Accept/Decline/Defer axis
// and its status mapping come from the built candidate-b components, never
// a re-derived copy.
import {
  allergyChipLabel,
  deriveTeethChips,
  nameInitials,
  planLineChipTone,
  planLineIsDecidable,
} from '@/dashboard/doctor-v2/cockpit-view';
import { formatIstShortDate, formatIstTime } from '@/lib/datetime-ist';
import {
  bannerIdentityLine,
  bannerLinkNote,
  consultBannerName,
  consultSafetyFactLabel,
  consultErrorMessage,
  planPatchConfirmedByRead,
  consultNoteSections,
  consultRecordedByLine,
  consultVisitOrdinal,
  doneChipLabel,
  nextCourseSublineFrom,
  paidAcrossVisitsMinorUnits,
  rupeeGlyphToRs,
  rupeesFromMinorLabel,
  FOLLOW_UP_CUSTOM_KEY,
  FOLLOW_UP_LABELS,
  followUpOptionLabel,
  followUpSummaryLine,
  parseConsultAppointmentId,
  clinicalReportedAnswers,
  consultDraftNoteRows,
  patientReportedAllergyLine,
  planItemDoctorLabel,
  relatedAppointmentsFactFrom,
  visitCategoryOptionLabels,
  structuredFormFromSheet,
  structuredSheetPatch,
  finishReviewsEqual,
  returnRequestsEqual, returnRequestProblem, returnRequestDate, returnRequestSummary, bookedReturnLine, activeReturnBooking, todaysIntakeReason, consultationDoctorLabel,
  todaysVisitNotice,
  type CaseHistoryLoadState,
  type ConsultNoteSectionDef,
  type StructuredSheetForm,
} from '@/dashboard/doctor/doctor-consult-view';
import {
  consentHeaderChip,
  type ConsentHeaderChip,
} from '@/dashboard/doctor/consult-consent-view';
import IntakeBand from '@/dashboard/doctor/IntakeBand';
import ConsultIntakeQuestionsBlock, {
  useVerifiedConsultAutosave,
  ConsultPreWriteError,
  definitiveConsultRejection,
  type ConsultWriterBoundary,
  consultFirstUnansweredKey,
  joinCurrentIntakeOwner,
} from '@/dashboard/doctor/ConsultIntakeQuestionsBlock';
import ConsentPanel from '@/dashboard/doctor/ConsentPanel';
import ClinicalConsentCapture, { ConsentUploadForVisit, ConsentOriginalButton, ClinicalConsentForm } from './ClinicalConsentCapture';
import { ConsultPatientRecord } from './ConsultPatientRecord';
import type { Patient360AppointmentWire } from '@/dashboard/patients/patient-360-view';
import TreatmentLedgerRail from '@/dashboard/doctor/TreatmentLedgerRail';
import {
  consultPathForAppointment,
  MID_DOT,
} from '@/dashboard/doctor/doctor-home-view';
import {
  catalogDefaultLabel,
  catalogDefaultSeedRupees,
  catalogPriceDisplay,
  catalogPriceSource,
  catalogPriceSourceLabel,
  filterCatalogGroups,
  filterItemsWithinGroup,
  planAddMode,
  planAmountProvenance,
  planAmountProvenanceLabel,
  planItemPriceDisplay,
  planTotalDisplay,
  PRICE_SETTER_NAMING_COPY,
  pricingUnitLabel,
  typeaheadCatalogResults,
  typeaheadFlatItems,
  type CatalogPriceSource,
} from '@/dashboard/doctor/treatment-picker-view';
import {
  consultSaveStateLabel,
  consultSaveStateTone,
  hasPendingPlanWork,
  shouldWarnOnNavigate,
  structuredFormHasContent,
  structuredFormsEqual,
  UNSAVED_NAV_WARNING,
  type ConsultSaveState,
} from '@/dashboard/doctor/consult-autosave';
import {
  canFireClose,
  closeCompletenessLine,
  closeConsentOwedLine,
  closeHeadline,
  closeVisit,
  deriveVisitClose,
  type CloseExplicitPick,
  type CloseVisitDeps,
} from '@/dashboard/doctor/consult-close';
import type { VisitPaymentView, ConsultReturnAppointment } from '@/dashboard/api';
import { ToothDiagram } from '@/dashboard/doctor/ToothDiagram';
import {
  savedToothRefLabel,
  sameToothSet,
  toothDisplayLabel,
  toothEntryContextFrom,
  TOOTH_STORAGE_UNAVAILABLE_HINT,
  type ToothEntryContext,
} from '@/dashboard/doctor/tooth-diagram-view';
import CaseHistoryRail from '@/dashboard/doctor/CaseHistoryRail';
import PreconsultIntakePanel, {
  PreconsultSafetyStrip,
  type PanelState as PreconsultPanelState,
} from '@/dashboard/doctor/PreconsultIntakePanel';
import ClinicalEvidencePanel, {EvidenceDialog, type ClinicalEvidenceSource} from '@/dashboard/doctor/ClinicalEvidencePanel';
import { useDashboardMeContext } from '@/dashboard/me-context';
// DOCTOR-FLOW-AFTER-INTAKE-V1: the intake chip primitive REUSED for the
// small-fixed-bank pickers (RC-2/RC-4 founder ruling: tap-chips where the
// vocabulary is small and fixed -- same component, never a clone), the D3
// stage-ladder derivations, and the D1/D3 panels.
import { IntakeChoiceChips } from '@/dashboard/appointments/PatientIntakeScreens';
import {
  ContinueTreatmentHeader,
  NextVisitPanel,
} from '@/dashboard/doctor/NextVisitPanel';
/* THE #781 HANDED LINE CONTROLS. Mounted here, not copied: the decision
   picklist, the per-line doctor picker and the remark field each own their
   own deliberate commit and their own failure line, and `usePlanLineWrite` is
   the ONE writer the three of them share so a line can only carry one change
   at a time. */
import PlanDecisionPicklist, {type PlanDecisionOutcome} from '@/dashboard/doctor/PlanDecisionPicklist';
import PlanDoctorPicker, {
  PlanDoctorOutcome,
} from '@/dashboard/doctor/PlanDoctorPicker';
import PlanRemarkField, {
  PlanRemarkOutcome,
} from '@/dashboard/doctor/PlanRemarkField';
import {
  usePlanLineWrite,
  type PlanWriteKind,
} from '@/dashboard/doctor/usePlanLineWrite';
import EstimatePrintView from '@/dashboard/doctor/EstimatePrintView';
import {
  consultStageDockLabel,
  deriveCourseStageLadder,
  nextVisitStageTitle,
  suggestedFollowUpOption,
} from '@/dashboard/doctor/consult-stage-view';
import '@/dashboard/doctor/consult-plan-row.css';

/**
 * DOCTOR-CLINICAL-WORKSPACE-V1 -- the CONSULT WORKSPACE
 * (/dashboard/doctor/consult/:appointmentId).
 *
 * The doctor's visit surface, ROUTED (not embedded): a persistent PATIENT
 * BANNER, the STRUCTURED CASE SHEET (chief complaint + category /
 * examination-findings / diagnosis category / treatment advised / doctor
 * note -- every section an EXISTING case_sheets or treatment_plan_items
 * column), and the finalize flow (lock + read-only-after + authorship,
 * FINALIZE LAW -- now also server-enforced).
 *
 * NO-MANUAL-ID LAW: there is NO appointment-id entry here or anywhere on
 * the doctor surface -- a consult opens from the queue or a patient-context
 * link. A malformed route param redirects to the queue, never to an id
 * prompt. DAY'S-APPOINTMENT LAW: when the opened visit is not today's and
 * the same patient HAS one today, the workspace banners the redirect
 * (founder finding: #42 opened while #43 was the day's visit).
 *
 * ERROR-HONESTY LAW: load errors render the server's message verbatim for
 * 4xx (scope denials say scope -- "This appointment belongs to another
 * clinic."); a 500 renders a retry line, never a raw internal string.
 *
 * Tested via react-dom/server + direct view-model calls (repo idiom).
 */

// --- Local form state ---------------------------------------------------------

interface ItemForm {
  readonly procedureName: string;
  /** Coded-picker selection (V6-P3): non-null = a catalog treatment is
   *  picked (the server writes the catalog name as the label; procedureName
   *  is not sent). null = free-text mode, exactly today's shape. */
  readonly catalogItemId: number | null;
  /** Display-only echo of the picked catalog item (never sent). */
  readonly catalogLabel: string;
  readonly catalogDefaultMinorUnits: number | null;
  /** Display-only echo of the picked item's configured floor
   *  (TREATMENT-PRICE-FLOOR-V1; never sent -- the backend re-checks the
   *  LIVE catalog value independently on every write). */
  readonly catalogMinimumMinorUnits: number | null;
  /** Display-only echo of the picked item's resolved price source
   *  (CLINIC-CATALOG-PRICING-TRUTH-S1-V1; never sent). */
  readonly catalogSource: CatalogPriceSource | null;
  /** PROGRESSIVE DISCLOSURE (S1 UX LAW): the selected service group --
   *  null = the group level renders; non-null = only THAT group's
   *  procedures render (the previous choice constrains the next; the
   *  full catalog is never rendered flat). */
  readonly catalogGroup: string | null;
  /** Picker search text -- narrows WITHIN the current disclosure scope. */
  readonly catalogQuery: string;
  /** The explicit "Add a treatment by name" escape inside the ONE add flow
   *  (D-6: free-text entry retained, never a second parallel UI). */
  readonly customMode: boolean;
  readonly toothArea: string;
  /** Item-grain canonical tooth codes from the odontogram
   *  (TOOTH-NOTATION-INTERIM-V1). OPTIONAL so pre-existing structural
   *  fixtures (incl. the #396-fenced doctor-workspace suite) stay valid;
   *  absent/[] = none; rides the create payload only when non-empty. */
  readonly toothRefs?: readonly string[];
  /** TOOTH->TREATMENT FLOW (law 2f): true while toothRefs were CARRIED from
   *  the diagnosis odontogram selection (renders the provenance line);
   *  cleared the moment the doctor adjusts teeth on the item. OPTIONAL --
   *  display provenance only, never sent. */
  readonly toothCarried?: boolean;
  readonly estimatedValue: string;
  readonly status: PlanItemStatusView;
  readonly declineReason: string;
}

const EMPTY_ITEM: ItemForm = {
  procedureName: '',
  catalogItemId: null,
  catalogLabel: '',
  catalogDefaultMinorUnits: null,
  catalogMinimumMinorUnits: null,
  catalogSource: null,
  catalogGroup: null,
  catalogQuery: '',
  customMode: false,
  toothArea: '',
  toothRefs: [],
  estimatedValue: '',
  status: 'advised',
  declineReason: '',
};

const PLAN_ITEM_STATUS_ORDER: readonly PlanItemStatusView[] = [
  'advised',
  'accepted',
  'declined',
  'deferred',
  'pending',
];

/** A single in-flight action: adding a procedure ('item'), saving a plan-row
 *  edit (its id), or the one-close act ('close'). Autosave never sets this
 *  (the doctor keeps typing while notes persist). */
type BusyKind = 'item' | 'close' | number | null;

/** Empty durable-profile view (mirror of the backend EMPTY_CLINICAL_PROFILE;
 *  the IntakeBand's honest zero state when the wire omits the block). */
const EMPTY_PROFILE_VIEW: PatientClinicalProfileView = {
  anaesthesiaAllergy: null,
  medicationAllergies: null,
  medicalAlerts: null,
  lastConfirmedAt: null,
  lastConfirmedCaseSheetId: null,
};

/* DOCTOR-INTAKE-ONE-FLOW-V1 (R1): the review-endpoint wiring const is
 * REMOVED with the review ceremony -- no surface on this page (or anywhere)
 * calls a review endpoint; the endpoint itself is gone. */

// --- Shared feedback banner ---------------------------------------------------

function FeedbackBanner({
  feedback,
}: {
  feedback: WorkbenchFeedback | null;
}): JSX.Element | null {
  if (feedback === null) return null;
  return (
    <div
      className={
        feedback.kind === 'success'
          ? 'workboard__feedback workboard__feedback--success'
          : 'workboard__feedback workboard__feedback--error'
      }
      role="status"
      aria-live="polite"
      data-testid="consult-feedback"
    >
      <div className="clinic-workbench__feedback-lines">
        {feedback.lines.map((line, i) => (
          <span key={String(i)}>{line}</span>
        ))}
      </div>
    </div>
  );
}

// --- Save-state indicator (TRUST LAW: ONE visible save state) -----------------

/** The single save-state line for the sheet: "Draft saved 1:45 PM" /
 *  "Saving..." / "Unsaved changes" / "Not saved - ...". Aria-live so a screen
 *  reader announces each transition; never a raw phone / clinical value. */
export function SaveStateIndicator({
  state,
}: {
  state: ConsultSaveState;
}): JSX.Element | null {
  const label = state.kind === 'error' && /^(Save outcome unknown|Checking saved values|Could not check saved values|Saved values changed|Saving…)/.test(state.message)
    ? state.message : consultSaveStateLabel(state);
  if (label === null) return null;
  return (
    <span
      className={`consult-savestate consult-savestate--${consultSaveStateTone(state)}`}
      role="status"
      aria-live="polite"
      data-testid="consult-savestate"
    >
      {label}
    </span>
  );
}

function ConsultRecoveryDialog({ kind, busy, canLeave, messages, onStay, onRetry, onCheck, onAbandon }: {
  kind: 'discard' | 'leave'; busy: boolean; canLeave: boolean; messages: string[];
  onStay: () => void; onRetry: () => void; onCheck: () => void; onAbandon: () => void;
}): JSX.Element {
  const stay = useRef<HTMLButtonElement>(null);
  // Capture before the shared drawer's child effect seeds its own focus.
  const previousFocus = useRef<HTMLElement | null>(typeof document === 'undefined'
    ? null : document.activeElement as HTMLElement | null);
  useEffect(() => {
    if (kind === 'leave') stay.current?.focus();
    // Synchronous cleanup lets StrictMode's next setup keep focus inside the
    // open dialog; deferred cleanup could pull it back out after that setup.
    return () => { if (previousFocus.current?.isConnected) previousFocus.current.focus(); };
  }, [kind]);
  if (kind === 'discard') return <Dialog open disablePointerDismissal={busy}
    onOpenChange={(open, details) => { if (open) return; if (busy) details.cancel(); else onStay(); }}>
    <DialogContent className="consult-v14g__discard" showCloseButton={false}
      initialFocus={stay} finalFocus={previousFocus} data-testid="consult-discard-dialog">
      <DialogTitle>Discard changes?</DialogTitle>
      <DialogDescription>Only changes that have not saved will be discarded. Autosaved drafts stay in the record. Saved records are checked before continuing.</DialogDescription>
      {messages.map((m, i) => <p key={i} role="status">{m}</p>)}
      <div className="consult-v14g__discard-actions">
        <AcButton variant="secondary" ref={stay} disabled={busy} onClick={onStay} data-testid="consult-discard-cancel">Cancel</AcButton>
        <AcButton variant="primary" disabled={busy || !canLeave} onClick={onAbandon} data-testid="consult-discard-confirm">
          {busy ? 'Checking saved values…' : 'Discard'}
        </AcButton>
      </div>
    </DialogContent>
  </Dialog>;
  return <Dialog open onOpenChange={(open) => { if (!open) onStay(); }}>
    <DialogContent className="p1-consult-recovery" showCloseButton={false}
      initialFocus={stay} finalFocus={previousFocus} data-testid="consult-leave-dialog">
      <DialogTitle>Unsaved changes</DialogTitle>
      <DialogDescription>{!canLeave
        ? 'A save is still outstanding or uncertain. Check its result before leaving.'
        : 'Keep editing, check saved state, or leave without unsaved changes.'}</DialogDescription>
      {busy ? <p role="status">Checking saved values…</p> : null}
      {messages.map((m, i) => <p key={i} role="status">{m}</p>)}
      <div className="ac-confirm__actions">
        <AcButton variant="secondary" ref={stay} onClick={onStay} data-testid="consult-leave-stay">Keep editing</AcButton>
        <AcButton variant="secondary" disabled={busy} onClick={onCheck} data-testid="consult-leave-check">Check saved state</AcButton>
        <AcButton variant="secondary" disabled={busy || !canLeave} onClick={onAbandon} data-testid="consult-leave-anyway">Leave anyway</AcButton>
      </div>
      {canLeave ? <AcButton variant="ghost" disabled={busy} onClick={onRetry} data-testid="consult-leave-retry">Retry save</AcButton> : null}
    </DialogContent>
  </Dialog>;
}


// --- C1: the persistent PATIENT BANNER ----------------------------------------

/**
 * The SNAPSHOT HEADER chips row (DOCTOR-OS-EXPERIENCE-V1 B1): labeled
 * chips, never prose, on the sticky banner. Renders ONLY facts the wire
 * states -- an absent registrationState / profile / consent read renders
 * NO chip (never a fabricated "all clear"). The name/UMR/age/sex and the
 * visit-status chip already live on this banner; the encounter-status
 * chip and the live SaveStateIndicator keep their existing homes (one
 * visible save state -- TRUST LAW).
 */
export function PatientBanner({
  context,
  clinicalProfile,
  consentChip = null,
  encounterStatus = null,
  visitOrdinal = null,
  allergyPendingReview = false,
  intakeReadKind = 'ready',
}: {
  context: DoctorConsultContext;
  /** Live durable-profile truth (page state may be fresher than the
   *  loaded context after an IntakeBand save). Defaults to the context's. */
  clinicalProfile?: PatientClinicalProfileView | null;
  /** The consent-state chip derived from the consents read (B3). */
  consentChip?: ConsentHeaderChip | null;
  /** DOCTOR-COCKPIT-VISUAL-CONFORM-V1: the visit lifecycle chip now rides
   *  the masthead idline (the candidate-b `Visit - Draft` chip position).
   *  OPTIONAL so every pre-package caller renders byte-identical; the page
   *  passes the derived status and the chip keeps its pinned testid. */
  encounterStatus?: CaseSheetClinicalView['status'] | null;
  /** ROUND 2 (coverage C06): the visit ordinal composed from the page's
   *  existing case-history read (entries + 1). null/absent = the chip
   *  renders the lifecycle word alone (honest while history loads). */
  visitOrdinal?: number | null;
  /** DOCTOR-CONSULT-TRUTH-AND-GATE-CORRECTIVE-V1 (C4 -- one allergy truth
   *  per viewport): TRUE when a patient-reported allergy answer exists on
   *  this visit while the durable record carries no answer yet. The chip
   *  then reads the pending-verification state instead of contradicting
   *  the "Patient reported allergies ... (awaiting doctor review)" line
   *  directly below it with "Allergy: not on file". */
  allergyPendingReview?: boolean;
  intakeReadKind?: PreconsultPanelState['kind'];
}): JSX.Element {
  const { appointment, patient } = context;
  const chip = dayStatusChip(appointment.status);
  const identity = bannerIdentityLine(patient);
  const linkNote = bannerLinkNote(patient);
  const profile = clinicalProfile ?? context.clinicalProfile ?? null;
  const registration = context.registrationState ?? null;
  const hasChips =
    profile?.anaesthesiaAllergy === 'yes' ||
    (profile !== null && profile.medicationAllergies !== null) ||
    registration !== null ||
    consentChip !== null;
  return (
    // DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (CANDIDATE-B-PIXELS-WIN): the
    // candidate-b case-sheet masthead -- avatar + name + one idline (UMR /
    // age-sex / lifecycle + day-status chips / clinic + appointment) -- in
    // place of the stacked banner card. Every field and testid is the same
    // truth as before; only the composition moved. The patient name is the
    // page h1 (the page-title block it replaces owned the h1 before).
    <section
      className="consult-banner"
      aria-label="Patient"
      data-testid="consult-banner"
    >
      <span className="consult-banner__avatar" aria-hidden="true">
        {nameInitials(patient.patientName)}
      </span>
      <div className="consult-banner__who">
        <h1 className="consult-banner__name" data-testid="consult-banner-name">
          {consultBannerName(patient)}
        </h1>
        <div className="consult-banner__idline">
          {identity !== '' ? (
            <span
              className="consult-banner__identity"
              data-testid="consult-banner-identity"
            >
              {identity}
            </span>
          ) : null}
          {/* C05 (round 2): the candidate-b allergy chip -- the honest
              durable-truth states via the doctor-v2 grammar (consumed by
              reference); the shouting danger chips below stay the alarm.
              C4 (TRUTH-AND-GATE corrective): while a patient-reported
              allergy answer awaits doctor review and the durable record is
              empty or partly recorded, the chip reads the pending-verification state --
              one allergy truth per viewport, never "not on file" directly
              above "Patient reported allergies: ...". Local override only;
              ADOPT-LATER: fold the pending state into the shared doctor-v2
              allergy grammar in Lane 2's DOCTOR-HOME-STATE-MODEL-V1
              primitives fast-follow. */}
          {(() => {
            const durableLabel = allergyChipLabel(
              profile,
              context.clinicalProfileAvailable === true,
            );
            const pending =
              allergyPendingReview &&
              (durableLabel === 'Allergy: not on file' || durableLabel === 'Allergy: partly recorded');
            const intakeUnknown = intakeReadKind === 'loading' || intakeReadKind === 'error' || intakeReadKind === 'unavailable';
            const intakeStatus = intakeReadKind === 'loading' ? 'loading intake' : 'intake unavailable';
            // Keep known durable safety information while the patient report
            // is unresolved; an unfinished read cannot assert absence.
            const label = intakeUnknown
              ? durableLabel === 'Allergy: not on file' ? `Allergy: ${intakeStatus}` : `${durableLabel} · ${intakeStatus}`
              : pending ? 'Allergy: pending review' : durableLabel;
            return (
              <AcBadge
                tone={pending || intakeUnknown ? 'pending' : 'neutral'}
                testId="consult-allergy-chip"
              >
                {label}
              </AcBadge>
            );
          })()}
          {encounterStatus !== null ? (
            <AcBadge
              tone={encounterStatus === 'finalized' ? 'positive' : 'pending'}
              testId="consult-encounter-status"
            >
              {/* C06: "Visit N - Draft" when the ordinal is composed from
                  the page's history read; the lifecycle word alone while
                  it loads. */}
              {visitOrdinal !== null
                ? `Visit ${visitOrdinal} ${MID_DOT} ${caseSheetStatusLabel(encounterStatus)}`
                : caseSheetStatusLabel(encounterStatus)}
            </AcBadge>
          ) : null}
          {/* The authoritative finalized record supplies the current stage.
              Do not repeat stored attendance beside that lifecycle badge. */}
          {encounterStatus === 'finalized' ? null : (
            <AcBadge tone={chip.tone} testId="consult-banner-status">
              {chip.label}
            </AcBadge>
          )}
          <span className="consult-banner__visit-meta">
            {clinicLabelOf(appointment.clinicName)}
            {` ${MID_DOT} Appointment #`}
            {appointment.id}
            {` ${MID_DOT} `}
            {formatIstTime(appointment.appointmentTime) || '--:--'}
          </span>
        </div>
        {linkNote !== null ? (
          <p
            className="consult-banner__link-note"
            data-testid="consult-banner-link-note"
          >
            {linkNote}
          </p>
        ) : null}
        {hasChips ? (
          <div className="consult-banner__chips" data-testid="consult-banner-chips">
            {profile?.anaesthesiaAllergy === 'yes' ? (
              // C6: impossible-to-miss danger alert -- the one shouting chip.
              <span className="consult-banner__alert">
                <AcBadge tone="danger" testId="consult-allergy-alert">
                  ANAESTHESIA ALLERGY
                </AcBadge>
              </span>
            ) : null}
            {profile !== null && profile.medicationAllergies !== null ? (
              <AcBadge
                tone="danger"
                title={profile.medicationAllergies}
                testId="consult-medication-allergy"
              >
                Medication allergy
              </AcBadge>
            ) : null}
            {registration !== null ? (
              registration.complete ? (
                <AcBadge tone="neutral" testId="consult-registration-chip">
                  Registered
                </AcBadge>
              ) : (
                <AcBadge tone="pending" testId="consult-registration-chip">
                  Registration incomplete
                </AcBadge>
              )
            ) : null}
            {consentChip !== null ? (
              <AcBadge tone={consentChip.tone} testId="consult-consent-chip">
                {consentChip.label}
              </AcBadge>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}

// --- C2: the STRUCTURED CASE SHEET ---------------------------------------------

function CategorySelect({
  id,
  label,
  value,
  options,
  disabled,
  testId,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  options: readonly string[];
  disabled: boolean;
  testId: string;
  onChange: (value: string) => void;
}): JSX.Element | null {
  // CONFIG-ABSENCE RENDER (DOCTOR-JOURNEY-COMPOSE-V1, SCOPE 3): an
  // unconfigured vocabulary renders NOTHING -- clean absence, the existing
  // config-absence pattern (the clinical.diagnosis_categories "chips are an
  // accelerator, never a constraint" posture; the no-dead-doors law). Raw
  // "Not configured." text never renders to a doctor. The vocabulary itself
  // now resolves server-side from clinic specialties OR the founder-seeded
  // org keys (resolveVisitCategoryVocabularies), so a seeded tenant like
  // Partha always sees a working picker here.
  if (options.length === 0) return null;
  return (
    <label className="clinic-workbench__field" htmlFor={id}>
      <span>{label}</span>
      <select
        id={id}
        className="clinic-workbench__input"
        value={value}
        disabled={disabled}
        data-testid={testId}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not selected</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </label>
  );
}

/** R3b (DOCTOR-INTAKE-ONE-FLOW-V1) -- the right panel's owner label. */
export const CONSULT_DOCTOR_RECORD_TITLE = "Doctor's record";
/** R3a -- the mirror row's provenance sub-line (the chief complaint is
 *  ANSWERED in Patient intake; this rail renders it read-only). */
export const CONSULT_MIRROR_SUB = 'From Patient intake';

export function StructuredSheetSection({
  sheet,
  form,
  sections,
  followUpOptions,
  complaintOptions,
  diagnosisOptions,
  busy,
  saveState,
  onFormChange,
  toothEntry = null,
  followUpEnabled = false,
  headDate = null,
  attribution = null,
  notesOnly = false,
  title,
  testId,
  showAttribution = false,
  finishNote = false,
  additions,
}: {
  notesOnly?: boolean;
  title?: string;
  testId?: string;
  showAttribution?: boolean;
  finishNote?: boolean;
  additions?: {editable:boolean;saved:ClinicalFinalizedAdditionContent;additions:readonly ClinicalFinalizedAddition[];boundary?:Pick<ConsultWriterBoundary,'pending'>};
  sheet: CaseSheetClinicalView | null;
  form: StructuredSheetForm;
  /** The CONFIG-BACKED section layout (server-resolved order, availability-
   *  filtered; SCOPE 1 -- the workspace renders sections from org config,
   *  never a hardcoded template). */
  sections: readonly ConsultNoteSectionDef[];
  /** Served follow-up options (the follow-up frow's vocabulary + the
   *  finalized read-only summary line). */
  followUpOptions: readonly CaseSheetFollowUpOptionView[];
  /** The RESOLVED per-field category option labels (SCOPE 3 -- server-resolved
   *  vocabulary; empty = clean absence, the select hides). */
  complaintOptions: readonly string[];
  diagnosisOptions: readonly string[];
  busy: BusyKind;
  saveState: ConsultSaveState;
  onFormChange: (form: StructuredSheetForm) => void;
  /** Tooth entry context: used here ONLY for the finalized teeth summary
   *  line's display tokens. ROUND 3: the odontogram card itself moved OUT of
   *  this component to the main column (correction 4 -- directly above the
   *  treatment course card). */
  toothEntry?: ToothEntryContext | null;
  /** ROUND 3 (correction 2): follow-up is a frow of THIS card (the
   *  20260728_1 storage gate the old standalone section carried).
   *  DOCTOR-FLOW-AFTER-INTAKE-V1 (D1): the row is now a READ-ONLY MIRROR of
   *  the Next-visit panel (one owner -- the panel edits; this row reads). */
  followUpEnabled?: boolean;
  /** The visit's short date for the card-head chip (reference: pend chip
   *  "06 Aug"); null = no chip. */
  headDate?: string | null;
  /** D2 (20260815_1): the visit-grain attribution block for the two rail
   *  rows (Converted by / Treatment doctor). ABSENT or available=false =
   *  the rows render nothing (pre-apply honesty; byte-identical fixtures). */
  attribution?: DoctorConsultContext['attribution'] | null;
}): JSX.Element {
  // Autosave does NOT disable the fields (the doctor keeps typing while it
  // persists) -- only a close/finalize in flight locks the sheet.
  //
  // ROUND 3 (founder correction 2, candidate-b architecture): this-visit
  // clinical fields render as the reference's COMPACT RAIL label-value rows
  // ("frow" grammar -- uppercase label column, value line, "Not recorded
  // yet" in subtle ink) with INLINE EDIT ON TAP: each row is a disclosure
  // whose body is the SAME textarea/select the spine carried (same testids,
  // same form state, same autosave engine -- presentation only; large empty
  // textareas no longer dominate the main flow). A row with content shows
  // its value; tapping opens the editor in place.
  const [finishNoteOpen,setFinishNoteOpen]=useState(false);
  const finishNoteRef=useRef<HTMLTextAreaElement>(null);
  const canAddNote = (field:ConsultNoteSectionDef['field']) => {
    const key=Object.entries(ADDITION_NOTE_FIELDS).find(([,value])=>value===field)?.[0] as keyof typeof ADDITION_NOTE_FIELDS|undefined;
    return additions?.editable===true&&key!==undefined&&!additions.saved.notes?.[key];
  };
  const laterNotes=additions?.additions.filter(a=>Object.keys(a.content.notes??{}).some(k=>sections.some(section=>ADDITION_NOTE_FIELDS[k as keyof typeof ADDITION_NOTE_FIELDS]===section.field)))??[];
  const anyBusy = busy !== null || additions?.boundary?.pending()===true;
  const finalized = sheet !== null && sheet.status === 'finalized';
  const followUpLine =
    finalized && sheet !== null
      ? followUpSummaryLine(sheet, followUpOptions)
      : followUpSummaryLine(
          {
            followUpOption: form.followUpOption === '' ? null : form.followUpOption,
            followUpNote: form.followUpNote === '' ? null : form.followUpNote,
          },
          followUpOptions,
        );

  const noteEditor=(s:ConsultNoteSectionDef)=>(<textarea
                  ref={finishNote ? finishNoteRef : undefined}
                  id={s.testId}
                  className="clinic-workbench__input cockpit-notes__area"
                  data-testid={s.testId}
                  aria-label={s.label}
                  rows={s.rows}
                  placeholder={s.hint}
                  title={s.guidance}
                  value={form[s.field]}
                  disabled={anyBusy}
                  onChange={(e) =>
                    onFormChange({ ...form, [s.field]: e.target.value })
                  }
                />);

  const frow = (
    key: string,
    label: string,
    value: string | null,
    editor: React.ReactNode | null,
    guidance?: string,
    sub?: string,
    // RC-5 (founder ruling 2026-08-15): the FIRST empty priority row renders
    // OPEN on a draft -- no expand click before the first keystroke; every
    // other row stays one intent away and nothing clinical is deleted.
    openWhenEmpty = false,
  ): JSX.Element => {
    const has = value !== null && value.trim() !== '';
    const valueSpan = (
      <span className="consult-frow__wrap">
        <span
          className={
            has ? 'consult-frow__v' : 'consult-frow__v consult-frow__v--empty'
          }
          {...(sub !== undefined ? { 'data-testid': `consult-frow-${key}` } : {})}
        >
          {/* Package 1 display amendment: missing values use an em dash;
              meaningful answer choices and failure explanations stay intact. */}
          {has ? value : '\u2014'}
        </span>
        {/* DOCTOR-INTAKE-ONE-FLOW-V1 (R3a): the row's provenance sub-line
            (the mirror row's "From Patient intake"). */}
        {sub !== undefined ? (
          <span className="consult-frow__sub">{sub}</span>
        ) : null}
      </span>
    );
    if (editor === null) {
      return (
        <div className="consult-frow" key={key}>
          <span className="consult-frow__l" title={guidance}>
            {label}
          </span>
          {valueSpan}
        </div>
      );
    }
    return (
      <FrowDetails key={key} initialOpen={openWhenEmpty && !has}>
        <summary className="consult-frow__summary">
          <span className="consult-frow__l" title={guidance}>
            {label}
          </span>
          {valueSpan}
        </summary>
        <div className="consult-frow__editor">{editor}</div>
      </FrowDetails>
    );
  };

  // Finalized teeth render from the SELF-DESCRIBING saved refs (server-
  // resolved mappings) under the org display default; absent = the row is
  // omitted entirely (structure forward -- no fabricated 'none').
  const savedTeeth = finalized && sheet !== null ? (sheet.toothRefs ?? []) : [];
  const teethLine =
    savedTeeth.length > 0
      ? savedTeeth
          .map((r) => savedToothRefLabel(r, toothEntry?.display ?? 'fdi'))
          .join('; ')
      : null;

  if(finishNote) {
    const section=sections.find(s=>s.field==='clinicalNote');
    if(!section)return <></>;
    const open=finishNoteOpen||!!form.clinicalNote.trim()||finalized;
    return <div className="consult-v14g__finish-note" data-testid="consult-internal-notes">
      {open?<><label htmlFor={section.testId}>Note <span>doctor only · not on the patient summary</span></label>
        {finalized&&!canAddNote(section.field)?<p className="consult-v14g__saved-note">{sheet?.clinicalNote?.trim()||'Not recorded at the original visit'}</p>:noteEditor(section)}
        {laterNotes.length?<SavedClinicalAdditions additions={laterNotes} section="notes"/>:null}
        {!finalized?<SaveStateIndicator state={saveState}/>:<p className="consult-frow__foot">{`Finalized · Recorded by ${sheet?.authoredByRole??'unknown'}.`}</p>}
      </>:<AcButton variant="ghost" disabled={anyBusy} onClick={()=>{setFinishNoteOpen(true);requestAnimationFrame(()=>finishNoteRef.current?.focus());}}>Add a doctor-only note</AcButton>}
    </div>;
  }

  return (
    <section
      className="ac-section consult-thisvisit"
      data-testid={testId ?? (notesOnly ? 'consult-internal-notes' : finalized ? 'consult-sheet-finalized' : 'consult-sheet')}
    >
      {/* DOCTOR-INTAKE-ONE-FLOW-V1 (R3b): the panel is LABELED for its
          owner -- "Doctor's record" (the honest-panels law; the intake
          panel across the grid is "Patient intake"), so two meanings of
          "recorded" are impossible at the label layer. The lifecycle word
          in mono + the live autosave chip ride the head unchanged. */}
      <div className="consult-card-head">
        <span className="consult-card-head__t">
          {title ?? (notesOnly ? 'Internal notes' : CONSULT_DOCTOR_RECORD_TITLE)}
        </span>
        <span className="consult-card-head__c">
          {finalized ? 'Finalized' : 'Draft'}
        </span>
        <span className="consult-card-head__grow" />
        {!finalized ? (
          <span title="Notes save automatically as you type - your work is never lost between visits.">
            <SaveStateIndicator state={saveState} />
          </span>
        ) : null}
        {headDate !== null ? <AcBadge tone="pending">{headDate}</AcBadge> : null}
      </div>
      {finalized && sheet !== null ? (
        <>
          {/* The saved category rows survive the lock beside their section (the
              consultNoteSummaryRows grammar on main). */}
          {sections.flatMap(section=>[frow(section.key,section.label,sheet[section.field] ?? null,canAddNote(section.field)?noteEditor(section):null,section.guidance,undefined,true),
            ...(section.categoryField==='chiefComplaintCategory'?[frow(`${section.key}-category`,'Complaint category',sheet.chiefComplaintCategory ?? null,null)]
              :section.categoryField==='diagnosisCategory'?[frow(`${section.key}-category`,'Diagnosis category',sheet.diagnosisCategory ?? null,null)]:[])])}
          {laterNotes.length?<SavedClinicalAdditions additions={laterNotes} section="notes"/>:null}
          {!notesOnly && teethLine !== null
            ? frow('teeth', CASE_SHEET_LABELS.toothRefs, teethLine, null)
            : null}
          {!notesOnly && frow('followup', FOLLOW_UP_LABELS.option, followUpLine, null)}
          {/* D2: the stamped attribution is record truth -- it SURVIVES the
              lock (read-only rows; walk-caught: the reseeded closed state
              rendered no converted-by row at all). */}
          {(!notesOnly || showAttribution) && attributionRows(attribution, true)}
          <p className="consult-frow__foot">
            {`Finalized - read only. Recorded by ${sheet.authoredByRole}.`}
          </p>
        </>
      ) : (
        <>
          {sections.map((s) => {
            // R3a (DOCTOR-INTAKE-ONE-FLOW-V1, one owner): the CHIEF
            // COMPLAINT row is a READ-ONLY MIRROR of the Patient intake
            // panel's first question ("What brings the patient in today?").
            // The value is the SAME form.chiefComplaint the write-through
            // feeds (live, fresher than the sheet during the debounce);
            // editing happens in the intake panel, never here. Only the
            // dependent Complaint-category select stays doctor-editable in
            // this row's disclosure.
            if (s.field === 'chiefComplaint') {
              const categoryEditor =
                complaintOptions.length > 0 ? (
                  <CategorySelect
                    id="consult-complaint-category"
                    label="Complaint category"
                    value={form.chiefComplaintCategory}
                    options={complaintOptions}
                    disabled={anyBusy}
                    testId="consult-complaint-category"
                    onChange={(v) =>
                      onFormChange({ ...form, chiefComplaintCategory: v })
                    }
                  />
                ) : null;
              return frow(
                s.key,
                s.label,
                form.chiefComplaint,
                categoryEditor,
                s.guidance,
                CONSULT_MIRROR_SUB,
              );
            }
            return frow(
              s.key,
              s.label,
              form[s.field],
              <>
                {noteEditor(s)}
                {s.categoryField === 'diagnosisCategory' ? (
                  <CategorySelect
                    id="consult-diagnosis-category"
                    label="Diagnosis category"
                    value={form.diagnosisCategory}
                    options={diagnosisOptions}
                    disabled={anyBusy}
                    testId="consult-diagnosis-category"
                    onChange={(v) =>
                      onFormChange({ ...form, diagnosisCategory: v })
                    }
                  />
                ) : null}
              </>,
              s.guidance,
              undefined,
              // RC-5: DIAGNOSIS is the priority row -- open when empty.
              s.field === 'findingsDiagnosis',
            );
          })}
          {/* D1 (DOCTOR-FLOW-AFTER-INTAKE-V1): the follow-up row is a
              READ-ONLY MIRROR of the Next-visit panel -- ONE owner (the
              panel writes through the same form; this row reads it), the
              R3a mirror idiom. The old in-rail editor is retired with its
              row (the RC-3 ruling: the select's job moved to the panel's
              chips). */}
          {followUpEnabled
            ? frow(
                'followup',
                'Next visit',
                followUpLine,
                null,
                undefined,
                'From the Next visit panel',
              )
            : null}
          {(!notesOnly || showAttribution) && attributionRows(attribution)}
        </>
      )}
    </section>
  );
}

/**
 * RC-5 mid-edit stability (walk-caught defect, Phase-2 W3): the frow's open
 * state belongs to the USER after mount. A LIVE `open` attribute derived
 * from row emptiness collapsed the row at the first keystroke (the field
 * gained content -> the attribute flipped off -> the textarea vanished
 * after one character). The initial render may open an empty priority row;
 * every later toggle is the user's own act, synced from the native event.
 */
function FrowDetails({
  initialOpen,
  children,
}: {
  initialOpen: boolean;
  children: React.ReactNode;
}): JSX.Element {
  const [open, setOpen] = useState(initialOpen);
  return (
    <details
      className="consult-frow consult-frow--edit"
      open={open}
      onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open)}
    >
      {children}
    </details>
  );
}

/** D2 (20260815_1): the two read-only attribution rows -- Converted by
 *  (set-once at the acceptance act; never editable anywhere) and Treatment
 *  doctor (edited in the Next-visit panel; mirrored here). Render NOTHING
 *  when the columns are not live (pre-apply honesty) -- never a row that
 *  cannot be true. */
function attributionRows(
  attribution: DoctorConsultContext['attribution'] | null | undefined,
  finalized = false,
): JSX.Element | null {
  if (attribution === null || attribution === undefined) return null;
  if (attribution.available !== true) return null;
  const convertedBy =
    attribution.conversionDoctorName ??
    (attribution.conversionDoctorId !== null
      ? `Doctor #${attribution.conversionDoctorId}`
      : null);
  const treating =
    attribution.treatmentDoctorName ??
    (attribution.treatmentDoctorId !== null
      ? `Doctor #${attribution.treatmentDoctorId}`
      : null) ??
    attribution.assignedDoctorName;
  return (
    <>
      <div className="consult-frow" data-testid="consult-frow-converted-by">
        <span
          className="consult-frow__l"
          title="Set at the acceptance act from the visit's assigned doctor - locked; no manual rewrite (attribution only: conversion the state stays payment-derived)."
        >
          Converted by
        </span>
        <span className="consult-frow__wrap">
          <span
            className={
              convertedBy !== null
                ? 'consult-frow__v'
                : 'consult-frow__v consult-frow__v--empty'
            }
          >
            {convertedBy ?? 'Set at acceptance'}
          </span>
          {convertedBy !== null ? (
            <span className="consult-frow__sub">
              Set at the acceptance act - locked
            </span>
          ) : null}
        </span>
      </div>
      <div className="consult-frow" data-testid="consult-frow-treatment-doctor">
        <span
          className="consult-frow__l"
          title={finalized ? "Treatment doctor recorded for this finalized visit." : "Who treats - defaults to the converting doctor; change it in the Next-visit panel for a handoff."}
        >
          Treatment doctor
        </span>
        <span className="consult-frow__wrap">
          <span
            className={
              treating !== null
                ? 'consult-frow__v'
                : 'consult-frow__v consult-frow__v--empty'
            }
          >
            {treating ?? '\u2014'}
          </span>
          {treating !== null && !finalized ? (
            <span className="consult-frow__sub">
              Change in the Next-visit panel
            </span>
          ) : null}
        </span>
      </div>
    </>
  );
}

// --- C2b: the FOLLOW-UP RECOMMENDATION (SCOPE 4; 20260728_1) -------------------
// RETIRED HERE (DOCTOR-FLOW-AFTER-INTAKE-V1, founder rulings 2026-08-15):
// the follow-up EDITOR moved to the NEXT VISIT panel (NextVisitPanel.tsx --
// same form seat, same follow_up_option/follow_up_note columns, same
// consult-followup-note testid + required-note validation; the option pick
// is now the D1 chip act). The rail's THIS VISIT card keeps a READ-ONLY
// mirror row (consult-frow-followup) so the record view stays whole.

// --- RC-1: the item-grain teeth entry (ONE tooth-selection truth) --------------

/**
 * DOCTOR-FLOW-AFTER-INTAKE-V1 RC-1 (founder ruling 2026-08-15): the add-form's
 * SECOND full odontogram is REMOVED from the default render. The carried
 * selection shows as removable chips (the ONE render shape, toothDisplayLabel);
 * the item-grain diagram opens ONLY behind the "Adjust teeth" / "Pick teeth"
 * intent (progressive reveal -- full capability preserved, zero capability
 * lost). The item-grain vs sheet-grain DB model (exactly-one-parent, D-10) is
 * untouched: this changes WHEN the diagram renders, never what it writes.
 */
function ItemTeethEntry({
  toothEntry,
  selected,
  disabled,
  onChange,
}: {
  toothEntry: ToothEntryContext | null;
  selected: readonly string[];
  disabled: boolean;
  onChange: (next: readonly string[]) => void;
}): JSX.Element | null {
  const [adjustOpen, setAdjustOpen] = useState(false);
  if (toothEntry === null) return null;
  const refByCode = new Map(toothEntry.references.map((r) => [r.toothCode, r]));
  // DR-04 honesty carried forward: storage not live -> the carried teeth
  // stay VISIBLE (display truth, never blanked) but no writable control
  // renders on them (a remove that cannot save is a dead control); the WHY
  // line renders in the row itself, and the free-text Tooth/Area beside it
  // stays the savable path (the picker's own storage gate).
  const live = toothEntry.storageLive;
  return (
    <div className="consult-item-teeth" data-testid="consult-item-teeth">
      <div className="consult-item-teeth__row">
        {selected.length > 0 ? (
          selected.map((code) => {
            const ref = refByCode.get(code);
            return (
              <span key={code} className="consult-item-teeth__chip">
                {ref !== undefined
                  ? toothDisplayLabel(ref, toothEntry.display)
                  : code}
                {live ? (
                  <button
                    type="button"
                    className="consult-item-teeth__remove"
                    aria-label={`Remove tooth ${code}`}
                    disabled={disabled}
                    data-testid={`consult-item-teeth-remove-${code}`}
                    onClick={() => onChange(selected.filter((c) => c !== code))}
                  >
                    x
                  </button>
                ) : null}
              </span>
            );
          })
        ) : (
          <span className="clinic-workbench__muted">No teeth on this procedure</span>
        )}
        <AcButton
          size="sm"
          variant="ghost"
          disabled={disabled}
          onClick={() => setAdjustOpen((v) => !v)}
          data-testid="consult-item-teeth-adjust"
        >
          {adjustOpen
            ? 'Hide teeth chart'
            : selected.length > 0 || !live
              ? live
                ? 'Adjust teeth'
                : 'View teeth chart'
              : 'Pick teeth'}
        </AcButton>
      </div>
      {!live ? (
        <span
          className="consult-frow__sub"
          data-testid="consult-item-teeth-readonly"
        >
          {TOOTH_STORAGE_UNAVAILABLE_HINT}
        </span>
      ) : null}
      {adjustOpen ? (
        <ToothDiagram
          references={toothEntry.references}
          display={toothEntry.display}
          selected={selected}
          disabled={disabled}
          storageLive={toothEntry.storageLive}
          idPrefix="consult-item"
          title={`${CASE_SHEET_LABELS.toothRefs} (this procedure)`}
          onChange={onChange}
        />
      ) : null}
    </div>
  );
}

// --- Treatment advised (plan items -- EXISTING child rows) ---------------------

/**
 * THE plan-status key (DOCTOR-PRECALL-POLISH-V1, DR-23). Four pairs, one word
 * of gloss each -- the compact replacement for the three-sentence legend.
 * The TERM is never spelled here: it resolves through the existing
 * PLAN_ITEM_STATUS_LABELS dictionary, so this key can never drift from the
 * status select the doctor actually operates. 'pending' is deliberately
 * absent: it is the undecided default, not a decision the doctor records.
 */
/** ROUND-3 teeth-strip grammar: the reference abbreviates areas
 *  ("UR <mid-dot> treated", "LR post <mid-dot> advised") -- a display
 *  truncation of the same derived label, never a second derivation. */
function teethChipShortLabel(label: string): string {
  return label
    .replace(/\s*quadrant\b/i, '')
    .replace(/\bposterior\b/i, 'post')
    .replace(/\banterior\b/i, 'ant')
    .replace(' - ', ` ${MID_DOT} `);
}

const PLAN_STATUS_KEY: ReadonlyArray<{
  readonly status: string;
  readonly gloss: string;
}> = [
  { status: 'advised', gloss: 'recommended' },
  { status: 'accepted', gloss: 'agreed' },
  { status: 'declined', gloss: 'refused' },
  { status: 'deferred', gloss: 'postponed' },
];

/**
 * DOCTOR-CONSULT-DELTA-V1 -- the TREATMENT-SPECIFIC doctor assignment context
 * (tracker row "Doctor Assigned (Treatment Specific)").
 *
 * The plan ledger reads and writes ONE existing column
 * (treatment_plan_items.performing_doctor_id) through THE ONE existing
 * plan-item write. The candidate roster is the SAME org-wide wire roster the
 * visit-grain handoff already receives, rendered through THE ONE existing
 * picker (HandoffDoctorPicker) -- no second roster read, no second select,
 * no second write path. ABSENT = no doctor row and no picker render, so
 * every pre-package fixture stays byte-identical.
 */
/** What the page banner says when ONE fact on a plan line is confirmed.
 *  One sentence per fact, in the vocabulary the surface already uses -- the
 *  three former handlers each wrote their own and they had drifted apart. */
const PLAN_WRITE_CONFIRMED_COPY: Record<PlanWriteKind, string> = {
  price: 'Treatment price saved.',
  decision: 'Decision recorded.',
  assignment: 'Doctor recorded for this treatment.',
  remark: 'Remark saved.',
};

export interface PlanItemDoctorAssign {
  readonly roster: NonNullable<DoctorConsultContext['clinicDoctors']>;
  readonly visitClinicId: number | null;
  /** The wire's roster-truncation flag (the picker says so; never silent). */
  readonly rosterTruncated: boolean;
  /* NO `onAssign` HERE ANY MORE. The assignment is written by the line's own
     `usePlanLineWrite`, which is the whole point of the one-write-per-line
     fence: a picker with its own writer could fire while a decision save was
     still unanswered. This context is now roster + scope only. */
  /** DOCTOR-HANDS-V1 (BUILD 2): the consult wire's PLAN-SCOPED procedure ->
   *  required-specialty map. The per-line picker rests on the doctors who
   *  perform THAT line's procedure instead of dumping every doctor at the
   *  branch ("why should 10 doctors here", recon 5.M). Absent / empty = the
   *  org mapped nothing, and the resting list is byte-identical to before. */
  readonly procedureSpecialties?: DoctorConsultContext['procedureSpecialties'];
}

export function TreatmentAdvisedSection({
  sheet, finalizedAdditions, examination, onFindingChange, onFindingTreatment, onRemoveItem, examinationRemovalHosts,
  itemForm,
  busy,
  catalog,
  onItemFormChange,
  onAddItem,
  onLineWrite,
  onLineSettled,
  toothEntry = null,
  seedToothRefs = [],
  journeySlot = null,
  rollupSlot = null,
  courseRows = [],
  onCompleteItem,
  completionAvailable = false,
  doctorAssign,
  compact = false,
  display = 'all', planDraftOwner, onEarlierPlanAccepted, investigations, consultationDoctor, todayValue, todayActions, todayDiscount, todayDraft, courseActions, planDiscounts = null, courseKnown = true, onEstimate, onSavedExtra, earlierEstimatesSlot, onPrintEstimate,
}: {
  finalizedAdditions?: ReturnType<typeof useFinalizedClinicalAdditions>;
  examinationRemovalHosts?: ReadonlyMap<number,HTMLDivElement>;
  onRemoveItem?: (itemId:number, input:PlanItemRemovalInput)=>Promise<void>;
  examination?: StructuredSheetForm['examination'];
  onFindingChange?: (value: NonNullable<StructuredSheetForm['examination']>)=>void;
  onFindingTreatment?: (toothCode:string)=>void;
  planDraftOwner?: PlanDraftOwner;
  investigations?: ClinicalInvestigationsView | null;
  earlierEstimatesSlot?: React.ReactNode;
  onPrintEstimate?:()=>void;
  onEarlierPlanAccepted?: (fact:ClinicalPlanAcceptanceFact,bearer:string)=>Promise<void>;
  consultationDoctor?: string;
  todayValue?: DoctorConsultationState;
  todayActions?: React.ReactNode;
  todayDiscount?: React.ReactNode;
  todayDraft?: { readonly dirty: boolean; readonly amount: number | null };
  courseActions?: React.ReactNode;
  planDiscounts?: Parameters<typeof consultPlanEstimate>[1];
  onEstimate?: (value:ReturnType<typeof consultPlanEstimate>)=>void;
  /** Masthead reads persisted pricing only; draft previews belong to the Plan footer. */
  onSavedExtra?: (minor:number|null)=>void;
  courseKnown?: boolean;
  display?: 'all' | 'add' | 'plan';
  compact?: boolean;
  sheet: CaseSheetClinicalView;
  itemForm: ItemForm;
  busy: BusyKind;
  /** The org treatment catalog (V6-P3). null / unavailable / empty -> the
   *  legacy free-text add form renders BYTE-IDENTICAL (D-6 fail-safe law). */
  catalog: TreatmentCatalogResult | null;
  onItemFormChange: (form: ItemForm) => void;
  onAddItem: () => void;
  /** THE ONE WRITER FOR EVERY PLAN LINE (#781 handoff). It replaces
   *  onItemEditChange / onSaveItem / onDecideItem / doctorAssign.onAssign's
   *  four separate paths; per-row failure copy and per-row pending state now
   *  live inside the line's own hook, so the page no longer keeps
   *  `itemSaveErrors` or a pending `itemEdits` copy for these three facts. */
  onLineWrite: (
    itemId: number,
    patch: PlanItemUpdateInput,
  ) => Promise<CaseSheetClinicalView>;
  onLineSettled?: (itemId: number, kind: PlanWriteKind, outcome: string) => void;
  /** Tooth entry context (TOOTH-NOTATION-INTERIM-V1): null = not offered --
   *  everything renders byte-identical to before this package. */
  toothEntry?: ToothEntryContext | null;
  /** TOOTH->TREATMENT FLOW (law 2f): the CURRENT diagnosis-grain odontogram
   *  selection; a picked treatment seeds its tooth set from it (adjustable
   *  per item -- carried context, never a hidden write). */
  seedToothRefs?: readonly string[];
  /** ROUND 2 (coverage C11-C15): the multi-visit course header (the
   *  TreatmentJourneyPanel mount) renders INSIDE this card, leading the
   *  ledger -- the candidate-b ONE dominant clinical cockpit card. The
   *  slot is the same engine mount the spine carried; only its home moved. */
  journeySlot?: React.ReactNode;
  /** ROUND 3 (ruled CONFLICT (a) -- MOCKUP WINS): the money rollup renders
   *  INSIDE this card, after the ledger and before the teeth strip. The
   *  slot is the SAME EstimationSummary strip; 2b gating is the caller's
   *  (renders only when plan lines exist). */
  rollupSlot?: React.ReactNode;
  /** ROUND 3 (correction 5 + the reference's COURSE-WIDE ledger): earlier
   *  visits' plan items as READ-ONLY ledger rows above this sheet's rows --
   *  the one ledger spans the course exactly as the reference draws it
   *  ("Done 12 Jun" beside today's undecided line). Composed by the page
   *  from the journey read; empty/absent = this sheet's rows alone. */
  courseRows?: readonly CourseLedgerExtraRow[];
  /** The EXISTING cross-sheet completion act (completePlanItem), relocated
   *  from the retired per-visit chronicle to the ledger rows themselves.
   *  Absent = no complete buttons render (older fixtures / read-only). */
  onCompleteItem?: (owningSheetId: number, itemId: number) => void;
  /** True when the journey read reports completion storage live. */
  completionAvailable?: boolean;
  /** DOCTOR-CONSULT-DELTA-V1: the treatment-specific doctor assignment
   *  context. Absent = no doctor fact and no picker render. */
  doctorAssign?: PlanItemDoctorAssign;
}): JSX.Element {
  const anyBusy = busy !== null;
  const isDraft = sheet.status === 'draft';
  const earlierWork = useEarlierPlanWork(`${sheet.patientId}:${sheet.id}`, courseRows, display === 'plan' && courseKnown);
  const earlierWorkRetryFocus = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (!earlierWork.loading && earlierWorkRetryFocus.current) {
      earlierWorkRetryFocus.current.focus(); earlierWorkRetryFocus.current = null;
    }
  }, [earlierWork.loading]);
  const unplanned=examinationTreatmentReview(examination,courseKnown?[...sheet.planItems,...courseRows.map(row=>row.item)]:undefined,finalizedAdditions?.enabled?finalizedAdditions.saved.examination:undefined).filter(row=>row.state!=='planned');
  const [planPreviews, setPlanPreviews] = useState<Record<number, {status:string; amount:number|null; dirty:boolean}>>({});
  useEffect(()=>setPlanPreviews({}),[sheet.id]);
  const onPlanPreview = useCallback((id:number, value:{status:string; amount:number|null; dirty:boolean}) => setPlanPreviews(previous=>{
    const old=previous[id];return old && old.status===value.status && old.amount===value.amount && old.dirty===value.dirty ? previous : {...previous,[id]:value};
  }),[]);
  const previewCourseRows=courseRows.map(row=>planPreviews[row.item.id] ? {...row,financialSheetId:planPreviews[row.item.id]!.status==='accepted'&&row.item.status!=='accepted'?sheet.id:row.financialSheetId,item:{...row.item,status:planPreviews[row.item.id]!.status as PlanItemStatusView}} : row);
  const previewItems = sheet.planItems.map(item=>planPreviews[item.id] ? {...item, status:planPreviews[item.id]!.status as PlanItemStatusView, estimatedValue:planPreviews[item.id]!.amount} : item);
  const pricing=useDoctorOrdinaryPricing(sheet.id,isDraft);
  const [extraPreview,setExtraPreview]=useState<OrdinaryPricePreview>({dirty:false,amount:null});
  const [testPreviews,setTestPreviews]=useState<Record<string,OrdinaryPricePreview>>({});
  useEffect(()=>{setExtraPreview({dirty:false,amount:null});setTestPreviews({});},[sheet.id]);
  const onExtraPreview=useCallback((value:OrdinaryPricePreview)=>setExtraPreview(old=>old.dirty===value.dirty&&old.amount===value.amount?old:value),[]);
  const onTestPreview=useCallback((id:string,value:OrdinaryPricePreview)=>setTestPreviews(old=>old[id]?.dirty===value.dirty&&old[id]?.amount===value.amount?old:{...old,[id]:value}),[]);
  const pricedInvestigations=withInvestigationPricePreviews(investigations,pricing.value,testPreviews);
  const savedExtra=pricing.value?.extra.status==='available'?pricing.value.extra:null;
  const savedExtraMinor=pricing.value?.available===true?savedExtra?.amountMinorUnits??null:null;
  useEffect(()=>{onSavedExtra?.(savedExtraMinor);},[savedExtraMinor,onSavedExtra]);
  const currentExtra=extraPreview.dirty?extraPreview.amount:savedExtra?.amountMinorUnits;
  const shownDiscounts=planDiscounts===null?null:currentExtra===undefined?planDiscounts:currentExtra===null?null:[...planDiscounts.filter(row=>row.caseSheetId!==sheet.id),...(currentExtra>0?[{caseSheetId:sheet.id,discountAmountInr:currentExtra/100}]:[])];
  const earlierExtra=consultPlanEstimate(courseRows.filter(row=>(row.financialSheetId??row.owningSheetId)!==sheet.id).map(row=>({caseSheetId:row.financialSheetId??row.owningSheetId,status:row.item.status,amount:row.item.estimatedValue})),planDiscounts,0,courseKnown).extra;
  const acceptedRows=[...previewItems,...previewCourseRows.filter(row=>(row.financialSheetId??row.owningSheetId)===sheet.id).map(row=>row.item)].filter(item=>item.status==='accepted');
  const acceptedMinor=acceptedRows.some(item=>item.estimatedValue===null)?null:acceptedRows.reduce((total,item)=>total+(item.estimatedValue??0)*100,0);
  const hasPlanDraft = Object.values(planPreviews).some(value=>value.dirty) || todayDraft?.dirty === true || extraPreview.dirty || Object.values(testPreviews).some(value=>value.dirty);
  const today = todayValue?.kind === 'ready' ? todayValue.view.financials : null;
  const consultationAmount = todayDraft?.dirty ? todayDraft.amount : today?.netMinorUnits??null;
  const estimate = consultPlanEstimate([
    ...previewCourseRows.map(row=>({caseSheetId:row.financialSheetId??row.owningSheetId,status:row.item.status,amount:row.item.estimatedValue,listMinor:row.item.catalogDefaultAmountMinorUnits})),
    ...previewItems.map(item=>({caseSheetId:sheet.id,status:item.status,amount:item.estimatedValue,listMinor:item.catalogDefaultAmountMinorUnits})),
  ], shownDiscounts, todayWithInvestigations(consultationAmount,pricedInvestigations), courseKnown);
  const money = (minor:number|null) => minor === null ? 'Unavailable' : rupeesFromMinorLabel(minor);
  const lines = (n:number) => `${n} ${n===1?'line':'lines'}`;
  const estimateIdentity=JSON.stringify(estimate);
  useEffect(()=>{onEstimate?.(estimate);},[estimateIdentity,onEstimate]);

  const addMode = planAddMode(catalog);
  // C25: the candidate-b teeth strip (per-quadrant chips from the plan's
  // own tooth areas + statuses) -- the doctor-v2 derivation, by reference.
  // ROUND 3: derived over the WHOLE course ledger (earlier visits' lines
  // included), matching the reference's strip.
  const teethChips = deriveTeethChips([
    ...(courseRows ?? []).map((r) => r.item),
    ...sheet.planItems,
  ]);
  const hasCourseHead = journeySlot !== null && journeySlot !== undefined;
  const ledger = (
    <>
      {!isDraft && sheet.planItems.length === 0 && (courseRows ?? []).length === 0 ? (
        // Honest read-only empty state (SCOPE 6): a finalized visit with no
        // recorded procedures says so plainly -- never a blank hole.
        <EmptyState
          title="No procedures were recorded for this visit."
          testId="consult-plan-empty-final"
        />
      ) : null}
      {sheet.planItems.length > 0 || (courseRows ?? []).length > 0 ? (
        <ul className="cockpit-plan__list" data-testid="consult-plan-list">
          {(courseRows ?? []).map((row) => (
            <CourseLedgerRow
              key={`c-${row.owningSheetId}-${row.item.id}`}
              row={row}
              anyBusy={anyBusy}
              canComplete={
                completionAvailable === true &&
                isDraft &&
                onCompleteItem !== undefined
              }
              onComplete={
                onCompleteItem !== undefined
                  ? () => onCompleteItem(row.owningSheetId, row.item.id)
                  : undefined
              }
            />
          ))}
          {sheet.planItems.map((item) => (
            <PlanItemRow
              key={item.id}
              item={item}
              editable={isDraft}
              anyBusy={anyBusy}
              toothDisplay={toothEntry?.display ?? 'fdi'}
              onLineWrite={onLineWrite}
              onLineSettled={onLineSettled}
              onComplete={
                completionAvailable === true &&
                isDraft &&
                onCompleteItem !== undefined &&
                item.status === 'accepted' &&
                item.completedAt == null
                  ? () => onCompleteItem(sheet.id, item.id)
                  : undefined
              }
              doctorAssign={doctorAssign}
              draftOwner={planDraftOwner}
            />
          ))}
        </ul>
      ) : null}
    </>
  );
  const addEditor = (<>
      {isDraft && addMode === 'legacy_form' ? (
        // LEGACY ADD FORM -- catalog unavailable (pre-20260711_3) or empty:
        // today's free-text flow BYTE-IDENTICAL (D-6 fail-safe law, pinned).
        <div className="cockpit-plan__add" data-testid="consult-plan-add">
          <h3 className="clinic-table__subtitle">
            Add a {CASE_SHEET_LABELS.procedureName.toLowerCase()}
          </h3>
          <div className="cockpit-plan__add-grid">
            <label className="clinic-workbench__field">
              <span>{CASE_SHEET_LABELS.procedureName}</span>
              <input
                type="text"
                className="clinic-workbench__input"
                data-testid="consult-item-name"
                maxLength={120}
                value={itemForm.procedureName}
                disabled={anyBusy}
                onChange={(e) =>
                  onItemFormChange({ ...itemForm, procedureName: e.target.value })
                }
              />
            </label>
            <label className="clinic-workbench__field">
              <span>{CASE_SHEET_LABELS.toothArea}</span>
              <input
                type="text"
                className="clinic-workbench__input"
                maxLength={60}
                value={itemForm.toothArea}
                disabled={anyBusy}
                onChange={(e) =>
                  onItemFormChange({ ...itemForm, toothArea: e.target.value })
                }
              />
            </label>
            <label className="clinic-workbench__field">
              <span>{CASE_SHEET_LABELS.estimatedValue}</span>
              <input
                type="text"
                inputMode="numeric"
                className="clinic-workbench__input"
                placeholder="whole rupees"
                value={itemForm.estimatedValue}
                disabled={anyBusy}
                onChange={(e) =>
                  onItemFormChange({ ...itemForm, estimatedValue: e.target.value })
                }
              />
            </label>
            <label className="clinic-workbench__field">
              <span>Status</span>
              <select
                className="clinic-workbench__input"
                value={itemForm.status}
                disabled={anyBusy}
                onChange={(e) =>
                  onItemFormChange({
                    ...itemForm,
                    status: e.target.value as PlanItemStatusView,
                  })
                }
              >
                {PLAN_ITEM_STATUS_ORDER.map((s) => (
                  <option key={s} value={s}>
                    {planItemStatusLabel(s)}
                  </option>
                ))}
              </select>
            </label>
            {itemForm.status === 'declined' ? (
              <label className="clinic-workbench__field">
                <span>{CASE_SHEET_LABELS.declineReason}</span>
                <select
                  className="clinic-workbench__input"
                  value={itemForm.declineReason}
                  disabled={anyBusy}
                  onChange={(e) =>
                    onItemFormChange({ ...itemForm, declineReason: e.target.value })
                  }
                >
                  <option value="">No reason</option>
                  {OUTCOME_REASON_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              </label>
            ) : null}
          </div>
          {/* Item-grain odontogram, FULL-WIDTH below the field grid (the
              same recognizability rule as the diagnosis diagram). LEGACY
              FAIL-SAFE FORM: byte-identical by the D-6 pinned law -- the
              RC-1 chips live on the CODED picker path only. */}
          {toothEntry !== null ? (
            <ToothDiagram
              references={toothEntry.references}
              display={toothEntry.display}
              selected={itemForm.toothRefs ?? []}
              disabled={anyBusy}
              storageLive={toothEntry.storageLive}
              idPrefix="consult-item"
              title={`${CASE_SHEET_LABELS.toothRefs} (this procedure)`}
              onChange={(next) =>
                onItemFormChange({ ...itemForm, toothRefs: next })
              }
            />
          ) : null}
          <AcButton
            size="sm"
            variant="secondary"
            disabled={anyBusy}
            onClick={onAddItem}
            data-testid="consult-add-item"
          >
            Add to plan
          </AcButton>
        </div>
      ) : null}
      {isDraft && addMode === 'picker' && catalog !== null ? (
        <TreatmentPickerAdd
          catalog={catalog}
          itemForm={itemForm}
          anyBusy={anyBusy}
          onItemFormChange={onItemFormChange}
          onAddItem={onAddItem}
          toothEntry={toothEntry}
          seedToothRefs={seedToothRefs}
        />
      ) : null}
  </>);
  if (display === 'add') return <div data-testid="consult-add-treatment-door">{addEditor}</div>;
  if (display === 'plan') return <section className="consult-v14g__plan" data-testid="consult-plan" data-sheet-id={sheet.id}>
    {earlierWork.error ? <div role="status" data-testid="consult-earlier-work-error"><p>Earlier work could not be checked.</p><AcButton variant="secondary" disabled={anyBusy || earlierWork.loading} onClick={event => {
      earlierWorkRetryFocus.current = event.currentTarget.closest('[data-testid="consult-stage-3"]')?.querySelector<HTMLElement>('#consult-stage-3-heading') ?? null;
      earlierWork.retry();
    }}>Retry earlier work</AcButton></div> : null}
    {pricing.state!=='ready'?<div className="consult-v14g__price-read" data-testid="consult-price-read" aria-busy={pricing.state==='loading'}>
      <p role="status">{pricing.state==='loading'?'Checking saved prices…':'Saved prices could not be checked. Your entries are kept.'}</p>
      <AcButton variant="secondary" disabled={anyBusy||pricing.state==='loading'} onClick={async event=>{
        const section=event.currentTarget.closest<HTMLElement>('[data-testid="consult-plan"]');
        const heading=section?.closest('[data-testid="consult-stage-3"]')?.querySelector<HTMLElement>('#consult-stage-3-heading');
        try{const value=await pricing.reload();if(value.available)requestAnimationFrame(()=>{if(section?.isConnected&&section.dataset.sheetId===String(sheet.id))heading?.focus();});}catch{/* The scoped reader retains the retry state. */}
      }}>Retry saved prices</AcButton>
    </div>:null}
    <div className="consult-v14g__plan-table"><Table aria-label="Treatment plan" data-testid="consult-plan-list">
      <TableHeader><TableRow>{['Tooth · area','Item','List price','Discount','Quoted price','Patient’s answer'].map(label => <TableHead key={label} scope="col">{label}</TableHead>)}</TableRow></TableHeader>
      <TableBody>
        <TableRow className="consult-v14g__plan-section"><TableCell colSpan={4}><b>Today’s visit</b> <span>charged at Reception</span></TableCell><TableCell className="plan-quote"><b>{money(estimate.today)}</b></TableCell><TableCell /></TableRow>
        <TableRow data-testid="consult-plan-today-fee">
          <TableCell className="plan-tooth" /><TableCell className="plan-item"><b>Consultation fee</b><small data-testid="consult-plan-conversion-doctor">{consultationDoctor ?? 'Unavailable'} · consultation doctor</small></TableCell>
          <TableCell className="plan-list">{today?.grossMinorUnits == null ? <small className="consult-v14g__money-unavailable">Unavailable</small> : money(todayValue?.kind==='ready' ? todayValue.view.amountAdjustment?.originalAmountMinorUnits ?? today.grossMinorUnits : today.grossMinorUnits)}</TableCell>
          <TableCell className="plan-discount">{todayDiscount ?? (today?.waivedMinorUnits ? <span>Written off · {money(today.waivedMinorUnits)}</span> : isFreeConsultationFollowUp(todayValue) ? 'Free follow-up' : today ? '—' : 'Unavailable')}</TableCell>
          <TableCell className="plan-quote"><b>{money(consultationAmount)}</b></TableCell><TableCell className="plan-answer"><AcBadge tone="neutral">Today’s charge</AcBadge></TableCell>
        </TableRow>
        {investigations?.available ? investigations.orders.map(order=><TableRow key={order.id} data-testid={`consult-plan-test-${order.id}`}>
          <TableCell className="plan-tooth">{order.tooth_refs.join(', ')||order.area||'—'}</TableCell><TableCell className="plan-item"><b>{order.choice}</b><small>Test ordered today</small></TableCell>
          <TableCell className="plan-list">{money(order.list_amount_minor_units)}</TableCell><TableCell className="plan-discount"><DoctorOrdinaryPriceEditor sheetId={sheet.id} kind="investigation" orderId={order.id} label={order.choice}
            saved={order.pricing?.status==='unavailable'?null:pricing.value?.investigations.find(value=>value.orderId===order.id)??(order.pricing?.status==='available'?order.pricing:order.list_amount_minor_units===null?null:{amountMinorUnits:order.list_amount_minor_units,version:0})}
            original={order.list_amount_minor_units} accepted={null} canWaive={isDraft&&pricing.value?.canWaiveInvestigations===true} canDiscount={isDraft&&pricing.value?.available===true&&pricing.value.canDiscount===true} disabled={anyBusy} owner={planDraftOwner} reload={pricing.reload}
            onPreview={value=>onTestPreview(order.id,value)} /></TableCell><TableCell className="plan-quote"><b>{money(investigationQuotedAmount(pricedInvestigations?.orders.find(value=>value.id===order.id)??order))}</b></TableCell><TableCell className="plan-answer"><AcBadge tone="neutral">Today’s charge</AcBadge></TableCell>
        </TableRow>) : investigations !== undefined ? <TableRow><TableCell colSpan={6}>Investigation charges unavailable.</TableCell></TableRow> : null}
        <TableRow className="consult-v14g__plan-section"><TableCell colSpan={4}><b>Treatment plan</b> <span>{sheet.planItems.length + courseRows.length} {sheet.planItems.length + courseRows.length === 1 ? 'line' : 'lines'}</span></TableCell><TableCell className="plan-quote"><b>{money(estimate.gross)}</b></TableCell><TableCell /></TableRow>
        {sheet.planItems.map(item => <PlanItemRow key={item.id} presentation="table" onPlanPreview={onPlanPreview} findingLabel={examination?.findings.filter(f=>item.toothRefs?.some(ref=>ref.toothCode===f.toothCode)).map(f=>f.label).join(', ')} item={item} editable={isDraft && item.completedAt == null} anyBusy={anyBusy}
          toothDisplay={toothEntry?.display ?? 'fdi'} onRemove={onRemoveItem} removalHost={examinationRemovalHosts?.get(item.id)} onLineWrite={onLineWrite} onLineSettled={onLineSettled} doctorAssign={doctorAssign} draftOwner={planDraftOwner} additionDoctor={finalizedAdditions?.editable?{value:finalizedAdditions.value.treatmentDoctors?.find(d=>d.planItemId===item.id)?.doctorId??null,saved:finalizedAdditions.saved.treatmentDoctors?.some(d=>d.planItemId===item.id)??false,pending:finalizedAdditions.boundary.pending(),change:doctorId=>finalizedAdditions.change({...finalizedAdditions.value,treatmentDoctors:[...(finalizedAdditions.value.treatmentDoctors??[]).filter(d=>d.planItemId!==item.id),...(doctorId===null?[]:[{planItemId:item.id,doctorId}])]})}:undefined} />)}
        {courseRows.map(row => { const {item,owningSheetId}=row; return <TableRow key={`prior-${owningSheetId}-${item.id}`} data-testid={`consult-course-item-${item.id}`}>
          <TableCell className="plan-tooth">{item.toothRefs?.map(ref => <span key={ref.toothCode} title={savedToothRefLabel(ref, toothEntry?.display ?? 'fdi')}>{ref.toothCode} </span>)}{item.toothArea}</TableCell>
          <TableCell className="plan-item"><b>{item.procedureName}</b><small>{row.visitDateIso ? `From ${formatIstShortDate(row.visitDateIso)}` : 'Earlier visit'}</small><small>{item.performingDoctorId === undefined || !doctorAssign ? 'Doctor unavailable' : planItemDoctorLabel(item.performingDoctorId, doctorAssign.roster)}</small><EarlierPlanWork row={row} read={earlierWork}/></TableCell>
          <TableCell className="plan-list">{item.catalogDefaultAmountMinorUnits == null ? 'Not recorded' : planItemPriceDisplay(item.catalogDefaultAmountMinorUnits / 100)}</TableCell><TableCell className="plan-discount">{item.catalogDefaultAmountMinorUnits == null || item.estimatedValue == null ? 'Not recorded' : item.catalogDefaultAmountMinorUnits < item.estimatedValue * 100 ? 'Unavailable' : item.catalogDefaultAmountMinorUnits === item.estimatedValue * 100 ? '—' : `− ${planItemPriceDisplay(item.catalogDefaultAmountMinorUnits / 100 - item.estimatedValue)}`}</TableCell>
          <TableCell className="plan-quote"><b>{planItemPriceDisplay(item.estimatedValue)}</b></TableCell>
          <TableCell className="plan-answer"><EarlierPlanDecision row={row} sheet={sheet} disabled={anyBusy||!isDraft} owner={planDraftOwner} onSaved={onEarlierPlanAccepted} reloadPrices={pricing.reload} onPreview={onPlanPreview}/>{item.completedAt ? <small>{doneChipLabel(item.completedAt,Date.now())}</small> : null}</TableCell>
        </TableRow>;})}
        {!sheet.planItems.length && !courseRows.length ? <TableRow><TableCell colSpan={6}>{isDraft ? 'No treatment yet. Add a treatment on the chart.' : <EmptyState title="No procedures were recorded for this visit." testId="consult-plan-empty-final" />}</TableCell></TableRow> : null}
      </TableBody>
    </Table></div>
    <div data-testid="consult-plan-totals">
      <p className="sr-only" role="status">{hasPlanDraft ? 'Unsaved treatment estimates' : 'Saved treatment estimates'}</p>
      {previewItems.length+courseRows.length ? <div className="consult-v14g__agreed" aria-label="What the patient has agreed to">
        <div><small>Patient has agreed to</small><strong data-testid="consult-plan-agreed">{money(estimate.agreed)}</strong><small>Today’s charges {money(estimate.today)} + accepted treatment {money(estimate.accepted.minor)}{estimate.extra!==null&&estimate.extra>0?` − extra discount ${money(estimate.extra)}`:''}</small><small>An estimate, not an amount due today.</small></div>
        <div>{[['Accepted treatment',estimate.accepted,money(estimate.acceptedNet)],['Advised · not yet agreed',estimate.advised,money(estimate.advised.minor)],...(estimate.unanswered.count ? [['No answer recorded · not agreed',estimate.unanswered,money(estimate.unanswered.minor)]]:[]),...(estimate.declined.count ? [['Declined · not charged',estimate.declined,money(estimate.declined.minor)]]:[]),...(estimate.deferred.count ? [['Deferred · not included',estimate.deferred,money(estimate.deferred.minor)]]:[])].map(([label,group,amount])=><div className="consult-v14g__agreed-row" key={String(label)}><AcBadge tone={group===estimate.accepted?'positive':group===estimate.advised?'pending':'neutral'}>{String(label)}</AcBadge><small>{group===estimate.accepted&&(group as {count:number}).count===0?'None yet':lines((group as {count:number}).count)}{group===estimate.accepted&&estimate.extra!==null&&estimate.extra>0?' · after discount':''}</small><b>{String(amount)}</b></div>)}</div>
      </div> : null}
      <dl className="consult-v14g__totals">
        {estimate.list!==estimate.gross ? <><dt>Treatment list prices</dt><dd>{money(estimate.list)}</dd><dt>{estimate.list!==null&&estimate.gross!==null&&estimate.list<estimate.gross?'Quoted above list price':'Discounts on treatments'}</dt><dd>{estimate.list===null||estimate.gross===null?'Unavailable':money(Math.abs(estimate.list-estimate.gross))}</dd></> : null}
        <dt>Treatments before extra discount</dt><dd data-testid="consult-rollup-plan">{money(estimate.gross)}</dd>
        <dt>Extra discount on accepted treatments</dt><dd><DoctorOrdinaryPriceEditor sheetId={sheet.id} kind="extra_discount" label="accepted treatments" saved={savedExtra} original={null} accepted={acceptedMinor}
          canDiscount={isDraft&&pricing.value?.available===true&&pricing.value.canDiscount===true} disabled={anyBusy} owner={planDraftOwner} reload={pricing.reload} onPreview={onExtraPreview} />{earlierExtra!==null&&earlierExtra>0?<small data-testid="consult-earlier-extra-discount">Earlier visit discount {money(earlierExtra)}</small>:null}</dd>
        <dt>Treatment estimate</dt><dd data-testid="consult-plan-treatment-total">{money(estimate.estimate)}</dd>
        <dt>Today’s charges</dt><dd>{money(estimate.today)}</dd>
        <dt>Total estimate</dt><dd data-testid="consult-plan-total">{money(estimate.total)}</dd>
        <div>Proposed treatment · an estimate, not a bill.{!courseKnown?' Earlier treatment is not confirmed.':null}</div>
      </dl>
      <div className="consult-v14g__estimate-actions">{todayActions || courseActions || journeySlot ? <details className="consult-v14g__plan-details consult-v14g__fee-actions" data-testid="consult-plan-details"><summary>Details</summary><div>
        {todayActions ? <section aria-label="Consultation fee details"><p>{todayValue?.kind!=='ready' || !today ? 'Consultation fee unavailable' : todayValue.bill?.feeRecorded ? 'Last confirmed' : 'Not recorded'}</p>{todayActions}</section> : null}
        {courseActions ? <section aria-label="Course status and actions">{courseActions}</section> : null}
        {journeySlot ? <section aria-label="Treatment course">{journeySlot}</section> : null}
      </div></details> : null}{earlierEstimatesSlot}{onPrintEstimate ? <AcButton variant="secondary" disabled={anyBusy} onClick={onPrintEstimate} data-testid="consult-print-estimate">Print estimate</AcButton> : null}</div>
    </div>
    {unplanned.length?<section className="consult-v14g__card consult-v14g__unplanned" data-testid="consult-unplanned-findings"><h3>Found, but no treatment yet</h3>{unplanned.map(({finding,state,label,canRecordNoTreatmentNeeded})=><div className="consult-v14g__unplanned-row" key={`${finding.toothCode}:${finding.label}`}>
      <b>{finding.toothCode}</b><span>{finding.label}</span>{state==='not_needed'?<span role="status">No treatment needed</span>:<>
      <AcButton variant="secondary" disabled={anyBusy||!isDraft||!onFindingTreatment} onClick={()=>onFindingTreatment?.(finding.toothCode)}>Add treatment</AcButton>
      {canRecordNoTreatmentNeeded?<AcButton variant="ghost" disabled={anyBusy||!onFindingChange||!examination||(!isDraft&&!finalizedAdditions?.editable)} onClick={()=>{if(examination)onFindingChange?.(recordFindingNoTreatmentNeeded(examination,finding,finalizedAdditions?.enabled?finalizedAdditions.saved.examination:undefined));}}>No treatment needed</AcButton>:<small role="status">{label}</small>}</>}
    </div>)}</section>:null}

  </section>;

  const body = (
    <>
      {ledger}
      {compact && isDraft && sheet.planItems.length === 0 && courseRows.length === 0 ? <p className="consult-overview__empty-plan">No treatment proposed.</p> : null}

      {compact && isDraft ? (
        <details className="consult-overview__add" data-testid="consult-add-treatment-door">
          <summary>Add treatment</summary>
          {addEditor}
        </details>
      ) : addEditor}
      {/* ROUND 3 (ruled CONFLICT (a)): the money rollup INSIDE the course
          card, after the working ledger, before the teeth strip -- exactly
          the reference's card anatomy. 2b gating rides the slot itself. */}
      {rollupSlot ?? null}
      {/* C25 (round 2): the candidate-b TEETH strip at the card foot --
          per-quadrant/area chips derived over the course ledger's lines. */}
      {teethChips.length > 0 ? (
        <div className="cockpit-plan__teeth" data-testid="consult-plan-teeth">
          <span className="cockpit-plan__teeth-label">Teeth</span>
          {teethChips.map((chip) => (
            <AcBadge key={chip.area} tone={chip.tone}>
              {teethChipShortLabel(chip.label)}
            </AcBadge>
          ))}
        </div>
      ) : null}
      {/* SCOPE 5 clinical helper copy (DR-23 compact key), ROUND-2 form: a
          single quiet caption at the card foot -- the four status words +
          one-word gloss; the governing sentences ride the tooltip
          (zero-information-loss). */}
      <p
        className="cockpit-plan__legend cockpit-plan__key cockpit-plan__key--foot"
        data-testid="consult-plan-legend"
        title="The close reads these to record the visit outcome. Nothing is ever defaulted to accepted."
      >
        {/* DOCTOR-CONSULT-DEMO-POLISH-V1 (item 5c): a MID_DOT between
            pairs -- without it the four term+gloss pairs ran together as
            one unbroken phrase ("Advised recommendedAccepted agreed..."). */}
        {PLAN_STATUS_KEY.map((entry, idx) => (
          <span key={entry.status} className="cockpit-plan__key-pair">
            {idx > 0 ? `${MID_DOT} ` : ''}
            <strong>{planItemStatusLabel(entry.status)}</strong> {entry.gloss}
          </span>
        ))}
      </p>
    </>
  );
  // ROUND 3 (correction 1 + the reference card anatomy): when the course
  // header leads, the JOURNEY BLOCK is the card's head -- no second title,
  // no sub-sentence (the pmeta line owns the counts; the rollup owns the
  // total with its W-B3 exclusion note). Without a course the card keeps
  // the round-2 SectionShell shape (honest fallback).
  if (hasCourseHead) {
    return (
      <section
        className="ac-section cockpit-course"
        data-testid="consult-plan"
      >
        {compact ? <h2 className="consult-overview__title">Visit plan</h2> : null}
        {journeySlot}
        {body}
      </section>
    );
  }
  return (
    <SectionShell
      eyebrow="Treatment advised"
      title={CASE_SHEET_LABELS.treatmentPlan}
      testId="consult-plan"
    >
      {body}
    </SectionShell>
  );
}

/** ROUND 3: one EARLIER-VISIT ledger row (read-only facts + the existing
 *  cross-sheet completion act) -- the course-wide ledger the reference
 *  draws. Same row grammar as PlanItemRow's ledger reading. */
export interface CourseLedgerExtraRow {
  readonly owningSheetId: number;
  readonly visitDateIso?: string | null;
  /** Original source stays unchanged; the financial decision visit is separate. */
  readonly financialSheetId?: number;
  readonly source?: ClinicalPlanItemView;
  readonly decision?: NonNullable<CourseJourneyResponse['currentDecisions']>['items'][number];
  readonly item: {
    readonly id: number;
    readonly procedureName: string;
    readonly toothArea: string | null;
    readonly estimatedValue: number | null;
    readonly status: PlanItemStatusView;
    readonly completedAt?: string | null;
    readonly completedInCaseSheetId?: number | null;
    readonly toothRefs?: ClinicalPlanItemView['toothRefs'];
    readonly performingDoctorId?: number | null;
    readonly catalogDefaultAmountMinorUnits?: number | null;
  };
}

/** Read the original visit's qualitative work through the existing scoped API.
 * This is dated clinical history, never a sitting count or current completion. */
function useEarlierPlanWork(scopeKey: string, rows: readonly CourseLedgerExtraRow[], enabled: boolean) {
  const withheld = useConsultationWithheld();
  const ids = enabled && !withheld ? [...new Set(rows.filter(row => row.item.status === 'accepted').map(row => row.owningSheetId))].sort((a,b) => a-b).join(',') : '';
  const key = `${scopeKey}:${ids}`;
  const [attempt, setAttempt] = useState(0);
  const [read, setRead] = useState<{key:string; wires:Record<number,ClinicalTodayWorkView|null>; loading:boolean; error:boolean}>({key:'',wires:{},loading:false,error:false});
  useEffect(() => {
    let cancelled = false;
    setRead({key,wires:{},loading:!!ids,error:false});
    if (!ids) return;
    void Promise.all(ids.split(',').map(async raw => {
      const id = Number(raw);
      try {
        const value = await fetchClinicalTodayWork(id);
        if (value.caseSheetId !== id || !value.available) throw Error('Earlier work unavailable');
        latestTodayFacts(value); // Preserve the existing exact-visit admission.
        return [id,value] as const;
      } catch { return [id,null] as const; }
    })).then(entries => { if (!cancelled) setRead({key,wires:Object.fromEntries(entries),loading:false,error:entries.some(([,value]) => value === null)}); });
    return () => { cancelled = true; };
  }, [key,ids,attempt]);
  return {wires:read.key === key && !withheld ? read.wires : {},loading:!!ids && (read.key !== key || read.loading),error:!withheld && read.key === key && read.error,retry:() => setAttempt(value => value+1)};
}

function EarlierPlanWork({row,read}:{row:CourseLedgerExtraRow;read:ReturnType<typeof useEarlierPlanWork>}) {
  if (row.item.status !== 'accepted' || row.item.completedAt) return null;
  if (read.loading) return <small role="status">Loading earlier work…</small>;
  const value = read.wires[row.owningSheetId];
  if (!value) return <small>Earlier work unavailable</small>;
  const fact = latestTodayFacts(value).find(fact => fact.planItemId === row.item.id && fact.owningCaseSheetId === row.owningSheetId);
  if (!fact || fact.status === 'not_today') return null;
  return <small data-testid={`consult-earlier-work-${row.item.id}`}>{fact.status === 'started' ? 'Started' : 'Work recorded'} {formatIstShortDate(fact.visitDate)}{fact.recordKind === 'dated_addition' ? ` · added ${formatIstShortDate(fact.recordedAt)}` : ''}</small>;
}

/** First acceptance of an earlier recommendation uses the existing Plan draft
 * boundary; an uncertain request is immutable until its saved receipt is read. */
function EarlierPlanDecision({row,sheet,disabled,owner,onSaved,reloadPrices,onPreview}:{
  row:CourseLedgerExtraRow;sheet:CaseSheetClinicalView;disabled:boolean;owner?:PlanDraftOwner;
  onSaved?:(fact:ClinicalPlanAcceptanceFact,bearer:string)=>Promise<void>;
  reloadPrices:(bearer?:string)=>Promise<import('@/dashboard/api').DoctorOrdinaryPricingView>;
  onPreview:(id:number,value:{status:string;amount:number|null;dirty:boolean})=>void;
}) {
  const identity=`${sheet.id}:${sheet.patientId}:${row.owningSheetId}:${row.item.id}`;
  const current=useRef(identity),generation=useRef(0),writing=useRef(false);
  const retryButton=useRef<HTMLButtonElement>(null);
  current.current=identity;
  const attempt=useRef<{body:ClinicalPlanAcceptanceInput;bearer:string;uncertain:boolean;acknowledged:boolean}|null>(null);
  const [present,setPresent]=useState(false),[message,setMessage]=useState<string|null>(null),[needsRead,setNeedsRead]=useState(false);
  const [outcome,setOutcome]=useState<PlanDecisionOutcome>({kind:'idle'});
  useEffect(()=>{generation.current++;attempt.current=null;writing.current=false;setPresent(false);setMessage(null);setNeedsRead(false);setOutcome({kind:'idle'});return()=>{generation.current++;};},[identity]);
  const source=row.source;
  const eligible=!!onSaved&&!!source?.updatedAt&&source.status==='advised'&&row.decision?.revision===0&&
    row.decision.effectiveStatus==='advised'&&!source.completedAt&&source.estimatedValue!==null&&
    Number.isSafeInteger(source.estimatedValue*100)&&source.estimatedValue>=0;
  const preview=useCallback((status:string)=>onPreview(row.item.id,{status,amount:row.item.estimatedValue,dirty:status!==row.item.status}),[row.item.id,row.item.status,row.item.estimatedValue,onPreview]);
  const commit=async(status:string):Promise<boolean>=>{
    if(writing.current||!onSaved||(!attempt.current&&(disabled||!eligible||needsRead||status!=='accepted')))return false;
    const scope=identity,epoch=generation.current,same=()=>current.current===scope&&generation.current===epoch;
    const returnFocus=document.activeElement===retryButton.current;
    writing.current=true;setOutcome({kind:'saving'});setMessage(null);
    try {
      if(!attempt.current){
        const bearer=await authBearer();if(!same())return false;
        if(!bearer)throw new PortalApiError(401,'Sign in again before accepting this treatment.');
        attempt.current={bearer,uncertain:false,acknowledged:false,body:{requestId:crypto.randomUUID(),owningCaseSheetId:row.owningSheetId,planItemId:row.item.id,expectedRevision:0,
          expected:{updatedAt:source!.updatedAt!,procedureName:source!.procedureName,toothArea:source!.toothArea,estimatedValue:source!.estimatedValue!,priorityRank:source!.priorityRank,status:'advised',declineReason:null,performingDoctorId:source!.performingDoctorId??null,itemNote:source!.itemNote??null,toothRefs:(source!.toothRefs??[]).map(ref=>ref.toothCode)}}};
        setPresent(true);
      }
      const pending=attempt.current;
      // Replay the same request even after a lost acknowledgement; recovery
      // may still need to finish the captured attribution/audit effects.
      const result=await acceptEarlierClinicalPlan(sheet.id,pending.body,pending.bearer);if(!same())return false;
      pending.acknowledged=true;
      const matches=(fact:ClinicalPlanAcceptanceFact)=>fact.requestId===pending.body.requestId&&fact.planItemId===row.item.id&&fact.owningCaseSheetId===row.owningSheetId&&fact.decisionCaseSheetId===sheet.id&&fact.financialAppointmentId===sheet.appointmentId&&fact.revision===1&&!fact.recoveryPending;
      if(!matches(result.fact))throw Error('Saved acceptance unavailable.');
      const read=await listClinicalPlanAcceptances(sheet.id,pending.bearer);if(!same())return false;
      const receipts=read.facts.filter(matches);
      if(!read.available||read.caseSheetId!==sheet.id||receipts.length!==1)throw Error('Saved acceptance unavailable.');
      const prices=await reloadPrices(pending.bearer);if(!same())return false;
      if(!prices.available)throw Error('Saved prices unavailable.');
      await onSaved(receipts[0]!,pending.bearer);if(!same())return false;
      attempt.current=null;setPresent(false);setNeedsRead(false);setOutcome({kind:'confirmed'});
      if(returnFocus)requestAnimationFrame(()=>{if(same())document.getElementById('consult-stage-3-heading')?.focus();});
      return true;
    } catch(error) {
      if(!same())return false;
      const pending=attempt.current;
      const refused=error instanceof PortalApiError&&error.status>=400&&error.status<500;
      if(refused&&!pending?.uncertain&&!pending?.acknowledged){
        attempt.current=null;setPresent(false);setNeedsRead(true);
        setMessage(`${error.message} Reload this visit and review the saved treatment before trying again.`);
      } else {
        if(pending)pending.uncertain=true;
        setMessage(pending?.acknowledged?'Acceptance saved. Retry to verify the current record before continuing.':'Save not confirmed. Retry the same acceptance before continuing.');
      }
      setOutcome({kind:'idle'});return false;
    } finally {if(same())writing.current=false;}
  };
  if(!source||source.status!=='advised'||!row.decision)return <>{planItemStatusLabel(row.item.status)}</>;
  return <div data-testid={`earlier-plan-decision-${row.item.id}`}>
    <PlanDecisionPicklist id={`earlier-plan-${row.item.id}`} testId={`earlier-plan-${row.item.id}`} presentation="segments"
      procedureName={row.item.procedureName} status={row.item.status} declineReason="" allowedActions={['advised','accepted']}
      disabled={disabled||!eligible||present||needsRead} outcome={outcome} operationPending={present} retryPending={present&&outcome.kind!=='saving'}
      draftOwner={owner} onPreview={preview} onCommit={commit}/>
    {message?<p role="alert">{message}</p>:null}
    {row.decision.acceptance?.caseSheetId===sheet.id?<small>Accepted this visit</small>:null}
    {present?<AcButton ref={retryButton} size="sm" disabled={disabled||outcome.kind==='saving'} onClick={()=>void commit('accepted')}>Retry same acceptance</AcButton>:null}
  </div>;
}

function CourseLedgerRow({
  row,
  anyBusy,
  canComplete,
  onComplete,
}: {
  row: CourseLedgerExtraRow;
  anyBusy: boolean;
  canComplete: boolean;
  onComplete?: () => void;
}): JSX.Element {
  const item = row.item;
  const done = item.completedAt != null;
  return (
    <li
      className="cockpit-plan__row"
      data-testid={`consult-course-item-${item.id}`}
    >
      <div className="cockpit-plan__row-main cockpit-plan__row-main--ledger">
        <span className="cockpit-plan__proc">{item.procedureName}</span>
        <span className="cockpit-plan__meta-line">
          {item.toothArea !== null && item.toothArea !== '' ? (
            <span className="cockpit-plan__tooth">{item.toothArea}</span>
          ) : null}
          <span className="cockpit-plan__value">
            {rupeeGlyphToRs(planItemPriceDisplay(item.estimatedValue))}
          </span>
          {/* C6: a missing/zero fee is never silent -- the flag rides the
              ledger row exactly as it rides the live rows below. */}
          {planLineFeeMissing(item.estimatedValue) ? (
            <AcBadge tone="pending" testId={`consult-course-fee-missing-${item.id}`}>
              {NO_FEE_RECORDED_LABEL}
            </AcBadge>
          ) : null}
        </span>
      </div>
      <div className="cockpit-plan__row-edit cockpit-plan__decided">
        <AcBadge
          tone={planLineChipTone(item.status, done)}
          testId={`consult-course-chip-${item.id}`}
        >
          {done
            ? doneChipLabel(item.completedAt as string, Date.now())
            : item.status === 'accepted'
              ? acceptedPlannedChipLabel()
              : planItemStatusLabel(item.status)}
        </AcBadge>
        {canComplete && !done && item.status === 'accepted' && onComplete ? (
          <AcButton
            size="sm"
            variant="secondary"
            disabled={anyBusy}
            onClick={onComplete}
            data-testid={`consult-journey-complete-${item.id}`}
          >
            Completed this visit
          </AcButton>
        ) : null}
      </div>
    </li>
  );
}

type EarlierConsentRead = {
  wires: Readonly<Record<number, CaseSheetConsentsWire | null>>;
  loading: boolean;
  error: boolean;
  retry: () => void;
};

function useEarlierTreatmentConsents(scopeKey: string, rows: readonly CourseLedgerExtraRow[]): EarlierConsentRead {
  const withheld = useConsultationWithheld();
  const ids = [...new Set(rows.filter(row => row.item.status === 'accepted').map(row => row.owningSheetId))].sort((a,b) => a-b).join(',');
  // First acceptance can add an uncovered treatment on an already-read visit.
  // Own the read by effective accepted item identities as well as patient/visit.
  const accepted = rows.filter(row => row.item.status === 'accepted')
    .map(row => `${row.owningSheetId}:${row.item.id}`).sort().join(',');
  const key = `${scopeKey}:${accepted}`;
  const [attempt, setAttempt] = useState(0);
  const [read, setRead] = useState<{ key: string; wires: Record<number, CaseSheetConsentsWire | null>; loading: boolean; error: boolean }>({ key: '', wires: {}, loading: true, error: false });
  useEffect(() => {
    let cancelled = false;
    setRead({ key, wires: {}, loading: ids.length > 0, error: false });
    if (!ids || withheld) return;
    void Promise.all(ids.split(',').map(async raw => {
      const id = Number(raw);
      try { return [id, await fetchCaseSheetConsents(id)] as const; }
      catch { return [id, null] as const; }
    })).then(entries => {
      if (!cancelled) setRead({ key, wires: Object.fromEntries(entries), loading: false, error: entries.some(([,wire]) => wire === null) });
    });
    return () => { cancelled = true; };
  }, [key, ids, attempt, withheld]);
  return { wires: read.key === key ? read.wires : {}, loading: !!ids && (read.key !== key || read.loading),
    error: read.key === key && read.error, retry: () => setAttempt(value => value + 1) };
}

function EarlierTreatmentConsents({ rows, read, patient, draftOwner, enabled, toothDisplay, visitStartedAt, clinicDoctors }: {
  rows: readonly CourseLedgerExtraRow[]; read: EarlierConsentRead; patient: DoctorConsultContext['patient']; draftOwner?:PlanDraftOwner; enabled:boolean; toothDisplay: 'fdi' | 'universal';
  visitStartedAt: string; clinicDoctors: NonNullable<DoctorConsultContext['clinicDoctors']>;
}): JSX.Element | null {
  const [open, setOpen] = useState(false),[uploadSheet,setUploadSheet]=useState<number|null>(null),[formSheet,setFormSheet]=useState<number|null>(null);
  const withheld = useConsultationWithheld();
  useEffect(() => { if (withheld) setOpen(false); }, [withheld]);
  const root = useRef<HTMLDivElement>(null);
  const retryFocus = useRef(false);
  useEffect(() => { if (retryFocus.current && !read.loading) { retryFocus.current = false; root.current?.focus(); } }, [read.loading]);
  const accepted = rows.filter(row => row.item.status === 'accepted');
  if (!accepted.length) return null;
  const sheets = [...new Set(accepted.map(row => row.owningSheetId))];
  const treatments = sheets.flatMap(id => read.wires[id]?.available ? (read.wires[id]?.consents ?? []).map(consent => ({ id, consent })) : []);
  // Consultation records are already admitted for this patient by the scoped
  // reader. Keep their actual owning sheet and deduplicate the same history
  // returned beside several course visits; they never satisfy treatment cover.
  const records = [...new Map([...treatments, ...sheets.flatMap(id => read.wires[id]?.available ?
    (read.wires[id]?.consultationConsents ?? []).map(consent => ({ id: consent.caseSheetId, consent })) : [])]
    .map(row => [row.consent.id, row])).values()]
    .sort((a,b) => (b.consent.signedAt ?? b.consent.createdAt).localeCompare(a.consent.signedAt ?? a.consent.createdAt));
  const signed = treatments.filter(({id,consent}) => ['signed_digital','signed_physical_captured'].includes(consent.state) && accepted.some(row => row.owningSheetId === id && consent.treatmentPlanItemIds.includes(row.item.id)));
  const location = (row: CourseLedgerExtraRow) => row.item.toothRefs?.map(ref => toothDisplay === 'fdi' ? ref.toothCode : savedToothRefLabel(ref,toothDisplay)).join(', ') || row.item.toothArea;
  const treatmentNames = (id:number, consent:TreatmentConsentView) => accepted.filter(row => row.owningSheetId === id && consent.treatmentPlanItemIds.includes(row.item.id))
    .map(row => [location(row),row.item.procedureName].filter(Boolean).join(' '));
  const unresolved = sheets.some(id => !read.wires[id]?.available);
  // A treatment first accepted today on an earlier course visit is owed its
  // own form; the server's uncovered list names exactly which treatments.
  const uncovered = sheets.map(id => ({ id, rows: read.wires[id]?.available ? accepted.filter(row => row.owningSheetId === id && read.wires[id]!.uncoveredAcceptedItemIds.includes(row.item.id)) : [] }))
    .filter(group => group.rows.length > 0);
  // Only a form recorded before this visit opened is an earlier consent; a
  // form captured since then for a newly accepted treatment is this visit's.
  const visitMs = Date.parse(visitStartedAt);
  const capturedThisVisit = (consent: TreatmentConsentView) => Number.isFinite(visitMs) && Date.parse(consent.createdAt) >= visitMs;
  return <div ref={root} tabIndex={-1} data-testid="consult-earlier-consents">
    {read.loading ? <p role="status">Loading earlier treatment consents…</p> : <>
      {unresolved ? <p role="status">Earlier treatment consent is unavailable.</p> : null}
      {uncovered.map(group => <div key={group.id} className="consult-v14g__consent-uncovered" data-testid={`consent-uncovered-earlier-${group.id}`}>
        <div className="consult-v14g__muted">{signed.length ? 'Not covered by a signed form yet:' : 'This one form lists:'}</div>
        <ul>{group.rows.map(row => <li key={row.item.id}><b>{location(row)}</b>{location(row) ? ' ' : ''}{row.item.procedureName} <span className="consult-v14g__muted">· {planItemDoctorLabel(row.item.performingDoctorId, clinicDoctors)}</span></li>)}</ul>
        <div className="consult-v14g__consent-actions">
          <AcButton variant="secondary" disabled={withheld} onClick={() => setFormSheet(group.id)}>View form ({group.rows.length} treatment{group.rows.length === 1 ? '' : 's'})</AcButton>
          <AcButton size="sm" data-consent-upload disabled={!enabled||withheld||uploadSheet!==null} onClick={()=>setUploadSheet(group.id)}>Upload signed form or video</AcButton>
        </div>
      </div>)}
      {signed.map(({id,consent}) => <div key={consent.id} className="consult-today-work__consent-line">
        <span><strong>{capturedThisVisit(consent) ? 'Consent for treatment' : 'Earlier consent'}</strong> · {treatmentNames(id,consent).join(' · ')}</span>
        <AcBadge tone="positive">{consentStateLabel(consent.state)}{consent.signedAt ? ` · ${formatIstShortDate(consent.signedAt)}` : ''}</AcBadge>
      </div>)}
      {!unresolved && !signed.length && !uncovered.length ? <p>No signed consent recorded for the earlier accepted treatment.</p> : null}
    </>}
    {read.error ? <AcButton variant="secondary" onClick={() => { retryFocus.current = true; read.retry(); }}>Retry earlier consent</AcButton> : null}
    {formSheet!==null?<EvidenceDialog presentation="v14g-consent" title="Treatment consent" eyebrow="Approved form" onClose={()=>setFormSheet(null)}><ClinicalConsentForm purpose="treatment" wording={read.wires[formSheet]?.template} caseSheetId={formSheet} onClose={()=>setFormSheet(null)}/></EvidenceDialog>:null}
    {uploadSheet!==null?<ConsentUploadForVisit caseSheetId={uploadSheet} patientId={patient.patientId} purpose="treatment" draftOwner={draftOwner} onAttached={()=>{setUploadSheet(null);retryFocus.current=true;read.retry();}} onClose={()=>setUploadSheet(null)}/>:null}
    {records.length > 0 ? <AcButton className="consult-v14g__consent-history-link" variant="ghost" onClick={() => setOpen(true)}>Earlier consents ({records.length})</AcButton> : null}
    {open ? <EvidenceDialog presentation="v14g-consent" title="Earlier consents" onClose={() => setOpen(false)}>
      <div className="consult-v14g__consent-history" aria-label="Saved consent records for this patient’s treatment course">{records.map(({id,consent}) => <div className="consult-v14g__consent-history-row" key={consent.id}>
        <span className="consult-v14g__consent-date">{consent.signedAt ? formatIstShortDate(consent.signedAt) : 'Date not recorded'}</span>
        <div className="consult-v14g__consent-description"><span>{consent.purpose === 'consultation' ? 'Consultation consent' : treatmentNames(id,consent).join(' · ') || 'Treatment names unavailable'}</span>
          <details><summary>Details</summary><small>{consent.consentNumber} · {consent.doctorName || 'Doctor not recorded'} · {consent.signerName || 'Signer not recorded'}</small></details></div>
        <span className="consult-v14g__consent-state">{consentStateLabel(consent.state)} · read-only</span>
        <div>{consent.recordSource === 'uploaded_original' ? <ConsentOriginalButton caseSheetId={id} consent={consent}/> : <a aria-label="Open form" className={acButtonClass('ghost','sm')} target="_blank" rel="noreferrer" href={consentPrintPath({caseSheetId:id,consentId:consent.id,patient,treatmentNames:treatmentNames(id,consent)})}>Open</a>}</div>
      </div>)}</div>
    </EvidenceDialog> : null}
  </div>;
}

/** Frozen stage-four placement of the existing whole-item completion act.
 * Partial-stage, deferral and after-care records are not fabricated here. */
export function ConsultTodayWork({ sheet, courseRows, currentConsents, earlierConsents, courseState, available, busy, onComplete, failedItems, toothDisplay }: {
  sheet: CaseSheetClinicalView | null;
  courseRows: readonly CourseLedgerExtraRow[];
  currentConsents: CaseSheetConsentsWire | null;
  earlierConsents: EarlierConsentRead;
  courseState: string;
  available: boolean;
  busy: boolean;
  onComplete?: (owningSheetId: number, itemId: number) => void;
  failedItems: readonly number[];
  toothDisplay: 'fdi' | 'universal';
}): JSX.Element {
  const rows = [...courseRows, ...(sheet?.planItems ?? []).map(item => ({ owningSheetId: sheet!.id, item }))].filter(row => row.item.status === 'accepted');
  return <section className="consult-v14g__card consult-today-work" data-testid="consult-today-work" aria-labelledby="consult-today-work-heading">
    <h3 id="consult-today-work-heading">2 · Today’s work <span>Treatment done</span></h3>
    {rows.length === 0 ? <p>{courseState === 'loading' ? 'Loading saved treatment…' : courseState === 'error' ? 'Earlier treatment could not be loaded.' : 'Nothing accepted yet, so nothing to record as done.'}</p> : <ul className="consult-today-work__list">{rows.map(({owningSheetId,item}) => {
      const wire = owningSheetId === sheet?.id ? currentConsents : earlierConsents.wires[owningSheetId] ?? null;
      const done = !!item.completedAt;
      const signed = wire?.consents.some(consent => (consent.state === 'signed_digital' || consent.state === 'signed_physical_captured') && consent.treatmentPlanItemIds.includes(item.id)) === true;
      const consentReady = wire?.available === true && (wire.requiredForProcedure === false || signed);
      const reason = done ? null : !available ? 'Completion is unavailable.' : !wire ? 'Checking signed consent…' : !wire.available ? 'Consent status is unavailable.' : !consentReady ? 'Upload the signed treatment consent first.' : null;
      return <li key={`${owningSheetId}:${item.id}`} data-testid={`consult-today-item-${item.id}`} tabIndex={-1}>
        <div className="consult-today-work__main"><strong>{item.procedureName}</strong>
          <span>{[item.toothArea, ...(item.toothRefs ?? []).map(ref => savedToothRefLabel(ref, toothDisplay))].filter(Boolean).join(' · ') || 'Tooth or area not recorded'}</span>
          {reason ? <p role="status">{reason}</p> : null}
          {failedItems.includes(item.id) ? <p role="alert">Completion was not confirmed. Retry to check the saved result.</p> : null}
        </div>
        {done ? <AcBadge tone="positive">{item.completedInCaseSheetId === sheet?.id ? 'Done today' : 'Recorded'} · {formatIstShortDate(item.completedAt!)} · kept as recorded</AcBadge> :
          <AcButton variant="secondary" disabled={busy || sheet?.status !== 'draft' || !available || !consentReady || !onComplete}
            onClick={() => onComplete?.(owningSheetId,item.id)} data-testid={`consult-journey-complete-${item.id}`}>{failedItems.includes(item.id) ? 'Retry completion' : 'Done today'}</AcButton>}
      </li>;
    })}</ul>}
  </section>;
}

/**
 * THE CODED PICKER (V6-P3) -- the primary add flow once the catalog is
 * applied AND populated: search -> select -> amount -> ONE "Add to plan"
 * action. Free-text entry survives as the explicit escape INSIDE this one
 * flow ("Add a treatment by name"); it is never a second parallel
 * form. Fields and chips, no prose (FIELDS-NOT-SENTENCES).
 */
function TreatmentPickerAdd({
  catalog,
  itemForm,
  anyBusy,
  onItemFormChange,
  onAddItem,
  toothEntry = null,
  seedToothRefs = [],
}: {
  catalog: TreatmentCatalogResult;
  itemForm: ItemForm;
  anyBusy: boolean;
  onItemFormChange: (form: ItemForm) => void;
  onAddItem: () => void;
  /** Tooth entry context (TOOTH-NOTATION-INTERIM-V1); null = not offered. */
  toothEntry?: ToothEntryContext | null;
  /** TOOTH->TREATMENT FLOW (law 2f): the diagnosis odontogram's current
   *  selection -- picking a treatment seeds its tooth set from it. */
  seedToothRefs?: readonly string[];
}): JSX.Element {
  // W-B1 keyboard walk: the index of the highlighted procedure hit in the
  // CURRENTLY VISIBLE hit list (-1 = none). Display-only; resets whenever
  // the query, group, or selection changes.
  const [highlight, setHighlight] = useState(-1);

  // TOOTH->TREATMENT FLOW (law 2f): the odontogram selection above SCOPES the
  // treatment being added -- when the item form carries no tooth work of its
  // own yet, the picked treatment's tooth set seeds from the diagnosis
  // selection (visible + adjustable in the item diagram below; provenance
  // stated, never a hidden write; savable teeth only).
  const carriedTeeth = (): Pick<ItemForm, 'toothRefs' | 'toothCarried'> =>
    (itemForm.toothRefs ?? []).length === 0 &&
    seedToothRefs.length > 0 &&
    toothEntry !== null &&
    toothEntry.storageLive
      ? { toothRefs: seedToothRefs, toothCarried: true }
      : {};

  const selectItem = (item: TreatmentCatalogItemView): void => {
    const seed = catalogDefaultSeedRupees(item.defaultAmountMinorUnits);
    setHighlight(-1);
    onItemFormChange({
      ...itemForm,
      ...carriedTeeth(),
      catalogItemId: item.id,
      catalogLabel: item.serviceName,
      catalogDefaultMinorUnits: item.defaultAmountMinorUnits,
      catalogMinimumMinorUnits: item.minimumAmountMinorUnits,
      // The resolved price SOURCE rides the selection for display (S1
      // read truth: clinic price / chain rate / not configured -- never a
      // silently substituted number). Display-only; never sent.
      catalogSource: catalogPriceSource(item),
      customMode: false,
      procedureName: '',
      // Seed the EDITABLE estimate only from an exact whole-rupee default;
      // a paise-precision default displays exactly and seeds nothing.
      estimatedValue: seed !== null ? String(seed) : '',
    });
  };
  const clearSelection = (): void => {
    // Back to the PROCEDURE level of the same group (the disclosure
    // ladder unwinds one step at a time).
    setHighlight(-1);
    onItemFormChange({
      ...itemForm,
      catalogItemId: null,
      catalogLabel: '',
      catalogDefaultMinorUnits: null,
      catalogMinimumMinorUnits: null,
      catalogSource: null,
      estimatedValue: '',
    });
  };
  const setQuery = (q: string): void => {
    setHighlight(-1);
    onItemFormChange({ ...itemForm, catalogQuery: q });
  };

  /**
   * W-B1 keyboard support (keyboard AND tap friendly; the W-B5 five-second
   * law): ArrowDown/ArrowUp walk the visible procedure hits, Enter picks
   * the highlighted hit -- or the FIRST hit when none is highlighted (type
   * "crown", press Enter, it is picked) -- and Escape clears the query.
   * When only a group-name match is visible, Enter steps into that group.
   */
  const searchKeys =
    (
      visible: readonly TreatmentCatalogItemView[],
      onEnterNoHit?: () => void,
    ) =>
    (e: { key: string; preventDefault: () => void }): void => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (visible.length > 0) {
          setHighlight((h) => Math.min(h + 1, visible.length - 1));
        }
        return;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (visible.length > 0) setHighlight((h) => Math.max(h - 1, 0));
        return;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        const pick =
          highlight >= 0 && highlight < visible.length
            ? visible[highlight]
            : visible[0];
        if (pick !== undefined) {
          selectItem(pick);
        } else if (onEnterNoHit !== undefined) {
          onEnterNoHit();
        }
        return;
      }
      if (e.key === 'Escape' && itemForm.catalogQuery !== '') {
        e.preventDefault();
        setQuery('');
      }
    };

  /** ONE procedure-option row grammar (typeahead + within-group levels):
   *  name + unit + price + source -- price renders on EVERY treatment hit
   *  (W-B3), with the unset state visible, never a blank or fake zero. */
  const procedureOption = (
    item: TreatmentCatalogItemView,
    visible: readonly TreatmentCatalogItemView[],
  ): JSX.Element => {
    const active = highlight >= 0 && visible[highlight]?.id === item.id;
    return (
      <button
        key={item.id}
        type="button"
        className={
          active
            ? 'treatment-picker__option treatment-picker__option--active'
            : 'treatment-picker__option'
        }
        data-testid={`picker-option-${item.id}`}
        disabled={anyBusy}
        onClick={() => selectItem(item)}
      >
        <span className="treatment-picker__option-name">{item.serviceName}</span>
        <span className="treatment-picker__option-meta">
          {pricingUnitLabel(item.pricingUnit)}
        </span>
        <span
          className="treatment-picker__option-default"
          data-testid={`picker-option-price-${item.id}`}
        >
          {catalogPriceDisplay(item)}
        </span>
        {/* RULING 1 (DOCTOR-PRICING-UX-CONFORMANCE-V1): the doctor's picker
            shows the formatted amount only -- no clinic-price/chain-rate
            qualifier here; that provenance stays on the leadership catalog
            browse surface, which calls catalogPriceSourceLabel directly. */}
      </button>
    );
  };

  // W-B2 ONE ADD-FLOW ANATOMY (S-2): pick treatment -> pick TEETH (the
  // existing FDI grid, tap + typed-code assist, multi-select) -> price ->
  // status (defaults advised) -> ONE Add. The grid leads, full-width.
  // ONE TEETH SECTION: while the grid is offered AND SAVABLE, the free-text
  // Tooth/area input no longer renders beside it (the founder-walked
  // duplicated-teeth defect); it REMAINS the teeth path whenever structured
  // entry cannot be saved -- tooth entry not offered at all (older server),
  // OR the chart is rendering LOCKED because tooth storage is not live
  // (DOCTOR-PRECALL-POLISH-V1). Nothing is ever lost: exactly one savable
  // teeth path is on screen in every state.
  // Saved rows' free-text loci render unchanged everywhere.
  const toothEntrySavable = toothEntry !== null && toothEntry.storageLive;
  // TREATMENT-PRICE-FLOOR-V1: the doctor learns AT THE FIELD, at the moment
  // of typing -- never only at save. Mirrors (never re-derives) the SAME
  // rule + numbers the backend write path enforces authoritatively; a
  // malformed/blank amount shows no floor error here (buildPlanItemCreatePayload's
  // format check owns that at submit).
  const amountFloorViolation = treatmentFloorViolationMessage(
    itemForm.catalogMinimumMinorUnits,
    (() => {
      const parsed = parseWholeInr(itemForm.estimatedValue);
      return typeof parsed === 'number' ? parsed : null;
    })(),
    itemForm.catalogLabel,
  );
  const detailFields = (
    <>
    {itemForm.toothCarried === true && (itemForm.toothRefs ?? []).length > 0 ? (
      // Law 2f provenance: the carried tooth scope is STATED, adjustable
      // below -- never a silent attach.
      <p
        className="clinic-workbench__muted"
        data-testid="picker-teeth-carried"
      >
        Teeth carried from the odontogram selection above - adjust below if
        this procedure covers different teeth.
      </p>
    ) : null}
    {/* RC-1: carried-teeth chips + the on-intent diagram (law 2f provenance
        stays above; the second always-on odontogram is retired). */}
    <ItemTeethEntry
      toothEntry={toothEntry}
      selected={itemForm.toothRefs ?? []}
      disabled={anyBusy}
      onChange={(next) =>
        onItemFormChange({ ...itemForm, toothRefs: next, toothCarried: false })
      }
    />
    <div className="cockpit-plan__add-grid">
      {!toothEntrySavable ? (
        <label className="clinic-workbench__field">
          <span>{CASE_SHEET_LABELS.toothArea}</span>
          <input
            type="text"
            className="clinic-workbench__input"
            maxLength={60}
            value={itemForm.toothArea}
            disabled={anyBusy}
            onChange={(e) =>
              onItemFormChange({ ...itemForm, toothArea: e.target.value })
            }
          />
        </label>
      ) : null}
      <label className="clinic-workbench__field">
        <span>{CASE_SHEET_LABELS.estimatedValue}</span>
        <input
          type="text"
          inputMode="numeric"
          className={
            amountFloorViolation !== null
              ? 'clinic-workbench__input ac-wizard__input--error'
              : 'clinic-workbench__input'
          }
          data-testid="picker-amount"
          placeholder="whole rupees"
          value={itemForm.estimatedValue}
          disabled={anyBusy}
          aria-invalid={amountFloorViolation !== null}
          aria-describedby={
            amountFloorViolation !== null ? 'picker-amount-floor-error' : undefined
          }
          onChange={(e) =>
            onItemFormChange({ ...itemForm, estimatedValue: e.target.value })
          }
          onBlur={() =>
            onItemFormChange({
              ...itemForm,
              estimatedValue: estimateInputDisplayOnBlur(itemForm.estimatedValue),
            })
          }
        />
        {amountFloorViolation !== null ? (
          <p
            id="picker-amount-floor-error"
            className="ac-wizard__field-error"
            role="alert"
            data-testid="picker-amount-floor-error"
          >
            <span className="ac-wizard__field-error-glyph" aria-hidden="true">
              !
            </span>
            {amountFloorViolation}
          </p>
        ) : null}
      </label>
      <div className="clinic-workbench__field">
        <span className="clinic-workbench__label">Status</span>
        {/* RC-2 (founder ruling 2026-08-15): the four decision tokens as
            tap-chips (one interaction; the CODED picker path only -- the
            legacy fail-safe form keeps its pinned select). Unpressing the
            active chip returns to 'pending' (the undecided default), so the
            full five-token vocabulary stays reachable -- no capability
            lost. */}
        <IntakeChoiceChips
          ariaLabel="Status"
          options={PLAN_ITEM_STATUS_ORDER.filter((s) => s !== 'pending').map(
            (s) => ({ code: s, label: planItemStatusLabel(s) }),
          )}
          isSelected={(code) => itemForm.status === code}
          onPick={(code) =>
            onItemFormChange({
              ...itemForm,
              status: (itemForm.status === code
                ? 'pending'
                : code) as PlanItemStatusView,
            })
          }
          disabled={anyBusy}
          testId="picker-status"
        />
      </div>
      {itemForm.status === 'declined' ? (
        <div className="clinic-workbench__field">
          <span className="clinic-workbench__label">
            {CASE_SHEET_LABELS.declineReason}
          </span>
          {/* RC-2/RC-4: the six-token reason bank as tap-chips (unpressing
              clears -- "No reason" stays reachable). */}
          <IntakeChoiceChips
            ariaLabel={CASE_SHEET_LABELS.declineReason}
            options={OUTCOME_REASON_OPTIONS.map((o) => ({
              code: o.value,
              label: o.label,
            }))}
            isSelected={(code) => itemForm.declineReason === code}
            onPick={(code) =>
              onItemFormChange({
                ...itemForm,
                declineReason: itemForm.declineReason === code ? '' : code,
              })
            }
            disabled={anyBusy}
            testId="picker-decline-reason"
          />
        </div>
      ) : null}
    </div>
    </>
  );

  // MODE 1: the free-text escape (explicit, inside the one flow).
  if (itemForm.customMode) {
    return (
      <div className="cockpit-plan__add" data-testid="consult-plan-add-picker">
        <h3 className="clinic-table__subtitle">Add a procedure by name</h3>
        <div className="cockpit-plan__add-grid">
          <label className="clinic-workbench__field">
            <span>{CASE_SHEET_LABELS.procedureName}</span>
            <input
              type="text"
              className="clinic-workbench__input"
              data-testid="consult-item-name"
              maxLength={120}
              value={itemForm.procedureName}
              disabled={anyBusy}
              onChange={(e) =>
                onItemFormChange({ ...itemForm, procedureName: e.target.value })
              }
            />
          </label>
        </div>
        {detailFields}
        <div className="treatment-picker__actions">
          <AcButton
            size="sm"
            variant="primary"
            disabled={anyBusy}
            onClick={onAddItem}
            data-testid="consult-add-item"
          >
            Add to plan
          </AcButton>
          <AcButton
            size="sm"
            variant="ghost"
            className={`${acButtonClass('ghost', 'sm')} treatment-picker__escape`}
            data-testid="picker-back-to-catalog"
            disabled={anyBusy}
            onClick={() =>
              onItemFormChange({
                ...itemForm,
                customMode: false,
                procedureName: '',
              })
            }
          >
            Back to catalog search
          </AcButton>
        </div>
      </div>
    );
  }

  // MODE 2: an item is selected -- detail fields + the ONE primary action.
  if (itemForm.catalogItemId !== null) {
    return (
      <div className="cockpit-plan__add" data-testid="consult-plan-add-picker">
        <h3 className="clinic-table__subtitle">Add from the treatment catalog</h3>
        <div className="treatment-picker__selected" data-testid="picker-selected">
          <span className="treatment-picker__selected-name">
            {itemForm.catalogLabel}
          </span>
          <span
            className="treatment-picker__default"
            data-testid="picker-selected-default"
          >
            {itemForm.catalogSource === null
              ? catalogDefaultLabel(itemForm.catalogDefaultMinorUnits)
              : itemForm.catalogSource === 'not_configured'
                ? catalogPriceSourceLabel('not_configured')
                : rupeesFromMinorLabel(itemForm.catalogDefaultMinorUnits ?? 0)}
          </span>
          {/* RULING 1 (DOCTOR-PRICING-UX-CONFORMANCE-V1): amount only on
              the doctor's picker -- the clinic-price/chain-rate qualifier
              that used to render here is removed; itemForm.catalogSource
              still drives the amount slot above (the "Price not set" gap
              copy), untouched. */}
          <AcButton
            size="sm"
            variant="ghost"
            className={`${acButtonClass('ghost', 'sm')} treatment-picker__escape`}
            data-testid="picker-change-selection"
            disabled={anyBusy}
            onClick={clearSelection}
          >
            Change
          </AcButton>
        </div>
        {/* W-B3/S-4: an unset price NAMES who can fix it (no in-product
            price writer exists for any role -- the read-only catalog). The
            doctor can still record the patient-specific estimate below. */}
        {itemForm.catalogSource === 'not_configured' ? (
          <p
            className="treatment-picker__note"
            data-testid="picker-price-naming"
          >
            {PRICE_SETTER_NAMING_COPY} You can still enter this patient&apos;s
            estimate below.
          </p>
        ) : null}
        {detailFields}
        <div className="treatment-picker__actions">
          <AcButton
            size="sm"
            variant="primary"
            disabled={anyBusy}
            onClick={onAddItem}
            data-testid="consult-add-item"
          >
            Add to plan
          </AcButton>
        </div>
      </div>
    );
  }

  // MODE 3: the entry level. RESTING state = the service-group list (the S1
  // PROGRESSIVE-DISCLOSURE LAW: the full catalog never renders flat; groups
  // derive from the catalog's own service_group values). TYPING flips to
  // the W-B1 TYPE-AHEAD: procedure hits by NAME or CODE across the whole
  // clinic-scoped catalog, grouped under their own still-tappable group
  // headings, each hit DIRECTLY selectable with its price visible -- the
  // two-hop group drill is no longer the only path to a procedure.
  if (itemForm.catalogGroup === null) {
    const browsing = itemForm.catalogQuery.trim() === '';
    const groups = browsing
      ? filterCatalogGroups(catalog.items, itemForm.catalogQuery)
      : [];
    const taGroups = typeaheadCatalogResults(
      catalog.items,
      itemForm.catalogQuery,
    );
    const taFlat = typeaheadFlatItems(taGroups);
    return (
      <div className="cockpit-plan__add" data-testid="consult-plan-add-picker">
        <h3 className="clinic-table__subtitle">Add from the treatment catalog</h3>
        {/* TOOTH->TREATMENT FLOW (law 2f): with teeth selected on the
            odontogram, the add flow OPENS scoped to that selection -- the
            doctor works tooth -> treatment -> price -> decision; SEARCH is
            the primary door (below), the group browse stays available and
            the raw catalog buckets are never the lead. */}
        {seedToothRefs.length > 0 && toothEntrySavable ? (
          <p
            className="cockpit-plan__legend"
            data-testid="picker-teeth-scope"
          >
            Selected teeth: {seedToothRefs.join(', ')}
          </p>
        ) : null}
        <input
          type="search"
          className="clinic-workbench__input treatment-picker__search"
          data-testid="picker-search"
          placeholder="Search treatments by name or code"
          aria-label="Search treatments by name or code"
          value={itemForm.catalogQuery}
          disabled={anyBusy}
          autoComplete="off"
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={searchKeys(taFlat, () => {
            // No procedure hit visible: Enter steps into the single
            // group-name match (the browse door), if there is exactly one.
            const only = taGroups.length === 1 ? taGroups[0] : undefined;
            if (only !== undefined) {
              setHighlight(-1);
              onItemFormChange({
                ...itemForm,
                catalogGroup: only.group,
                catalogQuery: '',
              });
            }
          })}
        />
        {browsing ? (
          groups.length === 0 ? (
            <p className="treatment-picker__empty" data-testid="picker-no-results">
              No catalog match.
            </p>
          ) : (
            /* DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (defect 4): the resting
               group list no longer FRONTS the add flow -- search is the
               primary door (above), and the raw catalog buckets sit behind
               this explicit fallback door (native details; closed by
               default). Same groups, same taps, same testids -- the browse
               path is demoted, never removed (2f order unchanged:
               teeth-scope -> search -> browse). */
            <details
              className="treatment-picker__browse"
              data-testid="picker-browse-door"
            >
              <summary className="treatment-picker__browse-summary">
                Browse the catalog
                <span className="treatment-picker__browse-count">
                  {groups.length} {groups.length === 1 ? 'group' : 'groups'}
                </span>
              </summary>
              <div className="treatment-picker__list" data-testid="picker-groups">
                {groups.map((g) => (
                  <button
                    key={g.group}
                    type="button"
                    className="treatment-picker__option"
                    data-testid={`picker-group-${g.group}`}
                    disabled={anyBusy}
                    onClick={() => {
                      // Selecting a group CONSTRAINS the next level and
                      // resets the search to the new scope.
                      setHighlight(-1);
                      onItemFormChange({
                        ...itemForm,
                        catalogGroup: g.group,
                        catalogQuery: '',
                      });
                    }}
                  >
                    <span className="treatment-picker__option-name">{g.group}</span>
                    <span className="treatment-picker__option-meta">
                      {g.itemCount} {g.itemCount === 1 ? 'procedure' : 'procedures'}
                    </span>
                  </button>
                ))}
              </div>
            </details>
          )
        ) : taGroups.length === 0 ? (
          <p className="treatment-picker__empty" data-testid="picker-no-results">
            No catalog match.
          </p>
        ) : (
          <div className="treatment-picker__list" data-testid="picker-typeahead">
            {taGroups.map((g) => (
              <div key={g.group} className="treatment-picker__ta-group">
                <button
                  type="button"
                  className="treatment-picker__option treatment-picker__group-head"
                  data-testid={`picker-group-${g.group}`}
                  disabled={anyBusy}
                  onClick={() => {
                    setHighlight(-1);
                    onItemFormChange({
                      ...itemForm,
                      catalogGroup: g.group,
                      catalogQuery: '',
                    });
                  }}
                >
                  <span className="treatment-picker__option-name">{g.group}</span>
                  <span className="treatment-picker__option-meta">
                    {g.itemCount} {g.itemCount === 1 ? 'procedure' : 'procedures'}
                  </span>
                </button>
                {g.items.map((item) => procedureOption(item, taFlat))}
              </div>
            ))}
          </div>
        )}
        {catalog.capped ? (
          <p className="treatment-picker__note">
            Showing the first {catalog.items.length} items - refine the search.
          </p>
        ) : null}
        <AcButton
          size="sm"
          variant="ghost"
          className={`${acButtonClass('ghost', 'sm')} treatment-picker__escape`}
          data-testid="picker-custom-escape"
          disabled={anyBusy}
          onClick={() =>
            // Belt (adversarial finding F4): entering the custom escape
            // ALWAYS clears any catalog selection, so a coded payload can
            // never ride under the free-text form.
            onItemFormChange({
              ...itemForm,
              ...carriedTeeth(),
              customMode: true,
              catalogItemId: null,
              catalogLabel: '',
              catalogDefaultMinorUnits: null,
              catalogMinimumMinorUnits: null,
              catalogSource: null,
            })
          }
        >
          Add a treatment by name
        </AcButton>
      </div>
    );
  }

  // The PROCEDURE level: ONLY the selected group's items.
  const scoped = filterItemsWithinGroup(
    catalog.items,
    itemForm.catalogGroup,
    itemForm.catalogQuery,
  );
  return (
    <div className="cockpit-plan__add" data-testid="consult-plan-add-picker">
      <h3 className="clinic-table__subtitle">Add from the treatment catalog</h3>
      <div className="treatment-picker__selected">
        <span className="treatment-picker__group-label">
          {itemForm.catalogGroup}
        </span>
        <AcButton
          size="sm"
          variant="ghost"
          className={`${acButtonClass('ghost', 'sm')} treatment-picker__escape`}
          data-testid="picker-back-to-groups"
          disabled={anyBusy}
          onClick={() => {
            setHighlight(-1);
            onItemFormChange({
              ...itemForm,
              catalogGroup: null,
              catalogQuery: '',
            });
          }}
        >
          All groups
        </AcButton>
      </div>
      <input
        type="search"
        className="clinic-workbench__input treatment-picker__search"
        data-testid="picker-search"
        placeholder="Search within this group"
        aria-label="Search within this group"
        value={itemForm.catalogQuery}
        disabled={anyBusy}
        autoComplete="off"
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={searchKeys(scoped)}
      />
      {scoped.length === 0 ? (
        <p className="treatment-picker__empty" data-testid="picker-no-results">
          No catalog match.
        </p>
      ) : (
        <div className="treatment-picker__list" data-testid="picker-list">
          {scoped.map((item) => procedureOption(item, scoped))}
        </div>
      )}
      {catalog.capped ? (
        <p className="treatment-picker__note">
          Showing the first {catalog.items.length} items - refine the search.
        </p>
      ) : null}
      <AcButton
        size="sm"
        variant="ghost"
        className={`${acButtonClass('ghost', 'sm')} treatment-picker__escape`}
        data-testid="picker-custom-escape"
        disabled={anyBusy}
        onClick={() =>
          // Belt (adversarial finding F4): entering the custom escape
          // ALWAYS clears any catalog selection, so a coded payload can
          // never ride under the free-text form (unreachable today by the
          // render guards; enforced here so a future handler tweak cannot
          // regress it silently).
          onItemFormChange({
            ...itemForm,
            customMode: true,
            catalogItemId: null,
            catalogLabel: '',
            catalogDefaultMinorUnits: null,
            catalogMinimumMinorUnits: null,
            catalogSource: null,
          })
        }
      >
        Add a treatment by name
      </AcButton>
    </div>
  );
}

/** The inline decision control (DOCTOR-JOURNEY-COMPOSE-V1, SCOPE 1 + law 2f
 *  tail): the doctor-v2 TreatmentCockpit decision anatomy on the LIVE plan
 *  row -- three real affordances on the real treatment_plan_items.status
 *  axis, rendered ONLY while a line is undecided (planLineIsDecidable). A
 *  decided line renders the existing status editor (change-of-mind and the
 *  decline reason keep their current home). */

function PlanItemRow({
  item,
  editable,
  anyBusy,
  toothDisplay = 'fdi',
  onLineWrite,
  onLineSettled,
  onComplete,
  doctorAssign, draftOwner, presentation = 'legacy', onPlanPreview, additionDoctor, findingLabel, onRemove, removalHost,
}: {
  additionDoctor?:{value:number|null;saved:boolean;pending:boolean;change:(doctorId:number|null)=>void};
  presentation?: 'legacy' | 'table';
  findingLabel?: string;
  removalHost?: HTMLDivElement;
  onRemove?: (itemId:number, input:PlanItemRemovalInput)=>Promise<void>;
  onPlanPreview?: (id:number, value:{status:string; amount:number|null; dirty:boolean}) => void;
  draftOwner?: PlanDraftOwner;
  item: ClinicalPlanItemView;
  editable: boolean;
  anyBusy: boolean;
  /** Org tooth-notation display for the saved tooth chips (fdi seeded). */
  toothDisplay?: 'fdi' | 'universal';
  /** THE ONE WRITER FOR THIS LINE (#781 handoff, integration order step 1).
   *  It is the page's EXISTING audited `updatePlanItem`, and it must resolve
   *  with the refreshed sheet or REJECT -- `usePlanLineWrite` reads the
   *  refreshed view to decide whether anything was actually confirmed, and a
   *  swallowed rejection would read as a save. The three former handlers
   *  (onDecideItem / onAssignItemDoctor / onSaveItem) are gone: two handlers
   *  on one line is the defect the overlap fence exists for. */
  onLineWrite: (
    itemId: number,
    patch: PlanItemUpdateInput,
  ) => Promise<CaseSheetClinicalView>;
  /** Optional: the page's own feedback banner, told about every settled
   *  attempt. Never used to decide anything on the line. */
  onLineSettled?: (itemId: number, kind: PlanWriteKind, outcome: string) => void;
  /** ROUND 3: the EXISTING completion act (completePlanItem on THIS sheet's
   *  row), relocated from the retired chronicle to the ledger row itself.
   *  Provided ONLY when lawful (accepted + uncompleted + draft + storage
   *  live) -- absence renders no button. */
  onComplete?: () => void;
  /** DOCTOR-CONSULT-DELTA-V1: the treatment-specific doctor assignment
   *  context (roster + write). Absent = byte-identical pre-package row. */
  doctorAssign?: PlanItemDoctorAssign;
}): JSX.Element {
  // DOCTOR-CONSULT-DELTA-V1: this row's own search-box text for THE ONE
  // picker (query state is the mount's, exactly as the visit-grain handoff
  // holds its own). Local UI state only -- never a second source of truth.
  const [doctorOpen, setDoctorOpen] = useState(false);
  const removal = useRef<PlanItemRemovalInput | null>(null);
  const removing = useRef(false);
  const removalAlive = useRef(true);
  const [removalState, setRemovalState] = useState<'idle'|'saving'|'unknown'>('idle');
  const [removalError, setRemovalError] = useState<string | null>(null);
  useEffect(()=>{removalAlive.current=true;return()=>{removalAlive.current=false;};},[]);
  /* ONE LINE, ONE HOOK (#781 handoff). `line.row` is the LAST CONFIRMED row --
     what a server response actually carried -- and `line.inFlight` is what
     makes every control on the line go busy together, which is what stops an
     assignment firing while a decision save is unanswered. */
  const line = usePlanLineWrite<ClinicalPlanItemView, CaseSheetClinicalView>({
    initial: item,
    write: async (kind, patch) => { try { return await onLineWrite(item.id, patch as PlanItemUpdateInput); } catch(error) { if(kind==='price' && error instanceof PortalApiError && error.status >= 400 && error.status < 500) setPriceError(consultErrorMessage(error).text); throw error; } },
    findRow: (view) => view.planItems.find((i) => i.id === item.id),
    onSettled: (kind, outcome) => onLineSettled?.(item.id, kind, outcome),
  });
  /* ONE SOURCE FOR THE THREE FACTS ON THIS LINE. The header meta, the picker
     and the failure line all read `row` -- never the page's `item` copy. That
     is the requirement carried from #781: the mid-walk frame there showed the
     meta reading "Doctor not assigned" while the picker and the alert named
     the assigned doctor, because two of them read one source and the third
     read another. */
  const row = line.row;
  const busy = line.inFlight !== null || removalState !== 'idle';
  usePlanControlDraft(draftOwner, `plan-line-${item.id}`, { dirty: false, signature: '', pending: busy, commit: () => true, reset: line.clearOutcomes });
  const assignedDoctorName =
    doctorAssign !== undefined
      ? planItemDoctorLabel(row.performingDoctorId, doctorAssign.roster)
      : null;
  // Coded-catalog provenance (V6-P3): the code chip + the default-vs-edited
  // distinction render as FIELDS beside the amount; legacy free-text items
  // render exactly as before (empty provenance = no chip). RULING 1
  // (DOCTOR-PRICING-UX-CONFORMANCE-V1, founder ruling 2026-08-28): the
  // clinic-price/chain-rate SOURCE naming that S1 layered in here is
  // removed on this doctor-facing ledger row -- a catalog-default amount
  // reads plainly as 'Catalog default', never naming which config layer
  // priced it (that stays a leadership-catalog-browse concept).
  const provenance = planAmountProvenance(item);
  const provenanceLabel = planAmountProvenanceLabel(
    provenance,
    item.catalogDefaultAmountMinorUnits ?? null,
  );
  // CALL-HISTORY-V1 package B (plan-row pricing unit): the SAVED row reads
  // its snapshot pricing unit beside the amount -- a per-session course must
  // never read as a single lump amount. THE ONE vocabulary (pricingUnitLabel,
  // the picker option row's own helper) over the snapshot the wire already
  // carries; '' (legacy free-text rows, non-core tokens) renders NO span, so
  // the meta-line separator never draws a dangling dot.
  const unitLabel = pricingUnitLabel(item.catalogPricingUnit ?? null);
  const [quoteDraft, setQuoteDraft] = useState<string | null>(null);
  const [discountDraft, setDiscountDraft] = useState<string | null>(null);
  const [discountMode, setDiscountMode] = useState<typeof PLAN_DISCOUNT_UNITS[number]>(PLAN_DISCOUNT_UNITS[0]);
  const [priceAttempted, setPriceAttempted] = useState(false);
  const [priceError, setPriceError] = useState<string | null>(null);
  const [previewDecision, setPreviewDecision] = useState<string>(item.status);
  const listPrice = wholePlanListPrice(row.catalogDefaultAmountMinorUnits);
  const shownQuote = quoteDraft ?? (row.estimatedValue == null ? '' : String(row.estimatedValue));
  const parsedQuote = parseWholeInr(shownQuote);
  const validQuote = parsedQuote !== false && (parsedQuote === null || Number.isSafeInteger(parsedQuote));
  const invalidDiscount = discountDraft !== null && planQuoteFromDiscount(listPrice,discountDraft,discountMode) === null;
  const priceDirty = quoteDraft !== null && (!validQuote || invalidDiscount || parsedQuote !== row.estimatedValue);
  const inferredDiscount = listPrice !== null && validQuote && parsedQuote !== null ? Math.max(0,listPrice-parsedQuote) : null;
  const previewPrice = validQuote && !invalidDiscount ? parsedQuote : null;
  useEffect(()=>{onPlanPreview?.(item.id,{status:editable ? previewDecision : row.status,amount:previewPrice,dirty:priceDirty || previewDecision!==row.status});},[item.id,onPlanPreview,editable,previewDecision,row.status,previewPrice,priceDirty]);
  const shownDiscount = discountDraft ?? (inferredDiscount === null || inferredDiscount === 0 ? '' : String(discountMode === '%' ? listPrice ? Number((inferredDiscount*100/listPrice).toFixed(1)) : 0 : inferredDiscount));
  usePlanControlDraft(presentation === 'table' ? draftOwner : undefined, `plan-price-${item.id}`, {dirty:priceDirty, signature:JSON.stringify([quoteDraft,discountDraft,discountMode]),pending:line.inFlight === 'price',
    commit:async () => {
      setPriceAttempted(true);
      if (!validQuote || invalidDiscount) { document.getElementById(`plan-quote-${item.id}`)?.focus(); return false; }
      setPriceError(null);
      const saved = await line.run('price',{estimatedValue:parsedQuote});
      if(saved){setQuoteDraft(null);setDiscountDraft(null);setPriceAttempted(false);}
      return saved;
    }, reset:() => {setQuoteDraft(null);setDiscountDraft(null);setPriceAttempted(false);setPriceError(null);},
  });
  const remove = async ():Promise<boolean> => {
    if (removing.current || line.inFlight !== null || !onRemove || !editable) return false;
    const retryingUncertain=removal.current!==null;
    if (!removal.current) {
      if (!row.updatedAt || row.completedAt || priceDirty || previewDecision!==row.status) return false;
      removal.current={requestId:crypto.randomUUID(),expected:{updatedAt:row.updatedAt,procedureName:row.procedureName,toothArea:row.toothArea,
        estimatedValue:row.estimatedValue,priorityRank:row.priorityRank,status:row.status,declineReason:row.declineReason,
        performingDoctorId:row.performingDoctorId??null,itemNote:row.itemNote??null,toothRefs:(row.toothRefs??[]).map(ref=>ref.toothCode)}};
    }
    removing.current=true;setRemovalState('saving');setRemovalError(null);
    try { await onRemove(row.id,removal.current);removal.current=null;return true; }
    catch(error){
      if(!removalAlive.current)return false;
      const refused=error instanceof ConsultPreWriteError || definitiveConsultRejection(error) || (error instanceof PortalApiError && error.status===409 && ['plan_removal_changed','plan_removal_unavailable'].includes(error.code??''));
      // A later refusal cannot prove an earlier unanswered attempt did not commit.
      if(!retryingUncertain&&refused){removal.current=null;setRemovalState('idle');}
      else setRemovalState('unknown');
      setRemovalError(consultErrorMessage(error).text);return false;
    } finally {removing.current=false;if(removalAlive.current&&!removal.current)setRemovalState('idle');}
  };
  usePlanControlDraft(draftOwner,`plan-remove-${item.id}`,{dirty:removalState!=='idle',signature:JSON.stringify(removal.current),
    pending:removalState!=='idle',retryPending:removalState==='unknown',commit:remove,reset:()=>setRemovalError(null)});
  const removalControls=(examination:boolean)=><>
    {editable&&onRemove?<AcButton variant="ghost" className="consult-v14g__remove" data-testid={`${examination?'consult-examination-remove':'consult-item-remove'}-${item.id}`}
      aria-label={examination?`Remove ${row.procedureName}`:undefined}
      disabled={anyBusy||removing.current||line.inFlight!==null||(!removal.current&&(!row.updatedAt||!!row.completedAt||priceDirty||previewDecision!==row.status))}
      title={!row.updatedAt?'Reload this visit before removing this treatment.':row.completedAt?'Recorded work is protected.':undefined}
      onClick={()=>void remove()}>{removalState==='saving'?'Removing…':removalState==='unknown'?'Retry same removal':examination?'✕':'Remove'}</AcButton>:null}
    {removalError?<p role="alert">{removalState==='unknown'?'Removal is not confirmed. Keep this visit open and retry the same removal. ':''}{removalError}</p>:null}
  </>;
  if (presentation === 'table') return <><TableRow data-testid={`consult-item-${item.id}`} aria-busy={busy} className={row.status === 'declined' ? 'is-declined' : ''}>
    <TableCell className="plan-tooth">{(row.toothRefs ?? []).map(ref => <span key={ref.toothCode} title={savedToothRefLabel(ref,toothDisplay)} data-testid={`consult-item-${item.id}-tooth-${ref.toothCode}`}>{toothDisplay === 'fdi' ? ref.toothCode : savedToothRefLabel(ref,toothDisplay)} </span>)}{row.toothArea && !row.toothRefs?.some(ref=>ref.toothCode===row.toothArea?.trim()) ? <small>{row.toothArea}</small> : null}{findingLabel?<small className="consult-v14g__finding-label">{findingLabel}</small>:null}</TableCell>
    <TableCell className="plan-item"><b>{row.procedureName}</b>{unitLabel ? <small>{unitLabel}</small> : null}
      {assignedDoctorName !== null ? <small className="consult-v14g__plan-doctor" data-testid={`consult-item-doctor-${item.id}`}>{assignedDoctorName}</small> : null}
      {editable && doctorAssign ? <details className="consult-v14g__plan-doctor-edit" open={doctorOpen} onToggle={e=>setDoctorOpen(e.currentTarget.open)}><summary data-testid={`consult-item-doctor-door-${item.id}`}>Change</summary>
        <PlanDoctorPicker itemId={item.id} procedureName={row.procedureName} catalogCode={row.catalogCode ?? null} performingDoctorId={row.performingDoctorId ?? null}
          roster={doctorAssign.roster} visitClinicId={doctorAssign.visitClinicId} rosterTruncated={doctorAssign.rosterTruncated} procedureSpecialties={doctorAssign.procedureSpecialties}
          busy={anyBusy || busy} onAssign={(_id,doctorId)=>void line.run('assignment',{performingDoctorId:doctorId})} instanceId={`consult-item-doctor-${item.id}`} />
      </details> : null}
      {doctorAssign ? <PlanDoctorOutcome itemId={item.id} performingDoctorId={row.performingDoctorId ?? null} roster={doctorAssign.roster} outcome={line.outcomes.assignment} /> : null}
      {!editable&&additionDoctor&&row.performingDoctorId==null&&doctorAssign?<><small>{additionDoctor.saved?'Added later: ':additionDoctor.value?'Unsaved: ':''}{additionDoctor.value?planItemDoctorLabel(additionDoctor.value,doctorAssign.roster):'Treatment doctor missing'}</small>
       {!additionDoctor.saved?<PlanDoctorPicker itemId={item.id} procedureName={row.procedureName} catalogCode={row.catalogCode??null} performingDoctorId={additionDoctor.value}
        roster={doctorAssign.roster} visitClinicId={doctorAssign.visitClinicId} rosterTruncated={doctorAssign.rosterTruncated} procedureSpecialties={doctorAssign.procedureSpecialties}
        busy={anyBusy||additionDoctor.pending} onAssign={(_id,doctorId)=>additionDoctor.change(doctorId)} instanceId={`consult-later-doctor-${item.id}`}/>:null}</>:null}
      {editable ? <><PlanRemarkField itemId={item.id} procedureName={row.procedureName} itemNote={row.itemNote ?? ''} outcome={line.outcomes.remark} busy={anyBusy || busy}
        draftOwner={draftOwner} onCommit={itemNote=>line.run('remark',{itemNote})} doorTestId={`consult-item-change-${item.id}`} />
        <PlanRemarkOutcome itemId={item.id} itemNote={row.itemNote ?? ''} outcome={line.outcomes.remark} /></> : row.itemNote ? <small>{row.itemNote}</small> : null}
      {removalControls(false)}
    </TableCell>
    <TableCell className="plan-list">{row.catalogDefaultAmountMinorUnits == null ? 'Not recorded' : planItemPriceDisplay(row.catalogDefaultAmountMinorUnits/100)}</TableCell>
    <TableCell className="plan-discount">{editable ? <><div className="consult-v14g__discount"><div className="consult-v14g__answer" role="group" aria-label={`Discount unit for ${row.procedureName}`}>
      {PLAN_DISCOUNT_UNITS.map(mode => <AcButton key={mode} size="sm" variant="ghost" aria-pressed={discountMode===mode} disabled={anyBusy || busy || listPrice===null}
        onClick={()=>{setDiscountMode(mode);setDiscountDraft(null);}}>{mode}</AcButton>)}
      </div><input aria-label={`Discount for ${row.procedureName}`} type="text" inputMode="decimal" value={shownDiscount} placeholder="0" disabled={anyBusy || busy || listPrice===null}
        aria-invalid={invalidDiscount || undefined} onChange={e=>{const value=e.target.value;setDiscountDraft(value);setPriceError(null);const quote=planQuoteFromDiscount(listPrice,value,discountMode);setQuoteDraft(quote===null ? shownQuote : String(quote));}} /></div>
      {listPrice===null ? <small>List price unavailable for discount.</small> : null}
      {invalidDiscount ? <p role="alert">{discountMode==='%' ? 'Enter a discount from 0 to 100%.' : 'Enter whole rupees up to the list price.'}</p> : null}
    </> : inferredDiscount === null ? 'Not recorded' : inferredDiscount ? `− ${planItemPriceDisplay(inferredDiscount)}` : '—'}</TableCell>
    <TableCell className="plan-quote">{editable ? <><input id={`plan-quote-${item.id}`} aria-label={`Quoted price for ${row.procedureName}`} type="text" inputMode="numeric" value={shownQuote} disabled={anyBusy || busy}
      aria-invalid={!validQuote || undefined} onChange={e=>{setQuoteDraft(e.target.value);setDiscountDraft(null);setPriceError(null);}} />
      {!validQuote && priceAttempted ? <p role="alert">Enter a whole rupee amount, or leave it blank if unknown.</p> : null}
      {line.outcomes.price.kind==='failed' ? <p role="alert">{priceError ?? 'Price save is not confirmed. Retry save to check it.'}<small>Last saved: {planItemPriceDisplay(row.estimatedValue)}</small></p> : null}
    </> : <b>{planItemPriceDisplay(row.estimatedValue)}</b>}
      {validQuote && parsedQuote !== null && listPrice !== null && parsedQuote>listPrice ? <small>+{planItemPriceDisplay(parsedQuote-listPrice)} above list</small> : null}
    </TableCell>
    <TableCell className="plan-answer">{editable ? <PlanDecisionPicklist id={`plan-decision-${item.id}`} presentation="segments" onPreview={setPreviewDecision} procedureName={row.procedureName} status={row.status} declineReason={row.declineReason ?? ''}
      outcome={line.outcomes.decision} disabled={anyBusy || busy} draftOwner={draftOwner} onCommit={(status,declineReason)=>line.run('decision',{status,declineReason:declineReason || null})} testId={`consult-decide-${item.id}`} />
      : <>{planItemStatusLabel(row.status)}{row.completedAt ? <small>{doneChipLabel(row.completedAt,Date.now())}</small> : null}</>}
    </TableCell>
  </TableRow>{removalHost?createPortal(removalControls(true),removalHost):null}</>;
  return (
    <li className="cockpit-plan__row" data-testid={`consult-item-${item.id}`}>
      {/* ROUND 2 (C17): the candidate-b ledger row reading -- procedure name
          on its own line, the mono meta (area/teeth . price . provenance)
          UNDER it. Same facts, same testids; only the row grammar moved. */}
      <div className="cockpit-plan__row-main cockpit-plan__row-main--ledger">
        <span className="cockpit-plan__proc">{item.procedureName}</span>
        <span className="cockpit-plan__meta-line">
          {/* C5 (TRUTH-AND-GATE corrective): the internal catalog snapshot
              code (e.g. "OPN-ROOT-CANAL-ACCESS-OPENING-<hex>") NEVER renders
              on the doctor's line -- display names only, everywhere on the
              consult surface. The code stays on the wire as provenance
              (resolvePlanItemPriceSource still resolves by it); only the
              render is removed. */}
          {item.toothArea !== null && item.toothArea !== '' ? (
            <span className="cockpit-plan__tooth">{item.toothArea}</span>
          ) : null}
          {/* Structured tooth chips (TOOTH-NOTATION-INTERIM-V1): org-default
              notation + canonical name from the SELF-DESCRIBING saved refs --
              beside (never replacing) the legacy free-text locus above. */}
          {(item.toothRefs ?? []).map((ref) => (
            <span
              key={ref.toothCode}
              className="cockpit-plan__tooth"
              title={savedToothRefLabel(ref, toothDisplay)}
              data-testid={`consult-item-${item.id}-tooth-${ref.toothCode}`}
            >
              {savedToothRefLabel(ref, toothDisplay)}
            </span>
          ))}
          {/* W-B3 PRICE TRUTH: an unset estimate renders the ruled unset-price
              state visibly -- never a blank, never a fake zero (a stored 0 is
              a TRUE ZERO and renders as a real amount). */}
          <span className="cockpit-plan__value">
            {rupeeGlyphToRs(planItemPriceDisplay(item.estimatedValue))}
          </span>
          {unitLabel !== '' ? (
            <span
              className="cockpit-plan__unit"
              data-testid={`consult-item-unit-${item.id}`}
            >
              {unitLabel}
            </span>
          ) : null}
          {provenanceLabel !== '' ? (
            <span
              className="cockpit-plan__provenance"
              data-testid={`consult-item-provenance-${item.id}`}
            >
              {provenanceLabel}
            </span>
          ) : null}
          {/* C6 (TRUTH-AND-GATE corrective): a catalog INR-0 / price-not-set
              line is FLAGGED at add time -- "Rs 0 - Clinic price" never flows
              silently into a Rs-0 plan. The amount itself still displays per
              the W-B3 truth above; this marker makes the gap loud. Works
              regardless of catalog data hygiene (the guard reads the line,
              not the catalog). */}
          {planLineFeeMissing(item.estimatedValue) ? (
            <AcBadge tone="pending" testId={`consult-item-fee-missing-${item.id}`}>
              {NO_FEE_RECORDED_LABEL}
            </AcBadge>
          ) : null}
          {/* DOCTOR-CONSULT-DELTA-V1: WHO PERFORMS THIS LINE, on the line
              itself. Three honest states and no fourth (roster name / bare
              id for an off-roster assignment / the ruled unassigned copy);
              the visit's own doctor is NEVER substituted for an unassigned
              line, so the plan can never imply an assignment nobody made. */}
          {assignedDoctorName !== null ? (
            <span
              className="cockpit-plan__doctor"
              data-testid={`consult-item-doctor-${item.id}`}
            >
              {assignedDoctorName}
            </span>
          ) : null}
        </span>
        {/* DOCTOR-CONSENT-REMARKS-V1 -- the SAVED remark reads back on the row
            itself, so a decided line (which renders no editor) still shows
            what the doctor wrote. No remark renders NOTHING: an empty line
            never draws an empty label. */}
        {(row.itemNote ?? '') !== '' ? (
          <span
            className="cockpit-plan__meta-line"
            data-testid={`consult-item-note-saved-${item.id}`}
          >
            {`${CASE_SHEET_LABELS.itemNote}: ${row.itemNote ?? ''}`}
          </span>
        ) : null}
      </div>
      {/* THE DECISION MOMENT (candidate-b anatomy; ruling 2026-08-09), now the
          handed picklist (#781, integration order step 3). It stays IN THE
          OPEN on every editable line -- decided or not -- because it is the
          one control the founder ruled must never sit behind a door, and
          because a decided line's change-of-mind must not need a second
          control. The inline Accept/Decline/Defer buttons AND the
          Change-disclosure status select are BOTH gone: leaving either would
          put two decision controls on one row.

          DELIBERATE COMMIT: the select only STAGES; nothing is written until
          Save decision. That is the fix for the arrow-key defect, where a
          closed select fires `change` on every arrow and wrote decisions
          nobody made. */}
      {editable ? (
        <div className="cockpit-plan__row-edit cockpit-plan__decide" aria-busy={busy}>
          <PlanDecisionPicklist
            id={`plan-decision-${item.id}`}
            procedureName={item.procedureName}
            status={row.status}
            declineReason={row.declineReason ?? ''}
            outcome={line.outcomes.decision}
            disabled={anyBusy || busy}
            draftOwner={draftOwner}
            onCommit={(status, declineReason) =>
              line.run('decision', {
                status,
                declineReason: declineReason === '' ? null : declineReason,
              })
            }
            testId={`consult-decide-${item.id}`}
          />
        </div>
      ) : null}
      {editable && !planLineIsDecidable(row.status) ? (
        /* DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (CANDIDATE-B-PIXELS-WIN): a
           DECIDED line reads as its STATUS CHIP (the candidate-b ledger:
           "Done 12 Jun" / "Accepted - planned" / declined with reason) --
           the change-of-mind editor is UNCHANGED underneath, folded one
           step deeper behind the Change disclosure (same select, same
           decline-reason vocabulary, same save write). */
        <div className="cockpit-plan__row-edit cockpit-plan__decided">
          <AcBadge
            tone={planLineChipTone(row.status, row.completedAt != null)}
            testId={`consult-item-chip-${item.id}`}
          >
            {row.completedAt != null
              ? doneChipLabel(row.completedAt, Date.now())
              : row.status === 'accepted'
                ? acceptedPlannedChipLabel()
                : row.status === 'declined' && row.declineReason !== null
                  ? `${planItemStatusLabel(row.status)} (${outcomeReasonLabel(row.declineReason)})`
                  : planItemStatusLabel(row.status)}
          </AcBadge>
          {onComplete !== undefined ? (
            <AcButton
              size="sm"
              variant="secondary"
              disabled={anyBusy}
              onClick={onComplete}
              data-testid={`consult-journey-complete-${item.id}`}
            >
              Completed this visit
            </AcButton>
          ) : null}
          {/* THE REMARK, on a DECIDED line, which is where the shipped page
              already puts it (#781 integration order steps 3 and 6).

              WHAT LEFT THE OLD "Change" DISCLOSURE: the status select and the
              decline-reason select (now the picklist above, in the open) and
              the hand-rolled textarea + Save + save-error (now the handed
              field). With those gone the disclosure held one control, and the
              handed field brings its own door -- so nesting them would be a
              door inside a door for a single textarea. The field IS the door
              now and it keeps the shipped door's testid, so the suites that
              open this row by testid keep working.

              The patch names ONLY itemNote, so the endpoint's
              absent-means-untouched contract leaves the decision alone. */}
          <PlanRemarkField
            itemId={item.id}
            procedureName={item.procedureName}
            itemNote={row.itemNote ?? ''}
            outcome={line.outcomes.remark}
            busy={anyBusy || busy}
            draftOwner={draftOwner}
            onCommit={(itemNote) => line.run('remark', { itemNote })}
            doorTestId={`consult-item-change-${item.id}`}
          />
          {/* OUTSIDE the disclosure above -- integration order step 5. */}
          <PlanRemarkOutcome
            itemId={item.id}
            itemNote={row.itemNote ?? ''}
            outcome={line.outcomes.remark}
          />
        </div>
      ) : !editable ? (
        /* READ-ONLY (a finalized sheet, or a non-editing audience): the status
           reads as text and nothing on the line writes. The third arm is
           `null` and it matters: an EDITABLE UNDECIDED line now carries the
           picklist above and must NOT also render this read-only status, or
           the row would state its decision twice. */
        <span
          className="cockpit-plan__status"
          data-testid={`consult-item-status-${item.id}`}
        >
          {planItemStatusLabel(row.status)}
          {row.status === 'declined' && row.declineReason !== null
            ? ` (${outcomeReasonLabel(row.declineReason)})`
            : ''}
        </span>
      ) : null}
      {/* DOCTOR-CONSULT-DELTA-V1 -- the treatment-specific doctor ASSIGNMENT
          door. ONE disclosure per editable line, serving decided and
          undecided lines alike (an implantologist is named when the line is
          advised, not only after it is accepted -- the banked FS-19 case).
          Behind it is THE ONE existing picker over THE ONE existing roster
          wire; the pick writes through THE ONE existing plan-item update. */}
      {editable && doctorAssign !== undefined ? (
        <div className="cockpit-plan__row-edit cockpit-plan__doctor-assign">
          <details
            className="cockpit-plan__change"
            open={doctorOpen}
            onToggle={(e) => setDoctorOpen(e.currentTarget.open)}
          >
            <summary
              className="cockpit-plan__change-summary"
              data-testid={`consult-item-doctor-door-${item.id}`}
            >
              {row.performingDoctorId == null
                ? 'Assign doctor'
                : 'Change doctor'}
            </summary>
            <div className="cockpit-plan__change-body cockpit-plan__change-body--note">
              {/* Integration order step 4: only the BODY changes. The
                  disclosure, its summary copy and its testid stay as they
                  are. The picker reads the LAST CONFIRMED assignment, the
                  same one the header meta above reads. */}
              <PlanDoctorPicker
                itemId={item.id}
                procedureName={item.procedureName}
                catalogCode={item.catalogCode ?? null}
                performingDoctorId={row.performingDoctorId ?? null}
                roster={doctorAssign.roster}
                visitClinicId={doctorAssign.visitClinicId}
                rosterTruncated={doctorAssign.rosterTruncated}
                procedureSpecialties={doctorAssign.procedureSpecialties}
                busy={anyBusy || busy}
                onAssign={(_itemId, doctorId) =>
                  void line.run('assignment', { performingDoctorId: doctorId })
                }
                instanceId={`consult-item-doctor-${item.id}`}
              />
            </div>
          </details>
          {/* THE ASSIGNMENT'S OUTCOME, OUTSIDE the disclosure -- integration
              order step 5, and the row #781's reviewer found missing. Without
              it a failed assignment is invisible the moment the doctor closes
              that door, which is the exact class this composition claims to
              prevent. It names the LAST CONFIRMED doctor through the ONE
              shipped label function, not a local lookup. */}
          <PlanDoctorOutcome
            itemId={item.id}
            performingDoctorId={row.performingDoctorId ?? null}
            roster={doctorAssign.roster}
            outcome={line.outcomes.assignment}
          />
        </div>
      ) : null}
    </li>
  );
}

/** Billing-on-sheet (CHECKOUT-HANDOFF-AND-DOCTOR-CONTEXT-V1): payments
 *  recorded against THIS visit, READ-ONLY -- a quiet card, never a form.
 *  Renders nothing when no payment exists (no blank panels).
 *
 *  V7-P4 adoption ("payments on checkout"): the rows render through the
 *  shared RelatedHistory primitive (Benchmark Book A row A5 ADOPT) --
 *  audience is the REAL viewer role (this route is doctor-fenced), values
 *  stay the same already-lawful wire facts, no status chip is invented
 *  (VisitPaymentView carries no void/state field -- honesty law). */
export function VisitPaymentsBlock({
  payments,
}: {
  payments: readonly VisitPaymentView[];
}): JSX.Element | null {
  if (payments.length === 0) return null;
  return (
    <RelatedHistory
      audience="doctor"
      title="Payments - this visit"
      items={payments.map((p, idx) => ({
        id: `${p.occurredAt}-${idx}`,
        title: rupeesFromMinorLabel(p.amountMinorUnits),
        facts: [p.method.replace(/_/g, ' ')],
        provenance: { atLabel: formatIstTime(p.occurredAt) || p.occurredAt },
      }))}
      emptyTitle="No payments recorded for this visit yet."
      testId="consult-visit-payments"
    />
  );
}

// --- C3: the ONE-CLOSE strip (collapses Finalize + Checkout; VOCABULARY LAW) ---

/** Statuses from which the visit can be CLOSED (the fulfil-from set +
 *  fulfilled -- a front-desk-fulfilled visit still closes from here). */
const CLOSEABLE_STATUSES: readonly string[] = [
  'arrived',
  'checked_in',
  'fulfilled',
];

/**
 * The ONE "Close the visit" act. Replaces the three ceremonies (per-procedure
 * pickers stay INLINE in the plan; the "Finalize visit" outcome and the
 * "Checkout" converted/not-converted collapse HERE). The derived summary is
 * shown BEFORE the click; the reason picker appears ONLY when the matrix
 * requires it; the inline question appears ONLY when the plan marks nothing;
 * the R-1 handoff renders when the org has not granted doctor checkout.
 */
export function CloseVisitStrip({
  sheet,
  context,
  explicitPick,
  notConvertedReason,
  busy,
  onExplicitPickChange,
  onNotConvertedReasonChange,
  onClose,
  onBackToQueue,
  noteRows = null,
  consentOwedCount = null,
  nextVisitLine = null,
  courseNoFollowUpWarn = false,
  evidenceOwedKinds = null,
  actionHost,
  viewCaseSheet,
  decisionItems,
}: {
  viewCaseSheet?: {open:()=>void;busy:boolean};
  decisionItems?: readonly ClinicalPlanItemView[];
  actionHost?: HTMLDivElement | null;
  sheet: CaseSheetClinicalView;
  context: DoctorConsultContext;
  explicitPick: CloseExplicitPick;
  notConvertedReason: string;
  busy: BusyKind;
  onExplicitPickChange: (pick: CloseExplicitPick) => void;
  onNotConvertedReasonChange: (reason: string) => void;
  onClose: () => void;
  /** The success state's ONE next action (back to /dashboard/doctor). */
  onBackToQueue: () => void;
  /** C7 (TRUTH-AND-GATE corrective): the live label/value rows of the
   *  clinical record as the doctor sees them (sections + categories +
   *  follow-up), for the confirm panel's completeness summary line.
   *  null/absent = no completeness line (older fixtures render
   *  byte-identical). WARN-ONLY by fence: these lines never block. */
  readonly noteRows?: ReadonlyArray<{
    readonly label: string;
    readonly value: string | null;
  }> | null;
  /** C7: uncovered accepted lines still owing consent (from the page's ONE
   *  consents read). null = wire unavailable/not required -> no line. */
  readonly consentOwedCount?: number | null;
  /** D1 (DOCTOR-FLOW-AFTER-INTAKE-V1): the next-visit fact line ("Next
   *  visit: Stage 3 of 4 - in 2 weeks - sent to Front Desk"); renders on
   *  the pre-close lead AND on EVERY closed branch. null/absent =
   *  byte-identical older render. */
  readonly nextVisitLine?: string | null;
  /** D1: a course visit with NO follow-up intent -> the confirm dialog adds
   *  ONE WARN-only line (the close act itself never blocks -- the standing
   *  close ruling). */
  readonly courseNoFollowUpWarn?: boolean;
  /** DOCTOR-CONSULT-CORRECTIVE-V1 (BUILD 1, L-05): the SERVED owed-evidence
   *  kinds for this visit, mirrored up from the evidence panel's ONE read
   *  (zero second fetch). The product already derived what the visit owes; it
   *  did not say so at the moment of close. null/absent = the read is
   *  unsettled / failed / sheetless -> NO line (honest absence, and older
   *  fixtures render byte-identical). WARN-ONLY by the ruled C7 fence: this
   *  line informs the close, it never gates it. */
  readonly evidenceOwedKinds?: readonly string[] | null;
}): JSX.Element {
  const anyBusy = busy !== null;
  const finalized = sheet.status === 'finalized';
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const status = context.appointment.status;
  const closeable = CLOSEABLE_STATUSES.includes(status);
  const canFulfil = context.capabilities.canFulfil;
  const currentItems=decisionItems??sheet.planItems;
  const derivation = deriveVisitClose(currentItems, explicitPick);
  const head = closeHeadline(derivation, currentItems, canFulfil);
  // CLOSE-IS-GATED (DOCTOR-JOURNEY-COMPOSE-V1, ordering law 2d): with plan
  // lines present but NO decision recorded (no accepted / declined /
  // deferred), the close machinery does not render -- the walked defect was
  // this strip asking "How did this visit conclude?" while undecided lines
  // sat right above it. The area instead states the truthful next step,
  // consistent with the #511 NEXT ladder (the same rung-3 label). A visit
  // with ZERO plan lines stays closable through the existing inline question
  // (nothing was advised, so there is no decision to wait for -- the ladder's
  // own rung-4 reading).
  const decisionsExist = currentItems.some(
    (i) =>
      i.status === 'accepted' ||
      i.status === 'declined' ||
      i.status === 'deferred',
  );
  const closeGatedOnDecisions =
    !finalized && currentItems.length > 0 && !decisionsExist;
  const convertedRecorded = context.outcomeEvents.includes('lead_converted');
  const notConvertedRecorded =
    context.outcomeEvents.includes('lead_not_converted');
  // IRREVERSIBLE-ACTION CONFIRMATION (SCOPE 2): the one close act now passes
  // through the shared ConfirmDialog (destructive posture -- Cancel focused
  // first; the derived conclusion + lock consequence restated in the body).
  const [closeConfirmOpen, setCloseConfirmOpen] = useState(false);

  if (finalized) {
    // The CLOSE SUCCESS state (CHECKOUT-HANDOFF-AND-DOCTOR-CONTEXT-V1):
    // states what happens NEXT -- derived from the PLAN SNAPSHOT through
    // the ONE shared handoff derivation (adversarial finding F3: an R-1
    // ungranted close records no outcome events, so keying these lines on
    // outcomeEvents left the re-entered workspace silent while the day
    // board shouted the CTA; the plan snapshot is the same source every
    // other surface reads). Saved return requests and optional bookings use
    // the existing Return flow; this closed summary does not create bookings.
    // Keep the read-only payments block and the existing queue action.
    const recordMetadata=<>
        <p className="clinic-workbench__hint" data-testid="consult-finalized-note">
          This visit is finalized. The{' '}
          {CASE_SHEET_LABELS.caseSheet.toLowerCase()} and plan are locked.
        </p>
        {/* F3 (consult attribution visibility): who recorded this clinical
            record, on the closed-visit handoff surface. Role-level only (the
            doctor wire carries no named actor; the named-actor / "Unattributed"
            line is DEFERRED to a backend read-model field). */}
        {consultRecordedByLine(sheet) !== null ? (
          <p
            className="clinic-workbench__muted"
            data-testid="consult-close-recorded-by"
          >
            {consultRecordedByLine(sheet)}
          </p>
        ) : null}
    </>;
    return (
      <div className={viewCaseSheet ? "consult-v14g__finished" : undefined}><SectionShell
        eyebrow={viewCaseSheet ? undefined : "Close"}
        title={viewCaseSheet ? "Visit finished" : "Visit closed"}
        testId="consult-close"
      >
        {viewCaseSheet?<span className="consult-v14g__finished-icon" aria-hidden="true">✓</span>:null}
        {viewCaseSheet?<p className="clinic-workbench__hint" data-testid="consult-finished-summary">{clinicalFinishOutcomeLabel(sheet.finishReview?.outcome)??'Outcome not recorded'} · saved to {context.patient.patientName?`${context.patient.patientName}’s`:'the patient’s'} case sheet.</p>:null}
        {viewCaseSheet?<div className="consult-v14g__finished-metadata">{recordMetadata}</div>:recordMetadata}
        <p className="consult-close__consequence" data-testid="consult-closed-handoff">
          {CONSULT_CLOSED_PAID_LINE}
        </p>
        {/* D1 (DOCTOR-FLOW-AFTER-INTAKE-V1): the closed state states the
            next-visit fact on EVERY branch -- the walked defect was the
            recorded follow-up rendering only on the advised-only leg. */}
        {nextVisitLine !== null ? (
          <p
            className="consult-close__consequence"
            data-testid="consult-closed-nextvisit"
          >
            {nextVisitLine}
          </p>
        ) : null}
        <VisitPaymentsBlock payments={context.paymentsForVisit} />
        <div className="clinic-workbench__actions">
          {viewCaseSheet ? <AcButton variant="secondary" disabled={busy!==null||viewCaseSheet.busy} onClick={viewCaseSheet.open}>View case sheet</AcButton> : null}
          <AcButton
            size="sm"
            variant={viewCaseSheet ? "secondary" : "primary"}
            disabled={busy!==null||viewCaseSheet?.busy===true}
            onClick={onBackToQueue}
            data-testid="consult-back-to-queue"
          >
            {viewCaseSheet ? 'Next patient' : <>Back to today&apos;s queue</>}
          </AcButton>
        </div>
      </SectionShell></div>
    );
  }

  // C7 (WARN-ONLY): the confirm panel's three advisory lines -- clinical
  // completeness, consent owed, missing fees -- derived from reads already on
  // the page. They inform the confirm; the close act itself is untouched
  // (one act, derive-not-ask -- no new blocking behavior without a founder
  // ruling).
  const completenessLine =
    noteRows !== null ? closeCompletenessLine(noteRows) : null;
  const consentOwedLine = closeConsentOwedLine(consentOwedCount ?? null);
  const feeMissingLine = closeFeeMissingLine(
    deriveAcceptedTruth(sheet.planItems),
  );

  const closeAction = <div className="clinic-workbench__actions">
            <AcButton
              size="sm"
              variant="primary"
              disabled={anyBusy || !canFireClose(derivation, notConvertedReason)}
              ref={closeButtonRef}
              onClick={() => setCloseConfirmOpen(true)}
              title="One act records the outcome and the conversion, and locks the record."
            data-testid="consult-close-button"
            >
              {busy === 'close' ? 'Closing...' : actionHost ? 'Finish visit' : 'Complete visit'}
            </AcButton>
          </div>;

  const handoffLead = (
          <div className="consult-close__lead">
            <p
              className="consult-close__headline"
              data-testid="consult-close-headline"
            >
              {actionHost && derivation.visitOutcome ? ({treatment_accepted:'Treatment accepted',treatment_declined:'Treatment declined',treatment_advised:'Advised only'} as const)[derivation.visitOutcome] : head.headline}
            </p>
            {head.consequence !== null ? (
              <p
                className="consult-close__consequence"
                data-testid="consult-close-consequence"
              >
                {head.consequence}
              </p>
            ) : null}
            {/* D1: the next-visit fact leads WITH the close conclusion --
                the recorded intent is visible at the moment it matters. */}
            {nextVisitLine !== null ? (
              <p
                className="clinic-workbench__hint"
                data-testid="consult-close-nextvisit"
              >
                {nextVisitLine}
              </p>
            ) : null}
            {/* BUILD 1 (L-05, 1B ORDER): the evidence panel that says what is
                owed renders ~2,600 lines BELOW this button, so the doctor met
                the terminal act before the facts. The owed summary now states
                itself HERE, above the act, through THE ONE existing formatter
                (owedKindsSummary) over the panel's own served read -- the
                panel is not moved, so the workspace's reading order is
                preserved. WARN-ONLY: nothing here gates the close. */}
            {evidenceOwedKinds !== null ? (
              <p
                className="clinic-workbench__hint"
                data-testid="consult-close-evidence-owed"
              >
                {owedKindsSummary(evidenceOwedKinds)}
              </p>
            ) : null}
          </div>
  );
  return (
    <SectionShell
      embedded={Boolean(actionHost)}
      eyebrow={actionHost ? undefined : "Close"}
      title={actionHost ? "Reception handoff" : "Close the visit"}
      // C7 copy heal: the old sub said "records ... records ..." twice.

      testId="consult-close"
    >
      {!closeable ? (
        <p className="clinic-workbench__hint" data-testid="consult-close-idle">
          The visit closes once the patient is checked in.
        </p>
      ) : closeGatedOnDecisions ? (
        // Law 2d: the truthful NEXT step instead of dead-end close machinery.
        <>
          <p
            className="clinic-workbench__hint"
            data-testid="consult-close-gated"
          >
            Next: {CONSULT_NEXT_RECORD_DECISIONS_LABEL.toLowerCase()} - mark
            each advised procedure Accept, Decline or Defer on the plan above.
            The close opens once a decision is recorded.
          </p>
          {/* Payments already recorded stay visible truth (read-only). */}
          <VisitPaymentsBlock payments={context.paymentsForVisit} />
        </>
      ) : (
        <>
          {/* PRE-CLOSE CLARITY LAW: the derived CONCLUSION leads as a
              headline, the CONSEQUENCE is stated before the confirm -- what
              the front desk sees/collects, adapted to the R-1 grant. The
              matrix (deriveVisitClose) stays the single source; this only
              phrases it (the LAYMAN TEST). */}
          {actionHost && !derivation.needsExplicitPick && evidenceOwedKinds?.length === 0 ? <details className="consult-v14g__supplemental" data-testid="consult-handoff-details"><summary>Details</summary>{handoffLead}</details> : handoffLead}


          {/* R-C: the ONE inline question, only when the plan marks nothing.
              RC-4 (founder ruling 2026-08-15): a THREE-token fixed bank is
              tap-chips, not a dropdown -- same vocabulary, one interaction. */}
          {derivation.needsExplicitPick ? (
            <div
              className="clinic-workbench__field"
              data-testid="consult-close-question"
            >
              {/* ONE VISIBLE PROMPT (founder finding, #780 review). The
                  close banner directly above already asks "How did this
                  visit conclude?" as its headline, so a second visible copy
                  of the same sentence as this field's label was the same
                  question printed twice, one line apart.
                  ACCESSIBLE LABELLING IS PRESERVED, not dropped: the chip
                  group keeps the identical `ariaLabel`, so a screen reader
                  still hears the question when it reaches the control. The
                  removal is of a DUPLICATE VISIBLE string, never of the
                  accessible name. */}
              <IntakeChoiceChips
                ariaLabel="How did this visit conclude?"
                options={[
                  { code: 'advised', label: 'Advised only - no decision today' },
                  /* V-1: the chips state the visit-OUTCOME the doctor
                     records; the reserved "Converted" is the payment-derived
                     commercial state (#267), not this pre-payment decision. */
                  { code: 'accepted', label: 'Patient accepted' },
                  { code: 'declined', label: 'Patient declined' },
                ]}
                isSelected={(code) => explicitPick === code}
                onPick={(code) =>
                  onExplicitPickChange(
                    (explicitPick === code ? null : code) as CloseExplicitPick,
                  )
                }
                disabled={anyBusy}
                testId="consult-close-pick"
              />
            </div>
          ) : null}

          {/* R-B: the reason chips, ONLY when the derived close requires it
              (RC-4: the SIX-token fixed bank as tap-chips). */}
          {derivation.reasonRequired ? (
            <div className="clinic-workbench__field">
              <span className="clinic-workbench__label">
                {CASE_SHEET_LABELS.declineReason}{' '}
                <span className="clinic-workbench__muted">
                  (price / timing / no response queue a follow-up)
                </span>
              </span>
              <IntakeChoiceChips
                ariaLabel={CASE_SHEET_LABELS.declineReason}
                options={OUTCOME_REASON_OPTIONS.map((o) => ({
                  code: o.value,
                  label: o.label,
                }))}
                isSelected={(code) => notConvertedReason === code}
                onPick={(code) =>
                  onNotConvertedReasonChange(
                    notConvertedReason === code ? '' : code,
                  )
                }
                disabled={anyBusy}
                testId="consult-close-reason"
              />
            </div>
          ) : null}

          {/* R-1 ungranted: the honest lock-and-handoff rides the
              CONSEQUENCE line above (one voice, no duplicate hint). */}

          {/* The ONE close act -- confirmation-gated (irreversible: the
              close locks the record; no edit/amendment path exists in this
              package, a named Rajeshwari-gated deferral). */}
          {actionHost ? createPortal(closeAction, actionHost) : closeAction}
          {closeConfirmOpen ? (
            <ConfirmDialog
              eyebrow="Close"
              title="Close the visit?"
              destructive
              confirmLabel="Close & lock"
              busyLabel="Closing..."
              busy={busy === 'close'}
              onConfirm={() => {
                setCloseConfirmOpen(false);
                onClose();
              }}
              onCancel={() => {
                setCloseConfirmOpen(false);
                // The nested dialog shell seeds focus before its wrapper can
                // capture this trigger. Restore the owned trigger after cleanup.
                requestAnimationFrame(() => closeButtonRef.current?.focus());
              }}
              confirmTestId="consult-close-confirm"
              cancelTestId="consult-close-cancel"
              testId="consult-close-dialog"
            >
              <p data-testid="consult-close-dialog-headline">{head.headline}</p>
              {head.consequence !== null ? <p>{head.consequence}</p> : null}
              {/* C7 (WARN-ONLY): completeness + consent-owed + fee-missing
                  advisory lines. The visit locked in the 2026-08-14 walk
                  with 7 of 9 fields Not recorded and consent still OWED,
                  warned about neither -- these lines state it BEFORE the
                  lock. No blocking: the confirm act is unchanged. */}
              {completenessLine !== null ? (
                <p
                  className="clinic-workbench__muted"
                  data-testid="consult-close-completeness"
                >
                  {completenessLine}
                </p>
              ) : null}
              {consentOwedLine !== null ? (
                <p
                  className="clinic-workbench__muted"
                  data-testid="consult-close-consent-owed"
                >
                  {consentOwedLine}
                </p>
              ) : null}
              {feeMissingLine !== null ? (
                <p
                  className="clinic-workbench__muted"
                  data-testid="consult-close-fee-missing"
                >
                  {feeMissingLine}
                </p>
              ) : null}
              {/* BUILD 1 (L-05): the last gate before the lock repeats what
                  the visit still owes -- WARN-ONLY, exactly like its three
                  siblings above. */}
              {evidenceOwedKinds !== null ? (
                <p
                  className="clinic-workbench__muted"
                  data-testid="consult-close-dialog-evidence-owed"
                >
                  {owedKindsSummary(evidenceOwedKinds)}
                </p>
              ) : null}
              {/* D1 (WARN-ONLY by the standing close ruling): a course visit
                  closing with no follow-up intent is asked ONCE -- never
                  blocked. */}
              {courseNoFollowUpWarn ? (
                <p
                  className="clinic-workbench__muted"
                  data-testid="consult-close-no-followup-warn"
                >
                  No follow-up is set for this course - close anyway?
                </p>
              ) : null}
              <p data-testid="consult-close-dialog-lock-note">
                This locks the clinical record. It cannot be edited afterwards.
              </p>
            </ConfirmDialog>
          ) : null}

          {/* Idempotency visibility: a partial close already recorded a leg
              (chip, not a second control). */}
          {convertedRecorded || notConvertedRecorded ? (
            <div
              className="consult-checkout__outcomes"
              data-testid="consult-close-recorded"
            >
              {/* V-1: the recorded-leg chips state the visit OUTCOME, never
                  the reserved commercial "Converted" (the doctor's close is
                  pre-payment; payment conversion is the #267 canon). The
                  writer event tokens (lead_converted / lead_not_converted)
                  are UNTOUCHED -- only the display words change. */}
              {convertedRecorded ? (
                <AcBadge tone="positive" testId="consult-converted-chip">
                  Treatment accepted recorded
                </AcBadge>
              ) : null}
              {notConvertedRecorded ? (
                <AcBadge tone="danger" testId="consult-not-converted-chip">
                  Treatment declined recorded
                </AcBadge>
              ) : null}
            </div>
          ) : null}

          {/* Billing-on-sheet: payments already recorded against this visit
              (read-only; renders nothing when none exist). */}
          <VisitPaymentsBlock payments={context.paymentsForVisit} />

          {/* DOCTOR-CONSULT-DEMO-POLISH-V1 (item 5a): the high-ticket
              "coming" seam is REMOVED (not TruthSeams-governed; rider R-11
              is OPEN, not accepted -- nothing on an accepted surface says
              "coming"). No storage for a doctor-declared flag exists (#245
              memo); the flag returns when R-11 is ruled and a storage
              writer exists. */}
        </>
      )}
    </SectionShell>
  );
}

// --- C8: the ESTIMATION column summary (paper triptych, right leaf) -----------

/**
 * The Estimation column's summary card: plan total + accepted estimate +
 * paid-this-visit as LABELED FIELDS (FIELDS-NOT-SENTENCES), composed from
 * the EXISTING display helpers (planTotalDisplay / acceptedEstimateTotal /
 * THE ONE INR formatter) -- read-only; the Money plane stays the single
 * writer. The payments detail rows keep their existing home inside the
 * close strip (VisitPaymentsBlock).
 */
export function EstimationSummary({
  sheet,
  payments,
  paidAllVisitsMinorUnits = null,
  onPrintEstimate,
}: {
  sheet: CaseSheetClinicalView;
  payments: readonly VisitPaymentView[];
  /** DOCTOR-CONSULT-DELTA-V1: the PRINT ESTIMATE door (tracker row "Print
   *  estimate"). Absent = no door renders, so every pre-package fixture is
   *  byte-identical. Printing is presentation over an already-read plan --
   *  the handler swaps in the print view; it never fetches and never
   *  writes. */
  onPrintEstimate?: () => void;
  /** ROUND 2 (coverage C21-24): the ALL-VISITS paid sum composed from the
   *  page's existing case-history read + this visit's payments. Provided =
   *  the candidate-b "Paid, all visits" cell; absent = the honest
   *  this-visit cell (byte-identical to round 1 / older fixtures). */
  paidAllVisitsMinorUnits?: number | null;
}): JSX.Element {
  const paidMinor = payments.reduce((sum, p) => sum + p.amountMinorUnits, 0);
  // C2 (TRUTH-AND-GATE corrective): the ACCEPTED cell reads THE accepted-
  // state truth owner over the live plan -- an accepted line NEVER renders
  // "Nothing accepted yet" (the walked drift: a zero-fee accepted line let
  // the value axis overwrite the decision axis). The handoff MONEY rule
  // (acceptedEstimateTotal, >0) is untouched -- it stays the collect-amount
  // derivation; this cell states the accepted STATE.
  const truth = deriveAcceptedTruth(sheet.planItems);
  const acceptedCell = acceptedCellDisplay(truth);
  // Candidate-b rollup progress: completed = accepted lines WITH completion
  // evidence (the same deriveCourseProgress reading the journey uses).
  const acceptedLines = sheet.planItems.filter((i) => i.status === 'accepted');
  const completedCount = acceptedLines.filter(
    (i) => i.completedAt != null,
  ).length;
  // DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (CANDIDATE-B-PIXELS-WIN): the money
  // reads as the candidate-b 4-cell rollup strip (PLAN / ACCEPTED /
  // COMPLETED / PAID) -- mono values over uppercase micro-labels on the
  // inset band -- instead of a stacked field list. Same derivations, same
  // honest fallbacks (never a fake zero); the PAID cell stays the honest
  // THIS-VISIT value the wire carries (the billing-plane all-visits figure
  // is not on this read -- a named deviation in the run record).
  // ROUND 3 (DNA rules 2+3): the reference's terse cell labels (PLAN /
  // ACCEPTED / COMPLETED / PAID, ALL VISITS), mono "Rs n" values, and the
  // reference's own .dim device for honest word-fallbacks (non-mono, quiet
  // -- a word is never dressed as a number). The strip now renders BARE
  // (no card wrapper): the ruled CONFLICT (a) seats it INSIDE the course
  // card via the rollupSlot.
  const cells: readonly {
    readonly key: string;
    readonly label: string;
    readonly value: string;
    readonly dim: boolean;
  }[] = [
    {
      key: 'plan',
      label: 'Plan',
      // W-B3: planTotalDisplay stays THE one plan-total derivation (honest
      // exclude-and-say text); the cell strips only the leading label words
      // its own micro-label already prints and re-skins the glyph to the
      // reference's "Rs " grammar.
      value:
        rupeeGlyphToRs(
          planTotalDisplay(sheet.planItems)
            .replace(/^Plan total:? /, '')
            .replace(/\.\s*$/, ''),
        ) || 'No procedures yet',
      dim: planTotalDisplay(sheet.planItems) === '',
    },
    {
      key: 'accepted',
      label: 'Accepted',
      value: acceptedCell.value,
      dim: acceptedCell.dim,
    },
    {
      key: 'completed',
      label: 'Completed',
      value:
        acceptedLines.length > 0
          ? `${completedCount} of ${acceptedLines.length}`
          : 'No accepted items',
      dim: acceptedLines.length === 0,
    },
    paidAllVisitsMinorUnits !== null
      ? {
          key: 'paid',
          label: 'Paid, all visits',
          value:
            paidAllVisitsMinorUnits > 0
              ? rupeesFromMinorLabel(paidAllVisitsMinorUnits)
              : 'No payment recorded',
          dim: paidAllVisitsMinorUnits <= 0,
        }
      : {
          key: 'paid',
          label: 'Paid this visit',
          value:
            payments.length > 0
              ? rupeesFromMinorLabel(paidMinor)
              : 'No payment recorded',
          dim: payments.length === 0,
        },
  ];
  return (
    <div
      className="consult-rollup"
      role="group"
      aria-label="Estimate and payment"
      data-testid="consult-estimation"
    >
      {cells.map((cell) => (
        <div className="consult-rollup__cell" key={cell.key}>
          <div className="consult-rollup__label">{cell.label}</div>
          <div
            className={
              cell.dim
                ? 'consult-rollup__value consult-rollup__value--dim'
                : 'consult-rollup__value'
            }
            data-testid={`consult-rollup-${cell.key}`}
          >
            {cell.value}
          </div>
        </div>
      ))}
      {/* DOCTOR-CONSULT-DELTA-V1 -- PRINT ESTIMATE. The door sits on the
          estimation strip because that is where the doctor reads the money;
          it opens the shared PrintSheet rail's estimate view over the SAME
          already-read plan (no fetch, no write). */}
      {onPrintEstimate !== undefined ? (
        <div className="consult-rollup__cell consult-rollup__cell--action">
          <AcButton
            size="sm"
            variant="ghost"
            onClick={onPrintEstimate}
            data-testid="consult-print-estimate"
          >
            Print estimate
          </AcButton>
        </div>
      ) : null}
    </div>
  );
}

// --- C38-C40: the rail RELATED block (candidate-b related rows) ----------------

/** The lens-composed appointments fact for the Related block (best-effort;
 *  null = the read is not held and the row is ABSENT -- LES-016: no row
 *  without its fact, no door without its grant). */
export interface RelatedAppointmentsFact {
  readonly todayCount: number;
  readonly upcomingCount: number;
  /** e.g. "Next: 14 Aug" -- null when nothing is booked ahead. */
  readonly nextLine: string | null;
}

/**
 * The candidate-b RELATED rail card: Appointments / Payments / Intake as
 * compact index rows under the chronicle. DISPLAY-ONLY composition over
 * reads the page (or the lens fetch) already holds:
 *  - Other appointments (C38; relabeled DOCTOR-CONSULT-DEMO-POLISH-V1 item
 *    3 -- the prior bare "Appointments" label read as self-referential
 *    while the doctor sat inside one of the counted visits): the doctor
 *    patient-lens read's today + upcoming counts, EXCLUDING the appointment
 *    this consult IS, and the next booked visit; the drill is the lens page
 *    and renders ONLY when the #294 lens signal grants it. WHERE FUTURE
 *    VISITS GET BUILT (the founder consult detail): the row states the
 *    handoff -- the close follow-up recommendation is what the front desk
 *    books from (booking stays desk-owned; CHECKOUT-HANDOFF law).
 *  - Payments (C39): the same paid-across-visits derivation the rollup's
 *    PAID cell uses (one derivation, two renders -- never a second sum).
 *  - Intake (C40): the mockup's own untappable row -- the answers live in
 *    the intake card of this page; this row is the index line, no door.
 * A row whose fact is absent renders nothing; the card renders only when
 * at least one row exists (contextual existence).
 */
export function ConsultRelatedRail({
  appointments,
  lensHref,
  paidAllVisitsMinorUnits,
  intakeAnswerCount,
  onNavigate,
}: {
  appointments: RelatedAppointmentsFact | null;
  /** The doctor patient-lens route when lawfully reachable, else null. */
  lensHref: string | null;
  onNavigate?: (path: string) => void;
  paidAllVisitsMinorUnits: number | null;
  /** Patient-reported intake answers on this visit; null = read not held. */
  intakeAnswerCount: number | null;
}): JSX.Element | null {
  const hasRow =
    appointments !== null ||
    paidAllVisitsMinorUnits !== null ||
    (intakeAnswerCount !== null && intakeAnswerCount > 0);
  if (!hasRow) return null;
  return (
    <SectionShell eyebrow="Patient" title="Related" testId="consult-related">
      <div className="consult-related">
        {appointments !== null ? (
          <div className="consult-related__row" data-testid="consult-related-appointments">
            {/* DOCTOR-CONSULT-DEMO-POLISH-V1 (item 3): "Other appointments"
                -- the count already excludes the visit this consult IS
                (ConsultWorkspacePage's lensRelated derivation), so the
                label matches what it counts even while the doctor is
                sitting inside one of this patient's appointments. */}
            <span className="consult-related__t">Other appointments</span>
            <span
              className="consult-related__c"
              title={
                appointments.nextLine ??
                'The next visit is booked by the front desk from the close follow-up.'
              }
            >
              {appointments.todayCount + appointments.upcomingCount}
            </span>
            {lensHref !== null ? (
              <Link
                to={lensHref}
                onClick={event => {
                  if (!onNavigate || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                  event.preventDefault(); onNavigate(lensHref);
                }}
                className="consult-related__chev"
                aria-label="Open appointments in the patient lens"
                data-testid="consult-related-appointments-door"
              >
                {'\u25B8'}
              </Link>
            ) : null}
          </div>
        ) : null}
        {paidAllVisitsMinorUnits !== null ? (
          <div className="consult-related__row" data-testid="consult-related-payments">
            <span className="consult-related__t">Payments</span>
            <span className="consult-related__c">
              {paidAllVisitsMinorUnits > 0
                ? rupeesFromMinorLabel(paidAllVisitsMinorUnits)
                : 'none'}
            </span>
            {lensHref !== null ? (
              <Link
                to={lensHref}
                onClick={event => {
                  if (!onNavigate || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                  event.preventDefault(); onNavigate(lensHref);
                }}
                className="consult-related__chev"
                aria-label="Open payments in the patient lens"
                data-testid="consult-related-payments-door"
              >
                {'\u25B8'}
              </Link>
            ) : null}
          </div>
        ) : null}
        {intakeAnswerCount !== null && intakeAnswerCount > 0 ? (
          <div className="consult-related__row" data-testid="consult-related-intake">
            <span className="consult-related__t">Intake answers</span>
            <span
              className="consult-related__seam"
              title={`${intakeAnswerCount} patient-reported answers - they render in the intake block above.`}
            >
              patient-reported
            </span>
          </div>
        ) : null}
      </div>
    </SectionShell>
  );
}

// --- B2: the BLOCKED START panel + the CONVERSION MOMENT banner ----------------

export interface ConsultStartBlocked {
  /** The 409 code (registration_incomplete / identity_review_required /
   *  patient_record_required / registration_enrichment_unavailable /
   *  contact_phone_unresolvable). */
  readonly code: string;
  /** The server message VERBATIM (it lists the exact missing fields). */
  readonly message: string;
}

const BLOCKED_TITLES: Readonly<Record<string, string>> = {
  registration_incomplete: 'Registration incomplete',
  identity_review_required: 'Identity review required',
  // CONSULT-START-MOBILE-GATE-V1 (W-33): the phone on file cannot be
  // resolved for patient creation -- a front-desk task, never a doctor
  // dead-end. The server message renders verbatim below the title.
  contact_phone_unresolvable: 'Mobile number needs the front desk',
};

function blockedPanelTestId(code: string): string {
  if (code === 'registration_incomplete') return 'consult-registration-blocked';
  if (code === 'identity_review_required') return 'consult-identity-blocked';
  return 'consult-start-blocked';
}

/** The full-width blocked state (B2): the consult cannot start, the server
 *  message renders VERBATIM, and the one door leads back Home -- the doctor
 *  NEVER recollects Reception-owned registration. */
export function ConsultStartBlockedPanel({
  blocked,
  onBackToHome,
}: {
  blocked: ConsultStartBlocked;
  onBackToHome: () => void;
}): JSX.Element {
  return (
    <section
      className="consult-blocked"
      data-testid={blockedPanelTestId(blocked.code)}
    >
      <EmptyState
        title={BLOCKED_TITLES[blocked.code] ?? 'Consult cannot start yet'}
        body={
          <>
            <span data-testid="consult-blocked-message">{blocked.message}</span>
            {blocked.code === 'registration_incomplete' ? (
              <span
                className="consult-blocked__ownership"
                data-testid="consult-blocked-ownership"
              >
                Reception completes registration - the doctor never recollects
                it.
              </span>
            ) : null}
          </>
        }
        action={
          <AcButton
            size="sm"
            variant="ghost"
            onClick={onBackToHome}
            data-testid="consult-blocked-back-home"
          >
            Back to Home
          </AcButton>
        }
      />
    </section>
  );
}

/** THE CONVERSION MOMENT made visible (identity ruling 3): a one-time,
 *  dismissible ok band when THIS start minted the patient + UMR. */
export function ConsultConvertedBanner({
  umr,
  onDismiss,
}: {
  umr: string | null;
  onDismiss: () => void;
}): JSX.Element {
  return (
    <div
      className="consult-converted"
      role="status"
      data-testid="consult-converted-banner"
    >
      <AcBadge tone="positive">New patient created</AcBadge>
      <span className="consult-converted__line">
        {umr !== null && umr !== ''
          ? `New patient created - UMR ${umr}`
          : 'New patient created - UMR assigned'}
      </span>
      <AcButton
        size="sm"
        variant="ghost"
        onClick={onDismiss}
        data-testid="consult-converted-dismiss"
      >
        Dismiss
      </AcButton>
    </div>
  );
}

// --- CONSULT-START-TRUTH-V1: the START-SIGNAL TROUBLE band (W-31) --------------

/** The start signal's visible trouble states. NO SILENT LOSS: the walk
 *  found both conversion doors dead on the live build with ZERO visible
 *  trace -- the fire-and-forget catch swallowed every failure outside the
 *  four named 409 codes (an auth refusal, a 500, a dropped transport), and
 *  a 200 from an OLDER api (no patientId in the result) no-opped
 *  invisibly. Every one of those now renders THIS band with a Retry door. */
export type ConsultStartTrouble =
  | {
      /** The start POST failed outside the named blocked codes. */
      readonly kind: 'failed';
      /** The mapped error message (server text verbatim for 4xx). */
      readonly message: string;
    }
  | {
      /** The start 200d WITHOUT resolving identity (older api shape --
       *  result.patientId absent) over a still-unlinked visit: the
       *  conversion consequence did NOT run (LES-094: deploy drift must
       *  be loud, never silent). */
      readonly kind: 'unresolved';
    }
  | {
      /** The server REFUSED the start because the appointment's stored
       *  status admits no consult -- 409 `appointment_not_actionable`
       *  (Lane 1 item 1 / D01).
       *
       *  THIS IS NOT A LOST SIGNAL, so it must not wear a lost signal's
       *  clothes. The QA walk resumed a CANCELLED visit and read "Start
       *  signal failed" over a Retry door: the copy blamed the transport
       *  for a refusal that was CORRECT, and the door invited a press that
       *  could only ever be refused again. This state names the visit's
       *  state and carries NO retry -- retrying is not what is needed, a
       *  different visit is. The workspace still opens (the doctor can read
       *  what was already recorded); only the futile press is gone. */
      readonly kind: 'not_actionable';
      /** The server's own sentence, verbatim (ERROR-PASSTHROUGH LAW). */
      readonly message: string;
    };

export const CONSULT_START_FAILED_TITLE = 'Start signal failed';
export const CONSULT_START_UNRESOLVED_TITLE = 'Identity not resolved';
export const CONSULT_START_UNRESOLVED_LINE =
  'The consult opened, but this visit resolved no patient identity - the patient record and UMR have not been created or linked yet.';
export const CONSULT_START_RETRY_LABEL = 'Retry start signal';
/** The rung-0 band's title: a STATE, never a failure (Lane 1 item 1 / D01). */
export const CONSULT_START_NOT_ACTIONABLE_TITLE = 'Consult not available';

/** The visible retry band (PATH A of CONSULT-START-TRUTH-V1): the workspace
 *  still opens (the consult is never blocked on the signal), but a lost or
 *  refused start is NAMED on screen with its one retry door -- never a
 *  silent loss the walk cannot see. */
export function ConsultStartTroubleBanner({
  trouble,
  pending,
  onRetry,
}: {
  trouble: ConsultStartTrouble;
  pending: boolean;
  onRetry: () => void;
}): JSX.Element {
  const failed = trouble.kind === 'failed';
  // A REFUSAL IS NOT A LOST SIGNAL (Lane 1 item 1 / D01): the state band
  // carries no Retry, because there is nothing to retry -- the appointment's
  // status is what it is, and pressing again can only be refused again.
  const notActionable = trouble.kind === 'not_actionable';
  const title = notActionable
    ? CONSULT_START_NOT_ACTIONABLE_TITLE
    : failed
      ? CONSULT_START_FAILED_TITLE
      : CONSULT_START_UNRESOLVED_TITLE;
  const line = notActionable
    ? trouble.message
    : failed
      ? trouble.message
      : CONSULT_START_UNRESOLVED_LINE;
  return (
    <div
      className={
        notActionable
          ? 'consult-start-trouble workboard__feedback'
          : 'consult-start-trouble workboard__feedback workboard__feedback--error'
      }
      role={notActionable ? 'status' : 'alert'}
      data-testid={
        notActionable
          ? 'consult-start-not-actionable-banner'
          : failed
            ? 'consult-start-failed-banner'
            : 'consult-start-unresolved-banner'
      }
    >
      <AcBadge tone={notActionable ? 'neutral' : 'danger'}>{title}</AcBadge>
      <span
        className="consult-start-trouble__line"
        data-testid="consult-start-trouble-message"
      >
        {line}
      </span>
      {notActionable ? null : (
        <AcButton
          size="sm"
          variant="secondary"
          disabled={pending}
          onClick={onRetry}
          data-testid="consult-start-retry"
        >
          {pending ? 'Retrying...' : CONSULT_START_RETRY_LABEL}
        </AcButton>
      )}
    </div>
  );
}

// --- Pure page content (SSR-testable) ------------------------------------------

/** The approved C history region retains the existing intake owner.
 * Its own Save intake action shows the saved summary; folding this region
 * is explicit, so a late read never closes an editor under the doctor. */
export function ConsultHistoryOverview({ chiefComplaint, children }: {
  chiefComplaint: string;
  children: React.ReactNode;
}): JSX.Element {
  // Only the initial presentation follows the viewport; later reads and resizes
  // never close the user's editor. The existing Go action opens this disclosure.
  const [initiallyOpen] = useState(() => typeof window === 'undefined' || !window.matchMedia('(max-width: 1100px)').matches);
  return <details className="ac-section consult-history-overview" data-testid="consult-history-overview" open={initiallyOpen}>
    <summary><strong>History &amp; safety</strong><span>{chiefComplaint.trim() || 'Chief complaint not recorded'}</span></summary>
    {children}
  </details>;
}

export interface ConsultWorkspaceContentProps {
  readonly context: DoctorConsultContext;
  readonly sheet: CaseSheetClinicalView | null;
  readonly form: StructuredSheetForm;
  readonly itemForm: ItemForm;
  /** The org treatment catalog (V6-P3). null = unavailable/failed -> the
   *  legacy free-text add form renders byte-identical (fail-safe law). */
  readonly catalog: TreatmentCatalogResult | null;
  /** One-close: the inline-question answer (null until the plan marks work). */
  readonly explicitPick: CloseExplicitPick;
  readonly notConvertedReason: string;
  readonly busy: BusyKind;
  readonly saveState: ConsultSaveState;
  readonly feedback: WorkbenchFeedback | null;
  /** CONSULT-NEXT-GUARD-V1 (W-23): the truthful NEXT-band label for the visit's
   *  CURRENT state, derived by the container from EXISTING view-models
   *  (consult-next-band.ts). OPTIONAL so pre-package fixtures render
   *  byte-identical: absent falls back to the legacy always-"close" copy (the
   *  real page always passes the derived ladder label). */
  readonly nextActionLabel?: string;
  readonly onOpenToday: (appointmentId: number) => void;
  readonly onFormChange: (form: StructuredSheetForm) => void;
  readonly onItemFormChange: (form: ItemForm) => void;
  readonly onAddItem: () => void;
  readonly onAddExaminationTreatment?: (request: ExaminationTreatmentRequest) => Promise<boolean>;
  /** THE ONE PLAN-LINE WRITER (#781 handoff, integration order step 1). It
   *  must resolve with the refreshed sheet or REJECT: the line's hook reads
   *  the refreshed view to decide whether the write was actually confirmed,
   *  and a reply that does not carry the row is `unconfirmed`, not a save. */
  readonly onLineWrite: (
    itemId: number,
    patch: PlanItemUpdateInput,
  ) => Promise<CaseSheetClinicalView>;
  readonly onRemoveItem?: (itemId:number, input:PlanItemRemovalInput)=>Promise<void>;
  readonly onLineSettled?: (
    itemId: number,
    kind: PlanWriteKind,
    outcome: string,
  ) => void;
  readonly onExplicitPickChange: (pick: CloseExplicitPick) => void;
  readonly onNotConvertedReasonChange: (reason: string) => void;
  readonly onClose: () => void;
  /** The close success state's ONE next action (back to the queue). */
  readonly onBackToQueue: () => void;
  /** Side-column slots (history rail / seams column). */
  readonly railSlot?: React.ReactNode;
  readonly consultationValue?: DoctorConsultationState;
  readonly onConsultationLockChange?: (locked:boolean)=>void;
  readonly reloadConsultation?: () => Promise<void>;
  readonly planDiscounts?: Parameters<typeof consultPlanEstimate>[1];
  readonly previousPlanSlot?: React.ReactNode;
  readonly previousRecords?: PreviousClinicalPlansRead;
  readonly earlierEstimatesSlot?: React.ReactNode;
  readonly shellSearchSlot?: React.ReactNode;
  readonly seamsSlot?: React.ReactNode;
  /** The HEADLESS intake fetch owner (PreconsultIntakePanel). CONSULT-INTAKE-
   *  FOLD-V1 (W-30): the former patient-reported REVIEW card is folded away, so
   *  this slot renders NOTHING; it stays mounted only to keep the page's ONE
   *  questionnaire fetch owner (#514) alive with byte-unchanged fetch
   *  conditions. Its state reaches the visible surfaces (questions block, safety
   *  strip, reason-for-visit line) via onStateChange -> intakeState. */
  readonly preconsultSlot?: React.ReactNode;
  /** The medical-safety strip under the banner (DOCTOR-OS-BUILD-PHASE-1-V1
   *  brief C1: read-only R-MED chips, provenance-labeled, S9 posture). */
  readonly safetySlot?: React.ReactNode;
  /** The multi-visit treatment-journey panel (V6-P4; below the plan). */
  readonly journeySlot?: React.ReactNode;
  /** The Tier-2 clinical-evidence panel (DOCTOR-CLINICAL-EVIDENCE-TIER2-V1).
   *  CONSULT-INTAKE-RENDER-HEAL-V1 (founder ruling, W-17): paper-first attach +
   *  evidence come AFTER clinical work, so this slot renders BELOW the clinical
   *  leaves now (reversing the earlier paper-first lead). ABSENT while the B4
   *  flag is off (flag-OFF = zero surfaces; this slot then renders nothing). */
  readonly evidenceSlot?: React.ReactNode;
  /** C28: the same scoped evidence read used by Examination, never an extra fetch. */
  readonly evidenceImagingCount?: number|null;
  readonly investigationWorkspace?: InvestigationWorkspace;
  readonly onPendingSaved?:()=>void;
  /** Verified /me doctor identity scoped to this visit's clinic. */
  readonly currentDoctorId?:number|null;
  readonly onTodayWorkSaved?:()=>Promise<void>;
  readonly onTodayWorkRead?:(value:ClinicalTodayWorkView|null)=>void;
  readonly todayWork?:ClinicalTodayWorkView|null;
  readonly todayWorkPending?:boolean;
  readonly attachmentsEnabled?: boolean;
  /** DOCTOR-OS-EXPERIENCE-V1 slots (all optional; absent = byte-identical
   *  pre-package render for older fixtures):
   *  - intakeSlot: the ANSWER block -- the ConsultIntakeQuestionsBlock plus the
   *    C6 durable-allergy IntakeBand. CONSULT-INTAKE-RENDER-HEAL-V1 (W-17): the
   *    FIRST working block of the main column (the consult opens here), above
   *    the review, the clinical leaves, and evidence.
   *  - consentSlot: the B3 ConsentPanel (Treatment-plan column, under the
   *    plan items).
   *  - clinicalProfile / consentChip: the snapshot-header chip inputs.
   *  - startBlocked: the B2 blocked state -- replaces the working surface.
   *  - convertedBanner: the one-time conversion moment (dismissible). */
  readonly intakeSlot?: React.ReactNode | ((details: React.ReactNode) => React.ReactNode);
  readonly consentSlot?: React.ReactNode;
  readonly clinicalProfile?: PatientClinicalProfileView | null;
  readonly consentChip?: ConsentHeaderChip | null;
  /** DOCTOR-INTAKE-ONE-FLOW-V1 (R3c): the first unanswered VISIBLE intake
   *  question key (consultFirstUnansweredKey over the block's reason-first
   *  order), so the NEXT dock's Go lands on that field's anchor. null =
   *  no per-field target (the door degrades through the block/sheet
   *  ladder). The old display-only reasonForVisit header line is REMOVED
   *  (R3a: the reason has ONE home -- the block's first question, mirrored
   *  read-only in the Doctor's record rail). */
  readonly nextIntakeTargetKey?: string | null;
  readonly startBlocked?: ConsultStartBlocked | null;
  readonly convertedBanner?: { readonly umr: string | null } | null;
  readonly onDismissConverted?: () => void;
  /** ROUND 2 (coverage C06): visit ordinal from the page's history read. */
  readonly visitOrdinal?: number | null;
  /** ROUND 2 (C21-24): the ALL-VISITS paid sum composed from the page's
   *  existing case-history read + this visit's payments (minor units).
   *  null/absent = the rollup keeps the honest this-visit cell. */
  readonly paidAllVisitsMinorUnits?: number | null;
  /** ROUND 2 (C09): the derived course sub-line under the NEXT dock
   *  headline ("Complete <procedure> - N remaining"); null = absent. */
  readonly nextCourseSubline?: string | null;
  /** ROUND 3: earlier visits' plan items for the course-wide ledger
   *  (composed by the page from the lifted journey read). */
  readonly courseRows?: readonly CourseLedgerExtraRow[];
  readonly onEarlierPlanAccepted?: (fact:ClinicalPlanAcceptanceFact,bearer:string)=>Promise<void>;
  /** ROUND 3: the EXISTING cross-sheet completion act (completePlanItem),
   *  relocated from the retired chronicle to the ledger rows. */
  readonly onCompleteItem?: (owningSheetId: number, itemId: number) => void;
  /** ROUND 3: journey read's completion-storage signal. */
  readonly completionAvailable?: boolean;
  /** CONSULT-START-TRUTH-V1 (W-31): the visible start-signal trouble band
   *  + its retry door. Absent = no trouble (byte-identical render). */
  readonly startTrouble?: ConsultStartTrouble | null;
  readonly startRetryPending?: boolean;
  readonly onRetryStart?: () => void;
  /** C4 (TRUTH-AND-GATE corrective): a patient-reported allergy answer is
   *  awaiting doctor review -- the banner chip reads pending-verification
   *  instead of contradicting the line below it. Absent = byte-identical. */
  readonly allergyPendingReview?: boolean;
  readonly intakeReadKind?: PreconsultPanelState['kind'];
  /** C7: uncovered accepted lines still owing consent (the page's ONE
   *  consents read), for the close confirm panel's advisory line. */
  readonly consentOwedCount?: number | null;
  /** BUILD 1 (L-05): the served owed-evidence kinds, mirrored up from the
   *  evidence panel's ONE read, so the close states what the visit owes.
   *  null = unsettled/sheetless -> no line. WARN-ONLY. */
  readonly evidenceOwedKinds?: readonly string[] | null;
  /** DOCTOR-FLOW-AFTER-INTAKE-V1 (D3): the continue-treatment header --
   *  the returning course patient's consult opens on "Continue treatment -
   *  Stage N of M", never visually from zero. Composed by the page from the
   *  lifted journey read (derive-only); ABSENT = byte-identical render. */
  readonly continueSlot?: React.ReactNode;
  /** DOCTOR-FLOW-AFTER-INTAKE-V1 (D1): the structured NEXT VISIT panel
   *  (interval chips + treatment doctor + desk note) riding the ONE sheet
   *  form. ABSENT = byte-identical render (older fixtures). */
  readonly nextVisitSlot?: React.ReactNode;
  /** D1: the close strip's next-visit fact line ("Next visit: Stage 3 -
   *  sent to Front Desk"); null = none set (the WARN-only dialog line then
   *  asks once on a course visit). */
  readonly nextVisitLine?: string | null;
  /** D1: TRUE when this is a course visit with NO follow-up intent set --
   *  the close dialog adds ONE WARN-only line (the close act never blocks;
   *  the standing ruling). */
  readonly courseNoFollowUpWarn?: boolean;
  /** DOCTOR-CONSULT-DELTA-V1: the treatment-specific doctor assignment
   *  context for the plan ledger. ABSENT = byte-identical render. */
  readonly doctorAssign?: PlanItemDoctorAssign;
  /** DOCTOR-CONSULT-DELTA-V1: the PRINT ESTIMATE door on the estimation
   *  strip. ABSENT = no door renders (byte-identical). */
  readonly onPrintEstimate?: () => void;
  readonly prescriptionSlot?: React.ReactNode;
  readonly treatmentConsents?: CaseSheetConsentsWire | null;
  readonly courseLoadState?: 'none' | 'loading' | 'ready' | 'error';
  readonly completionErrors?: readonly number[];
  readonly printoutsSlot?: React.ReactNode;
  readonly viewCaseSheet?: {open:()=>void;busy:boolean};
  readonly finalizedAdditions?: ReturnType<typeof useFinalizedClinicalAdditions>;
  readonly stageScopeKey?: string;
  readonly startAdditions?: boolean;
  readonly questionsRecorded?: boolean;
  readonly questionsPresentation?: 'questions' | 'summary';
  readonly historyDetails?: DoctorPreconsultView;
  readonly activeCoursePlanItems?: readonly Pick<ClinicalPlanItemView, 'status' | 'toothRefs'>[];
  readonly onSaveStage?: () => Promise<boolean>;
  readonly stageSaveState?: ConsultSaveState;
  readonly planDraftOwner?: PlanDraftOwner;
  readonly stageDiscard?: { visible: boolean; busy: boolean; onDiscard: () => Promise<boolean> };
  readonly onOpenPatientRecord?: () => void;
  readonly finishQuestions?: readonly string[];
  readonly finishPlanPending?: boolean;
  readonly finishPrescriptionPending?: boolean;
  readonly paperCapture?: { open: () => void; busy: boolean; error: string | null } | null;
}

/** Finish reads the same live/saved facts as their editors. Unknown reads and
 * independent unfinished writers stay visible; this is advisory, never a new
 * permission or clinical completion writer. */
function FinishReview({ questions, context, sheet, form, rows, courseKnown, consents, earlier,
  estimate, planPending, prescriptionPending, todayWork, todayWorkPending, investigations, evidenceSource, busy, go, paper, onOpenItems }: {
  onOpenItems: (count: number, statuses: ConsultStageStatuses) => void;
  questions?: readonly string[]; context: DoctorConsultContext; sheet: CaseSheetClinicalView | null;
  form: StructuredSheetForm; rows: readonly CourseLedgerExtraRow[]; courseKnown: boolean;
  consents: CaseSheetConsentsWire | null; earlier: EarlierConsentRead;
  estimate: ReturnType<typeof consultPlanEstimate> | null; planPending: boolean; prescriptionPending: boolean;
  todayWork?:ClinicalTodayWorkView|null;todayWorkPending:boolean;
  investigations?:ClinicalInvestigationsView|null;evidenceSource?:ClinicalEvidenceSource|null;
  busy: boolean; go: (stage: ConsultStage) => void;
  paper?: { open: () => void; busy: boolean; error: string | null } | null;
}): JSX.Element {
  const all = [...(sheet?.planItems ?? []).map(item => ({ owningSheetId: sheet!.id, item })), ...rows];
  const accepted = all.filter(row => row.item.status === 'accepted');
  const exam = examinationSummary(form.examination);
  const investigationIssues=savedInvestigationReview(sheet?.id??null,context.appointment.clinicId,context.patient.patientId,investigations,evidenceSource);
  const planIssues = [
    ...examinationTreatmentReview(form.examination,courseKnown?all.map(row=>row.item):undefined,sheet?.status==='finalized'?sheet.examination:undefined).flatMap(row=>row.warning?[row.warning]:[]),
    ...(!courseKnown ? ['Earlier treatment is not fully loaded.'] : []),
    ...all.filter(row => !row.item.performingDoctorId && !['declined','deferred'].includes(row.item.status)).map(row => `Treatment doctor not chosen: ${row.item.procedureName}`),
    ...(all.some(row => !['declined','deferred'].includes(row.item.status)) && estimate?.estimate == null ? ['Treatment prices are not fully available.'] : []),
    ...(planPending ? ['Plan changes are not yet saved.'] : []),
  ];
  const consentIssues = accepted.flatMap(({owningSheetId,item}) => {
    const wire = owningSheetId === sheet?.id ? consents : earlier.wires[owningSheetId];
    if (!wire?.available) return [`Consent status unavailable: ${clinicalPlanReviewLabel(item)}`];
    if (!wire.requiredForProcedure) return [];
    const signed = wire.consents.some(value => ['signed_digital','signed_physical_captured'].includes(value.state) && value.treatmentPlanItemIds.includes(item.id));
    return signed ? [] : [`Treatment consent not uploaded: ${clinicalPlanReviewLabel(item)}`];
  });
  if (!courseKnown) consentIssues.push('Earlier treatment is not fully loaded.');
  const work=savedTodayWorkReview(sheet?.id??null,accepted,todayWork,courseKnown,todayWorkPending);
  const medicineIssues = context.prescriptionAvailable !== true ? ['Medicines are unavailable.'] :
    prescriptionPending ? ['Medicine changes are not yet saved.'] : prescriptionProblems(sheet?.prescription);
  const checks: {name: string; stage: ConsultStage; issues: readonly string[]; detail: string}[] = [
    {name:'Questions',stage:1,issues:questions ?? ['Questions are not yet available.'],detail:'Required history answered'},
    {name:'Examination',stage:2,issues:[...(context.examinationAvailable !== true ? ['Examination is unavailable.'] : !exam ? ['No problem recorded — add one or choose “No problem found”.'] : []),...investigationIssues,...(!examinationEqual(form.examination,sheet?.examination??null)?['Examination changes are not yet saved.']:[])],detail:exam ?? 'Not recorded'},
    {name:'Plan & cost',stage:3,issues:planIssues,detail:all.length ? `${accepted.length} accepted · ${estimate?.acceptedNet==null?'Unavailable':rupeesFromMinorLabel(estimate.acceptedNet)} · ${all.filter(row=>row.item.status==='advised').length} advised` : 'No treatment planned'},
    {name:'Consent',stage:4,issues:consentIssues,detail:accepted.length ? `Consent checked for ${accepted.length} accepted` : 'No treatment consent needed'},
    {name:'Today’s work',stage:4,issues:work.issues,detail:work.detail},
    {name:'Medicines',stage:4,issues:medicineIssues,detail:sheet?.prescription?.noMedicinesToday ? 'None today' : `${sheet?.prescription?.medicines.length ?? 0} ${(sheet?.prescription?.medicines.length ?? 0) === 1 ? 'medicine' : 'medicines'}`},
  ];
  const openCount=checks.reduce((total,check)=>total+check.issues.length,0);
  const checkStatus=JSON.stringify(Object.fromEntries([1,2,3,4].map(stage=>[stage,checks.filter(check=>check.stage===stage).some(check=>check.issues.length)?'open':'ready'])));
  useEffect(()=>onOpenItems(openCount,JSON.parse(checkStatus) as ConsultStageStatuses),[openCount,checkStatus,onOpenItems]);
  const amount = (value:number|null|undefined) => typeof value === 'number' ? rupeesFromMinorLabel(value) : 'unavailable';
  return <>
    {paper ? <div className="consult-v14g__paperline"><span>Wrote it on the paper case sheet?</span>
      <AcButton variant="secondary" disabled={busy || paper.busy} onClick={paper.open} data-testid="consult-finish-paper">{paper.busy ? 'Preparing…' : 'Upload paper case sheet'}</AcButton>
      {paper.error ? <p role="alert">{paper.error}</p> : null}</div> : null}
    <section className="consult-v14g__card consult-v14g__checks" aria-label="Visit checks" data-testid="consult-finish-checks">
      {checks.map(check => <div key={check.name} className="consult-v14g__check" data-check={check.name} data-state={check.issues.length ? 'open' : 'ready'}>
        <span className={`consult-v14g__check-icon ${check.issues.length ? 'is-open' : 'is-ready'}`} aria-hidden="true">{check.issues.length ? '!' : '✓'}</span>
        <div><b>{check.name}</b><p>{check.issues.length ? check.issues.join(' · ') : check.detail}</p></div>
        <AcButton variant={check.issues.length ? 'secondary' : 'ghost'} disabled={busy} onClick={()=>go(check.stage)} aria-label={`${check.issues.length?'Fix':'Review'} ${check.name}`}>{check.issues.length ? 'Fix' : 'Review'}</AcButton>
      </div>)}
    </section>
    <section className="consult-v14g__card consult-v14g__charges" aria-label="Charges" data-testid="consult-finish-charges"><div><b>Charges</b>
      <p>Today’s charges {amount(estimate?.today)} · patient agreed {amount(estimate?.agreed)} · accepted treatment {amount(estimate?.acceptedNet)} · advised, not yet agreed {amount(estimate?.advised.minor)} · total estimate {amount(estimate?.total)} · estimate, not an amount due today · Reception takes payment</p></div>
      <AcButton variant="ghost" disabled={busy} onClick={()=>go(3)} aria-label="Review charges">Review</AcButton>
    </section>
  </>;
}

export function ConsultWorkspaceContent(
  props: ConsultWorkspaceContentProps,
): JSX.Element {
  const {
    context,
    sheet,
    form,
    itemForm,
    catalog,
    explicitPick,
    notConvertedReason,
    busy,
    saveState,
    stageSaveState = saveState,
    feedback,
    nextActionLabel = CONSULT_OPEN_NEXT_ACTION_LABEL,
    onOpenToday,
    onFormChange,
    onItemFormChange,
    onAddItem,
    onLineWrite,
    onLineSettled,
    onExplicitPickChange,
    onNotConvertedReasonChange,
    onClose,
    onBackToQueue,
    railSlot,
    seamsSlot,
    preconsultSlot,
    safetySlot,
    journeySlot,
    evidenceSlot,
    attachmentsEnabled,
    intakeSlot,
    consentSlot,
    clinicalProfile,
    startBlocked = null,
    convertedBanner = null,
    onDismissConverted,
    startTrouble = null,
    startRetryPending = false,
    onRetryStart,
    visitOrdinal = null,
    paidAllVisitsMinorUnits = null,
    continueSlot = null,
    nextVisitSlot = null,
    nextVisitLine = null,
    courseNoFollowUpWarn = false,
    courseRows = [],
    completionAvailable = false,
    allergyPendingReview = false,
    consentOwedCount = null,
    evidenceOwedKinds = null,
    doctorAssign,
    onPrintEstimate,
  } = props;

  const [historyDetailsOpen, setHistoryDetailsOpen] = useState<string | null>(null);
  const [compactHeader, setCompactHeader] = useState(false);
  const historyDetailsOpener = useRef<HTMLButtonElement>(null);
  const stageNavigation = useRef<((stage: ConsultStage) => void) | null>(null);
  useEffect(() => {
    const update = () => setCompactHeader(previous => window.scrollY > 160 ? true : window.scrollY <= 40 ? false : previous);
    update(); window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);
  const [investigationRead,setInvestigationRead]=useState<{identity:string;value:ClinicalInvestigationsView|null}|null>(null);
  const visitStageIdentity=props.stageScopeKey??`${context.appointment.id}:${context.patient.patientId??''}`;
  const [examinationRemovalSlots,setExaminationRemovalSlots]=useState<ReadonlyMap<string,HTMLDivElement>>(()=>new Map());
  const bindExaminationRemovalHost=useCallback((id:number,host:HTMLDivElement|null)=>{
    const key=`${visitStageIdentity}:${id}`;
    setExaminationRemovalSlots(previous=>{
      if(previous.get(key)===(host??undefined))return previous;
      const next=new Map(previous);if(host)next.set(key,host);else next.delete(key);return next;
    });
  },[visitStageIdentity]);
  const examinationRemovalHosts=new Map((sheet?.planItems??[]).flatMap(item=>{
    const host=examinationRemovalSlots.get(`${visitStageIdentity}:${item.id}`);return host?[[item.id,host] as const]:[];
  }));
  const investigationIdentity=props.investigationWorkspace?.identity??'';
  const onInvestigationRead=useCallback((value:ClinicalInvestigationsView|null)=>setInvestigationRead(previous=>previous?.identity===investigationIdentity&&JSON.stringify(previous.value)===JSON.stringify(value)?previous:{identity:investigationIdentity,value}),[investigationIdentity]);
  const currentInvestigations=props.investigationWorkspace===undefined?undefined:investigationRead?.identity===investigationIdentity?investigationRead.value:null;
  const [planEstimate,setPlanEstimate]=useState<{key:string;value:ReturnType<typeof consultPlanEstimate>}|null>(null);
  const planEstimateKey=`${props.stageScopeKey??context.appointment.id}:${sheet?.id??'none'}`;
  const onEstimate=useCallback((value:ReturnType<typeof consultPlanEstimate>)=>{
    setPlanEstimate(previous=>previous?.key===planEstimateKey && JSON.stringify(previous.value)===JSON.stringify(value)?previous:{key:planEstimateKey,value});
  },[planEstimateKey]);
  const currentEstimate=planEstimate?.key===planEstimateKey?planEstimate.value:null;
  const [savedExtraRead,setSavedExtraRead]=useState<{key:string;minor:number|null}|null>(null);
  const onSavedExtra=useCallback((minor:number|null)=>setSavedExtraRead(previous=>previous?.key===planEstimateKey&&previous.minor===minor?previous:{key:planEstimateKey,minor}),[planEstimateKey]);
  const [finishItems, setFinishItems] = useState<{key:string;count:number;statuses:ConsultStageStatuses}|null>(null);
  const onFinishItems=useCallback((count:number,statuses:ConsultStageStatuses)=>setFinishItems(previous=>previous?.key===planEstimateKey&&previous.count===count&&JSON.stringify(previous.statuses)===JSON.stringify(statuses)?previous:{key:planEstimateKey,count,statuses}),[planEstimateKey]);
  const returnOpen=context.returnRequestAvailable===true && (!form.returnRequest || (form.returnRequest.timing==='other' && !returnRequestDate(form.returnRequest)) || !!returnRequestProblem(form.returnRequest,sheet?.returnRequest,new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date())));
  const finishCount=finishItems?.key===planEstimateKey ? finishItems.count+(returnOpen?1:0) : null;
  const stageStatuses:ConsultStageStatuses={};
  const recordedStages=[props.questionsRecorded===true,!!sheet?.examination,!!sheet?.planItems.length,!!sheet?.prescription||!!props.todayWork?.facts.length];
  if(finishItems?.key===planEstimateKey)recordedStages.forEach((recorded,index)=>{if(recorded)stageStatuses[(index+1) as ConsultStage]=finishItems.statuses[(index+1) as ConsultStage];});

  const estimateFooter=<div className="consult-v14g__footer-money" data-testid="consult-plan-footer">{[
    ['Today’s charges',currentEstimate?.today],['Patient agreed',currentEstimate?.agreed],['Treatment estimate',currentEstimate?.estimate],['Total estimate',currentEstimate?.total],
  ].map(([label,amount])=><div key={String(label)}><small>{label}</small><b>{typeof amount==='number'?rupeesFromMinorLabel(amount):'Unavailable'}</b></div>)}</div>;
  const earlierConsents = useEarlierTreatmentConsents(`${context.appointment.id}:${context.patient.patientId}`, courseRows);
  const earlierAccepted = courseRows.some(row => row.item.status === 'accepted');
  const currentAccepted = sheet?.planItems.some(item => item.status === 'accepted') === true;
  const awaitingCourse = props.courseLoadState === 'loading' || props.courseLoadState === 'error';
  // Frozen V14g facts(): accepted treatment count and net, excluding Today's
  // charges. Reuse the estimate projection over saved rows only. A preview,
  // failed read or another visit's pricing can never become this saved fact.
  const savedPlanRows=[...courseRows.map(row=>({caseSheetId:row.financialSheetId??row.owningSheetId,status:row.item.status,amount:row.item.estimatedValue})),...(sheet?.planItems??[]).map(item=>({caseSheetId:sheet!.id,status:item.status,amount:item.estimatedValue}))];
  const savedExtraMinor=savedExtraRead?.key===planEstimateKey?savedExtraRead.minor:null;
  const savedDiscounts=sheet&&props.planDiscounts&&savedExtraMinor!==null
    ? [...props.planDiscounts.filter(row=>row.caseSheetId!==sheet.id),{caseSheetId:sheet.id,discountAmountInr:savedExtraMinor/100}]:null;
  const savedPlanEstimate=consultPlanEstimate(savedPlanRows,savedDiscounts,null,!awaitingCourse);
  // Frozen planSoFar(): the same draft-aware projection as Plan & cost,
  // including Today's charges. The saved masthead remains a separate fact.
  // Never hide autosave recovery or present a partial course as a known count.
  const examinationSummary=(saveState.kind==='idle'||saveState.kind==='clean') && (awaitingCourse||savedPlanRows.length>0||(currentInvestigations?.orders.length??0)>0)
    ? <span data-testid="consult-examination-plan-summary">Plan so far · {awaitingCourse?'Treatment lines unavailable':`${savedPlanRows.length} treatment line${savedPlanRows.length===1?'':'s'}`}{currentInvestigations?.orders.length ? ` · ${currentInvestigations.orders.map(order=>order.choice).join(', ')}` : ''} · patient agreed <b>{awaitingCourse||savedExtraMinor===null||currentEstimate?.agreed==null?'Unavailable':rupeesFromMinorLabel(currentEstimate.agreed)}</b> · advised {awaitingCourse||currentEstimate?.advised.minor==null?'Unavailable':rupeesFromMinorLabel(currentEstimate.advised.minor)}</span>
    : undefined;
  const notice = todaysVisitNotice(context);
  // SCOPE 1: the config-backed section layout (server-resolved order,
  // availability-filtered; legacy three-section fallback client-side).
  const sections = consultNoteSections(context);
  const followUpOptions = context.followUpOptions ?? [];
  // SCOPE 3 (DOCTOR-JOURNEY-COMPOSE-V1): the resolved per-field category
  // options -- server-resolved vocabulary when served; older servers degrade
  // to the legacy specialties list; empty = the select hides (clean absence).
  const complaintOptions = visitCategoryOptionLabels(
    context.complaintCategoryOptions,
    context.clinicSpecialties,
  );
  const diagnosisOptions = visitCategoryOptionLabels(
    context.diagnosisCategoryOptions,
    context.clinicSpecialties,
  );
  const questionDetails = <>
                {sections.some(section => section.field === 'chiefComplaint' || section.field === 'medicalDentalHistory') ? <details className="consult-v14g__supplemental">
                  <summary>Additional history and visit details</summary>
                  <StructuredSheetSection sheet={sheet} form={form} notesOnly title="Visit details" testId="consult-history-details"
                    sections={sections.filter(section => section.field === 'chiefComplaint' || section.field === 'medicalDentalHistory')}
                    followUpOptions={followUpOptions} complaintOptions={complaintOptions} diagnosisOptions={diagnosisOptions}
                    busy={busy} saveState={saveState} onFormChange={onFormChange} additions={props.finalizedAdditions} />
                </details> : null}
                <details className="consult-overview__previous consult-v14g__supplemental" data-testid="consult-previous-context">
                  <summary>Previous visits and continuing care</summary>{continueSlot ?? null}{railSlot ?? null}
                </details>
  </>;
  const encounterSectionsAvailable = context.encounterSectionsAvailable === true;
  // C7 (TRUTH-AND-GATE corrective): the LIVE label/value rows of the clinical
  // record as the doctor currently sees them (form truth -- fresher than the
  // sheet during the autosave debounce), for the close confirm panel's
  // completeness line. Same row grammar the finalized card renders.
  const closeNoteRows = [
    ...consultDraftNoteRows(sections, form),
    ...(encounterSectionsAvailable
      ? [
          {
            label: FOLLOW_UP_LABELS.option,
            value: context.returnRequestAvailable === true
              ? returnRequestSummary(form.returnRequest) : followUpSummaryLine(
              {
                followUpOption:
                  form.followUpOption === '' ? null : form.followUpOption,
                followUpNote: form.followUpNote === '' ? null : form.followUpNote,
              },
              context.followUpOptions ?? [],
            ),
          },
        ]
      : []),
  ];
  // TOOTH-NOTATION-INTERIM-V1: tooth entry is offered ONLY when the server
  // served the reference set AND reported tooth storage live (null = every
  // surface renders byte-identical to before this package).
  const toothEntry = toothEntryContextFrom(context);
  // VISIBLE ENCOUNTER STATUS (SCOPE 2): one status chip in the page header.
  const encounterStatus =
    sheet === null ? 'draft' : sheet.status;
  const profile = clinicalProfile ?? context.clinicalProfile ?? null;
  // Display only, the same fallback the saved print uses: until a complaint is
  // saved on this visit's sheet, show today's admitted intake reason. Nothing
  // is written into the case sheet or any earlier note.
  const todaysIntakeReasonText = todaysIntakeReason(props.historyDetails, context.appointment.id);
  const patientHeader = <>
    <section className={`consult-v14g__patient${compactHeader ? ' is-compact' : ''}`} aria-label="Patient" data-testid="consult-banner">
      <div className="consult-v14g__patient-line">
        <h1 data-testid="consult-banner-name">{consultBannerName(context.patient)}</h1>
        <span data-testid="consult-banner-identity">{bannerIdentityLine(context.patient)} · {visitOrdinal === null ? 'Visit' : `Visit ${visitOrdinal}`} · {encounterStatus === 'finalized' ? 'Finalized' : 'Draft'}</span>
        {props.onOpenPatientRecord ? <AcButton variant="secondary" disabled={busy !== null} onClick={props.onOpenPatientRecord} data-testid="consult-patient-record">Patient record</AcButton> : null}
      </div>
      <div className="consult-v14g__facts">
        <span className="is-purpose" data-testid="consult-purpose-fact"><b>{visitOrdinal !== null && visitOrdinal > 1 ? 'Today' : 'Came for'}</b>{form.chiefComplaint.trim() || todaysIntakeReasonText || 'Not recorded'}</span>
        <span data-testid="consult-anaesthesia-fact" className={profile?.anaesthesiaAllergy === 'yes' ? 'is-alert' : ''}><b>Anaesthesia allergy</b>{consultSafetyFactLabel(profile?.anaesthesiaAllergy === 'yes' ? 'Yes' : profile?.anaesthesiaAllergy === 'no' ? 'No' : null, context.clinicalProfileAvailable === true, props.intakeReadKind, allergyPendingReview)}</span>
        <span data-testid="consult-medication-fact" className={profile?.medicationAllergies ? 'is-alert' : ''}><b>Medicine allergy</b>{consultSafetyFactLabel(profile?.medicationAllergies, context.clinicalProfileAvailable === true, props.intakeReadKind, allergyPendingReview)}</span>
        <span data-testid="consult-history-fact"><b>History</b>{consultSafetyFactLabel(profile?.medicalAlerts, context.clinicalProfileAvailable === true, props.intakeReadKind)}</span>
        {sheet?.examination?.findings.length ? <span data-testid="consult-found-fact"><b>Found</b>{sheet.examination.findings.map(f => `${f.toothCode} ${f.label.toLocaleLowerCase('en')}`).join(' · ')}</span> : null}
        {typeof props.evidenceImagingCount==='number'&&props.evidenceImagingCount>0?<span data-testid="consult-imaging-fact"><b>X-rays</b>{props.evidenceImagingCount} attached</span>:null}
        {savedPlanRows.length>0?<span data-testid="consult-saved-plan-fact"><b>Plan</b>{awaitingCourse?'Unavailable':`${savedPlanEstimate.accepted.count} accepted · ${savedPlanEstimate.acceptedNet===null?'Unavailable':rupeesFromMinorLabel(savedPlanEstimate.acceptedNet)}`}</span>:null}
        {(props.questionsRecorded || (visitOrdinal !== null && visitOrdinal > 1) || props.questionsPresentation === 'summary') ? <AcButton variant="ghost" size="sm" className="consult-v14g__details-fact" ref={historyDetailsOpener} disabled={busy !== null} onClick={() => setHistoryDetailsOpen(visitStageIdentity)} data-testid="consult-view-details">View details</AcButton> : null}
      </div>
    </section>
    {safetySlot ?? null}
    <Dialog open={historyDetailsOpen === visitStageIdentity} onOpenChange={open => { if (!open) setHistoryDetailsOpen(null); }}>
      <DialogContent showCloseButton={false} finalFocus={historyDetailsOpener} data-testid="consult-history-details-dialog">
        <DialogTitle>History and allergies</DialogTitle>
        <dl className="consultation-output__facts">
          <div><dt>Anaesthesia allergy · Doctor record</dt><dd>{consultSafetyFactLabel(profile?.anaesthesiaAllergy === 'yes' ? 'Yes' : profile?.anaesthesiaAllergy === 'no' ? 'No' : null, context.clinicalProfileAvailable === true, props.intakeReadKind, allergyPendingReview)}</dd></div>
          <div><dt>Medicine allergies · Doctor record</dt><dd>{consultSafetyFactLabel(profile?.medicationAllergies, context.clinicalProfileAvailable === true, props.intakeReadKind, allergyPendingReview)}</dd></div>
          <div><dt>Medical history · Doctor record</dt><dd>{consultSafetyFactLabel(profile?.medicalAlerts, context.clinicalProfileAvailable === true, props.intakeReadKind)}</dd></div>
        </dl>
        {props.historyDetails?.audience === 'clinical' && !props.historyDetails.underIdentityReview && props.historyDetails.appointmentId === context.appointment.id ? <section aria-label="Patient-reported history">
          <p>{props.historyDetails.provenanceLabel}</p>
          <dl className="consultation-output__facts">{props.historyDetails.answers.map((answer,index) => <div key={index}><dt>{answer.prompt?.trim() || 'Question label unavailable'}</dt><dd>{[...answer.selectedLabels,answer.detailText].filter(Boolean).join(' · ') || 'Not recorded'}</dd></div>)}</dl>
        </section> : <p>Patient-reported history unavailable.</p>}
        <div className="consult-v14g__detail-actions">
          <AcButton variant="secondary" onClick={() => setHistoryDetailsOpen(null)}>Close</AcButton>
          <AcButton disabled={busy !== null || sheet?.status === 'finalized'} onClick={() => {
            setHistoryDetailsOpen(null); stageNavigation.current?.(1);
            // Reuse the mounted editor's own Update/Edit action and focus owner.
            // A switched/unmounted visit cannot receive this deferred activation.
            const opener = historyDetailsOpener.current;
            requestAnimationFrame(() => { if (!opener?.isConnected || opener !== historyDetailsOpener.current) return;
              const root = opener.closest('.consult-v14g');
              const edit = root?.querySelector<HTMLButtonElement>('[data-testid="consult-carry-update"], [data-testid="consult-intake-edit"]');
              if (edit && !edit.disabled) edit.click();
              else root?.querySelector<HTMLElement>('#consult-stage-1-heading')?.focus({preventScroll:true});
            });
          }}>Edit answers</AcButton>
        </div>
      </DialogContent>
    </Dialog>
  </>;

  const missingAdditionStage:ConsultStage=!props.finalizedAdditions?.saved.notes?.chief_complaint?1:!props.finalizedAdditions.saved.examination?2:sheet?.planItems.some(item=>item.performingDoctorId==null&&!props.finalizedAdditions?.saved.treatmentDoctors?.some(d=>d.planItemId===item.id))?3:!props.finalizedAdditions.saved.prescription?4:5;
  const closeStrip = (finishActionHost:HTMLDivElement|null) => sheet !== null ? (
            <CloseVisitStrip
              actionHost={finishActionHost}
              decisionItems={[...sheet.planItems,...courseRows.filter(row=>row.source&&row.decision?.acceptance?.caseSheetId===sheet.id).map(row=>({...row.source!,status:row.item.status}))]}
              sheet={sheet}
              context={context}
              explicitPick={explicitPick}
              notConvertedReason={notConvertedReason}
              busy={busy}
              onExplicitPickChange={onExplicitPickChange}
              onNotConvertedReasonChange={onNotConvertedReasonChange}
              onClose={onClose}
              onBackToQueue={onBackToQueue}
              viewCaseSheet={props.viewCaseSheet}
              noteRows={closeNoteRows}
              consentOwedCount={consentOwedCount}
              evidenceOwedKinds={evidenceOwedKinds}
              nextVisitLine={nextVisitLine}
              courseNoFollowUpWarn={courseNoFollowUpWarn}
            />
          ) : null;

  return (
    <div className="dashboard consult-workspace consult-workspace--overview consult-workspace--v14g" data-testid="consult-workspace">
      <style>{`
        .consult-workspace--overview .consult-workspace__columns {
          grid-template-columns: 216px minmax(0, 1fr) 280px;
          gap: var(--ac-space-4); align-items: start;
        }
        .consult-workspace--overview .consult-masthead {
          border: 0; border-bottom: 1px solid hsl(var(--ac-line));
          border-radius: 0; background: transparent; box-shadow: none;
          padding: var(--ac-space-3) 0; flex-direction: column; align-items: stretch;
        }
        .consult-workspace--overview .consult-banner__name { font-size: 1.25rem; }
        .consult-workspace--overview .ac-section { box-shadow: none; border-radius: var(--ac-radius-md); }
        .consult-workspace--overview :is(.ac-section__title, .consult-card-head__t, .consult-overview__title, .tooth-diagram__title) {
          font-size: 1rem; font-weight: 600; letter-spacing: normal; text-transform: none;
        }
        .consult-workspace--overview .consult-overview__title { margin: 0; padding: var(--ac-space-4); }
        .consult-workspace--overview :is(.consult-thisvisit, .cockpit-course) { gap: 0; }
        .consult-workspace--overview .consult-thisvisit > .consult-frow {
          padding: var(--ac-space-2) var(--ac-space-4);
          border-top: 1px solid hsl(var(--ac-line));
        }
        .consult-workspace--overview .consult-thisvisit .consult-frow__l {
          text-transform: none; letter-spacing: normal; font-size: var(--ac-text-detail); font-weight: 500;
        }
        .consult-workspace--overview .consult-thisvisit .consult-frow__summary::after {
          content: '▸'; margin-left: auto; color: hsl(var(--ac-brand));
        }
        .consult-workspace--overview .consult-thisvisit details[open] > .consult-frow__summary::after { content: '▾'; }
        .consult-workspace--overview .cockpit-course > .ac-section {
          border: 0; border-top: 1px solid hsl(var(--ac-line)); border-radius: 0;
          padding: var(--ac-space-3) var(--ac-space-4); gap: var(--ac-space-2);
        }
        .consult-workspace--overview .consult-journey { padding: var(--ac-space-3) var(--ac-space-4); }
        .consult-workspace--overview .consult-journey__jt { flex-wrap: wrap; gap: var(--ac-space-2); }
        .consult-workspace--overview .consult-journey__pmeta { gap: var(--ac-space-2); }
        .consult-workspace--overview .consult-overview__empty-plan { margin: 0; padding: var(--ac-space-3) var(--ac-space-4); }
        .consult-workspace--overview .consult-nextvisit { padding: var(--ac-space-4); gap: var(--ac-space-2); }
        .consult-workspace--overview .consult-nextvisit > .consult-card-head { padding: 0; flex-wrap: wrap; }
        .consult-workspace--overview .consult-nextvisit > .consult-frow__sub { margin: 0; }

        .consult-workspace--overview .consult-overview__add { padding: var(--ac-space-3) var(--ac-space-4); }
        .consult-workspace--overview .consult-overview__add > summary,
        .consult-tooth-history { border-left:3px solid var(--ac-reference-color-7195ba); background:var(--ac-reference-color-f0f5fa); padding:10px 12px; margin:0 0 12px; font-size:var(--ac-text-caption); }
        .consult-tooth-history p { font-size:var(--ac-text-caption); margin-top:4px; color:var(--ac-reference-color-4c6672); }
        .consult-tooth-history h3, .consult-tooth-history strong { font-size:var(--ac-text-caption); }
        .consult-workspace--overview .consult-overview__previous > summary {
          cursor: pointer; color: hsl(var(--ac-brand)); font-weight: 600;
          padding: var(--ac-space-2) 0;
        }
        .consult-workspace--overview .consult-overview__previous { padding: var(--ac-space-4); }
        .consult-workspace--overview .consult-overview__previous[open] > summary { margin-bottom: var(--ac-space-3); }
        .consult-workspace--overview summary:focus-visible { outline: 2px solid hsl(var(--ac-brand)); outline-offset: 3px; }
        .consult-workspace--overview .consult-masthead__dock { align-items: flex-start; width: 100%; max-width: none; background: hsl(var(--ac-brand) / .04); border: 1px solid hsl(var(--ac-line)); border-left: 3px solid hsl(var(--ac-brand)); border-radius: var(--ac-radius-md); padding: var(--ac-space-4); }
        .consult-workspace--overview .consult-thisvisit .consult-card-head { flex-wrap: wrap; min-width: 0; }
        .consult-workspace--overview .consult-thisvisit .consult-card-head > span { min-width: 0; max-width: 100%; }
        .consult-workspace--overview .consult-thisvisit .consult-savestate { white-space: normal; overflow-wrap: anywhere; }
        .consult-workspace--overview .consult-history-overview { padding: var(--ac-space-4); }
        .consult-workspace--overview .consult-history-overview > summary { cursor: pointer; display: flex; flex-wrap: wrap; gap: var(--ac-space-3); align-items: baseline; }
        .consult-workspace--overview .consult-history-overview > summary strong { color: hsl(var(--ac-brand)); }
        .consult-workspace--overview .consult-history-overview > summary span { overflow-wrap: anywhere; }
        .consult-workspace--overview .consult-history-overview[open] > summary { margin-bottom: var(--ac-space-3); }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card { box-shadow: none; border: 0; }
        .consult-workspace--overview .consult-intake-option-a__summary { display: grid; grid-template-columns: minmax(0, 1fr); gap: var(--ac-space-3); }
        .consult-workspace--overview .consult-intake-option-a__summary > :not(.consult-frow) { grid-column: 1 / -1; }
        .consult-workspace--overview .consult-intake-option-a__summary .consult-frow { display: block; border-bottom: 1px solid hsl(var(--ac-line)); }
        .consult-workspace--overview .consult-intake-option-a__summary .consult-frow > span { display: block; }
        .consult-workspace--overview .consult-history-overview > summary::before { content: '▸'; color: hsl(var(--ac-brand)); }
        .consult-workspace--overview .consult-history-overview[open] > summary::before { content: '▾'; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram { --tooth-curve: 0.3; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__arch { padding-inline: 4px; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__quadrant { flex: 1; min-width: 0; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__quadrant-teeth { display: grid; grid-auto-flow: column; grid-auto-columns: minmax(0, 1fr); }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__tooth { min-width: 0; width: 100%; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__tooth--midline { margin-left: 0; }
        .consult-workspace--overview .consult-teeth-card .tooth-diagram__anat { width: 100%; max-width: 34px; }
        .consult-workspace--overview :is(.consult-workspace__side, .consult-workspace__history) { min-width: 0; }
        .consult-workspace--overview .cockpit-plan__add-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (min-width: 600px) and (max-width: 1000px) {
          .consult-workspace--overview .consult-intake-option-a__summary { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card > .ac-section { border: 0; border-radius: 0; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card .ac-section__head { padding: var(--ac-space-3) 0; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card .consult-intake { padding: var(--ac-space-3) 0; gap: var(--ac-space-3); }
        .consult-workspace--overview .consult-intake-option-a__fields { min-width: 0; padding: 0; margin: 0; border: 0; }
        .consult-workspace--overview .consult-intake-option-a__fields { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 20px 24px; }
        .consult-workspace--overview .consult-intake-option-a__fields > :not([data-testid^="consult-intake-q-"]) { grid-column: 1 / -1; }
        .consult-workspace--overview .consult-intake-option-a__fields .p1-select { width: 100%; }
        .consult-workspace--overview .consult-intake-checkboxes { display: grid; gap: 6px; }
        .consult-workspace--overview .consult-intake-checkboxes label { display: flex; align-items: center; gap: 6px; font-weight: 400; }
        @media (max-width: 600px) { .consult-workspace--overview .consult-intake-option-a__fields { grid-template-columns: minmax(0,1fr); } }

        .consult-workspace--overview .consult-intake-option-a__summary .consult-frow { padding: var(--ac-space-2) 0; }
        .consult-workspace--overview .consult-intake-option-a__summary .consult-frow__l { text-transform: none; letter-spacing: 0; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card > .ac-section { padding: 0; }
        .consult-workspace--overview .consult-intake-option-a__summary { gap: 0; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card .ac-section__head { gap: var(--ac-space-2); margin: 0; flex-wrap: wrap; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card .ac-section__title { white-space: nowrap; }
        .consult-workspace--overview:not(.consult-workspace--v14g) .consult-intake-card .ac-section__head button { white-space: nowrap; }
        .consult-workspace--overview .consult-intake__summary-label { text-transform: none; letter-spacing: 0; }
        .consult-workspace--overview .consult-intake__confirm { margin-top: 0; gap: var(--ac-space-2); }
        .consult-workspace--overview .cockpit-course > .ac-section__embedded { padding: var(--ac-space-3) var(--ac-space-4); }
        .consult-workspace--overview .consult-nextvisit__choices > summary { cursor: pointer; color: hsl(var(--ac-brand)); }
        .consult-workspace--overview .consult-nextvisit__choices > summary strong { display: block; color: hsl(var(--ac-ink)); font-weight: 500; margin-top: var(--ac-space-1); }
        .consult-workspace--overview .consult-nextvisit__choices[open] > summary { margin-bottom: var(--ac-space-3); }
        .consult-workspace--overview .consult-workspace__clinical-stack,
        .consult-workspace--overview .consult-workspace__clinical-tail { display: contents; }
        .consult-workspace--overview .consult-workspace__clinical-tail > * { grid-column: 1 / -1; }
        /* Selected S39 executable: history, examination, plan. Opening the
           existing intake editor grants it the full row without losing content. */
        .consult-workspace--overview .consult-workspace__history { min-width: 0; }
        .consult-workspace--overview .consult-intake-option-a__summary { grid-template-columns: minmax(0, 1fr); }
        .consult-workspace--overview .consult-workspace__columns:has(.consult-history-overview[open] .consult-intake-option-a__fields) .consult-workspace__history { grid-column: 1 / -1; }
        .consult-workspace--overview .consult-workspace__columns:has(.consult-history-overview[open] .consult-intake-option-a__fields) .consult-workspace__main { grid-column: 1 / 3; }
        .consult-workspace--overview .consult-workspace__columns:has(.consult-history-overview[open] .consult-intake-option-a__fields) .consult-intake-option-a__summary { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (min-width: 760px) and (max-width: 1100px) {
          .consult-workspace--overview .consult-workspace__columns { grid-template-columns: minmax(0, 1fr) 258px; gap: 12px; }
          .consult-workspace--overview .consult-workspace__history { grid-column: 1 / -1; }
          .consult-workspace--overview .consult-workspace__columns:has(.consult-history-overview[open] .consult-intake-option-a__fields) .consult-workspace__main { grid-column: auto; }
          .consult-workspace--overview .consult-intake-option-a__summary { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        /* Approved C tablet editor: one quadrant per row, never sixteen
           compressed targets. Labels retain patient orientation in the wrap. */
        @media (min-width: 760px) and (max-width: 1100px) {
          .consult-workspace--overview .consult-workspace__columns .consult-teeth-card .tooth-diagram__arch { flex-direction: column; align-items: stretch; }
          .consult-workspace--overview .consult-workspace__columns .consult-teeth-card .tooth-diagram__arch-label { flex-basis: auto; }
          .consult-workspace--overview .consult-workspace__columns .consult-teeth-card .tooth-diagram__quadrant { margin-left: 0; flex-direction: column; }
          .consult-workspace--overview .consult-workspace__columns .consult-teeth-card .tooth-diagram__tooth { min-width: 0; min-height: 44px; }
          .consult-workspace--overview .consult-workspace__columns .consult-teeth-card .tooth-diagram__anat { max-width: 34px; }
        }
        .consult-workspace--overview [data-testid="consult-intake-locked"] .consult-frow { display: block; padding: 8px 0; }
        .consult-workspace--overview [data-testid="consult-intake-locked"] .consult-frow > span { display: block; }
        .consult-workspace--overview [data-testid="consult-intake-locked"] .consult-frow__l { text-transform: none; letter-spacing: 0; font-weight: 400; margin-bottom: 4px; }
        .consult-workspace--overview .consult-intake-option-a__actions { display: flex; gap: var(--ac-space-2); flex-wrap: wrap; align-items: center; }
        .consult-workspace--overview .consult-intake__confirm { align-items: flex-start; }
        .consult-workspace--overview .consult-intake__confirm > [data-testid="consult-intake-last-confirmed"] { display: block; flex-basis: 100%; color: hsl(var(--ac-ink-muted)); }
        @media (max-width: 759px) {
          .consult-workspace--overview .consult-workspace__columns { grid-template-columns: minmax(0, 1fr); }
          .consult-workspace--overview .consult-workspace__columns:has(.consult-history-overview[open] .consult-intake-option-a__fields) .consult-workspace__main { grid-column: auto; }
          .consult-workspace--overview .consult-masthead { flex-wrap: wrap; }
          .consult-workspace--overview .consult-masthead__dock { width: 100%; max-width: none; }
          .consult-workspace--overview :is(button, summary) { min-height: 2.75rem; }
        }
        .consult-workspace.consult-workspace--overview .cockpit-course .cockpit-plan__list .cockpit-plan__row { grid-template-columns: minmax(0, 1fr); }
        .consult-workspace--overview .consult-workspace__side :is(.cockpit-plan__row-main, .cockpit-plan__decided, .cockpit-plan__decide) { min-width: 0; max-width: 100%; overflow-wrap: anywhere; }
        /* S39: existing task, consent and completion controls in the approved regions. */
        .consult-workspace--overview .consult-today-task { border-left: 4px solid hsl(var(--ac-brand)); margin-bottom: 16px; }
        .consult-workspace--overview .consult-today-task .next-action-bar { margin: 0; }
        .consult-workspace--overview [data-testid="consult-close"] .clinic-workbench__actions { justify-content: flex-end; }
      `}</style>
      {/* DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (CANDIDATE-B-PIXELS-WIN): the
          page-title block is retired -- the candidate-b case sheet opens on
          the patient masthead, not a screen name. The breadcrumb trail
          stays (compact); the h1 is the patient name in the masthead; the
          lifecycle chip rides the masthead idline; the two-channel line
          moved to the quiet page foot. */}
      {props.shellSearchSlot}

      {notice !== null && context.todaysAppointmentId !== null ? (
        <div
          className="consult-workspace__notice"
          role="alert"
          data-testid="consult-todays-notice"
        >
          <span>{notice}</span>
          <AcButton
            size="sm"
            variant="primary"
            onClick={() => onOpenToday(context.todaysAppointmentId as number)}
            data-testid="consult-open-todays"
          >
            Open today&apos;s visit
          </AcButton>
        </div>
      ) : null}

      {/* THE COCKPIT MASTHEAD ROW: identity left, the NEXT dock top-right
          (candidate-b masthead anatomy). The NEXT band is the SAME
          NextActionBar carrying the SAME #511 ladder label -- docked, not
          restacked; it renders exactly when it did before (open visit,
          start not blocked). */}
      {startBlocked !== null ? patientHeader : null}

      {/* DOCTOR-INTAKE-ONE-FLOW-V1 (R3a): the display-only reason-for-visit
          header line is REMOVED -- the reason has ONE home now: the FIRST
          visible question of the Patient intake panel (it IS the chief
          complaint), mirrored read-only in the Doctor's record rail. */}

      {/* THE CONVERSION MOMENT (LEAD-UNTIL-CONSULT ruling item 3): a
          one-time dismissible band when THIS start minted patient + UMR. */}
      {convertedBanner !== null ? (
        <ConsultConvertedBanner
          umr={convertedBanner.umr}
          onDismiss={onDismissConverted ?? (() => undefined)}
        />
      ) : null}

      {/* CONSULT-START-TRUTH-V1 (W-31): a lost/refused/no-op start signal is
          NAMED here with its retry door -- the workspace still opens, but a
          dead conversion is never silent again. */}
      {startTrouble !== null && startTrouble !== undefined ? (
        <ConsultStartTroubleBanner
          trouble={startTrouble}
          pending={startRetryPending}
          onRetry={onRetryStart ?? (() => undefined)}
        />
      ) : null}

      {/* The MEDICAL-SAFETY STRIP (brief s.7.3 item 1): the R-MED
          safety-flagged patient-reported answers as read-only chips, right
          under the WHO banner -- risk reads first. Composed from the intake
          panel's ONE fetch; S9: never a blocking acknowledgement. */}

      {startBlocked !== null ? (
        // B2 BLOCKED STATE: the consult cannot start (409 from the start
        // act) -- the blocked panel REPLACES the working surface so the
        // doctor never charts against an unstartable visit. The server
        // message renders VERBATIM; the one door leads back Home.
        <><ConsultStartBlockedPanel
          blocked={startBlocked}
          onBackToHome={onBackToQueue}
        /><p className="consult-workspace__channel-note">Clinical record · not shared over WhatsApp.</p></>
      ) : (
        <>
          {preconsultSlot ?? null}

          {feedback?.kind === 'error' ? <FeedbackBanner feedback={feedback} /> : null}
          <ConsultStages startAdditions={props.startAdditions} stageStatuses={stageStatuses} questionsTitle={props.questionsPresentation==='summary'?'Before you start':'Questions'} notice={props.finalizedAdditions?.enabled?<div className="consult-workspace__notice consult-v14g__completion-notice" data-testid="finalized-additions-state"><p>Original visit recorded {sheet?formatIstDate(sheet.createdAt):''} · {sheet?.authoredByRole}. Recorded entries stay read only. Missing information is added with today's date.</p>
            {props.finalizedAdditions.loading?<p role="status">Loading later entries…</p>:null}
            {props.finalizedAdditions.error?<><p role="alert">{props.finalizedAdditions.error}</p><AcButton onClick={()=>void props.finalizedAdditions?.reload()}>Check again</AcButton></>:null}
          </div>:null} finishStatus={<span data-testid="consult-finish-open-items">{finishCount===null?'Checking visit…':`${finishCount} open item${finishCount===1?'':'s'}`}</span>} footerSummary={estimateFooter} header={patientHeader} scopeKey={props.stageScopeKey ?? `${context.appointment.id}:${context.patient.patientId ?? ''}`}
            headingAction={(stage,go)=>{stageNavigation.current=go;return stage===3 && sheet?.status!=='finalized' ? <AcButton variant="secondary" disabled={busy!==null} onClick={()=>go(2)}>Add treatment on the chart</AcButton> : null;}}
            finalized={sheet?.status === 'finalized'} additions={props.finalizedAdditions?.editable} additionStage={missingAdditionStage} busy={busy !== null || props.finalizedAdditions?.boundary.pending() === true}
            footerNote={<p className="consult-workspace__channel-note">Clinical record · not shared over WhatsApp.</p>}
            examinationSummary={examinationSummary} onSave={props.onSaveStage} discard={props.stageDiscard} saveStatus={<>{stageSaveState.kind === 'idle' ? 'Saved answers move into the bar at the top.' : <SaveStateIndicator state={stageSaveState} />}{feedback?.kind === 'success' ? <span className="sr-only">{feedback.lines.join(' ')}</span> : null}</>}>
            {(go, finishActionHost, completing, beginAdditions) => [
              <div key="questions" className="consult-v14g__questions">
                <p className="consult-v14g__intro" data-testid="consult-next-action" title={nextActionLabel}>{props.questionsPresentation==='summary'?'Check today’s reason and confirm nothing has changed since the last visit.':'Ask these first, the same order as the paper case sheet. When you save, they move into the bar above.'}</p>
                <section data-testid="consult-history-overview" aria-label="History and safety">{typeof intakeSlot === 'function' ? intakeSlot(questionDetails) : <>{intakeSlot ?? null}{questionDetails}</>}</section>

              </div>,
              <ConsultExamination key="examination" toothEntry={toothEntry} readOnly={sheet?.status === 'finalized'} recordedExamination={props.finalizedAdditions?.enabled?props.finalizedAdditions.saved.examination:undefined} treatmentReadOnly={props.finalizedAdditions?.enabled} investigations={props.investigationWorkspace ? {...props.investigationWorkspace,onRead:onInvestigationRead}:undefined}
                selected={form.toothRefs} onSelect={teeth => onFormChange({ ...form, toothRefs: teeth })}
                examination={form.examination ?? null} onChange={examination => onFormChange({ ...form, examination })}
                available={context.examinationAvailable === true} disabled={busy !== null || (sheet?.status === 'finalized' && !props.finalizedAdditions?.editable) || props.finalizedAdditions?.boundary.pending() === true}
                planItems={sheet?.planItems ?? []} activeCoursePlanItems={props.activeCoursePlanItems} catalog={catalog}
                findingOptions={context.findingOptions?.map(option => option.label) ?? []}
                frequentTreatmentCodes={context.frequentTreatmentCodes ?? []}
                onAddTreatment={props.onAddExaminationTreatment ?? (async () => false)}
                onReviewPlan={() => go(3)} onRemovalHost={bindExaminationRemovalHost} previousSlot={props.previousPlanSlot} previousRecords={props.previousRecords}
                legacySlot={sections.some(section => section.field === 'examinationFindings' || section.field === 'findingsDiagnosis') ? <details className="consult-v14g__supplemental">
                  <summary>Additional examination notes</summary>
                  <StructuredSheetSection sheet={sheet} form={form} notesOnly title="Examination notes" testId="consult-examination-notes"
                    sections={sections.filter(section => section.field === 'examinationFindings' || section.field === 'findingsDiagnosis')}
                    followUpOptions={followUpOptions} complaintOptions={complaintOptions} diagnosisOptions={diagnosisOptions}
                    busy={busy} saveState={saveState} onFormChange={onFormChange} toothEntry={toothEntry} additions={props.finalizedAdditions} />
                </details> : null}
                evidenceSlot={evidenceSlot || attachmentsEnabled === false ? <div data-testid="consult-evidence-group">
                  {attachmentsEnabled === false ? <SectionShell title="X-rays, photos & case-sheet scan"><p data-testid="consult-attachments-unavailable">Attachments unavailable.</p></SectionShell> : null}
                  {evidenceSlot}
                </div> : null} />,
              <div key="plan" className="consult-workspace__side">
              {sheet !== null ? (
                <div className="consult-spine" data-testid="consult-spine">
                  {/* Correction 1 + ruled CONFLICT (a): journey header +
                      course-wide ledger + rollup compose as ONE course
                      card. */}
                  <DoctorConsultationBlock key={props.stageScopeKey} value={props.consultationValue} draftOwner={props.planDraftOwner} onLockChange={props.onConsultationLockChange} appointmentId={context.appointment.id}
                    reload={props.reloadConsultation ?? (async()=>{throw new Error('Fee unavailable');})}
                    renderPlan={({fee,course,discount,draft}) => (
                  <TreatmentAdvisedSection
                    consultationDoctor={consultationDoctorLabel(savedVisitDoctorLabels(sheet, context.attribution).conversion, sheet.status, context.clinicDoctors?.find(doctor => doctor.id === props.currentDoctorId)?.name)} investigations={currentInvestigations} todayValue={props.consultationValue} todayActions={fee} todayDiscount={discount} todayDraft={draft} courseActions={course}
                    earlierEstimatesSlot={props.earlierEstimatesSlot} onPrintEstimate={onPrintEstimate}
                    planDiscounts={props.planDiscounts} courseKnown={!awaitingCourse} onEstimate={onEstimate} onSavedExtra={onSavedExtra}
                    compact
                    display="plan"
                    onEarlierPlanAccepted={props.onEarlierPlanAccepted}
                    planDraftOwner={props.planDraftOwner}
                    sheet={sheet}
                    finalizedAdditions={props.finalizedAdditions}
                    examination={form.examination} onFindingChange={examination=>onFormChange({...form,examination})} onFindingTreatment={toothCode=>{onFormChange({...form,toothRefs:[toothCode]});go(2);}}
                    itemForm={itemForm}
                    busy={busy}
                    catalog={catalog}
                    onItemFormChange={onItemFormChange}
                    onAddItem={onAddItem}
                    onLineWrite={onLineWrite} onRemoveItem={props.onRemoveItem} examinationRemovalHosts={examinationRemovalHosts}
                    onLineSettled={onLineSettled}
                    toothEntry={toothEntry}
                    seedToothRefs={form.toothRefs}
                    journeySlot={journeySlot}
                    courseRows={courseRows}
                    completionAvailable={false}
                    doctorAssign={doctorAssign}
                    rollupSlot={
                      /* CLINICAL-BEFORE-MONEY (law 2b): the rollup renders
                         only after at least one treatment line exists --
                         placement moved by the ruled CONFLICT (a); the law
                         holds. */
                      sheet.planItems.length > 0 ? (
                        <EstimationSummary
                          sheet={sheet}
                          payments={context.paymentsForVisit}
                          paidAllVisitsMinorUnits={paidAllVisitsMinorUnits}
                          onPrintEstimate={onPrintEstimate}
                        />
                      ) : null
                    }
                  />
                    )} />
                </div>
              ) : null}

              </div>,
              <div key="care" className="consult-v14g__care">
                <section className="consult-v14g__card" data-testid="consult-treatment-consent" aria-labelledby="consult-treatment-consent-heading">
                  <h3 id="consult-treatment-consent-heading">1 · Treatment consent <span>One form for all the treatments the patient accepted</span></h3>
                  <div hidden={!currentAccepted && (earlierAccepted || awaitingCourse)}>{sheet === null ? <p>Nothing accepted yet, so no treatment consent is needed.</p> : consentSlot ?? <p role="status">Treatment consent is unavailable.</p>}</div>
                  {!currentAccepted && awaitingCourse ? <p role="status">{props.courseLoadState === 'error' ? 'Earlier treatment could not be loaded.' : 'Loading saved treatment…'}</p> : null}
                  <EarlierTreatmentConsents key={`${context.appointment.id}:${context.patient.patientId}`} rows={courseRows} read={earlierConsents} patient={context.patient} draftOwner={props.planDraftOwner} enabled={attachmentsEnabled===true} toothDisplay={toothEntry?.display ?? 'fdi'} visitStartedAt={sheet?.createdAt ?? context.appointment.appointmentTime} clinicDoctors={context.clinicDoctors ?? []} />
                </section>
                <ClinicalTodayWork key={props.stageScopeKey??`${context.appointment.id}:${context.patient.patientId}`}
                  clinicDoctors={context.clinicDoctors??[]} currentDoctorId={props.currentDoctorId}
                  workspace={{identity:props.stageScopeKey??`${context.appointment.id}:${context.patient.patientId}`,caseSheetId:sheet?.id??null,finalized:sheet?.status==='finalized',draftOwner:props.planDraftOwner,onRead:props.onTodayWorkRead,onSaved:props.onTodayWorkSaved}}
                  rows={[...(courseRows??[]),...(sheet?.planItems??[]).map(item=>({owningSheetId:sheet!.id,item}))].filter(row=>row.item.status==='accepted').map(({owningSheetId,item})=>{
                    const wire=owningSheetId===sheet?.id?props.treatmentConsents:earlierConsents.wires[owningSheetId];
                    const signed=wire?.consents.some(consent=>consent.purpose==='treatment'&&(consent.state==='signed_digital'||consent.state==='signed_physical_captured')&&consent.treatmentPlanItemIds.includes(item.id))===true;
                    return {owningSheetId,id:item.id,procedureName:item.procedureName,performingDoctorId:item.performingDoctorId,completedAt:item.completedAt,completedInCaseSheetId:item.completedInCaseSheetId,
                      location:[item.toothArea,...(item.toothRefs??[]).map(ref=>savedToothRefLabel(ref,toothEntry?.display??'fdi'))].filter(Boolean).join(' · '),
                      toothLabel:(item.toothRefs??[]).map(ref=>(toothEntry?.display??'fdi')==='fdi'?ref.toothCode:savedToothRefLabel(ref,'universal')).join(', ')||item.toothArea||null,
                      consentReady:wire?.available===true&&(wire.requiredForProcedure===false||signed),consentReason:!wire?'Checking signed consent…':!wire.available?'Consent status is unavailable.':'Upload the signed treatment consent first.'};
                  })}
                  completionUnavailable={completionAvailable!==true}
                  disabled={busy!==null||completionAvailable!==true||(sheet?.status==='finalized'&&!props.finalizedAdditions?.editable)} patientLabel={context.patient.patientName??'Patient record'} clinicLabel={context.appointment.clinicName??'Clinic unavailable'} visitDate={context.appointment.appointmentTime}/>

              {props.prescriptionSlot ?? <SectionShell title="Prescription" testId="consult-prescription-status">
                <div className="consult-frow__wrap">
                  <span className="consult-frow__v consult-frow__v--empty" data-testid="consult-prescription-value">&mdash;</span>
                  <span className="consult-frow__sub">Prescription status unavailable.</span>
                </div>
              </SectionShell>}

              </div>,
              <div key="finish" className="consult-workspace__clinical-tail consult-v14g__finish">
                {sheet?.status==='finalized'?<>{closeStrip(finishActionHost)}<DoctorVisitPending key={`${visitStageIdentity}:${sheet.id}`} caseSheetId={sheet.id} appointmentId={context.appointment.id} patientId={context.patient.patientId} clinicId={context.appointment.clinicId} owner={props.planDraftOwner} onSaved={props.onPendingSaved} onFill={()=>beginAdditions(missingAdditionStage)}/></>:null}
                <div className="consult-v14g__finish-editing" hidden={sheet?.status==='finalized'&&!completing}>
                {props.finalizedAdditions?.enabled?<SavedClinicalAdditions additions={props.finalizedAdditions.additions} doctors={context.clinicDoctors} plans={sheet?.planItems}/>:null}
                <FinishReview questions={props.finishQuestions} context={context} sheet={sheet} form={form}
                  rows={courseRows} courseKnown={!awaitingCourse} consents={props.treatmentConsents ?? null} earlier={earlierConsents}
                  estimate={currentEstimate} planPending={props.finishPlanPending ?? false} prescriptionPending={props.finishPrescriptionPending ?? false}
                  todayWork={props.todayWork} todayWorkPending={props.todayWorkPending??false}
                  investigations={currentInvestigations} evidenceSource={props.investigationWorkspace?.evidenceSource}
                  busy={busy !== null} go={go} paper={props.paperCapture} onOpenItems={onFinishItems} />
                {nextVisitSlot ?? null}
                <ClinicalFinishReview key={`${context.appointment.id}:${context.patient.patientId}`} sheet={sheet} form={form} available={context.finishReviewAvailable===true}
                  busy={busy!==null} onFormChange={onFormChange} courseKnown={!awaitingCourse} courseRows={courseRows} todayWork={props.todayWork??null}
                  note={<><StructuredSheetSection finishNote notesOnly sheet={sheet} form={form}
                    sections={sections.filter(section=>section.field==='clinicalNote')} followUpOptions={followUpOptions}
                    complaintOptions={complaintOptions} diagnosisOptions={diagnosisOptions} busy={busy} saveState={saveState} onFormChange={onFormChange} additions={props.finalizedAdditions}/>
                    {context.attribution?.available===true?<details className="consult-v14g__supplemental" data-testid="consult-doctor-record-details"><summary>Doctor’s record</summary><StructuredSheetSection sheet={sheet} form={form} notesOnly
                      title="Doctor’s record" sections={[]} followUpOptions={followUpOptions} complaintOptions={complaintOptions}
                      diagnosisOptions={diagnosisOptions} busy={busy} saveState={saveState} onFormChange={onFormChange}
                      attribution={context.attribution} showAttribution/></details>:null}
                    {sheet?.status!=='finalized'?closeStrip(finishActionHost):null}</>} />
          {props.printoutsSlot ?? null}
                </div>
              </div>,
            ]}
          </ConsultStages>
        </>
      )}
      {/* Optional presentation seam retained for existing callers. The clinic
          page no longer supplies a future-phase footer (2026-10-05 ruling). */}
      {seamsSlot ?? null}
    </div>
  );
}

// --- Stateful wirer (default export) --------------------------------------------

const OUTCOME_DEPS: OutcomeRecordDeps = {
  markTreatmentAdvised,
  markTreatmentAccepted,
  markTreatmentDeclined,
  advanceLeadStageBackHalf,
};

/** The ONE-CLOSE orchestrator's injected domain ops -- each an EXISTING
 *  audited write (no new endpoint, no new write semantics). recordVisitOutcome
 *  reuses the back-half recordOutcome; the doctor never advances the coc-only
 *  `patient` stage (advancePatientStage: false). */
const CLOSE_DEPS: CloseVisitDeps = {
  fulfil: (appointmentId) => markAppointmentFulfilled(appointmentId),
  recordVisitOutcome: (action, appointmentId, declineReason) =>
    recordOutcome(OUTCOME_DEPS, {
      action,
      appointmentId,
      declineReason,
      declineReasonLabel:
        declineReason !== '' ? outcomeReasonLabel(declineReason) : '',
      advancePatientStage: false,
    }).then((r) => r.feedback),
  markConverted: (appointmentId) => markLeadConverted(appointmentId),
  markNotConverted: (appointmentId, reason) =>
    markAppointmentNotConverted(appointmentId, reason),
  finalize: (caseSheetId) => updateCaseSheet(caseSheetId, { status: 'finalized' }),
  errorText: (err) => consultErrorMessage(err).text,
  errorCode: (err) =>
    err !== null &&
    typeof err === 'object' &&
    'code' in err &&
    typeof (err as { code?: unknown }).code === 'string'
      ? (err as { code: string }).code
      : null,
};

function deriveItemEdits(
  sheet: CaseSheetClinicalView,
): Record<number, PlanItemEdit> {
  const edits: Record<number, PlanItemEdit> = {};
  for (const it of sheet.planItems) {
    edits[it.id] = {
      status: it.status,
      declineReason: it.declineReason ?? '',
      itemNote: it.itemNote ?? '',
    };
  }
  return edits;
}

// Local optional wire extension while P2 owns the shared API type assembly.
export type DoctorConsultationState =
  | { readonly kind: 'unavailable' }
  | {
      readonly kind: 'ready';
      readonly contextKey: string;
      readonly bill: ConsultationActionsProps['bill'];
      readonly course: (NonNullable<ConsultationActionsProps['course']> & {readonly activity?: ConsultationActivityDisplay | null}) | null;
      readonly hints: ConsultationActionsProps['hints'];
      readonly view: {
        readonly eligibility?: { readonly kind: 'free'; readonly amountMinorUnits: 0 } | { readonly kind: 'charge'; readonly amountMinorUnits: number } | { readonly kind: 'unresolved'; readonly reason: string };
        readonly financialSource: 'saved_line' | 'eligibility' | 'unavailable';
        readonly financials: { readonly grossMinorUnits: number; readonly waivedMinorUnits: number; readonly netMinorUnits: number } | null;
        readonly activity: ConsultationActivityDisplay | null;
        readonly reversalActivity: ConsultationActivityDisplay | null;
        readonly amountAdjustment?: {
          readonly originalAmountMinorUnits: number;
          readonly version: number;
          readonly lastActivity: { readonly actorDisplayName?: string | null; readonly reason?: string | null; readonly reasonRecorded?: boolean | null; readonly before_amount: number; readonly after_amount: number; readonly actor_staff_user_id: number; readonly actor_role: string; readonly occurred_at: string; readonly request_id: string } | null;
        } | null;
      };
    };
/** A zero amount is not a classification. Preserve the saved financial snapshot
 * when current eligibility differs, and never call a waiver a free follow-up. */
function isFreeConsultationFollowUp(value: DoctorConsultationState | undefined): boolean {
  return value?.kind === 'ready' && value.view.eligibility?.kind === 'free' &&
    value.view.financialSource !== 'unavailable' && value.view.financials?.grossMinorUnits === 0 &&
    value.view.financials.netMinorUnits === 0 && value.bill?.waived !== true;
}
type ConsultContextWithConsultation = DoctorConsultContext & {
  readonly consultation?: DoctorConsultationState;
};

/** A local editor over the one versioned consultation-fee writer. An unanswered
 * attempt remains immutable and blocks restore; an old GET cannot prove it failed. */
function useConsultationFeeDraft(value: DoctorConsultationState | undefined, appointmentId: number,
  reload: () => Promise<void>, owner: PlanDraftOwner | undefined, sharedLocked: boolean) {
  const [raw, setRaw] = useState<string | null>(null);
  const [reason, setReason] = useState<string | null>(null);
  const [writingOff, setWritingOff] = useState(false);
  const reasonInput = useRef<HTMLInputElement>(null);
  const undoWriteOff = useRef<null | (() => void)>(null);
  const [mode, setMode] = useState<(typeof PLAN_DISCOUNT_UNITS)[number] >(PLAN_DISCOUNT_UNITS[0]);
  const [convertedAmount, setConvertedAmount] = useState<{ mode:(typeof PLAN_DISCOUNT_UNITS)[number]; shown:string; amount:number } | null>(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [needsRead, setNeedsRead] = useState(false);
  const [attemptPresent, setAttemptPresent] = useState(false);
  const attempt = useRef<{body: ConsultationFeeAmountInput | {action:'waive_fee';billId:number;reason:string}; bearer: string; acknowledged: boolean; uncertain: boolean} | null>(null);
  const inFlight = useRef(false);
  const lastScope = useRef({ appointmentId, key: value?.kind === 'ready' ? value.contextKey : String(appointmentId) });
  if (lastScope.current.appointmentId !== appointmentId) lastScope.current = { appointmentId, key: String(appointmentId) };
  if (value?.kind === 'ready') lastScope.current.key = value.contextKey;
  // An unavailable read is not an identity change and cannot erase a sent request.
  const scope = lastScope.current.key;
  const active = useRef({ scope, generation: 0 });
  if (active.current.scope !== scope) active.current = { scope, generation: active.current.generation + 1 };
  useEffect(() => { setRaw(null); setReason(null); setWritingOff(false); undoWriteOff.current=null; setMode(PLAN_DISCOUNT_UNITS[0]); setConvertedAmount(null); setBusy(false); setMessage(null); setNeedsRead(false); setAttemptPresent(false); attempt.current = null; inFlight.current = false;
    return () => { active.current.generation++; }; }, [scope]);
  const ready = value?.kind === 'ready' ? value : null;
  const basis = ready?.view.amountAdjustment;
  const original = basis?.originalAmountMinorUnits ?? null;
  const saved = ready?.view.financials?.netMinorUnits ?? null;
  const eligible = Boolean(ready?.bill?.status === 'draft' && ready.bill.feeRecorded && !ready.bill.waived && ready.hints.canWaive && basis && Number.isSafeInteger(basis.version) && original !== null && original > 0);
  const savedDiscount = original !== null && saved !== null ? original - saved : null;
  const shown = raw ?? (savedDiscount ? String(mode === PLAN_DISCOUNT_UNITS[0] ? savedDiscount / 100 : Number((savedDiscount * 100 / original!).toFixed(2))) : '');
  // Switching display units must not change a paise through percent rounding.
  // The quoted fee stays canonical until the input is actually edited.
  const converted = raw !== null && convertedAmount?.mode === mode && convertedAmount.shown === raw ? convertedAmount : null;
  const amount = converted ? converted.amount : original === null ? null : consultationAmountFromDiscount(original, shown, mode);
  const savedReason = ready?.bill?.waived ? ready.view.activity?.reason ?? null : basis?.lastActivity?.reason ?? null;
  const shownReason = reason ?? savedReason ?? '';
  const draftAmount = writingOff ? 0 : amount;
  const dirty = attemptPresent || writingOff || (raw !== null && (amount === null || amount !== saved)) || (reason !== null && reason.trim() !== (savedReason ?? ''));
  useEffect(() => { if (writingOff) reasonInput.current?.focus(); }, [writingOff]);
  const locked = busy || attemptPresent || needsRead;
  const writeOff = () => {
    if (locked || sharedLocked || !eligible || ready?.bill?.reversed) return;
    undoWriteOff.current = () => { setRaw(raw); setReason(reason); setMode(mode); setConvertedAmount(convertedAmount); };
    setWritingOff(true); setMessage(null);
  };
  const undo = () => {
    if (locked || sharedLocked) return;
    undoWriteOff.current?.(); undoWriteOff.current=null; setWritingOff(false); setMessage(null);
    requestAnimationFrame(() => document.getElementById('consult-fee-discount')?.focus());
  };
  const commit = async (): Promise<boolean> => {
    if (inFlight.current || sharedLocked || needsRead) return false;
    if (!attempt.current && (!eligible || draftAmount === null || (draftAmount === 0 && !writingOff))) {
      setMessage(draftAmount === 0 ? 'Use Write off and add a reason for the full fee.' : 'Enter a discount up to the original fee.');
      document.getElementById('consult-fee-discount')?.focus(); return false;
    }
    if (!attempt.current && original !== null && draftAmount !== null && draftAmount < original && !shownReason.trim()) {
      setMessage(writingOff ? 'Add a reason for the write-off.' : 'Add a reason for the discount.'); reasonInput.current?.focus(); return false;
    }
    const generation = active.current.generation;
    const current = () => active.current.generation === generation;
    inFlight.current = true; setBusy(true); setMessage(null);
    try {
      let pending = attempt.current;
      if (!pending) {
        const bearer = await authBearer();
        if (!current()) return false;
        if (!bearer) throw new Error('Session unavailable');
        pending = { body: writingOff
          ? { action:'waive_fee', billId:ready!.bill!.id, reason:shownReason.trim() }
          : { action: 'set_fee_amount', billId: ready!.bill!.id, amountMinorUnits: draftAmount!, expectedVersion: basis!.version, requestId: crypto.randomUUID(), reason: original !== null && draftAmount! < original ? shownReason.trim() || null : null },
          bearer, acknowledged: false, uncertain: false };
        attempt.current = pending; setAttemptPresent(true);
      }
      if (!pending.acknowledged) {
        try { await setConsultationFeeAmount(appointmentId, pending.body, pending.bearer); }
        catch (error) {
          // A lost waiver receipt followed by its legitimate reversal cannot be
          // replayed by the sealed waiver writer. Verify the original event,
          // then reload current truth; never write the old waiver over reversal.
          if (pending.body.action !== 'waive_fee' || !pending.uncertain || !(error instanceof PortalApiError) || error.status !== 409) throw error;
          if (await authBearer() !== pending.bearer) throw error;
          const checked = (await fetchDoctorConsultContext(appointmentId) as ConsultContextWithConsultation).consultation;
          if (!current() || await authBearer() !== pending.bearer || checked?.kind !== 'ready' || checked.contextKey !== scope
            || checked.bill?.id !== pending.body.billId || !checked.bill.originalActor || checked.view.activity?.reason !== pending.body.reason) throw error;
        }
        if (!current()) return false;
        pending.acknowledged = true;
      }
      // A replay receipt can precede a later legitimate edit. Only fresh context
      // may populate the row/footer/print; never apply the receipt's old amount.
      await reload();
      if (!current()) return false;
      attempt.current = null; setAttemptPresent(false); setRaw(null); setReason(null); setWritingOff(false); undoWriteOff.current=null; setNeedsRead(false); setMessage(null); return true;
    } catch (error) {
      if (!current()) return false;
      const pending = attempt.current;
      const refused = error instanceof PortalApiError && error.status >= 400 && error.status < 500;
      if (refused && pending && !pending.acknowledged && !pending.uncertain) {
        attempt.current = null; setAttemptPresent(false);
        setNeedsRead(error.status === 409 || error.status === 401 || error.status === 403);
        setMessage(consultErrorMessage(error).text);
      } else {
        if (pending) pending.uncertain = true;
        setMessage(pending?.acknowledged ? 'Fee saved. Reload the current fee before continuing.' : 'Save not confirmed. Retry the same fee change before continuing.');
      }
      return false;
    } finally { if (current()) { inFlight.current = false; setBusy(false); } }
  };
  const check = async () => {
    if (inFlight.current || attempt.current) return;
    const generation = active.current.generation; inFlight.current = true; setBusy(true);
    try { await reload(); if (generation === active.current.generation) { setNeedsRead(false); setMessage('Saved fee reloaded. Review your discount before saving again.'); } }
    catch { if (generation === active.current.generation) setMessage('Fee could not be checked. Your discount is still here.'); }
    finally { if (generation === active.current.generation) { inFlight.current = false; setBusy(false); } }
  };
  usePlanControlDraft(owner, `consultation-fee-${scope}`, { dirty, signature: JSON.stringify([raw, mode, reason, writingOff, scope]), pending: locked,
    commit, reset: () => { setRaw(null); setReason(null); setWritingOff(false); setConvertedAmount(null); undoWriteOff.current=null; setMessage(null); setNeedsRead(false); } });
  const control = !eligible && !dirty && !locked ? (ready?.bill?.waived ? <div><span>Written off</span><small>{savedReason ?? 'Reason unavailable'}</small></div> : null) : <div data-testid="consult-fee-editor" aria-busy={busy}>
    {writingOff ? <div className="consult-v14g__fee-writeoff"><AcBadge tone="neutral">Written off</AcBadge><AcButton size="sm" variant="ghost" disabled={locked || sharedLocked} onClick={undo}>Undo</AcButton></div> : <div className="consult-v14g__discount"><div role="group" aria-label="Consultation discount in rupees or percent">
      {PLAN_DISCOUNT_UNITS.map(unit => <AcButton key={unit} size="sm" variant="ghost" aria-pressed={mode===unit} disabled={!eligible || locked || sharedLocked}
        onClick={() => { const currentAmount = amount; setMode(unit); if (raw !== null && original !== null && currentAmount !== null) { const next = String(unit === PLAN_DISCOUNT_UNITS[0] ? (original-currentAmount)/100 : Number(((original-currentAmount)*100/original).toFixed(2))); setRaw(next); setConvertedAmount({mode:unit,shown:next,amount:currentAmount}); } }}>{unit}</AcButton>)}
    </div><input id="consult-fee-discount" aria-label="Discount for Consultation" type="text" inputMode="decimal" value={shown} placeholder="0" disabled={!eligible || locked || sharedLocked}
      aria-invalid={amount===null || undefined} aria-description={converted && mode==='%' ? 'Rounded percentage. The quoted fee is kept until you edit this value.' : undefined} onChange={event => { setConvertedAmount(null); setRaw(event.target.value); setMessage(null); }} /></div>}
    {!writingOff && !locked && eligible && !ready?.bill?.reversed ? <AcButton size="sm" variant="ghost" disabled={sharedLocked} onClick={writeOff}>Write off</AcButton> : null}
    {draftAmount !== null && original !== null && draftAmount < original ? <AcInput ref={reasonInput} aria-label={writingOff?'Reason for writing off Consultation':'Reason for discounting Consultation'}
      placeholder={writingOff?'Reason for writing off':'Reason for the discount'} value={shownReason} maxLength={1000} disabled={!eligible || locked || sharedLocked}
      aria-invalid={Boolean(message && !shownReason.trim()) || undefined} onChange={event => { setReason(event.target.value); setMessage(null); }} /> : null}
    {dirty && draftAmount !== null ? <small>Not saved · quoted {rupeesFromMinorLabel(draftAmount)}</small> : null}
    {!writingOff && amount === null && raw !== null ? <p role="alert">Enter a discount up to {original === null ? 'the original fee' : rupeesFromMinorLabel(original)}.</p> : null}
    {message ? <p role="alert">{message}</p> : null}
    {busy ? <small role="status">Saving or checking fee…</small> : null}
    {attemptPresent ? <AcButton size="sm" disabled={busy || sharedLocked} onClick={() => void commit()}>{attempt.current?.acknowledged ? 'Reload current fee' : 'Retry same fee change'}</AcButton> : needsRead ? <AcButton size="sm" disabled={busy || sharedLocked} onClick={() => void check()}>Reload saved fee</AcButton> : null}
  </div>;
  return { locked, control, managesFee:eligible || dirty || locked, draft: { dirty, amount:draftAmount } };
}

/** Approved consultation rail composition; never a generic bill-line editor. */
export function DoctorConsultationBlock({ value, appointmentId, reload, renderPlan, onLockChange, draftOwner }: {
  readonly onLockChange?: (locked:boolean)=>void;
  readonly draftOwner?: PlanDraftOwner;
  readonly renderPlan?: (sections:{fee:React.ReactNode;course:React.ReactNode;discount?:React.ReactNode;draft?:{dirty:boolean;amount:number|null}}) => React.ReactNode;
  readonly value?: DoctorConsultationState;
  readonly appointmentId: number;
  readonly reload: () => Promise<void>;
}): JSX.Element | null {
  const [refreshing, setRefreshing] = useState(false);
  const [sharedLocked, setSharedLocked] = useState(false);
  const feeDraft = useConsultationFeeDraft(value, appointmentId, reload, draftOwner, sharedLocked);
  useEffect(() => { onLockChange?.(sharedLocked || feeDraft.locked); }, [onLockChange, sharedLocked, feeDraft.locked]);
  // Chair-side density belongs to this host, not the shared Money controls.
  const controlsStyle = <style>{`
    .consult-v14g__fee-boundary { border: 0; padding: 0; margin: 0; min-width: 0; }
    [data-testid="consultation-actions"] { display: grid; gap: var(--ac-space-3); }
    :is([data-testid="consultation-fee-actions"], [data-testid="consultation-course-actions"]) :is(button, input) { min-height: 44px; }
    [data-testid="consultation-fee-actions"], [data-testid="consultation-course-actions"] { display: flex; flex-wrap: wrap; gap: var(--ac-space-2); }
    [data-testid="consultation-fee-actions"] > :not(button), [data-testid="consultation-course-actions"] > :not(button) { flex-basis: 100%; }
  `}</style>;
  if (value === undefined && !renderPlan) return null;
  if (value === undefined || value.kind === 'unavailable') { const unavailable = <SectionShell title="Consultation fee" testId="consultation-fee">
    {controlsStyle}<ErrorState title="Fee unavailable" detail="Check the saved fee." />
    <AcButton disabled={refreshing} onClick={() => { setRefreshing(true); void reload().catch(() => {}).finally(() => setRefreshing(false)); }}>{refreshing ? 'Checking…' : 'Check saved fee'}</AcButton>
  </SectionShell>; return renderPlan ? <>{renderPlan({fee:unavailable,course:null,discount:feeDraft.control,draft:feeDraft.draft})}</> : unavailable; }
  const amounts = value.view.financials;
  const course=value.course;
  const closed=course?.status==='completed'||course?.status==='abandoned';
  const feeStatus=value.bill?.reversed?'Last confirmed · Reversed':value.bill?.waived?'Last confirmed · Waived':value.bill?.feeRecorded?'Last confirmed':'Not recorded';
  return <>{controlsStyle}<ConsultationActions key={value.contextKey} contextKey={value.contextKey} appointmentId={appointmentId}
    bill={value.bill} course={course} hints={value.hints} reload={reload} onLockChange={setSharedLocked}
    renderSections={({fee,course:courseActions})=>{const feeSection = <SectionShell title="Consultation fee" sub="This visit" testId="consultation-fee">
        {amounts!==null?<p><AcBadge tone={value.bill?.feeRecorded?'positive':'pending'}>{feeStatus}</AcBadge></p>:null}
        {amounts===null?<ErrorState title="Fee unresolved" detail="Fee cannot be determined yet." />:<FieldGrid fields={[
          {label:'Original',value:rupeesFromMinorLabel(value.view.amountAdjustment?.originalAmountMinorUnits ?? amounts.grossMinorUnits)},
          {label:'Waived',value:rupeesFromMinorLabel(amounts.waivedMinorUnits)},
          {label:'Payable',value:rupeesFromMinorLabel(amounts.netMinorUnits)},
        ]}/>}
        {value.bill===null?<p>No bill started.</p>:null}
        {value.view.amountAdjustment?.lastActivity?<ConsultationAttribution label="Fee adjusted" activity={{actorDisplayName:value.view.amountAdjustment.lastActivity.actorDisplayName,actorStaffUserId:value.view.amountAdjustment.lastActivity.actor_staff_user_id,actorRole:value.view.amountAdjustment.lastActivity.actor_role,reason:value.view.amountAdjustment.lastActivity.reason,occurredAt:value.view.amountAdjustment.lastActivity.occurred_at}}/>:null}
        {value.view.activity?<ConsultationAttribution label="Waived" activity={value.view.activity}/>:null}
        {value.view.reversalActivity?<ConsultationAttribution label="Reversed" activity={value.view.reversalActivity}/>:null}
        {value.bill?.waived&&value.bill.status!=='draft'?<p>Reversal unavailable: bill {value.bill.status}.</p>:value.bill?.waived&&!value.bill.originalActor?<p>Only the original actor can reverse this waiver.</p>:value.bill?.waived&&!value.hints.canReverseWaiver?<ErrorState title="Reversal unavailable" detail="Permission required."/>:null}
        <fieldset disabled={feeDraft.locked} className="consult-v14g__fee-boundary">{renderPlan && feeDraft.managesFee ? null : fee}</fieldset>
      </SectionShell>;
      const courseSection = <SectionShell title="Current treatment course" sub="Across visits" testId="consultation-course">
        {course?<>
          <p><AcBadge tone={closed?'positive':'pending'}>{course.status.charAt(0).toUpperCase()+course.status.slice(1)}</AcBadge></p>
          <p>{course.unfinishedAcceptedCount>0?`${course.unfinishedAcceptedCount} accepted treatment${course.unfinishedAcceptedCount===1?'':'s'} unfinished.`:'All accepted treatment completed.'}</p>
          {course.activity?<ConsultationAttribution label={course.status==='abandoned'?'Abandoned':'Completed'} activity={course.activity}/>:closed?<p>Course history unavailable.</p>:null}
          {!closed&&!value.hints.canCompleteCourse&&!value.hints.canAbandonCourse?<ErrorState title="Course actions unavailable" detail="Permission required."/>:null}
          <fieldset disabled={feeDraft.locked} className="consult-v14g__fee-boundary">{courseActions}</fieldset>
          <details><summary>Details</summary><p>Course #{course.id}</p></details>
        </>:<p>No course linked.</p>}
      </SectionShell>;
      return renderPlan ? renderPlan({fee:feeSection,course:courseSection,discount:feeDraft.control,draft:feeDraft.draft}) : <>{feeSection}{courseSection}</>;
    }}/></>;
}

/** A failed/unsupported refresh must reject so the action never claims success. */
export async function refreshDoctorConsultation(
  appointmentId: number,
  fetchContext: typeof fetchDoctorConsultContext,
  apply: (value: Extract<DoctorConsultationState, { kind: 'ready' }>) => void,
): Promise<void> {
  const next: ConsultContextWithConsultation = await fetchContext(appointmentId);
  if (next.appointment.id !== appointmentId || next.consultation?.kind !== 'ready') {
    throw new Error('Consultation state could not be confirmed');
  }
  apply(next.consultation);
}

type LoadState =
  | { kind: 'loading' }
  | { kind: 'error'; text: string; scopeDenied: boolean }
  | { kind: 'ready'; context: ConsultContextWithConsultation; consultationEpoch: number };

/** R-07 once-guard: appointment ids whose consult-started signal this
 *  SESSION already fired (module-level so StrictMode double-effects and
 *  rapid re-mounts cannot double-fire; the server's idempotency select
 *  remains the cross-session backstop). */
const consultStartFiredIds = new Set<number>();

export default function ConsultWorkspacePage(): JSX.Element | null {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const registerSharedNavigation = useRegisterRoleNavigationGuard();
  const refreshPendingVisits=useDoctorPending()?.refresh;
  const appointmentId = parseConsultAppointmentId(params.appointmentId);
  // Tier-2 evidence flag signal (B4): the /me absent-key convention --
  // absence = disabled, fail-closed; the router 503 gate stays the boundary.
  const meCtx = useDashboardMeContext();
  const evidenceEnabled = meCtx?.me?.clinicalEvidenceEnabled === true;
  // The #294 lens signal (LES-016): the Related rows' drill doors -- and the
  // lens fetch behind the appointments fact -- exist only where the lens is
  // lawfully reachable. No signal = no fetch, no door, no dead end.
  const lensEnabled = meCtx?.me?.doctorLensEnabled === true;
  const [headerQuery, setHeaderQuery] = useState('');
  const [headerSearchOpen, setHeaderSearchOpen] = useState(false);
  const [headerSearchPending, setHeaderSearchPending] = useState(false);

  const consultationIdentity = useConsultationIdentity();
  // Same-actor /me refreshes update permissions below without dropping in-flight
  // request identities. Actual actor/org/role/clinic/visit changes still fence them.
  const consultationScope = useRef({ identity: consultationIdentity, appointmentId, epoch: 0 });
  if (consultationScope.current.identity !== consultationIdentity || consultationScope.current.appointmentId !== appointmentId) {
    consultationScope.current = { identity: consultationIdentity, appointmentId, epoch: consultationScope.current.epoch + 1 };
  }
  const [, redrawConsultationLock] = useState(0);
  const consultationLock = useRef({epoch:consultationScope.current.epoch,locked:false});
  if(consultationLock.current.epoch!==consultationScope.current.epoch) consultationLock.current={epoch:consultationScope.current.epoch,locked:false};
  const consultationEpoch=consultationScope.current.epoch;
  const onConsultationLockChange=useCallback((locked:boolean)=>{
    if(consultationEpoch!==consultationScope.current.epoch||consultationLock.current.locked===locked)return;
    consultationLock.current={epoch:consultationEpoch,locked};redrawConsultationLock(n=>n+1);
  },[consultationEpoch]);
  const [load, setLoad] = useState<LoadState>({ kind: 'loading' });
  const contextReadSequence = useRef(0);
  const accessDeniedRef = useRef<{epoch:number;text:string} | null>(null);
  const [accessDenied, setAccessDenied] = useState<{epoch:number;text:string} | null>(null);
  const [checkingAccess, setCheckingAccess] = useState(false);
  const accessCheckButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (accessDenied?.epoch !== consultationEpoch) return;
    const frame = requestAnimationFrame(() => accessCheckButton.current?.focus());
    return () => cancelAnimationFrame(frame);
  }, [accessDenied, consultationEpoch]);
  useEffect(() => { if (accessDenied?.epoch === consultationEpoch) setHeaderSearchOpen(false); }, [accessDenied, consultationEpoch]);
  useEffect(() => { accessDeniedRef.current = null; setAccessDenied(null); setCheckingAccess(false); }, [consultationEpoch]);
  const rejectCurrentAccess = useCallback((error: unknown) => {
    if (!(error instanceof PortalApiError) || ![401,403].includes(error.status)) return;
    // Invalidate all context reads started before this authoritative refusal.
    contextReadSequence.current++;
    const refusal = { epoch: consultationScope.current.epoch, text: consultErrorMessage(error).text };
    accessDeniedRef.current = refusal; setAccessDenied(refusal);
  }, []);

  const [sheet, setSheet] = useState<CaseSheetClinicalView | null>(null);
  const [form, setForm] = useState<StructuredSheetForm>(
    structuredFormFromSheet(null),
  );
  const finalizedAdditions=useFinalizedClinicalAdditions(`${consultationIdentity}:${appointmentId}:${consultationEpoch}`,sheet?.appointmentId===appointmentId?sheet:null,rejectCurrentAccess);
  const additionsRef=useRef(finalizedAdditions);additionsRef.current=finalizedAdditions;
  const displayForm=finalizedAdditions.enabled?formWithAdditions(form,finalizedAdditions.value):form;
  const [itemForm, setItemForm] = useState<ItemForm>(EMPTY_ITEM);
  // The org treatment catalog (V6-P3). null until loaded; a fetch failure or
  // pre-apply state stays null/unavailable -> the legacy add form renders
  // byte-identical (fail-safe law). Fetched once per clinic context.
  const [catalog, setCatalog] = useState<TreatmentCatalogResult | null>(null);
  const [itemEdits, setItemEdits] = useState<Record<number, PlanItemEdit>>({});
  /* CORRECTIVE 1's per-row failure map is GONE, and its requirement is kept
     rather than dropped: every plan-line failure now renders through the
     handed outcome components, beside the control that produced it AND
     outside the disclosure it lives in -- which is strictly more than the old
     map could do, since that one only reached the Change disclosure. */
  // One-close state: the inline-question answer (null until the plan marks
  // nothing and the doctor must pick), and the picked non-conversion reason.
  const [explicitPick, setExplicitPick] = useState<CloseExplicitPick>(null);
  const [notConvertedReason, setNotConvertedReason] = useState<string>('');
  const [busy, setBusy] = useState<BusyKind>(null);
  const [feedback, setFeedback] = useState<WorkbenchFeedback | null>(null);
  // DOCTOR-CONSULT-DELTA-V1: the PRINT ESTIMATE swap (the #442 print idiom;
  // presentation state only -- it fetches nothing and writes nothing).
  // Keep all editor owners mounted while a verified saved print is open.
  const printOrigin = useRef<HTMLElement | null>(null);
  const [clinicalPrint, setClinicalPrint] = useState<{epoch:number; kind:ConsultationPrintKind|'estimate'; sheet:CaseSheetClinicalView; intake:DoctorPreconsultView; estimate?: React.ComponentProps<typeof EstimatePrintView>['savedEstimate']; visitAttribution?:SavedVisitDoctorLabels; returnVisitLabel?:string|null; returnBooking?:{line:string|null;failed:boolean}; clinicalProfile?:PatientClinicalProfileView;todayWork?:ClinicalTodayWorkView|null;additions?:readonly ClinicalFinalizedAddition[]; previousRecords?:readonly CaseSheetClinicalView[]}|null>(null);
  const [preparingPrintEpoch, setPreparingPrintEpoch] = useState<number|null>(null);
  const preparingPrint = preparingPrintEpoch === consultationScope.current.epoch;
  const [printFailure, setPrintFailure] = useState<{epoch:number;text:string}|null>(null);
  const printError = printFailure?.epoch === consultationScope.current.epoch ? printFailure.text : null;
  const printLock = useRef<{epoch:number}|null>(null);

  // The intake panel's state, mirrored up for the banner safety strip (one
  // fetch, one truth -- DOCTOR-OS-BUILD-PHASE-1-V1).
  const [intakeState, setIntakeState] = useState<PreconsultPanelState>({
    kind: 'loading',
  });
  // DOCTOR-INTAKE-ONE-FLOW-V1 (R3c): the block's LIVE answered-key set,
  // lifted as a comma-joined string (a stable primitive, so same-value
  // updates no-op) -- the NEXT dock's Go derives its first-unanswered
  // target from the LIVE answers, not just the persisted read.
  const [answeredIntakeKeys, setAnsweredIntakeKeys] = useState<string | null>(null);
  // DOCTOR-OS-EXPERIENCE-V1 state:
  // - startGate: the B2 blocked verdict / the one-time conversion banner
  //   from THE consult-start act (never guessed client-side).
  // - consentsWire: the B3 consents read, hoisted from the panel so the
  //   snapshot header derives its consent chip from the SAME read.
  // - profileOverride: the durable clinical profile AFTER an IntakeBand
  //   write (fresher than the loaded context until the next context load).
  // - history: the ONE lifted case-history read (rail + ledger share it).
  const [startGate, setStartGate] = useState<
    | { kind: 'none' }
    | { kind: 'blocked'; code: string; message: string }
    | { kind: 'converted'; umr: string | null }
    // CONSULT-START-TRUTH-V1 (W-31): the two NO-SILENT-LOSS states -- a
    // failed start POST (any non-named error) and a 200 that resolved no
    // identity over a lead-only visit. Both render the retry band.
    | { kind: 'failed'; message: string }
    | { kind: 'unresolved' }
    // Lane 1 item 1 (D01): the server's 409 `appointment_not_actionable` --
    // a CORRECT refusal, named as a state and carrying no retry door.
    | { kind: 'not_actionable'; message: string }
  >({ kind: 'none' });
  // A start POST in flight (entry or retry) -- disables the retry door.
  const [startPending, setStartPending] = useState(false);
  // The start-result identity truth (CONSULT-START-TRUTH-V1), judged
  // against the context at whichever moment arrives second (the two mount
  // reads race): resolved=false + lead-only context -> the 'unresolved'
  // band; resolved=true + lead-only context -> ONE context re-read.
  const startIdentityRef = useRef<{
    resolved: boolean;
    contextRefreshed: boolean;
  } | null>(null);
  const [consentRefreshKey,setConsentRefreshKey] = useState(0);
  const [investigationRefreshKey,setInvestigationRefreshKey] = useState(0);
  const [consentsWire, setConsentsWire] = useState<CaseSheetConsentsWire | null>(
    null,
  );
  const profileWriteRevision = useRef(0);
  const [profileOverride, setProfileOverride] =
    useState<PatientClinicalProfileView | null>(null);
  const [historyRetry,setHistoryRetry] = useState(0);
  const [history, setHistory] = useState<CaseHistoryLoadState>({
    kind: 'loading',
  });
  // ROUND 3: THE ONE LIFTED JOURNEY READ (one fetch, several renders: the
  // course head, the course-wide ledger rows, the completion gating).
  const [journeyWire, setJourneyWire] = useState<CourseJourneyResponse | null>(
    null,
  );
  const [journeyLoad, setJourneyLoad] = useState<
    'none' | 'loading' | 'error' | 'ready'
  >('none');
  // ROUND 2 (coverage C38): the lens-composed appointments fact for the
  // Related rail row. Best-effort over the EXISTING doctor patient-lens
  // read; any failure (or no lens grant) leaves it null -> the row is
  // ABSENT, never a fabricated count.
  // V14g Patient record: an in-consult view (frozen prototype), keyed to the
  // consultation epoch so a patient change closes it. Appointments come from
  // the same existing doctor-lens read as the Related rail.
  const [recordEpoch, setRecordEpoch] = useState<number | null>(null);
  const [lensAppointments, setLensAppointments] = useState<readonly Patient360AppointmentWire[] | null>(null);
  const [lensRelated, setLensRelated] = useState<RelatedAppointmentsFact | null>(
    null,
  );
  // ROUND 2 (coverage C28): the imaging-on-file count MIRRORED UP from the
  // evidence panel's ONE list read (one fetch, two renders -- the C8 idiom).
  // null = flag off / read not settled -> no claimed count in the masthead.
  const [evidenceSource,setEvidenceSource]=useState<ClinicalEvidenceSource|null>(null);
  const [evidenceImagingRead,setEvidenceImagingRead]=useState<{epoch:number;sheetId:number|null;count:number|null}|null>(null);
  const evidenceSheetId=sheet?.id??null;
  const onImagingCount=useCallback((count:number|null)=>{
    if(consultationEpoch!==consultationScope.current.epoch)return;
    setEvidenceImagingRead(previous=>previous?.epoch===consultationEpoch&&previous.sheetId===evidenceSheetId&&previous.count===count?previous:{epoch:consultationEpoch,sheetId:evidenceSheetId,count});
  },[consultationEpoch,evidenceSheetId]);
  // BUILD 1 (L-05): the owed-evidence kinds MIRRORED UP from the same ONE
  // evidence read (no second fetch), so the close can state what is still
  // owed BEFORE the doctor is offered the act that ends the visit.
  const [evidenceOwedKinds, setEvidenceOwedKinds] = useState<
    readonly string[] | null
  >(null);

  const [paperCapture, setPaperCapture] = useState<{scope: number; open: () => void; busy: boolean; error: string | null} | null>(null);
  const registerPaperCapture = useCallback((entry: {open: () => void; busy: boolean; error: string | null} | null) => {
    setPaperCapture(previous => entry && appointmentId !== null ? {scope: appointmentId, ...entry} : previous?.scope === appointmentId ? null : previous);
  }, [appointmentId]);

  // TRUST LAYER + CLOSE refs: the debounced autosave and the close act read the
  // LIVEST sheet/form/plan (never a stale render closure) and track the
  // last-persisted form so dirty-detection is exact. Kept as refs so a
  // keystroke never re-arms an effect.
  const sheetRef = useRef(sheet);
  const formRef = useRef(form);
  const pendingPlanCreate = useRef<Promise<boolean> | null>(null);
  const failedPlanCreates = useRef(new Set<string>());
  const planCreationRequests = useRef(new Map<string, { requestId: string; payload: Parameters<typeof createPlanItem>[1] }>());
  const joinPlanWritersRef = useRef<() => Promise<boolean>>(async () => true);

  const lastSavedFormRef = useRef<StructuredSheetForm>(form);
  const formEditRevision = useRef(0);
  const itemEditsRef = useRef(itemEdits);
  const contextRef = useRef<DoctorConsultContext | null>(null);
  const defaultFeeSave = useRef(createConsultationFeeSave());
  const [todayWorkRead,setTodayWorkRead]=useState<{epoch:number;value:ClinicalTodayWorkView|null}>({epoch:consultationEpoch,value:null});
  const onTodayWorkRead=useCallback((value:ClinicalTodayWorkView|null)=>{
    if(consultationEpoch!==consultationScope.current.epoch)return;
    if(value&&(value.caseSheetId!==sheetRef.current?.id||value.facts.some(fact=>fact.caseSheetId!==value.caseSheetId)))return;
    setTodayWorkRead({epoch:consultationEpoch,value});
  },[consultationEpoch]);
  // The consult-start effect fires BEFORE loadContext is defined in source
  // order; the ref decouples them (assigned right after the definition --
  // the sheetRef.current render-assignment idiom).
  const loadContextRef = useRef<
    (mode: 'initial' | 'refresh' | 'reseed' | 'start' | 'recheck') => Promise<void>
  >(() => Promise.resolve());
  sheetRef.current = sheet;
  formRef.current = form;
  itemEditsRef.current = itemEdits;
  if (load.kind === 'ready') contextRef.current = load.context;

  // NO-MANUAL-ID LAW: a malformed param goes back to the queue -- there is
  // no id prompt to fall into.
  useEffect(() => {
    if (appointmentId === null) navigate('/dashboard/doctor', { replace: true });
  }, [appointmentId, navigate]);

  // THE CATALOG FETCH (V6-P3): once the consult context resolves, load the
  // active catalog for THIS appointment's clinic (clinic-override-resolved
  // server-side). Best-effort: any failure leaves catalog null and the
  // legacy add form stands byte-identical -- the consult never blocks on
  // master data. If the doctor already typed a free-text name before the
  // catalog settled populated, the picker opens in its explicit custom
  // escape so the typing is never stranded.
  const contextClinicId =
    load.kind === 'ready' ? load.context.appointment.clinicId : null;
  const me = meCtx?.me;
  const actingDoctor = readDoctorQueueClinicView(
    me?.role === 'doctor' && 'doctorQueueIdentity' in me ? me.doctorQueueIdentity : undefined,
    contextClinicId,
  );
  // CONSULT-SWITCH RESET (attack-review finding, 2026-07-27): the route
  // is one param route, so consult-to-consult navigation (the
  // DAY'S-APPOINTMENT banner, a patient-context link) never remounts
  // this component. The picker's in-flight selection -- and with S1 its
  // price + SOURCE claim -- must never survive into ANOTHER patient's
  // (possibly another clinic's) workspace, and the previous clinic's
  // loaded catalog must never render as this clinic's truth. Reset both
  // whenever the appointment changes; the catalog effect below refetches
  // for the new context (same-clinic included: contextClinicId cycles
  // through null while the context reloads).
  useEffect(() => {
    setItemForm(EMPTY_ITEM);
    setCatalog(null);
    // DOCTOR-OS-EXPERIENCE-V1: no cross-consult truth may survive the
    // switch -- the blocked verdict, the conversion banner, the consents
    // read, and the durable-profile override all belong to ONE visit.
    setStartGate({ kind: 'none' });
    setConsentsWire(null);
    setProfileOverride(null);
    // The next visit must never seed its editor from the previous intake read.
    setIntakeState({ kind: 'loading' });
    setAnsweredIntakeKeys(null);
    // ROUND 2: the Related appointments fact and the mirrored evidence
    // count belong to ONE patient's visit exactly as the states above.
    setLensRelated(null);
    setEvidenceImagingRead(null);
    setEvidenceOwedKinds(null);
    // ROUND 3: the journey truth belongs to ONE course/visit.
    setJourneyWire(null);
    setJourneyLoad('none');
    // CONSULT-START-TRUTH-V1: the start-signal truth belongs to ONE visit.
    startIdentityRef.current = null;
  }, [appointmentId]);
  useEffect(() => {
    if (contextClinicId === null) return;
    let cancelled = false;
    fetchTreatmentCatalog(contextClinicId)
      .then((result) => {
        if (cancelled) return;
        setCatalog(result);
        if (result.available && result.items.length > 0) {
          setItemForm((prev) =>
            prev.procedureName.trim() !== '' && !prev.customMode
              ? {
                  ...prev,
                  customMode: true,
                  // F4 belt: EVERY entry into the custom escape clears the
                  // coded selection -- a hidden coded payload must never
                  // ride under the free-text form (attack-review pin).
                  catalogItemId: null,
                  catalogLabel: '',
                  catalogDefaultMinorUnits: null,
                  catalogMinimumMinorUnits: null,
                  catalogSource: null,
                }
              : prev,
          );
        }
      })
      .catch(() => {
        if (!cancelled) setCatalog(null);
      });
    return () => {
      cancelled = true;
    };
  }, [contextClinicId]);

  // FRONTDESK-CHECKIN-AND-IDENTITY-V1 (rider R-07): entering the consult
  // workspace IS the Start/Resume-consult act -- record the consult_started
  // signal on entry (never blocks the workspace; the server is idempotent --
  // one event per appointment ever -- and guards finalized sheets, so a View
  // entry records nothing). Until the founder applies migration 20260711_1
  // the server answers recorded:false and every display keeps the
  // draft-signal fallback (pre-apply fail-safe). The module-level once-guard
  // closes the client-side race the adversarial review named (StrictMode
  // double-effects / rapid re-mounts); the residual cross-TAB race is
  // accepted and bounded -- a DB unique index would be a founder migration.
  //
  // CONSULT-START-TRUTH-V1 (W-31): fire-and-FORGET is retired -- the send
  // stays non-blocking but its FATE is visible state, never silence. The
  // live walk found both conversion doors dead with zero trace: the old
  // catch mapped only the four named 409 codes and swallowed everything
  // else (an auth refusal, a 500, a dropped transport), and a 200 from an
  // older api (no patientId) no-opped invisibly. Now: any non-named failure
  // -> the 'failed' retry band; a 200 resolving NO identity over a
  // lead-only visit -> the 'unresolved' retry band; and one PHI-free
  // console line per phase (send / result / failed) so a founder walk can
  // read the signal's fate without the Network panel.
  //
  const fireConsultStart = useCallback(
    (mode: 'entry' | 'retry') => {
      if (appointmentId === null) return;
      // --- THE ELIGIBILITY GATE (#769 CORRECTIVE 1) -------------------------
      //
      // A visit THE SHARED RULE marks non-actionable performs ZERO start
      // requests. Not a call whose 409 we handle nicely -- NO CALL.
      //
      // The first cut of this package stopped the futile DOORS (the Owed work
      // Resume, the Close coach) and then relabelled the server's refusal
      // honestly. The reviewers were right that this is not the same thing:
      // open a cancelled visit's consult by URL and the page still ASKED, and
      // then dressed up the No. The brief said do not ask.
      //
      // THE GATE LIVES INSIDE THE ONE SENDER so no caller can route around it
      // -- the entry effect, the retry door, and any future caller all pass
      // through this line. The effect below additionally waits for the
      // context, because a status this page has not loaded yet is not a
      // status: `unknown` keeps the request (the pre-corrective behaviour, and
      // the W-31 never-a-lost-press property), and only a KNOWN-ineligible
      // status withholds it.
      //
      // THE SERVER REFUSAL STAYS THE BACKSTOP, untouched: this is a client
      // that stops asking, never a fence that stops refusing.
      const verdict = consultDoorVerdict(
        contextRef.current?.appointment.status,
      );
      if (verdict.kind === 'blocked') {
        // One PHI-free line, so a walk can see the decision that produced no
        // network row at all -- the same observability posture as the send /
        // result / failed lines below. A SILENT skip is what
        // CONSULT-START-TRUTH-V1 was built to abolish; this skip says so.
        console.info('[consult-start] not sent - appointment not actionable', {
          appointmentId,
          mode,
          status: contextRef.current?.appointment.status ?? null,
        });
        // No band is set here ON PURPOSE: the NEXT band's rung 0 already names
        // this state on this screen, and a second sentence saying the same
        // thing would rebuild the two-statements-for-one-fact defect this
        // package exists to remove.
        return;
      }
      // A retry is an explicit user act: it clears the once-guard so the
      // signal really re-fires (a 200 no-op keeps the guard set otherwise).
      if (mode === 'retry') consultStartFiredIds.delete(appointmentId);
      if (consultStartFiredIds.has(appointmentId)) return;
      consultStartFiredIds.add(appointmentId);
      setStartPending(true);
      console.info('[consult-start] send', { appointmentId, mode });
      const startEpoch = consultationScope.current.epoch;
      void markConsultStarted(appointmentId)
        .then((result) => {
          if (startEpoch !== consultationScope.current.epoch) return;
          // LEAD-UNTIL-CONSULT (DOCTOR-OS-EXPERIENCE-V1): the start now
          // RESOLVES IDENTITY server-side. THE CONVERSION MOMENT is made
          // visible once; and when the start created the visit's case-sheet
          // entry while this page still holds none, the context re-reads so
          // the sheet mounts -- reseed ONLY over a pristine form (typed work
          // is never clobbered by a background start resolving late).
          const converted = result.convertedAtConsult === true;
          const identityResolved =
            typeof result.patientId === 'string' && result.patientId !== '';
          startIdentityRef.current = {
            resolved: identityResolved,
            contextRefreshed: false,
          };
          console.info('[consult-start] result', {
            appointmentId,
            recorded: result.recorded,
            alreadyRecorded: result.alreadyRecorded,
            convertedAtConsult: converted,
            identityResolved,
            caseSheetId: result.caseSheetId ?? null,
          });
          if (converted) {
            setStartGate({ kind: 'converted', umr: result.patientUmr ?? null });
          } else if (identityResolved) {
            // A lawful start resolved identity: clear an earlier trouble
            // band (a successful retry heals the screen).
            setStartGate((prev) =>
              prev.kind === 'failed' || prev.kind === 'unresolved'
                ? { kind: 'none' }
                : prev,
            );
          } else if (
            contextRef.current !== null &&
            contextRef.current.patient.linked !== true
          ) {
            setStartGate({ kind: 'unresolved' });
          }
          const sheetAppeared =
            typeof result.caseSheetId === 'number' && sheetRef.current === null;
          const linkResolvedOverLeadOnly =
            identityResolved &&
            !converted &&
            contextRef.current !== null &&
            contextRef.current.patient.linked !== true;
          if (linkResolvedOverLeadOnly && startIdentityRef.current !== null) {
            // The context below re-reads for the linked header; stamp it so
            // the load-judgment effect never double-refreshes.
            startIdentityRef.current.contextRefreshed = true;
          }
          if (converted || sheetAppeared || linkResolvedOverLeadOnly) {
            return loadContextRef.current('start');
          }
        })
        .catch((err: unknown) => {
          if (startEpoch !== consultationScope.current.epoch) return;
          // Allow a later entry (or the retry door) to re-fire after a
          // failure.
          consultStartFiredIds.delete(appointmentId);
          // B2 BLOCKED STATE: the named 409s replace the working surface
          // with the honest panel (server message VERBATIM). EVERY other
          // failure renders the visible retry band -- the workspace still
          // opens, but the dead signal is named (NO SILENT LOSS).
          const code =
            err !== null &&
            typeof err === 'object' &&
            'code' in err &&
            typeof (err as { code?: unknown }).code === 'string'
              ? (err as { code: string }).code
              : null;
          console.error('[consult-start] failed', {
            appointmentId,
            code,
            message: consultErrorMessage(err).text,
          });
          // THE APPOINTMENT-STATE REFUSAL (Lane 1 item 1 / D01). It is a
          // NAMED 409 like the four below, but it does NOT replace the
          // working surface: the visit's already-recorded work stays
          // readable, and the doctor is told the visit's state instead of
          // being handed a Retry that cannot succeed. THE SERVER REFUSAL IS
          // UNCHANGED -- this only stops mislabelling it.
          if (code === 'appointment_not_actionable') {
            setStartGate({
              kind: 'not_actionable',
              message: consultErrorMessage(err).text,
            });
            return;
          }
          if (
            code === 'registration_incomplete' ||
            code === 'identity_review_required' ||
            code === 'patient_record_required' ||
            code === 'registration_enrichment_unavailable' ||
            code === 'contact_phone_unresolvable'
          ) {
            setStartGate({
              kind: 'blocked',
              code,
              message: consultErrorMessage(err).text,
            });
          } else {
            setStartGate({
              kind: 'failed',
              message: consultErrorMessage(err).text,
            });
          }
        })
        .finally(() => {
          if (startEpoch === consultationScope.current.epoch) setStartPending(false);
        });
    },
    [appointmentId],
  );

  // THE ENTRY FIRE WAITS FOR THE STATUS (#769 CORRECTIVE 1). It used to fire
  // on mount, BEFORE the consult context had loaded -- so the gate above could
  // not have seen a cancelled status even in principle, and the request went
  // out every time. Holding until the load SETTLES is what makes "zero start
  // requests for a non-actionable visit" true at the ROUTE, not merely true
  // inside the gate.
  //
  // 'error' settles too, and deliberately still fires: a context this page
  // could not read tells us nothing about the appointment's status, and
  // withholding the signal there would silently lose a real consult start on
  // a flaky read. Unknown keeps the request; the server re-fences it.
  useEffect(() => {
    if (load.kind === 'loading') return;
    fireConsultStart('entry');
  }, [load.kind, fireConsultStart]);

  // The second half of the start/context race: the context landed AFTER the
  // start resolved. A lead-only context over a resolved start re-reads once
  // (the header must show the identity the start resolved); a lead-only
  // context over an identity-less 200 surfaces the unresolved band.
  useEffect(() => {
    if (load.kind !== 'ready') return;
    if (load.context.patient.linked === true) return;
    const startTruth = startIdentityRef.current;
    if (startTruth === null) return;
    if (startTruth.resolved) {
      if (!startTruth.contextRefreshed) {
        startTruth.contextRefreshed = true;
        void loadContextRef.current('refresh');
      }
      return;
    }
    setStartGate((prev) => (prev.kind === 'none' ? { kind: 'unresolved' } : prev));
  }, [load]);

  /** The ONE draft write (create-or-update) from the CURRENT form. Updates the
   *  persisted sheet + the plan-edit map + the last-saved snapshot; it does
   *  NOT set `busy` (the doctor keeps typing while it saves) and NEVER reseeds
   *  the live form (never moves the cursor). Rejects with a PHI-safe mapped
   *  message. This is the EXISTING draft path -- no new endpoint. */
  const persistDraft = useCallback(async (): Promise<void> => {
    if (accessDeniedRef.current?.epoch === consultationScope.current.epoch) throw new Error('Current visit access must be checked.');
    if (appointmentId === null) return;
    const saveEpoch = consultationScope.current.epoch;
    // A retained callback must never pair an old appointment with new refs.
    if (appointmentId !== consultationScope.current.appointmentId) return;
    if (contextRef.current?.appointment.id !== appointmentId) {
      throw new ConsultPreWriteError('Visit context changed. Reopen the visit before saving.');
    }
    // The start response can be lost or remain pending after its write commits.
    // Read saved state independently instead of making draft persistence wait
    // indefinitely for that signal. Do not reseed the doctor's in-flight form.
    if (sheetRef.current === null) {
      let latest: DoctorConsultContext;
      try {
        latest = await fetchDoctorConsultContext(appointmentId);
      } catch (err) {
        if (saveEpoch !== consultationScope.current.epoch) return;
        throw new ConsultPreWriteError(consultErrorMessage(err).text);
      }
      if (saveEpoch !== consultationScope.current.epoch) return;
      if (latest.appointment.id !== appointmentId ||
          (latest.caseSheet !== null && latest.caseSheet.appointmentId !== appointmentId)) {
        throw new ConsultPreWriteError('Visit context changed. Reopen the visit before saving.');
      }
      if (sheetRef.current === null && latest.caseSheet !== null) {
        sheetRef.current = latest.caseSheet;
        setSheet(latest.caseSheet);
      }
    }
    if (saveEpoch !== consultationScope.current.epoch) return;
    const currentForm = formRef.current;
    const currentSheet = sheetRef.current;
    if (contextRef.current?.appointment.id !== appointmentId ||
        (currentSheet !== null && currentSheet.appointmentId !== appointmentId)) {
      throw new ConsultPreWriteError('Visit context changed. Reopen the visit before saving.');
    }
    // SEVERABILITY (20260728_1): the encounter-section + follow-up fields
    // ride the patch ONLY when the server reported their storage live --
    // pre-apply the draft write stays byte-identical to today's shape.
    // TOOTH REFS (20260730_1, same posture): the diagnosis-grain codes ride
    // ONLY when tooth storage is live AND the selection changed vs the last
    // saved baseline (a full-set replace is never sent redundantly, so the
    // per-mutation audit rows record real changes, not autosave echoes).
    const patch = structuredSheetPatch(
      currentForm,
      contextRef.current?.encounterSectionsAvailable === true,
      contextRef.current?.toothRefsAvailable === true &&
        !sameToothSet(currentForm.toothRefs, lastSavedFormRef.current.toothRefs),
      // D2 (20260815_1, same severability posture): the treatment-doctor pick
      // rides ONLY when attribution storage is live AND the value changed vs
      // the last saved baseline -- an autosave can never clear a server-side
      // stamp the form has not seen.
      contextRef.current?.attribution?.available === true &&
        currentForm.treatmentDoctorId !==
          lastSavedFormRef.current.treatmentDoctorId,
    );
    const examinationChanged = !examinationEqual(currentForm.examination, lastSavedFormRef.current.examination);
    if (examinationChanged && contextRef.current?.examinationAvailable !== true) {
      throw new ConsultPreWriteError('Finding storage is unavailable. Your changes are still here.');
    }
    const finishChanged=!finishReviewsEqual(currentForm.finishReview,lastSavedFormRef.current.finishReview);
    if(finishChanged&&(contextRef.current?.finishReviewAvailable!==true||!currentSheet||currentSheet.finishReviewRevision===undefined))throw new ConsultPreWriteError('Visit review storage is unavailable. Your changes are still here.');
    const returnChanged = !returnRequestsEqual(currentForm.returnRequest, lastSavedFormRef.current.returnRequest);
    if (returnChanged && (contextRef.current?.returnRequestAvailable !== true || !currentSheet || currentSheet.returnRequestRevision === undefined)) {
      throw new ConsultPreWriteError('Return visit storage is unavailable. Your changes are still here.');
    }
    const returnProblem = returnRequestProblem(currentForm.returnRequest,lastSavedFormRef.current.returnRequest,
      new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()));
    if(returnProblem)throw new ConsultPreWriteError(returnProblem);
    const clinicalPatch = { ...patch, ...(finishChanged?{finishReview:currentForm.finishReview??null,finishReviewRevision:currentSheet!.finishReviewRevision}:{}), ...(returnChanged ? {returnRequest:currentForm.returnRequest??null,returnRequestRevision:currentSheet!.returnRequestRevision} : {}), ...(examinationChanged ? {
      examination: currentForm.examination ?? null,
      ...(currentSheet ? { examinationRevision: currentSheet.examinationRevision ?? 0 } : {}),
    } : {}) };
    let saved: CaseSheetClinicalView;
    try {
      saved =
        currentSheet === null
          ? await createCaseSheet({ appointmentId, ...clinicalPatch })
          : await updateCaseSheet(currentSheet.id, clinicalPatch);
    } catch (err) {
      if (saveEpoch !== consultationScope.current.epoch) return;
      const message = consultErrorMessage(err).text;
      throw err instanceof PortalApiError
        ? new PortalApiError(err.status, message, err.code) : new Error(message);
    }
    // A completed write belongs to its originating visit, even if the server
    // committed it before navigation. Do not install its state into a new one.
    if (saveEpoch !== consultationScope.current.epoch) return;
    // CORRECTIVE 1: the plan the editor was last reconciled against, captured
    // BEFORE the ref is overwritten -- syncItemEdits needs it to tell a field
    // the doctor edited from one the server moved underneath them.
    const previousPlanItems = sheetRef.current?.planItems ?? [];
    sheetRef.current = saved;
    lastSavedFormRef.current = currentForm;
    setSheet(saved);
    setItemEdits((prev) =>
      syncItemEdits(prev, saved.planItems, previousPlanItems),
    );
    // CONVERSION-CONSEQUENCE-MINT-V1 (W-20): when the sheet-materializing
    // CREATE resolved the visit's patient server-side (the keystroke ran the
    // conversion because the fire-and-forget start signal was lost) while
    // this page still shows the unlinked banner, re-read the context so the
    // identity header, the case-history rail, and the snapshot chips reflect
    // the linked patient -- 'refresh' mode only (context truth; typed work is
    // never touched).
    if (
      currentSheet === null &&
      saved.patientId !== null &&
      contextRef.current !== null &&
      contextRef.current.patient.linked !== true
    ) {
      void loadContextRef.current('refresh');
    }
  }, [appointmentId]);

  /** MATERIALIZE-ON-ATTACH (Tier 2): resolve the sheet id for an evidence
   *  attach, creating the draft through THE ONE existing writer
   *  (persistDraft -> POST /api/case-sheets) when no sheet exists yet --
   *  an attachment is a sheet-materializing act exactly as a keystroke is
   *  (the paper-first contract; finalize-from-evidence DR-3/B3). */
  const ensureSheetForEvidence = useCallback(async (): Promise<
    number | null
  > => {
    if (sheetRef.current !== null) return sheetRef.current.id;
    try {
      await persistDraft();
    } catch {
      return null;
    }
    // persistDraft mutates sheetRef on success (create-or-update writer);
    // the cast re-widens what TS narrowed to null before the await.
    const materialized = sheetRef.current as CaseSheetClinicalView | null;
    return materialized === null ? null : materialized.id;
  }, [persistDraft]);

  const completionLock = useRef<{ epoch: number; itemId: number } | null>(null);
  const failedCompletions = useRef(new Set<number>());
  const verifiedContextRef = useRef<DoctorConsultContext | null>(null);
  const recoveryLock = useRef(false);
  const [recoveryBusy, setRecoveryBusy] = useState(false);
  const [, refreshRecovery] = useState(0);
  const recoveryChanged = useCallback(() => refreshRecovery(v => v + 1), []);
  const planControlDrafts = useRef(new Map<string, PlanControlDraft>());
  const planDraftOwner = useMemo<PlanDraftOwner>(() => ({ changed: recoveryChanged,
    register: (key, draft) => {
      planControlDrafts.current.set(key, draft); recoveryChanged();
      return () => { if (planControlDrafts.current.get(key) === draft) { planControlDrafts.current.delete(key); recoveryChanged(); } };
    },
  }), [recoveryChanged]);
  const prescriptionRecoveryRef = useRef<ConsultWriterBoundary | null>(null);
  const prescriptionSaveRef = useRef<(() => Promise<boolean>) | null>(null);
  const registerPrescriptionRecovery = useCallback((value: ConsultWriterBoundary | null) => { prescriptionRecoveryRef.current = value; }, []);
  const registerPrescriptionSave = useCallback((value: (() => Promise<boolean>) | null) => { prescriptionSaveRef.current = value; }, []);
  const profileRecoveryRef = useRef<ConsultWriterBoundary | null>(null);
  const profileBeforeLeaveRef = useRef<(() => Promise<boolean>) | null>(null);
  const profileSaveRef = useRef<(() => Promise<boolean>) | null>(null);
  const registerProfileSave = useCallback((value: (() => Promise<boolean>) | null) => { profileSaveRef.current = value; }, []);
  const [questionsPresentation, setQuestionsPresentation] = useState<{epoch:number;value:'questions'|'summary'} | null>(null);
  const registerQuestionsPresentation = useCallback((value:'questions'|'summary') => {
    setQuestionsPresentation({epoch:consultationScope.current.epoch,value});
  }, []);
  const registerProfileRecovery = useCallback((value: ConsultWriterBoundary | null) => { profileRecoveryRef.current = value; }, []);
  const registerProfileBeforeLeave = useCallback((value: (() => Promise<boolean>) | null) => { profileBeforeLeaveRef.current = value; }, []);
  const intakeRecoveryRef = useRef<ConsultWriterBoundary | null>(null);
  const registerIntakeRecovery = useCallback((value: ConsultWriterBoundary | null) => {
    intakeRecoveryRef.current = value;
  }, []);
  const autosave = useVerifiedConsultAutosave({
    scope: String(consultationScope.current.epoch),
    capture: () => formRef.current,
    baseline: () => lastSavedFormRef.current,
    same: structuredFormsEqual,
    readVerified: async () => {
      const epoch = consultationScope.current.epoch;
      const visit = consultationScope.current.appointmentId;
      const before = contextRef.current;
      if (visit === null || before?.appointment.id !== visit) throw new Error('Visit context unavailable.');
      const verified = await fetchDoctorConsultContext(visit);
      if (epoch !== consultationScope.current.epoch ||
          verified.appointment.id !== visit || verified.appointment.clinicId !== before.appointment.clinicId ||
          (before.patient.patientId !== null && verified.patient.patientId !== before.patient.patientId) ||
          (verified.caseSheet !== null && verified.caseSheet.appointmentId !== visit)) {
        throw new Error('Visit context changed. Your typing is still here.');
      }
      verifiedContextRef.current = verified;
      const value = structuredFormFromSheet(verified.caseSheet);
      return { value, restore: () => {
        formRef.current = value; setForm(value); formEditRevision.current++;
      } };
    },
    acknowledge: value => {
      lastSavedFormRef.current = value;
      const verified = verifiedContextRef.current;
      if (verified?.appointment.id === consultationScope.current.appointmentId) {
        sheetRef.current = verified.caseSheet; setSheet(verified.caseSheet);
        // Preserve independent profile revisions and unrelated local plan edits.
        setItemEdits(previous => syncItemEdits(previous, verified.caseSheet?.planItems ?? [], contextRef.current?.caseSheet?.planItems ?? []));
      }
    },
    enabled: sheet === null || sheet.status !== 'finalized',
    isDirty: () =>
      // A retained save cycle must not treat the old form as the next visit
      // while that visit's context is still loading.
      load.kind === 'ready' &&
      load.consultationEpoch === consultationScope.current.epoch &&
      !structuredFormsEqual(formRef.current, lastSavedFormRef.current),
    // "Worth persisting" = the form has content (so we auto-CREATE only a
    // non-empty sheet) OR the sheet already exists (so clearing a field
    // persists the deletion, and the close flush never stalls on an
    // emptied-but-existing sheet).
    hasContent: () =>
      structuredFormHasContent(formRef.current) || sheetRef.current !== null,
    formatNow: () => formatIstTime(new Date().toISOString()) || 'just now',
    save: persistDraft,
  });
  const autosaveRef = useRef(autosave);
  autosaveRef.current = autosave;

  const intakeBeforeLeaveRef = useRef<(() => Promise<boolean>) | null>(null);
  const registerIntakeBeforeLeave = useCallback((flush: (() => Promise<boolean>) | null) => {
    intakeBeforeLeaveRef.current = flush;
  }, []);
  const navigationPending = useRef<number | null>(null);
  const [recoveryDialog, setRecoveryDialog] = useState<'discard' | 'leave' | null>(null);
  const recoveryDecision = useRef<{ epoch: number; resolve: (value: boolean) => void } | null>(null);
  const settleRecovery = useCallback((value: boolean) => {
    const decision = recoveryDecision.current;
    recoveryDecision.current = null;
    setRecoveryDialog(null);
    decision?.resolve(value && decision.epoch === consultationScope.current.epoch);
  }, []);
  useEffect(() => {
    settleRecovery(false);
    recoveryLock.current = false; setRecoveryBusy(false);
    return () => { recoveryDecision.current?.resolve(false); recoveryDecision.current = null; };
  }, [appointmentId, consultationIdentity, settleRecovery]);
  const askRecovery = useCallback((kind: 'discard' | 'leave'): Promise<boolean> => {
    if (recoveryDecision.current !== null) return Promise.resolve(false);
    return new Promise(resolve => {
      recoveryDecision.current = { epoch: consultationScope.current.epoch, resolve };
      setRecoveryDialog(kind);
    });
  }, []);
  const joinWriters = useCallback(async (retryCompletionItem?: number): Promise<boolean> => {
    if(consultationLock.current.locked || accessDeniedRef.current?.epoch === consultationScope.current.epoch)return false;
    if (sheetRef.current?.status !== 'finalized' && contextRef.current?.returnRequestAvailable === true) {
      const problem=returnRequestProblem(formRef.current.returnRequest,lastSavedFormRef.current.returnRequest,
        new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()));
      if(problem){setFeedback({kind:'error',lines:[problem]});return false;}
    }
    const epoch = consultationScope.current.epoch;
    const intakeSaved = await joinCurrentIntakeOwner(() => intakeBeforeLeaveRef.current);
    if (consultationScope.current.epoch !== epoch) return false;
    // The intake boundary already joins both writers when valid. Always join
    // notes afterward too, including a failed questionnaire/validation path;
    // do not launch a competing reconciliation of the same writer.
    const notesSaved = await autosaveRef.current.flush().catch(() => false);
    const createSaved = await (pendingPlanCreate.current ?? Promise.resolve(true)).catch(() => false);
    const profileSaved = await (profileBeforeLeaveRef.current?.() ?? Promise.resolve(true)).catch(() => false);
    if (consultationScope.current.epoch !== epoch) return false;
    const medicinesSaved = await (prescriptionSaveRef.current?.() ?? Promise.resolve(true)).catch(() => false);
    if (consultationScope.current.epoch !== epoch) return false;
    // Today completion is a registered plan draft; keep it pending if medicines failed.
    const planSaved = medicinesSaved && await joinPlanWritersRef.current();
    const additionsSaved=await additionsRef.current.flush().catch(()=>false);
    return additionsSaved && medicinesSaved && profileSaved && intakeSaved && notesSaved && createSaved && failedPlanCreates.current.size === 0 && planSaved && [...failedCompletions.current].every(id => id === retryCompletionItem) && consultationScope.current.epoch === epoch;
  }, []);
  // Explicit Save/Finish only: navigation/print joins never provision a bill.
  const saveDefaultConsultationFee = useCallback(async (): Promise<boolean> => {
    const scope = consultationScope.current;
    const before = contextRef.current as ConsultContextWithConsultation | null;
    const currentSheet = sheetRef.current;
    if (scope.appointmentId === null || before?.appointment.id !== scope.appointmentId) return false;
    if (currentSheet?.status !== 'draft') return true;
    let readSequence: number | undefined;
    const current = () => consultationScope.current.epoch === scope.epoch &&
      consultationScope.current.identity === scope.identity && consultationScope.current.appointmentId === scope.appointmentId &&
      accessDeniedRef.current?.epoch !== scope.epoch && sheetRef.current?.id === currentSheet.id &&
      (readSequence === undefined || contextReadSequence.current === readSequence);
    try {
      const saved = await defaultFeeSave.current<ConsultContextWithConsultation>({ identity: scope.identity,
        context: {...before, caseSheet: currentSheet}, current, bearer: authBearer, requestId: () => crypto.randomUUID(),
        submit: ensureConsultationFee,
        read: async (visit, bearer) => {
          readSequence = ++contextReadSequence.current;
          return await fetchDoctorConsultContext(visit, bearer) as ConsultContextWithConsultation;
        },
        apply: fresh => {
          // Financial readback only: never reseed joined clinical editors or
          // replace their own newer saved notes/profile/plan baselines.
          const latest = contextRef.current as ConsultContextWithConsultation | null;
          if (latest) contextRef.current = {...latest, consultation: fresh.consultation} as ConsultContextWithConsultation;
          setLoad(previous => previous.kind === 'ready' && previous.consultationEpoch === scope.epoch
            ? {...previous, context: {...previous.context, consultation: fresh.consultation}} : previous);
        },
      });
      if (!saved && current()) setFeedback({kind:'error',lines:['The consultation fee could not be confirmed. Retry Save before continuing.']});
      return saved && current();
    } catch (error) {
      if (current()) {
        rejectCurrentAccess(error);
        setFeedback({kind:'error',lines:[error instanceof PortalApiError && error.status >= 400 && error.status < 500
          ? consultErrorMessage(error).text : 'The consultation fee could not be confirmed. Retry Save before continuing.']});
      }
      return false;
    }
  }, [rejectCurrentAccess]);
  const restoreVerified = async (): Promise<boolean> => {
    if (recoveryLock.current || completionLock.current || failedCompletions.current.size || pendingPlanCreate.current || failedPlanCreates.current.size || pendingPlanWrites.current.size) return false;
    const epoch = consultationScope.current.epoch;
    const writers = [autosaveRef.current.boundary, intakeRecoveryRef.current, profileRecoveryRef.current, prescriptionRecoveryRef.current, additionsRef.current.enabled?additionsRef.current.boundary:null].filter((w): w is ConsultWriterBoundary => w !== null);
    if (writers.some(w => w.pending() || w.uncertain())) return false;
    recoveryLock.current = true; setRecoveryBusy(true);
    const planPrepared = [...planControlDrafts.current.values()].map(draft => draft.prepareRestore());
    const prepared = await Promise.all(writers.map(w => w.prepareRestore().catch(() => null)));
    try {
      if (epoch !== consultationScope.current.epoch || prepared.some(p => p === null || !p.valid()) || planPrepared.some(p => !p.valid()) || pendingPlanWrites.current.size) return false;
      const verified = verifiedContextRef.current?.caseSheet;
      if ([...uncertainPlanWrites.current].some(([id, patch]) =>
        !verified || verified.id !== sheetRef.current?.id ||
        !planPatchConfirmedByRead(verified.planItems.find(row => row.id === id), patch))) return false;
      // No await between validation and installation: both baselines apply as
      // one UI act, and neither restoration calls onEdit/onReasonChange.
      prepared.forEach(p => p!.apply());
      planPrepared.forEach(p => p.apply());
      // The verified context read above is authoritative even after a lost PUT
      // response: keep persisted values and discard only uncommitted row drafts.
      failedPlanWrites.current.clear(); uncertainPlanWrites.current.clear();
      return true;
    } finally {
      prepared.forEach(p => p?.release());
      if (epoch === consultationScope.current.epoch) { recoveryLock.current = false; setRecoveryBusy(false); }
    }
  };
  const checkWriters = async (): Promise<boolean> => {
    if (recoveryLock.current) return false;
    const epoch = consultationScope.current.epoch;
    recoveryLock.current = true; setRecoveryBusy(true);
    try {
      const results = await Promise.all([
        autosaveRef.current.boundary.check(),
        intakeRecoveryRef.current?.check() ?? Promise.resolve(true),
        profileRecoveryRef.current?.check() ?? Promise.resolve(true),
        prescriptionRecoveryRef.current?.check() ?? Promise.resolve(true),
        additionsRef.current.enabled?additionsRef.current.boundary.check():Promise.resolve(true),
      ]);
      return results.every(Boolean) && epoch === consultationScope.current.epoch;
    } finally {
      if (epoch === consultationScope.current.epoch) { recoveryLock.current = false; setRecoveryBusy(false); }
    }
  };
  const retryRecovery = async (): Promise<void> => {
    if (recoveryLock.current) return;
    const epoch = consultationScope.current.epoch;
    recoveryLock.current = true; setRecoveryBusy(true);
    try {
      if (await joinWriters() && epoch === consultationScope.current.epoch) settleRecovery(true);
    } finally {
      if (epoch === consultationScope.current.epoch) { recoveryLock.current = false; setRecoveryBusy(false); }
    }
  };
  const flushBeforeLeave = useCallback(async (): Promise<boolean> => {
    const epoch = consultationScope.current.epoch;
    if (consultationLock.current.locked || navigationPending.current === epoch) return false;
    // The open capture already offers the only safe exact-file retry. Do not
    // stack a discard/leave dialog over its uncertain consent or report writer.
    if ([...planControlDrafts.current].some(([key,draft]) =>
      (key.startsWith('consent-') || key.startsWith('investigations-')) &&
      draft.dirty() && !draft.prepareRestore().valid())) return false;
    navigationPending.current = epoch;
    try {
      if (await joinWriters()) return true;
      if (consultationScope.current.epoch !== epoch) return false;
      return await askRecovery('leave');
    } finally {
      if (navigationPending.current === epoch) navigationPending.current = null;
    }
  }, [joinWriters, askRecovery]);
  useEffect(() => registerSharedNavigation(flushBeforeLeave), [registerSharedNavigation, flushBeforeLeave]);
  // Browser history is a separate exit from the owned buttons and shared
  // shell. Hold Back/Forward until the same two writers have settled; a
  // failed save resets the transition and leaves the draft editable.
  const historyBlocker = useBlocker(({ currentLocation, nextLocation, historyAction }) =>
    historyAction === 'POP' &&
    (currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search),
  );
  const historyBlockerRef = useRef(historyBlocker);
  historyBlockerRef.current = historyBlocker;
  const historyBlocked = historyBlocker.state === 'blocked';
  useEffect(() => {
    if (!historyBlocked) return;
    let live = true;
    void flushBeforeLeave().then((saved) => {
      if (!live || historyBlockerRef.current.state !== 'blocked') return;
      if (saved) historyBlockerRef.current.proceed();
      else historyBlockerRef.current.reset();
    }).catch(() => {
      if (live && historyBlockerRef.current.state === 'blocked') historyBlockerRef.current.reset();
    });
    return () => { live = false; };
  }, [historyBlocked, flushBeforeLeave]);
  const leaveVisit = useCallback(async (path: string): Promise<void> => {
    if (await flushBeforeLeave()) navigate(path);
  }, [flushBeforeLeave, navigate]);

  /** Every notes edit: update state + ref, then (re)start the debounce so the
   *  content persists ~1s later without a manual click. */
  const onFormChange = useCallback((next: StructuredSheetForm) => {
    if(additionsRef.current.enabled){
      setForm(previous=>({...previous,toothRefs:next.toothRefs}));
      additionsRef.current.change(additionContentFromForm(additionsRef.current.value,next));return;
    }
    formEditRevision.current += 1;
    setForm(next);
    formRef.current = next;
    autosaveRef.current.onEdit();
  }, []);

  /**
   * Load (or refresh) the consult context:
   *   - 'initial': the first open -- show the loading state, reseed the sheet.
   *   - 'refresh': a mid-close refresh -- context (status / outcome tokens)
   *      ONLY, never reseed (a partial close keeps the editable sheet so the
   *      doctor can retry without losing unsaved edits).
   *   - 'start': adopt the newly created sheet; reseed only if no edits
   *      existed before the read or arrived while it was in flight.
   *   - 'reseed' : after a successful close -- reseed the sheet from server
   *      (now finalized / read-only) WITHOUT the loading flash.
   */
  const loadContext = useCallback(
    (mode: 'initial' | 'refresh' | 'reseed' | 'start' | 'recheck' | 'close-recovery'): Promise<void> => {
      if (appointmentId === null) return Promise.resolve();
      if (mode === 'initial') setLoad({ kind: 'loading' });
      const readSequence = ++contextReadSequence.current;
      const epoch = consultationScope.current.epoch;
      const editRevision = formEditRevision.current;
      const profileRevision = profileWriteRevision.current;
      const pristineAtRead = structuredFormsEqual(
        formRef.current, lastSavedFormRef.current,
      );
      return fetchDoctorConsultContext(appointmentId)
        .then((context) => {
          if (epoch !== consultationScope.current.epoch || readSequence !== contextReadSequence.current) return;
          // Once refused, only the person's explicit recheck can restore UI.
          if (accessDeniedRef.current?.epoch === epoch && mode !== 'recheck') return;
          accessDeniedRef.current = null; setAccessDenied(null);
          setLoad({ kind: 'ready', context, consultationEpoch: epoch });
          // A read that began before a successful profile write is not newer
          // truth. Preserve the confirmed result until a subsequent read.
          if (profileRevision === profileWriteRevision.current) setProfileOverride(null);
          if (mode === 'refresh' || mode === 'recheck') return; // context only; keep unsaved edits
          if (mode === 'close-recovery') {
            // A transport failure is not a failed commit. Only this fresh,
            // ordered read of the same sheet may recover a completed Finish.
            // Unreadable or still-draft results keep the existing error/draft;
            // never retry the writer or relax the finalized-record lock.
            if (context.caseSheet?.id !== sheetRef.current?.id ||
                context.caseSheet?.status !== 'finalized') return;
            setFeedback({ kind: 'success', lines: ['Saved record confirmed.'] });
          }
          if (mode === 'start' ||
              (mode === 'initial' && editRevision !== formEditRevision.current)) {
            const hadSheet = sheetRef.current !== null;
            if (!hadSheet && context.caseSheet !== null) {
              sheetRef.current = context.caseSheet;
              setSheet(context.caseSheet);
            }
            // Never replace a newer saved sheet or reset an active debounce.
            if (hadSheet || !pristineAtRead ||
                editRevision !== formEditRevision.current) return;
          }
          const seededForm = structuredFormFromSheet(context.caseSheet);
          setSheet(context.caseSheet);
          sheetRef.current = context.caseSheet;
          setForm(seededForm);
          formRef.current = seededForm;
          // The loaded sheet is the clean baseline -- dirty is measured from here.
          lastSavedFormRef.current = seededForm;
          autosaveRef.current.reset();
          setItemEdits(
            context.caseSheet !== null ? deriveItemEdits(context.caseSheet) : {},
          );
          // Seed the non-conversion reason from the plan's primary recoverable
          // decline (the close reason picker pre-fills; the doctor may change
          // it). Reset the inline-question answer for the fresh visit.
          const suggested =
            context.caseSheet !== null
              ? suggestVisitOutcome(context.caseSheet.planItems)
              : null;
          setNotConvertedReason(suggested ? suggested.declineReason : '');
          setExplicitPick(null);
        })
        .catch((err: unknown) => {
          if (epoch !== consultationScope.current.epoch || readSequence !== contextReadSequence.current) return;
          if (mode !== 'initial') {
            rejectCurrentAccess(err);
            if (err instanceof PortalApiError && [401,403].includes(err.status)) { setClinicalPrint(null); settleRecovery(false); }
            return; // Transport failure retains last truth; authoritative refusal hides it.
          }
          const mapped = consultErrorMessage(err);
          setLoad({
            kind: 'error',
            text: mapped.text,
            scopeDenied: mapped.scopeDenied,
          });
        });
    },
    [appointmentId, meCtx?.me, consultationIdentity, rejectCurrentAccess, settleRecovery],
  );
  loadContextRef.current = loadContext;

  const loadedConsultScope = useRef<string | null>(null);
  useEffect(() => {
    const key = `${appointmentId}:${consultationIdentity}`;
    const changedVisit = loadedConsultScope.current !== key;
    loadedConsultScope.current = key;
    if (changedVisit) setFeedback(null);
    // A refreshed permission hint must not reseed unsaved clinical notes.
    void loadContext(changedVisit || contextRef.current === null ? 'initial' : 'refresh');
  }, [loadContext, appointmentId, meCtx?.me?.organizationId, meCtx?.me?.role]);

  // THE ONE lifted case-history read (C8/C7): the earlier-visits rail and
  // the treatment ledger render from the SAME fetch (one fetch, two
  // renders). Keyed on the linked patient; unlinked visits fetch nothing.
  const historyPatientId =
    load.kind === 'ready' && accessDenied?.epoch !== consultationEpoch ? load.context.patient.patientId : null;
  // DOCTOR-CONSULT-DEMO-POLISH-V1 (item 3): the id of the appointment this
  // consult IS -- excluded from the RELATED rail's "Other appointments"
  // count below so the row never counts the visit you are already inside.
  const currentAppointmentId =
    load.kind === 'ready' ? load.context.appointment.id : null;
  useEffect(() => {
    if (historyPatientId === null) return;
    let cancelled = false;
    setHistory({ kind: 'loading' });
    fetchDoctorCaseHistory(historyPatientId)
      .then((data) => {
        if (cancelled) return;
        setHistory({ kind: 'ready', history: data });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setHistory({ kind: 'error', text: consultErrorMessage(err).text });
      });
    return () => {
      cancelled = true;
    };
  }, [historyPatientId,historyRetry]);
  const previousPlansRead=usePreviousClinicalPlans(historyPatientId,currentAppointmentId,history,()=>setHistoryRetry(value=>value+1));
  // Returning summary: an earlier treatment's saved progress is shown as
  // recorded (started / work recorded on a date), never as an invented count.
  const previousPlanRows=useMemo(()=>previousPlansRead.sheets.flatMap(previous=>previous.planItems.map(item=>({owningSheetId:previous.id,item}))),[previousPlansRead.sheets]);
  const previousPlanWork=useEarlierPlanWork(`${historyPatientId}:${currentAppointmentId}`,previousPlanRows,previousPlansRead.kind==='ready'&&!previousPlansRead.failed);
  // One saved Return booking read for Finish; the booking card's writes bump
  // the revision, so Finish names the same appointment the card shows.
  const [returnBookingRevision,setReturnBookingRevision]=useState(0);
  const returnBookingKey=load.kind==='ready'&&load.context.returnRequestAvailable===true&&load.context.patient.patientId!==null?`${load.context.appointment.id}:${returnBookingRevision}`:null;
  const [returnBookingRead,setReturnBookingRead]=useState<{key:string;appointment:ConsultReturnAppointment|null;failed:boolean}|null>(null);
  useEffect(()=>{
    if(returnBookingKey===null||currentAppointmentId===null)return;
    let cancelled=false;
    fetchConsultReturnBooking(currentAppointmentId).then(r=>{if(!cancelled)setReturnBookingRead({key:returnBookingKey,appointment:r.appointment,failed:false});})
      .catch(()=>{if(!cancelled)setReturnBookingRead({key:returnBookingKey,appointment:null,failed:true});});
    return()=>{cancelled=true;};
  },[returnBookingKey,currentAppointmentId]);
  const savedReturnBooking=returnBookingRead?.key===returnBookingKey?returnBookingRead:null;

  // ROUND 2 (C38): the Related block's appointments fact, composed from the
  // EXISTING doctor patient-lens read -- fired ONLY where the lens signal
  // grants the read (LES-016), for a linked patient. Best-effort: failure
  // leaves the fact null and the row absent.
  //
  // DOCTOR-CONSULT-DEMO-POLISH-V1 (item 3): todayAppointments is a pure
  // IST-date-window read (lib/adapters/supabase/patient-360-read-model.ts)
  // that does NOT exclude the appointment this consult IS -- so a bare
  // "Appointments" count could read as self-referential (or, near a window
  // edge, misleadingly low) while the doctor is sitting inside one of the
  // very appointments being counted. The row is renamed "Other
  // appointments" (ConsultRelatedRail) and the count here excludes
  // currentAppointmentId, so the number is truthful under either label.
  useEffect(() => {
    if (!lensEnabled || historyPatientId === null) return;
    let cancelled = false;
    fetchDoctorPatientLens(historyPatientId)
      .then((lens) => {
        if (cancelled) return;
        setLensRelated(relatedAppointmentsFactFrom(lens, currentAppointmentId));
        setLensAppointments([...new Map([...lens.upcomingAppointments, ...lens.todayAppointments, ...lens.recentVisits].map(a => [a.appointmentId, a])).values()]);
      })
      .catch(() => {
        if (!cancelled) setLensRelated(null);
      });
    return () => {
      cancelled = true;
    };
  }, [lensEnabled, historyPatientId, currentAppointmentId]);

  // ROUND 3: the lifted journey read -- fires when the sheet carries a
  // course; ERROR is a visible state with a retry door (never silent).
  const journeyCourseId = sheet?.treatmentCourseId ?? null;
  const journeyReadGeneration = useRef(0);
  const loadJourney = useCallback(() => {
    const generation = ++journeyReadGeneration.current;
    const epoch = consultationScope.current.epoch;
    const current = () => generation === journeyReadGeneration.current && epoch === consultationScope.current.epoch && sheetRef.current?.treatmentCourseId === journeyCourseId;
    if (journeyCourseId === null) { setJourneyWire(null); setJourneyLoad('none'); return; }
    setJourneyWire(null); setJourneyLoad('loading');
    return fetchTreatmentCourseJourney(journeyCourseId)
      .then(j => {
        if (!current()) return;
        if (j.courseId !== journeyCourseId) { setJourneyLoad('error'); return; }
        setJourneyWire(j); setJourneyLoad('ready');
      })
      .catch(() => { if (current()) setJourneyLoad('error'); });
  }, [journeyCourseId]);
  useEffect(() => { loadJourney(); return () => { journeyReadGeneration.current++; }; }, [loadJourney]);

  const onEarlierPlanAccepted=useCallback(async(fact:ClinicalPlanAcceptanceFact,bearer:string)=>{
    const current=sheetRef.current,epoch=consultationScope.current.epoch;
    if(!current?.treatmentCourseId||current.id!==fact.decisionCaseSheetId||current.appointmentId!==fact.financialAppointmentId)throw Error('The acceptance visit changed.');
    const [context,journey]=await Promise.all([fetchDoctorConsultContext(current.appointmentId,bearer),fetchTreatmentCourseJourney(current.treatmentCourseId,bearer)]);
    if(epoch!==consultationScope.current.epoch||sheetRef.current?.id!==current.id)throw Error('The visit changed.');
    const decision=journey.currentDecisions?.items.find(d=>d.planItemId===fact.planItemId&&d.owningCaseSheetId===fact.owningCaseSheetId);
    if(context.appointment.id!==current.appointmentId||context.caseSheet?.id!==current.id||context.patient.patientId!==current.patientId||context.appointment.clinicId!==contextRef.current?.appointment.clinicId||journey.courseId!==current.treatmentCourseId||journey.clinicId!==context.appointment.clinicId||decision?.effectiveStatus!=='accepted'||decision.revision!==1||decision.acceptance?.requestId!==fact.requestId||decision.acceptance.caseSheetId!==current.id||decision.acceptance.appointmentId!==current.appointmentId)throw Error('The saved acceptance could not be verified.');
    // Adopt only saved attribution and explicit current decisions, preserving all
    // authored notes and raw historical plans. Do not unmount the pending row.
    journeyReadGeneration.current++;
    const merged={...sheetRef.current,conversionDoctorId:context.caseSheet.conversionDoctorId,treatmentDoctorId:context.caseSheet.treatmentDoctorId};
    sheetRef.current=merged;setSheet(merged);setJourneyWire(journey);setJourneyLoad('ready');
    setLoad(previous=>previous.kind==='ready'&&previous.consultationEpoch===epoch?{...previous,context:{...previous.context,attribution:context.attribution,consultation:(context as ConsultContextWithConsultation).consultation}}:previous);
  },[]);

  const onTodayWorkSaved=useCallback(async()=>{
    const current=sheetRef.current,epoch=consultationScope.current.epoch;if(!current)return;
    const context=await fetchDoctorConsultContext(current.appointmentId);
    if(epoch!==consultationScope.current.epoch)return;
    if(context.caseSheet?.id!==current.id||context.patient.patientId!==current.patientId||context.appointment.clinicId!==contextRef.current?.appointment.clinicId)throw Error('The saved treatment could not be verified.');
    const latest=sheetRef.current;if(!latest||latest.id!==current.id)return;
    const merged={...latest,planItems:context.caseSheet.planItems};sheetRef.current=merged;setSheet(merged);
    setItemEdits(previous=>syncItemEdits(previous,context.caseSheet!.planItems,latest.planItems));
    await loadJourney();
    if(epoch===consultationScope.current.epoch)await refreshPendingVisits?.();
  },[loadJourney,refreshPendingVisits]);

  // Reuse the existing idempotent completion act. Join authored drafts first;
  // then register this write with the same pending-plan boundary used by Close.
  // Only the returned plan facts are installed, never stale notes/medicines.
  const onCompleteCourseItem = useCallback(async (owningSheetId: number, itemId: number) => {
    const current = sheetRef.current;
    const epoch = consultationScope.current.epoch;
    if (current === null || current.status !== 'draft' || current.appointmentId !== consultationScope.current.appointmentId || completionLock.current) return;
    const returnFocus = document.activeElement instanceof HTMLElement && document.activeElement.dataset.testid === `consult-journey-complete-${itemId}`;
    const lock = { epoch, itemId }; completionLock.current = lock;
    setBusy(itemId); setFeedback(null);
    let write: Promise<CaseSheetClinicalView> | null = null;
    try {
      if (!await joinWriters(itemId) || epoch !== consultationScope.current.epoch) return;
      if (sheetRef.current?.id !== current.id || sheetRef.current.status !== 'draft') return;
      write = completePlanItem(owningSheetId, itemId, { completedInCaseSheetId: current.id });
      pendingPlanWrites.current.set(itemId, write);
      const view = await write;
      if (epoch !== consultationScope.current.epoch) return;
      const completed = view.planItems.find(item => item.id === itemId);
      if (view.id !== owningSheetId || view.patientId !== current.patientId || !completed?.completedAt ||
          (owningSheetId === current.id && view.appointmentId !== current.appointmentId)) {
        throw new Error('Could not verify the treatment completion. Retry to check the saved result.');
      }
      if (owningSheetId === current.id) {
        const latest = sheetRef.current;
        if (!latest || latest.id !== current.id || latest.patientId !== current.patientId) return;
        const merged = { ...latest, planItems: view.planItems };
        sheetRef.current = merged; setSheet(merged);
        setItemEdits(previous => syncItemEdits(previous, view.planItems, latest.planItems));
      }
      failedCompletions.current.delete(itemId);
      setFeedback({ kind: 'success', lines: [completed.completedInCaseSheetId === current.id
        ? 'Recorded as completed this visit.' : 'The existing completion record was kept.'] });
      await loadJourney();
      if (returnFocus) requestAnimationFrame(() => {
        if (epoch === consultationScope.current.epoch) (document.querySelector<HTMLElement>(`[data-testid="consult-today-item-${itemId}"]`) ?? document.querySelector<HTMLElement>('#consult-stage-4-heading'))?.focus();
      });
    } catch (error) {
      if (epoch === consultationScope.current.epoch) {
        if (write) failedCompletions.current.add(itemId);
        setFeedback({ kind: 'error', lines: [error instanceof Error ? error.message : 'Could not confirm treatment completion. Retry to check the saved result.'] });
      }
    } finally {
      if (epoch === consultationScope.current.epoch) {
        if (write && pendingPlanWrites.current.get(itemId) === write) pendingPlanWrites.current.delete(itemId);
        if (completionLock.current === lock) completionLock.current = null;
        setBusy(null);
      }
    }
  }, [joinWriters, loadJourney]);

  // ROUND 3: the course-wide ledger rows -- EARLIER visits' plan items
  // (oldest visit first; the current sheet's rows render live below them).
  // Only visits that actually carry items contribute (correction 5).
  const courseRows: CourseLedgerExtraRow[] =
    journeyWire === null || sheet === null
      ? []
      : [...journeyWire.visits]
          .filter((v) => v.caseSheetId !== sheet.id)
          .sort((a, b) =>
            (a.appointmentTimeIso ?? '') < (b.appointmentTimeIso ?? '') ? -1 : 1,
          )
          .flatMap((v) =>
            (Array.isArray(v.plan.planItems) ? v.plan.planItems : []).map(
              (item) => ({
                owningSheetId: v.caseSheetId,
                visitDateIso: v.appointmentTimeIso,
                source: 'priorityRank' in item ? item as ClinicalPlanItemView : undefined,
                decision: journeyWire.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===v.caseSheetId),
                financialSheetId: journeyWire.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===v.caseSheetId)?.acceptance?.caseSheetId ?? v.caseSheetId,
                item: {
                  id: item.id,
                  procedureName: item.procedureName,
                  toothArea: item.toothArea ?? null,
                  estimatedValue: item.estimatedValue ?? null,
                  status: journeyWire.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===v.caseSheetId)?.effectiveStatus ?? item.status,
                  completedAt: item.completedAt ?? null,
                  performingDoctorId: 'performingDoctorId' in item ? item.performingDoctorId as number | null | undefined : undefined,
                  catalogDefaultAmountMinorUnits: 'catalogDefaultAmountMinorUnits' in item ? item.catalogDefaultAmountMinorUnits as number | null | undefined : undefined,
                  completedInCaseSheetId: 'completedInCaseSheetId' in item ? item.completedInCaseSheetId as number | null : null,
                  toothRefs: 'toothRefs' in item ? item.toothRefs as ClinicalPlanItemView['toothRefs'] : undefined,
                },
              }),
            ),
          );

  // WARN-ON-NAVIGATE (dirty only). The browser backstop fires on tab close /
  // refresh / external nav while authored content is unsaved -- notes pending
  // the debounce, a plan edit not yet saved, or a typed-but-unadded procedure.
  // The debounced autosave shrinks this window to ~1s; in-app SPA navigation
  // is covered by the autosave's save-on-unmount. A finalized sheet is locked,
  // so it never warns.
  const planWorkPending =
    sheet !== null &&
    (hasPendingPlanWork(
      sheet.planItems,
      itemEdits,
      itemForm.procedureName,
      itemForm.catalogItemId !== null,
    ) ||
      // A tapped-but-unadded tooth selection on the item form is authored
      // work too (TOOTH-NOTATION-INTERIM-V1).
      (itemForm.toothRefs ?? []).length > 0);
  // A finalized original can still have an uncertain report/consent upload.
  // Its registered draft remains protected until the existing writer verifies it.
  const warnOnLeave = [...planControlDrafts.current.values()].some(d => d.dirty()) ||
    ((sheet === null || sheet.status !== 'finalized') &&
    (shouldWarnOnNavigate(autosave.saveState) || planWorkPending || completionLock.current !== null || failedCompletions.current.size > 0));
  useEffect(() => {
    if (!warnOnLeave || typeof window === 'undefined') return undefined;
    const handler = (e: BeforeUnloadEvent): string => {
      e.preventDefault();
      e.returnValue = UNSAVED_NAV_WARNING;
      return UNSAVED_NAV_WARNING;
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [warnOnLeave]);

  // One serialized creation path, reused by the old add control and frozen
  // chart. An uncertain request retains its key and payload through retry.
  const createPlanLines = useCallback((payloads: readonly Parameters<typeof createPlanItem>[1][]): Promise<boolean> => {
    if (pendingPlanCreate.current) return Promise.resolve(false);
    const epoch = consultationScope.current.epoch;
    const visit = consultationScope.current.appointmentId;
    const attempt = (async () => {
      setBusy('item'); setFeedback(null);
      try {
        if (!await autosaveRef.current.flush()) return false;
        if (epoch !== consultationScope.current.epoch) return false;
        if (sheetRef.current === null) await persistDraft();
        if (epoch !== consultationScope.current.epoch) return false;
        const current = sheetRef.current;
        if (!current || current.appointmentId !== visit || current.status === 'finalized') return false;
        for (const payload of payloads) {
          const key = `${epoch}:${JSON.stringify(payload)}`;
          let request = planCreationRequests.current.get(key);
          if (!request) {
            request = { requestId: crypto.randomUUID(), payload };
            planCreationRequests.current.set(key, request);
          }
          failedPlanCreates.current.add(key);
          const view = await createPlanItem(current.id, { ...request.payload, requestId: request.requestId });
          if (epoch !== consultationScope.current.epoch) return false;
          if (view.id !== current.id || view.appointmentId !== current.appointmentId || view.patientId !== current.patientId) {
            throw new Error('Could not confirm this visit’s treatment save.');
          }
          const previousItems = sheetRef.current?.planItems ?? [];
          sheetRef.current = view; setSheet(view);
          setItemEdits(prev => syncItemEdits(prev, view.planItems, previousItems));
          failedPlanCreates.current.delete(key);
          // Keep the successful request for this mounted visit too: two rapid
          // activations before the render must not create a second treatment.
        }
        setFeedback({ kind: 'success', lines: ['Treatment saved to the plan.'] });
        return true;
      } catch (err) {
        if (epoch === consultationScope.current.epoch) setFeedback({ kind: 'error', lines: [consultErrorMessage(err).text] });
        return false;
      } finally {
        if (epoch === consultationScope.current.epoch) setBusy(null);
      }
    })();
    pendingPlanCreate.current = attempt;
    void attempt.finally(() => { if (pendingPlanCreate.current === attempt) pendingPlanCreate.current = null; });
    return attempt;
  }, [persistDraft]);
  const onAddExaminationTreatment = useCallback((request: ExaminationTreatmentRequest) => {
    const item = catalog?.available ? catalog.items.find(row => row.id === request.catalogItemId && row.active) : undefined;
    if (!item) return Promise.resolve(false);
    // Reuse the existing catalogue picker's exact whole-INR default rule.
    // A fractional/unconfigured quote remains unknown; never round or invent it.
    const seed = catalogDefaultSeedRupees(item.defaultAmountMinorUnits);
    return createPlanLines(request.targets.map(target => ({
      catalogItemId: request.catalogItemId, estimatedValue: seed,
      toothRefs: target.toothRefs, toothArea: target.toothArea, status: 'advised',
    })));
  }, [catalog, createPlanLines]);
  const onAddItem = useCallback(() => {
    const built = buildPlanItemCreatePayload(itemForm);
    if (!built.ok) { setFeedback({ kind: 'error', lines: [built.error] }); return; }
    const epoch = consultationScope.current.epoch;
    void createPlanLines([built.payload]).then(ok => {
      if (ok && epoch === consultationScope.current.epoch) setItemForm(EMPTY_ITEM);
    });
  }, [itemForm, createPlanLines]);

  /** THE ONE PLAN-LINE WRITE (#781 handoff, integration order step 1).
   *
   *  It replaces `onItemEditChange` + `onSaveItem` (the pending-copy editor),
   *  `onDecideItem` (the inline decide act) and `onAssignItemDoctor` (the
   *  picker's own write) with a single audited call. Until all of them went
   *  through one path the one-write-per-line fence protected nothing: two
   *  handlers on one line is exactly the defect it exists for, and it is how
   *  a stale reply used to erase a confirmed decision.
   *
   *  IT RETHROWS. The line's hook classifies the failure into the four codes
   *  and renders the copy; swallowing the rejection here would report a
   *  refused write as a save. It also resolves with the REFRESHED sheet,
   *  because the hook reads that view to decide whether this row was really
   *  confirmed -- a reply that does not carry the row is `unconfirmed`.
   */
  const pendingPlanWrites = useRef(new Map<number, Promise<CaseSheetClinicalView>>());
  const failedPlanWrites = useRef(new Set<number>());
  const uncertainPlanWrites = useRef(new Map<number, PlanItemUpdateInput>());
  useEffect(() => {
    pendingPlanWrites.current.clear();
    failedPlanWrites.current.clear(); uncertainPlanWrites.current.clear();
    completionLock.current = null; failedCompletions.current.clear();
    setBusy(null); setFeedback(null);
    pendingPlanCreate.current = null;
    failedPlanCreates.current.clear();
    planCreationRequests.current.clear();
  }, [appointmentId, consultationIdentity]);
  const onLineWrite = useCallback(
    async (itemId: number, patch: PlanItemUpdateInput): Promise<CaseSheetClinicalView> => {
      const current = sheetRef.current;
      const epoch = consultationScope.current.epoch;
      const expectedClinic = contextRef.current?.appointment.clinicId;
      if (current === null || current.appointmentId !== consultationScope.current.appointmentId) {
        throw new Error('The visit record is not loaded.');
      }
      if (pendingPlanWrites.current.has(itemId)) throw new Error('This treatment is still saving.');
      setBusy(itemId);
      setFeedback(null);
      let dispatched = false;
      const submitted = structuredClone(patch);
      const write = (async () => {
        let view: CaseSheetClinicalView | null = null;
        const unanswered = uncertainPlanWrites.current.get(itemId);
        if (unanswered) {
          const verified = await fetchDoctorConsultContext(current.appointmentId);
          if (epoch !== consultationScope.current.epoch || verified.appointment.id !== current.appointmentId ||
              expectedClinic === undefined || verified.appointment.clinicId !== expectedClinic || verified.patient.patientId !== current.patientId ||
              verified.caseSheet?.id !== current.id || !planPatchConfirmedByRead(verified.caseSheet.planItems.find(row => row.id === itemId), unanswered)) {
            throw new ConsultPreWriteError('Save outcome unknown. Check saved values again before retrying. Your typing is still here.');
          }
          uncertainPlanWrites.current.delete(itemId);
          // An exact retry of an independently confirmed result needs no
          // second PUT or audit. A genuinely newer edit can now use the writer.
          if (planPatchConfirmedByRead(verified.caseSheet.planItems.find(row => row.id === itemId), submitted)) view = verified.caseSheet;
        }
        if (view === null) { dispatched = true; view = await updatePlanItem(current.id, itemId, submitted); }
        if (epoch !== consultationScope.current.epoch) throw new Error('The consultation changed.');
        if (view.id !== current.id || view.appointmentId !== current.appointmentId ||
            view.patientId !== current.patientId || !view.planItems.some(row => row.id === itemId)) {
          throw new Error('Could not confirm the treatment save. Reload to check before retrying.');
        }
        const merged = { ...(sheetRef.current ?? current), planItems: view.planItems };
        sheetRef.current = merged;
        setSheet(merged);
        setItemEdits(prev => syncItemEdits(prev, view.planItems, current.planItems));
        failedPlanWrites.current.delete(itemId); uncertainPlanWrites.current.delete(itemId);
        return view;
      })();
      pendingPlanWrites.current.set(itemId, write);
      try {
        return await write;
      } catch (error) {
        if (epoch === consultationScope.current.epoch) {
          failedPlanWrites.current.add(itemId);
          if (dispatched && !definitiveConsultRejection(error)) uncertainPlanWrites.current.set(itemId, submitted);
        }
        throw error;
      } finally {
        if (epoch === consultationScope.current.epoch) {
          pendingPlanWrites.current.delete(itemId);
          if (pendingPlanWrites.current.size === 0) setBusy(null);
        }
      }
    },
    [],
  );

  const onRemoveItem = useCallback(async(itemId:number,input:PlanItemRemovalInput):Promise<void>=>{
    const current=sheetRef.current,epoch=consultationScope.current.epoch,clinic=contextRef.current?.appointment.clinicId;
    if(!current||current.status!=='draft'||current.appointmentId!==consultationScope.current.appointmentId||clinic==null)
      throw new ConsultPreWriteError('The current draft visit is not loaded.');
    if(pendingPlanWrites.current.size||completionLock.current!==null)throw new ConsultPreWriteError('Wait for the treatment save to finish.');
    for(const key of [`plan-price-${itemId}`,`plan-remark-${itemId}`,`plan-decision-${itemId}:decision`])
      if(planControlDrafts.current.get(key)?.dirty())throw new ConsultPreWriteError('Save or discard this treatment’s changes before removing it.');
    setBusy(itemId);setFeedback(null);
    const write=(async()=>{
      const view=await removePlanItem(current.id,itemId,input);
      if(epoch!==consultationScope.current.epoch||clinic!==contextRef.current?.appointment.clinicId)throw new Error('The consultation changed.');
      if(view.id!==current.id||view.patientId!==current.patientId||view.appointmentId!==current.appointmentId||view.planItems.some(row=>row.id===itemId))
        throw new Error('Could not confirm removal. Retry the same removal to check it.');
      const merged={...(sheetRef.current??current),planItems:view.planItems};sheetRef.current=merged;setSheet(merged);
      setItemEdits(prev=>syncItemEdits(prev,view.planItems,current.planItems));
      failedPlanWrites.current.delete(itemId);uncertainPlanWrites.current.delete(itemId);
      void loadJourney();setFeedback({kind:'success',lines:['Treatment removed from this draft.']});
      requestAnimationFrame(()=>{if(epoch===consultationScope.current.epoch)document.querySelector<HTMLElement>('.consult-v14g__stage:not([hidden]) h2')?.focus({preventScroll:true});});
      return view;
    })();
    pendingPlanWrites.current.set(itemId,write);
    try {await write;} finally {if(epoch===consultationScope.current.epoch){pendingPlanWrites.current.delete(itemId);if(!pendingPlanWrites.current.size)setBusy(null);}}
  },[loadJourney]);

  /** The page banner's half of a settled line write. A FAILURE is deliberately
   *  NOT banner-ed: it already renders on the line, beside the control that
   *  produced it, and a second copy at the foot of the column would be the
   *  same fact twice. */
  const onLineSettled = useCallback(
    (_itemId: number, kind: PlanWriteKind, outcome: string) => {
      if (outcome !== 'confirmed') return;
      if (kind === 'decision') void loadContext('refresh');
      void loadJourney();
      setFeedback({ kind: 'success', lines: [PLAN_WRITE_CONFIRMED_COPY[kind]] });
    },
    [loadContext, loadJourney],
  );

  /** Flush every pending plan-item inline edit (status / reason) before the
   *  close locks the plan -- no marked procedure is lost. Returns false on the
   *  first write that fails (the close then STOPS honestly). */
  const flushPlanEdits = useCallback(async (): Promise<boolean> => {
    const epoch = consultationScope.current.epoch;
    const pending = [...pendingPlanWrites.current.values()];
    const outcomes = await Promise.allSettled(pending);
    if (epoch !== consultationScope.current.epoch || outcomes.some(result => result.status === 'rejected')) return false;
    // Draft commit order is independent of visual table placement. Validate
    // prices before decisions, and preserve decision-before-remark behavior.
    const priority = (key: string) => key.startsWith('doctor-extra-before:') ? -1 : key.startsWith('plan-price-') ? 0 : key.endsWith(':decision') ? 1 : key.startsWith('plan-remark-') ? 2 : 3;
    const drafts = [...planControlDrafts.current].sort(([a],[b]) => priority(a)-priority(b));
    for (const [, draft] of drafts) {
      if (!await draft.flush() || epoch !== consultationScope.current.epoch) return false;
    }
    if (failedPlanWrites.current.size > 0) return false;
    // Row drafts are the only editable plan source. The retired itemEdits
    // mirror is not a writer: React may not have rendered the preceding PUT
    // yet, so flushing that mirror can restore an older decision or remark.

    return true;
  }, []);

  joinPlanWritersRef.current = flushPlanEdits;

  /**
   * The ONE close act (SCOPE 3). Flush pending notes + plan edits (never close
   * over unsaved content), then run the client-side orchestrator over the
   * EXISTING audited writes: GRANTED -> fulfil -> derived outcome -> derived
   * conversion -> lock; UNGRANTED (R-1) -> lock the clinical record + honest
   * handoff. Refresh from server truth afterward (reseed on success -> the
   * locked read-only view; a light context refresh on a partial failure so the
   * strip re-derives and a retry completes the rest).
   */
  const onClose = useCallback(async () => {
    const ctx = contextRef.current;
    if (ctx === null) return;
    setBusy('close');
    setFeedback(null);
    const closeEpoch = consultationScope.current.epoch;
    const notesOk = await joinWriters();
    if (closeEpoch !== consultationScope.current.epoch) return;
    if (!notesOk) {
      setFeedback({
        kind: 'error',
        lines: [
          'Your consultation changes could not be saved, so the visit was not closed. Check the editors and try again.',
        ],
      });
      setBusy(null);
      return;
    }
    if (!await saveDefaultConsultationFee()) {
      if (closeEpoch === consultationScope.current.epoch) setBusy(null);
      return;
    }
    if (closeEpoch !== consultationScope.current.epoch) return;
    // joinWriters already flushed every registered plan draft exactly once.
    let freshSheet = sheetRef.current;
    if (freshSheet === null) {
      setFeedback({
        kind: 'error',
        lines: ['Record the visit notes before closing.'],
      });
      setBusy(null);
      return;
    }
    let currentCourseForClose:CourseJourneyResponse|null=null;
    if(freshSheet.treatmentCourseId!==null){
      try{currentCourseForClose=await fetchTreatmentCourseJourney(freshSheet.treatmentCourseId);
        if(closeEpoch!==consultationScope.current.epoch)return;
        if(currentCourseForClose.courseId!==freshSheet.treatmentCourseId||currentCourseForClose.visits.some(v=>v.plan.audience!=='clinical'))throw Error('Current treatment unavailable.');
      }catch{if(closeEpoch===consultationScope.current.epoch){setFeedback({kind:'error',lines:['Current treatment could not be verified. Retry before finishing.']});setBusy(null);}return;}
    }
    // Today’s deliberate writer has now settled. Derive only from freshly
    // admitted saved current-visit work, not pre-save UI state or dated additions.
    if(ctx.finishReviewAvailable===true && !formRef.current.finishReview?.outcome) {
      try {
        const expected=freshSheet;
        const [verified,today,course]=await Promise.all([
          getCaseSheet(expected.id),fetchClinicalTodayWork(expected.id),
          Promise.resolve(currentCourseForClose),
        ]);
        if(closeEpoch!==consultationScope.current.epoch)return;
        if(verified.audience!=='clinical'||verified.id!==expected.id||verified.appointmentId!==expected.appointmentId||verified.patientId!==expected.patientId||verified.treatmentCourseId!==expected.treatmentCourseId||
          today.caseSheetId!==expected.id||today.facts.some(fact=>fact.caseSheetId!==expected.id)||
          course&&(course.courseId!==expected.treatmentCourseId||course.visits.some(visit=>visit.plan.audience!=='clinical')))throw Error('Saved work changed.');
        const rows=(course?.visits??[]).filter(visit=>visit.caseSheetId!==expected.id).flatMap(visit=>(visit.plan.planItems??[]).map(item=>({item:{
          id:item.id,status:course?.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===visit.caseSheetId)?.effectiveStatus??item.status,completedAt:item.completedAt??null,
          completedInCaseSheetId:'completedInCaseSheetId' in item?item.completedInCaseSheetId as number|null:null,
        }})));
        const outcome=derivedFinishOutcome(verified,rows,true,today);
        if(!outcome)throw Error('Saved work unavailable.');
        onTodayWorkRead(today);
        onFormChange({...formRef.current,finishReview:{version:1,googleReviewAsked:formRef.current.finishReview?.googleReviewAsked??null,outcome}});
        if(!await autosaveRef.current.flush())throw Error('Visit outcome was not saved.');
        if(closeEpoch!==consultationScope.current.epoch)return;
        freshSheet=sheetRef.current;
        if(!freshSheet||freshSheet.id!==expected.id)throw Error('Visit changed.');
      }catch{
        if(closeEpoch===consultationScope.current.epoch){setFeedback({kind:'error',lines:['The saved work and visit outcome could not be confirmed. Retry before finishing.']});setBusy(null);}return;
      }
    }
    if(ctx.returnRequestAvailable===true && (!freshSheet.returnRequest || (freshSheet.returnRequest.timing==='other'&&!returnRequestDate(freshSheet.returnRequest)))) {
      setFeedback({kind:'error',lines:['Set the return visit, or choose No follow-up needed, before finishing.']});setBusy(null);return;
    }
    const newlyAccepted=(currentCourseForClose?.visits??[]).flatMap(visit=>visit.plan.audience==='clinical'?(visit.plan.planItems??[]).map(item=>item as ClinicalPlanItemView).filter(item=>currentCourseForClose!.currentDecisions?.items.some(d=>d.planItemId===item.id&&d.owningCaseSheetId===visit.caseSheetId&&d.effectiveStatus==='accepted'&&d.acceptance?.caseSheetId===freshSheet!.id)).map(item=>({...item,status:'accepted' as const})):[]);
    const derivation = deriveVisitClose([...freshSheet.planItems,...newlyAccepted], explicitPick);
    const result = await closeVisit(CLOSE_DEPS, {
      appointmentId: freshSheet.appointmentId,
      caseSheetId: freshSheet.id,
      canFulfil: ctx.capabilities.canFulfil,
      currentStatus: ctx.appointment.status,
      recordedOutcomeEvents: ctx.outcomeEvents,
      derivation,
      notConvertedReason,
    });
    // The admitted old visit may finish, but its receipt must not read/reseed
    // the next visit or clear that visit's own pending Finish state.
    if (closeEpoch !== consultationScope.current.epoch) return;
    setFeedback(result.feedback);
    // AWAIT the refresh BEFORE re-enabling the close button: a second click may
    // NOT run against a STALE snapshot. onClose reads contextRef (status +
    // recordedOutcomeEvents) for its idempotency skips; the appointment_events
    // ledger is append-only with no server dedup, so a stale re-run would
    // double-record the outcome/conversion. Keeping busy set until the fresh
    // context lands closes that window (adversarial-review [MAJOR] fix).
    await loadContext(result.closed ? 'reseed' : 'close-recovery');
    if (closeEpoch !== consultationScope.current.epoch) return;
    setBusy(null);
  }, [explicitPick, notConvertedReason, flushPlanEdits, loadContext, joinWriters, saveDefaultConsultationFee, onFormChange, onTodayWorkRead]);

  if (appointmentId === null) return null;

  if (load.kind === 'loading' || (load.kind === 'ready' &&
      (load.context.appointment.id !== appointmentId ||
       load.consultationEpoch !== consultationScope.current.epoch))) {
    // Route/principal changes must hide the previous visit synchronously,
    // before the effect starts its new read. Never paint another patient's header.
    // The shared skeleton loading primitive (SCOPE 6: no borrowed
    // cross-surface classes; role-neutral, aria role=status built in).
    return (
      <div className="dashboard consult-workspace">
        <LoadingState label="Opening the visit..." lines={4} />
      </div>
    );
  }

  if (load.kind === 'error') {
    // The shared section-failure wrapper: WHAT failed + the domain message
    // VERBATIM (ERROR-HONESTY LAW) + ONE way back (never a dead end).
    return (
      <div className="dashboard consult-workspace">
        <ErrorState
          title="This visit could not be opened."
          detail={load.text}
          testId="consult-load-error"
          action={
            <AcButton
              size="sm"
              variant="secondary"
              onClick={() => navigate('/dashboard/doctor')}
              data-testid="consult-back-to-queue"
            >
              Back to my queue
            </AcButton>
          }
        />
      </div>
    );
  }

  // ROUND 2 masthead + rollup derivations (coverage C06 / C09 / C21-24 /
  // C39): pure composition over the reads this page already holds -- the
  // lifted case-history state, this visit's served payments, and the plan on
  // the sheet. Each answers null when not exactly derivable (honest absence).
  const visitOrdinal = consultVisitOrdinal(history, load.context.appointment.id);
  const paidAllVisits = paidAcrossVisitsMinorUnits(
    history,
    load.context.appointment.id,
    load.context.paymentsForVisit,
  );
  const courseSubline =
    sheet !== null ? nextCourseSublineFrom(sheet.planItems) : null;
  // C40: the intake index line's count -- the page's ONE intake read.
  // DOCTOR-CONSULT-DEMO-POLISH-V1 (item 1): counts CLINICAL answers only
  // (clinicalReportedAnswers) -- reason_for_visit is desk-owned and already
  // shown as its own header line, so it must never inflate this "patient-
  // reported answers render in the intake block above" count on its own.
  const intakeAnswerCount =
    intakeState.kind === 'ready' && intakeState.view.questionnairePresent
      ? clinicalReportedAnswers(intakeState.view.answers).length
      : null;

  // D3 + D1 (DOCTOR-FLOW-AFTER-INTAKE-V1): the stage ladder, the panel's
  // honest suggestion, and the next-visit fact line -- PURE derivations over
  // reads already lifted on this page (the ONE journey read, the ONE sheet
  // form, the consult context). consult-stage-view.ts owns the honesty
  // fences: no ladder pre-apply, no ladder without an accepted item, a
  // suggestion only from the course's own recorded interval.
  const stageLadder = deriveCourseStageLadder(journeyWire);
  const followUpSuggestion = suggestedFollowUpOption(
    journeyWire,
    sheet?.id ?? null,
  );
  const followUpOptionsWire = load.context.followUpOptions ?? [];
  const attributionWire = load.context.attribution ?? null;
  const rosterWire = load.context.clinicDoctors ?? [];
  // DOCTOR-FINDABILITY-AT-SCALE-V1: the wire says when the org roster
  // exceeded its bound -- the picker then renders the incompleteness.
  const rosterTruncatedWire = load.context.clinicDoctorsTruncated === true;
  const finalizedSheet =
    sheet !== null && sheet.status === 'finalized' ? sheet : null;
  // The close strip's fact line (pre-close lead + EVERY closed branch): the
  // LIVE form pre-close (autosave persists the same token at the tap), the
  // FINALIZED sheet after (the durable truth). '' = nothing recorded -> no
  // line (byte-identical older render).
  const nextVisitToken =
    finalizedSheet !== null
      ? (finalizedSheet.followUpOption ?? '')
      : form.followUpOption;
  const nextVisitNote = (
    finalizedSheet !== null ? (finalizedSheet.followUpNote ?? '') : form.followUpNote
  ).trim();
  let nextVisitLine: string | null = null;
  if (nextVisitToken !== '') {
    const optionPart =
      nextVisitToken === FOLLOW_UP_CUSTOM_KEY
        ? nextVisitNote !== ''
          ? nextVisitNote
          : 'Other'
        : followUpOptionLabel(nextVisitToken, followUpOptionsWire);
    const stagePart =
      stageLadder !== null ? nextVisitStageTitle(stageLadder) : null;
    // The handoff doctor for the fact line: the form's explicit pick, else
    // the stamped treatment doctor, else the visit's assigned doctor (the
    // same precedence the panel shows). Name resolves from the served
    // roster only -- unresolvable = the line simply omits the doctor.
    const nextVisitDoctorId =
      (finalizedSheet !== null
        ? (finalizedSheet.treatmentDoctorId ?? null)
        : form.treatmentDoctorId) ??
      attributionWire?.treatmentDoctorId ??
      attributionWire?.assignedDoctorId ??
      null;
    const nextVisitDoctorName =
      rosterWire.find((d) => d.id === nextVisitDoctorId)?.name ?? null;
    nextVisitLine = `Next visit: ${[
      ...(stagePart !== null ? [stagePart] : []),
      optionPart,
      ...(nextVisitDoctorName !== null ? [`with ${nextVisitDoctorName}`] : []),
      finalizedSheet !== null
        ? 'sent to Front Desk to schedule'
        : 'sent to Front Desk at close',
    ].join(' - ')}`;
  }
  if(load.context.returnRequestAvailable===true){
    nextVisitLine=returnRequestSummary(finalizedAdditions.enabled?finalizedAdditions.saved.returnRequest:finalizedSheet?.returnRequest??form.returnRequest);
    const booked=savedReturnBooking?.appointment&&activeReturnBooking(savedReturnBooking.appointment.status)?savedReturnBooking.appointment:null;
    if(booked)nextVisitLine=bookedReturnLine(booked,load.context.appointment.clinicName??'This clinic',load.context.clinicDoctors?.find(doctor=>doctor.id===booked.doctorId)?.name??null);
  }
  const recordOpen = recordEpoch === load.consultationEpoch;
  const recordDoctorName = (id: number | null | undefined) => id == null ? null : load.context.clinicDoctors?.find(doctor => doctor.id === id)?.name ?? null;
  const recordEffectiveStatus = (owningSheetId: number, itemId: number) =>
    journeyWire?.currentDecisions?.items.find(d => d.planItemId === itemId && d.owningCaseSheetId === owningSheetId)?.effectiveStatus ?? null;
  // Legacy D1 remains warn-only. Frozen V14g requires an explicit Return
  // choice when its storage is available; None is a choice, not a missing fact.
  const courseNoFollowUpWarn =
    load.context.returnRequestAvailable !== true &&
    stageLadder !== null && !stageLadder.complete && nextVisitToken === '';

  const liveIntakeComplete = answeredIntakeKeys !== null && intakeState.kind === 'ready'
    ? consultLiveRequiredAnswered(intakeState.view.questions,
      new Set(answeredIntakeKeys.split(',').filter(Boolean))) : null;
  // Once the mounted editor has reported its current answers, a prior saved
  // completeness flag must not override newly missing/invalid required detail.
  const nextActionIntake = liveIntakeComplete === false && intakeState.kind === 'ready'
    ? { ...intakeState, view: { ...intakeState.view,
      completion: { ...intakeState.view.completion, complete: false } } }
    : intakeState;

  // The stage footer describes the whole visit, not only the notes writer.
  // Reuse the mounted recovery owners; this projection never saves or clears them.
  const stageWriters = [autosave.boundary, intakeRecoveryRef.current,
    profileRecoveryRef.current, prescriptionRecoveryRef.current,
    finalizedAdditions.enabled ? finalizedAdditions.boundary : null]
    .filter((writer): writer is ConsultWriterBoundary => writer !== null);
  const unsettledWriter = stageWriters.find(writer => writer.uncertain() || writer.message() !== null);
  const stageSaveState: ConsultSaveState = stageWriters.some(writer => writer.pending()) ||
    pendingPlanCreate.current !== null || pendingPlanWrites.current.size > 0
    ? { kind: 'saving' }
    : unsettledWriter
      ? { kind: 'error', message: unsettledWriter.message() ?? 'Save outcome unknown. Check saved values before continuing.' }
      : uncertainPlanWrites.current.size > 0 || failedPlanCreates.current.size > 0 || failedPlanWrites.current.size > 0 || failedCompletions.current.size > 0
        ? { kind: 'error', message: 'Treatment save is not confirmed. Retry the affected treatment.' }
        : stageWriters.some(writer => writer.dirty?.()) ||
          !structuredFormsEqual(formRef.current, lastSavedFormRef.current) ||
          [...planControlDrafts.current.values()].some(draft => draft.dirty())
          ? { kind: 'dirty' }
          : finalizedAdditions.enabled ? finalizedAdditions.saveState : autosave.saveState;

  const prepareClinicalPrint = async (kind: ConsultationPrintKind|'estimate') => {
    if (printLock.current?.epoch === consultationScope.current.epoch) return;
    const epoch = consultationScope.current.epoch;
    printOrigin.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const lock={epoch};printLock.current=lock;setPreparingPrintEpoch(epoch);setPrintFailure(null);
    try {
      if (!await joinWriters()) {
        if (epoch === consultationScope.current.epoch) setPrintFailure({epoch,text:'Save is not confirmed. Resolve the saved record before printing.'});
        return;
      }
      if (epoch !== consultationScope.current.epoch) return;
      const expectedSheet = sheetRef.current;
      if (!expectedSheet) throw new Error('Visit record unavailable.');
      const needsEstimate = kind === 'estimate' || kind === 'patient' || kind === 'internal';
      // All writers have settled. These independent admitted reads can run
      // together; validate their exact patient/visit/course identities below.
      // The internal sheet also joins this visit's current earlier-records read
      // (the shared admitted reader), so a print requested while it loads waits
      // for it instead of keeping "unavailable" after it arrives.
      const [saved, savedIntake, estimateContext, estimateCourse, investigations, savedAdditions, todayWork, previousRead] = await Promise.all([
        getCaseSheet(expectedSheet.id), getIntakeQuestionnaire(expectedSheet.appointmentId),
        needsEstimate ? fetchDoctorConsultContext(appointmentId) : Promise.resolve(null),
        needsEstimate && expectedSheet.treatmentCourseId != null ? fetchTreatmentCourseJourney(expectedSheet.treatmentCourseId) : Promise.resolve(null),
        needsEstimate ? fetchClinicalInvestigations(expectedSheet.id) : Promise.resolve(null),
        expectedSheet.status==='finalized' ? fetchClinicalFinalizedAdditions(expectedSheet.id) : Promise.resolve(null),
        needsEstimate ? fetchClinicalTodayWork(expectedSheet.id) : Promise.resolve(null),
        kind === 'internal' ? previousPlansRead.settled() : Promise.resolve(null),
      ]);
      const savedBooking = needsEstimate && load.context.returnRequestAvailable === true
        ? await fetchConsultReturnBooking(expectedSheet.appointmentId).then(r => ({ failed: false, appointment: r.appointment }), () => ({ failed: true, appointment: null }))
        : null;
      if (epoch !== consultationScope.current.epoch) return;
      if (savedIntake.audience !== 'clinical' || savedIntake.underIdentityReview || savedIntake.appointmentId !== appointmentId ||
          saved.audience !== 'clinical' || saved.id !== expectedSheet.id || saved.patientId !== load.context.patient.patientId || saved.appointmentId !== appointmentId) throw new Error('Record changed');
      if(savedAdditions&&(!savedAdditions.available||savedAdditions.additions.some(a=>a.caseSheetId!==saved.id)))throw new Error('Later entries unavailable.');
      if(todayWork&&(todayWork.caseSheetId!==saved.id||todayWork.facts.some(fact=>fact.caseSheetId!==saved.id)))throw new Error('Saved work belongs to another visit.');
      const savedPrescription=prescriptionWithAdditions(saved,savedAdditions?.additions??[]);
      if (kind === 'prescription' && prescriptionProblems(savedPrescription).length) {
        setPrintFailure({epoch,text:'Complete the saved medicines before printing. ' + prescriptionProblems(savedPrescription).join(' ')}); return;
      }
      let estimate: React.ComponentProps<typeof EstimatePrintView>['savedEstimate'];
      let visitAttribution:SavedVisitDoctorLabels|undefined,returnVisitLabel:string|null=null,clinicalProfile:PatientClinicalProfileView|undefined;
      let returnBooking:{line:string|null;failed:boolean}|undefined;
      if(needsEstimate){
        const context=estimateContext,course=estimateCourse;
        if(epoch!==consultationScope.current.epoch)return;
        if(!context || saved.treatmentCourseId !== expectedSheet.treatmentCourseId || context.patient.patientId!==saved.patientId || context.appointment.id!==saved.appointmentId || context.caseSheet?.id!==saved.id ||
          (course && (course.courseId!==saved.treatmentCourseId || course.visits.some(visit=>visit.plan.audience!=='clinical'))))throw new Error('Estimate source changed');
        const earlier=(course?.visits??[]).filter(visit=>visit.caseSheetId!==saved.id).flatMap(visit=>(visit.plan.planItems??[]).map(item=>({...item,status:course?.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===visit.caseSheetId)?.effectiveStatus??item.status,financialSheetId:course?.currentDecisions?.items.find(d=>d.planItemId===item.id&&d.owningCaseSheetId===visit.caseSheetId)?.acceptance?.caseSheetId??visit.caseSheetId,toothArea:'toothArea' in item?item.toothArea as string|null:null,toothRefs:'toothRefs' in item?item.toothRefs as ClinicalPlanItemView['toothRefs']:undefined,performingDoctorId:'performingDoctorId' in item?item.performingDoctorId as number|null:null,owningSheetId:visit.caseSheetId})));
        const rows=[...saved.planItems.map(item=>({...item,owningSheetId:saved.id,financialSheetId:saved.id})),...earlier];
        const fee=(context as ConsultContextWithConsultation).consultation;
        clinicalProfile=context.clinicalProfileAvailable === true ? context.clinicalProfile : undefined;
        visitAttribution=savedVisitDoctorLabels(saved,context.attribution);
        const followUp=saved.followUpOption?.trim();
        returnVisitLabel=saved.returnRequest !== undefined ? returnRequestSummary(saved.returnRequest) : followUp ? (followUp===FOLLOW_UP_CUSTOM_KEY ? saved.followUpNote?.trim()||'Other' : followUpOptionLabel(followUp,context.followUpOptions??[])) : null;
        if(savedBooking){
          const booked=savedBooking.appointment&&savedBooking.appointment.patientId===saved.patientId&&activeReturnBooking(savedBooking.appointment.status)?savedBooking.appointment:null;
          returnBooking={failed:savedBooking.failed,line:booked?bookedReturnLine(booked,context.appointment.clinicName??'This clinic',context.clinicDoctors?.find(doctor=>doctor.id===booked.doctorId)?.name??null):null};
        }

        if(investigations?.orders.some(order=>Number(order.case_sheet_id)!==saved.id||order.patient_id!==saved.patientId||Number(order.clinic_id)!==context.appointment.clinicId))throw new Error('Investigation source changed');
        estimate={investigations,consultationFee:fee?.kind==='ready'?fee.view.financials?.netMinorUnits??null:null,consultationFeeReason:isFreeConsultationFollowUp(fee)?'Free follow-up':fee?.kind==='ready'?(fee.bill?.waived?fee.view.activity?.reason:fee.view.amountAdjustment?.lastActivity?.reason)??null:null,rows:rows.map(item=>({...item,doctorLabel:context.clinicDoctors?.find(doctor=>doctor.id===item.performingDoctorId)?.name??null})),totals:consultPlanEstimate(rows.map(item=>({caseSheetId:item.financialSheetId,status:item.status,amount:item.estimatedValue})),clinicalEstimateDiscounts([saved,...(course?.visits??[]).filter(visit=>visit.caseSheetId!==saved.id).flatMap(visit=>visit.plan.audience==='clinical'?[{id:visit.caseSheetId,estimateAdjustment:visit.plan.estimateAdjustment}]:[])]),todayWithInvestigations(fee?.kind==='ready'?fee.view.financials?.netMinorUnits??null:null,investigations))};
      }
      if (accessDeniedRef.current?.epoch === epoch) return;
      setClinicalPrint({ epoch, kind, sheet: saved, intake: savedIntake, estimate, visitAttribution, returnVisitLabel, returnBooking, clinicalProfile, todayWork, additions:savedAdditions?.additions??[], previousRecords:previousRead?.kind==='ready'&&!previousRead.failed ? previousRead.sheets.filter(previous=>previous.patientId===saved.patientId&&previous.appointmentId!==saved.appointmentId&&previous.status==='finalized') : undefined });
    } catch { if (epoch === consultationScope.current.epoch) setPrintFailure({epoch,text:'Could not verify the saved record. Please try again.'}); }
    finally { if(printLock.current===lock)printLock.current=null;if(epoch===consultationScope.current.epoch)setPreparingPrintEpoch(null); }
  };

  return (
    <ConsultationPresentationContext.Provider value={accessDenied?.epoch === consultationEpoch}>
    <Dialog open={clinicalPrint !== null && clinicalPrint.epoch===consultationScope.current.epoch} onOpenChange={open=>{if(!open)setClinicalPrint(null);}}>
      {clinicalPrint !== null && clinicalPrint.epoch===consultationScope.current.epoch ? <DialogContent className="consult-v14g__print-dialog" showCloseButton={false} id="consult-print-dialog" initialFocus={()=>document.getElementById('consult-print-dialog')} finalFocus={printOrigin} data-testid="consult-print-dialog">
        <DialogTitle className="sr-only">{clinicalPrint.kind==='estimate'?'Treatment estimate':CONSULTATION_PRINT_TITLES[clinicalPrint.kind]}</DialogTitle>
        <PrintSheetHostContext.Provider value={true}>
        {clinicalPrint.kind==='estimate' ? <EstimatePrintView
          sheet={clinicalPrint.sheet} savedEstimate={clinicalPrint.estimate} visitOrdinal={visitOrdinal}
          clinicLabel={load.context.appointment.clinicName??'Clinic unavailable'} patientLabel={consultBannerName(load.context.patient)} patientUmr={load.context.patient.umr}
          backLabel="Close" onBack={()=>setClinicalPrint(null)}/>
         : <ConsultationPrintView kind={clinicalPrint.kind} additions={clinicalPrint.additions} sheet={clinicalPrint.sheet} intake={clinicalPrint.intake} patient={load.context.patient}
          savedEstimate={clinicalPrint.estimate} previousRecords={clinicalPrint.previousRecords} todayWork={clinicalPrint.todayWork} visitAttribution={clinicalPrint.visitAttribution} returnVisitLabel={clinicalPrint.returnVisitLabel} returnBooking={clinicalPrint.returnBooking} clinicalProfile={clinicalPrint.clinicalProfile}
          clinicLabel={load.context.appointment.clinicName??'Clinic unavailable'} visitDate={load.context.appointment.appointmentTime} onBack={()=>setClinicalPrint(null)}/>}
        </PrintSheetHostContext.Provider>
        <div className="consult-v14g__print-close"><AcButton variant="primary" onClick={()=>setClinicalPrint(null)}>Close</AcButton></div>
      </DialogContent>:null}
    </Dialog>
    {accessDenied?.epoch === consultationScope.current.epoch ? <div className="dashboard consult-workspace">
      <ErrorState title="Visit access is unavailable" detail={accessDenied.text} testId="consult-access-denied"
        action={<AcButton ref={accessCheckButton} disabled={checkingAccess} onClick={() => { setCheckingAccess(true); void loadContext('recheck').finally(() => setCheckingAccess(false)); }}>{checkingAccess ? 'Checking access…' : 'Check access again'}</AcButton>} />
    </div> : null}
    {/* Preserve unresolved request owners for the same actor while withholding
        protected content and controls after an authoritative read refusal. */}
    <div hidden={accessDenied?.epoch === consultationScope.current.epoch}>
    {recoveryDialog !== null ? <ConsultRecoveryDialog
      kind={recoveryDialog}
      busy={recoveryBusy}
      messages={[["Treatment changes", [...planControlDrafts.current.values()].some(draft=>!draft.prepareRestore().valid()) ? "A treatment save is outstanding or uncertain. Return to the affected line and retry it." : null], ["Clinical notes", autosave.boundary.message()], ["Patient intake", intakeRecoveryRef.current?.message() ?? null], ["Doctor-confirmed profile", profileRecoveryRef.current?.message() ?? null], ["Medicines", prescriptionRecoveryRef.current?.message() ?? null], ["Later entries", finalizedAdditions.boundary.message()], ["Treatment", pendingPlanCreate.current || pendingPlanWrites.current.size ? "Saving…" : uncertainPlanWrites.current.size ? "Save outcome unknown. Check saved values again before leaving. Your typing is still here." : failedPlanCreates.current.size || failedCompletions.current.size ? "Save is not confirmed. Keep editing and retry the affected treatment before leaving." : failedPlanWrites.current.size ? "Save is not confirmed. Saved values will be checked before unsaved changes are discarded." : null]].filter((entry): entry is [string, string] => entry[1] !== null).map(([label, message]) => label + ': ' + message)}
      canLeave={!finalizedAdditions.boundary.pending() && !finalizedAdditions.boundary.uncertain() && !autosave.boundary.pending() && !autosave.boundary.uncertain() &&
        !(intakeRecoveryRef.current?.pending() ?? false) && !(intakeRecoveryRef.current?.uncertain() ?? false) &&
        !(profileRecoveryRef.current?.pending() ?? false) && !(profileRecoveryRef.current?.uncertain() ?? false) &&
        !(prescriptionRecoveryRef.current?.pending() ?? false) && !(prescriptionRecoveryRef.current?.uncertain() ?? false) &&
        !pendingPlanCreate.current && failedPlanCreates.current.size === 0 && pendingPlanWrites.current.size === 0 && !completionLock.current && failedCompletions.current.size === 0 && [...planControlDrafts.current.values()].every(draft=>draft.prepareRestore().valid())}
      onStay={() => settleRecovery(false)}
      onRetry={() => void retryRecovery()}
      onCheck={() => void checkWriters()}
      onAbandon={() => void restoreVerified().then(ok => { if (ok) settleRecovery(true); })}
    /> : null}
    {preparingPrint ? <p role="status">Checking saved record…</p> : null}
    {printError ? <p role="alert" data-testid="consult-print-error">{printError}</p> : null}
    {recordOpen ? <ConsultPatientRecord patient={load.context.patient}
      viewerSpecialty={load.context.clinicDoctors?.find(doctor => doctor.id === (actingDoctor.status === 'available' ? actingDoctor.doctorId : null))?.specialty ?? null}
      profile={load.context.clinicalProfileAvailable === true ? load.context.clinicalProfile ?? null : null}
      sheets={[...(sheet ? [sheet] : []), ...previousPlansRead.sheets.filter(previous => previous.patientId === load.context.patient.patientId && previous.id !== sheet?.id)]}
      sheetsState={previousPlansRead.kind === 'ready' ? previousPlansRead.failed ? 'error' : 'ready' : previousPlansRead.kind}
      history={history.kind === 'ready' ? history.history.entries : []}
      doctorName={recordDoctorName} effectiveStatus={recordEffectiveStatus}
      appointments={lensAppointments} returnLine={nextVisitLine}
      // A finished visit is only unsaved through its later-entries writer.
      unsaved={sheet?.status === 'finalized'
        ? finalizedAdditions.editable && (finalizedAdditions.boundary.dirty() || finalizedAdditions.boundary.pending() || finalizedAdditions.boundary.uncertain())
        : stageSaveState.kind === 'dirty' || stageSaveState.kind === 'saving' || stageSaveState.kind === 'error'}
      attachmentsEnabled={evidenceEnabled === true} clinicId={load.context.appointment.clinicId}
      onBack={() => setRecordEpoch(null)} /> : null}
    <fieldset hidden={recordOpen} disabled={preparingPrint || accessDenied?.epoch === consultationScope.current.epoch} style={{border:0,margin:0,padding:0,minWidth:0}} aria-label="Consultation workspace">
    <ConsultWorkspaceContent
      currentDoctorId={actingDoctor.status==='available'?actingDoctor.doctorId:null}
      stageScopeKey={`${load.context.appointment.id}:${load.consultationEpoch}`}
      stageSaveState={stageSaveState}
      questionsPresentation={questionsPresentation?.epoch===load.consultationEpoch?questionsPresentation.value:'questions'}
      finalizedAdditions={finalizedAdditions}
      onOpenPatientRecord={lensEnabled && load.context.patient.patientId !== null
        ? () => { setRecordEpoch(load.consultationEpoch); window.scrollTo(0, 0); }
        : undefined}
      planDraftOwner={planDraftOwner}
      stageDiscard={{ visible: !structuredFormsEqual(formRef.current, lastSavedFormRef.current) ||
        intakeRecoveryRef.current?.dirty?.() === true || profileRecoveryRef.current?.dirty?.() === true ||
        prescriptionRecoveryRef.current?.dirty?.() === true || finalizedAdditions.boundary.dirty?.() === true || [...planControlDrafts.current.values()].some(d => d.dirty()) || failedPlanWrites.current.size > 0,
        busy: recoveryBusy || finalizedAdditions.boundary.pending(), onDiscard: () => askRecovery('discard') }}
      onSaveStage={async () => {
        const epoch = consultationScope.current.epoch;
        // This is an explicit Save act. Ordinary navigation still uses the
        // profile's existing manual-save guard and never silently saves it.
        if (profileSaveRef.current && !await profileSaveRef.current()) return false;
        if (epoch !== consultationScope.current.epoch) return false;
        const saved = await joinWriters();
        if (!saved || epoch !== consultationScope.current.epoch) return false;
        return await saveDefaultConsultationFee() && epoch === consultationScope.current.epoch;
      }}
      context={load.context}
      sheet={sheet}
      form={displayForm}
      itemForm={itemForm}
      catalog={catalog}
      explicitPick={explicitPick}
      notConvertedReason={notConvertedReason}
      busy={busy ?? (consultationLock.current.locked ? 'item' : null)}
      saveState={finalizedAdditions.enabled?finalizedAdditions.saveState:autosave.saveState}
      feedback={feedback}
      // CONSULT-NEXT-GUARD-V1 (W-23): derive the truthful NEXT-band label from
      // the view-models already on this page (the case sheet + the mirrored
      // intake state) -- no new read. D3 (DOCTOR-FLOW-AFTER-INTAKE-V1): on a
      // course visit whose ladder still has a not-done stage, the CLOSE rung
      // (and only the close rung -- every earlier W-23/one-flow rung stands)
      // speaks the stage instead: one obvious next action per stage.
      nextActionLabel={consultStageDockLabel(
        consultNextActionLabel({
          sheet,
          intake: nextActionIntake,
          // RUNG 0 (Lane 1 item 1 / D01): the appointment's stored status,
          // already on this page in the loaded consult context -- no new
          // read. On a CANCELLED visit the band names the state instead of
          // coaching "Close the visit ...", the last step of a consult that
          // can never run. Absent while the context is still loading, which
          // the ladder treats as "no rung 0", never as a state.
          appointmentStatus: load.kind === 'ready'
            ? load.context.appointment.status
            : undefined,
          // DOCTOR-INTAKE-HISTORY-V1: proven-live required-completeness from
          // the block's own lifted answer state clears the intake rung the
          // moment the acts happen (the walked in-session lag: the mounted
          // read cannot refresh itself). Same grain as the server gate
          // (required over the served set); same source the Go door tracks.
          liveRequiredAnswered:
            intakeState.kind === 'ready' &&
            consultLiveRequiredAnswered(
              intakeState.view.questions,
              new Set((answeredIntakeKeys ?? '').split(',').filter((k) => k !== '')),
            ),
        }),
        stageLadder,
        sheet,
      )}
      // D3: the continue-treatment header (renders nothing without an honest
      // ladder -- a single-visit consult stays byte-identical).
      continueSlot={<ContinueTreatmentHeader ladder={stageLadder} />}
      // D1: the structured next-visit intent panel, riding the ONE sheet
      // form (the chip tap IS the act; autosave persists it). Mounted only
      // with a sheet -- the intent needs its carrier.
      nextVisitSlot={
        sheet !== null ? (
          <NextVisitPanel key={`${consultationEpoch}:${load.context.appointment.id}:${load.context.patient.patientId}`}
            compact
            returnRequestAvailable={load.context.returnRequestAvailable===true && sheet.returnRequestRevision!==undefined}
            savedRequest={finalizedAdditions.enabled?finalizedAdditions.saved.returnRequest??null:sheet.returnRequest??null}
            returnCandidates={[
              ...sheet.planItems,
              ...(journeyWire?.visits??[]).filter(visit=>visit.caseSheetId!==sheet.id && visit.sheetStatus==='finalized').flatMap(visit=>visit.plan.audience==='clinical'?(visit.plan.planItems??[]):[]),
            ].filter(item=>item.status==='accepted'&&!item.completedAt).map(item=>({id:item.id,label:['toothArea' in item ? item.toothArea : null,item.procedureName].filter(Boolean).join(' · ')}))}
            ladder={stageLadder}
            followUpOptions={followUpOptionsWire}
            suggestedOption={followUpSuggestion}
            form={displayForm}
            sheetFinalized={finalizedSheet !== null && (!finalizedAdditions.editable || !!finalizedAdditions.saved.returnRequest || !!finalizedSheet.followUpOption || !!finalizedSheet.followUpDueDate || !!finalizedSheet.followUpNote)}
            attribution={attributionWire}
            clinicDoctors={rosterWire}
            visitClinicId={load.context.appointment.clinicId}
            rosterTruncated={rosterTruncatedWire}
            busy={busy !== null || finalizedAdditions.boundary.pending()}
            onFormChange={onFormChange}
            // DOCTOR-HANDS-V1 (BUILD 1): her own booking door, offered ONLY
            // when this visit has a golden patient record to book against.
            // With no linked record the panel is byte-identical to before
            // (the intent still reaches the desk) -- honest absence, never a
            // booking against a guessed identity.
            booking={
              load.context.patient.patientId !== null
                ? {
                    identity: `${consultationIdentity}:${load.context.appointment.id}`,
                    clinicName: load.context.appointment.clinicName ?? 'This clinic',
                    currentDoctorId: actingDoctor.status === 'available' ? actingDoctor.doctorId : null,
                    returnChannel: {
                      read: () => fetchConsultReturnBooking(load.context.appointment.id),
                      slots: (date, doctorId, durationMinutes, appointmentId) => fetchConsultNextVisitSlots(load.context.appointment.id, date, {doctorId, durationMinutes, appointmentId}),
                      beforeWrite: async () => {
                        const epoch = consultationScope.current.epoch;
                        if (!await joinWriters() || epoch !== consultationScope.current.epoch) throw new Error('Save is not confirmed or the patient changed. Resolve the consultation changes before booking.');
                      },
                      create: input => createConsultReturnBooking(load.context.appointment.id, input).finally(() => setReturnBookingRevision(value => value + 1)),
                      change: input => changeConsultReturnBooking(load.context.appointment.id, input).finally(() => setReturnBookingRevision(value => value + 1)),
                      cancel: input => cancelConsultReturnBooking(load.context.appointment.id, input).finally(() => setReturnBookingRevision(value => value + 1)),
                    },
                    patientName: consultBannerName(load.context.patient),
                    patientId: load.context.patient.patientId,
                    clinicId: load.context.appointment.clinicId,
                    // PROPOSE-THEN-CONFIRM off the chosen interval, through
                    // THE ONE existing derivation (LAKSHMI-5-BOOK-DOOR-
                    // CORRECTIVE-V1) the desk's Book door already uses. No
                    // second date rule; an interval-less token proposes
                    // nothing and the picker opens on its standing default.
                    proposedDate:
                      load.context.returnRequestAvailable === true ? returnRequestDate(displayForm.returnRequest) ?? '' : proposedFollowUpDate(form.followUpOption, null) ?? '',
                    channel: {
                      fetchSlots: (date: string) =>
                        fetchConsultNextVisitSlots(
                          load.context.appointment.id,
                          date,
                        ),
                      book: async (startIso: string) => {
                        const epoch = consultationScope.current.epoch;
                        const visit = load.context.appointment.id;
                        if (!await joinWriters()) throw new Error('Save is not confirmed. Resolve the consultation changes before booking.');
                        if (epoch !== consultationScope.current.epoch) throw new Error('The open patient changed. Reopen booking for the current visit.');
                        return bookConsultNextVisit(visit, startIso);
                      },
                    },
                  }
                : undefined
            }
          />
        ) : null
      }
      nextVisitLine={nextVisitLine}
      courseNoFollowUpWarn={courseNoFollowUpWarn}
      visitOrdinal={visitOrdinal}
      paidAllVisitsMinorUnits={paidAllVisits}
      nextCourseSubline={courseSubline}
      onConsultationLockChange={onConsultationLockChange}
      consultationValue={consultationIdentity && load.consultationEpoch === consultationScope.current.epoch ? load.context.consultation : { kind: 'unavailable' }}
      planDiscounts={sheet && sheet.audience==='clinical' ? clinicalEstimateDiscounts([sheet,...(journeyWire?.visits??[]).filter(visit=>visit.caseSheetId!==sheet.id).flatMap(visit=>visit.plan.audience==='clinical'?[{id:visit.caseSheetId,estimateAdjustment:visit.plan.estimateAdjustment}]:[])]) : null}
            reloadConsultation={async () => {
              const epoch = consultationScope.current.epoch;
              const readSequence = ++contextReadSequence.current;
              try { await refreshDoctorConsultation(load.context.appointment.id, fetchDoctorConsultContext, (value) => {
                if (epoch !== consultationScope.current.epoch || readSequence !== contextReadSequence.current || accessDeniedRef.current?.epoch === epoch) throw new Error('Consultation context changed');
                setLoad(previous => previous.kind === 'ready'
                  ? { ...previous, consultationEpoch: epoch, context: { ...previous.context, consultation: value } }
                  : previous);
                const before = load.context.consultation;
                if (value.course?.id === journeyCourseId &&
                    (before?.kind !== 'ready' || before.course?.status !== value.course?.status)) {
                  loadJourney();
                }
              }); } catch (error) { if (epoch === consultationScope.current.epoch && readSequence === contextReadSequence.current) rejectCurrentAccess(error); throw error; }
            }}
      courseRows={courseRows}
      onCompleteItem={onCompleteCourseItem}
      completionAvailable={load.context.completionAvailable === true || journeyWire?.completionAvailability === 'available'}
      treatmentConsents={consentsWire} completionErrors={[...failedCompletions.current]} courseLoadState={journeyLoad}
      startAdditions={location.state?.doctorAdditions===true&&location.state?.appointmentId===load.context.appointment.id}
      historyDetails={intakeState.kind==='ready'?intakeState.view:undefined}
      activeCoursePlanItems={journeyLoad==='ready' && (journeyWire?.courseStatus==='active'||journeyWire?.courseStatus==='planned') && journeyWire.courseId===sheet?.treatmentCourseId ? courseRows.map(row=>row.item) : []}
      questionsRecorded={intakeState.kind==='ready'&&intakeState.view.answers.length>0}
      finishQuestions={intakeState.kind === 'ready' ? [
        ...(intakeRecoveryRef.current?.dirty?.() || intakeRecoveryRef.current?.pending() || intakeRecoveryRef.current?.uncertain() ? ['Question changes are not yet saved.'] : []),
        ...(profileRecoveryRef.current?.dirty?.() || profileRecoveryRef.current?.pending() || profileRecoveryRef.current?.uncertain() ? ['History confirmation changes are not yet saved.'] : []),
        ...(liveIntakeComplete === true ? [] : intakeState.view.questions.filter(question => question.required && !(answeredIntakeKeys ?? '').split(',').includes(question.key)).map(question => `Not answered: ${question.prompt}`)),
        ...(liveIntakeComplete !== true && intakeState.view.questions.filter(question => question.required).length === 0 ? ['Required questions are unavailable.'] : []),
        ...(visitOrdinal !== null && visitOrdinal > 1 && profileOverride?.lastConfirmedCaseSheetId !== sheet?.id ? ['History not confirmed for this visit.'] : []),
        ...(consentsWire?.captureAvailable !== true ? ['Consultation consent status is unavailable.'] : consentsWire.consultationConsents?.some(record => record.state === 'signed_physical_captured' && record.originalAvailable) ? [] : ['Consultation consent not uploaded.']),
      ] : [intakeState.kind === 'loading' ? 'Loading questions…' : 'Questions are unavailable.']}
      finishPlanPending={[...planControlDrafts.current.values()].some(draft => draft.dirty()) || pendingPlanWrites.current.size > 0 || uncertainPlanWrites.current.size > 0 || failedPlanCreates.current.size > 0}
      finishPrescriptionPending={prescriptionRecoveryRef.current?.dirty?.() === true || prescriptionRecoveryRef.current?.pending() === true || prescriptionRecoveryRef.current?.uncertain() === true}
      paperCapture={evidenceEnabled && paperCapture?.scope === appointmentId ? paperCapture : null}
      onOpenToday={(id) => void leaveVisit(consultPathForAppointment(id))}
      onFormChange={onFormChange}
      onItemFormChange={setItemForm}
      onAddItem={onAddItem}
      onAddExaminationTreatment={onAddExaminationTreatment}
      onLineWrite={onLineWrite} onRemoveItem={onRemoveItem}
      onLineSettled={onLineSettled}
      doctorAssign={{
        roster: rosterWire,
        visitClinicId: load.context.appointment.clinicId,
        rosterTruncated: rosterTruncatedWire,
        procedureSpecialties:
          load.kind === 'ready'
            ? load.context.procedureSpecialties
            : undefined,
      }}
      prescriptionSlot={<ClinicalPrescriptionPanel
        addition={finalizedAdditions.editable?{value:finalizedAdditions.value.prescription??null,recorded:finalizedAdditions.saved.prescription??null,pending:finalizedAdditions.boundary.pending(),onChange:prescription=>finalizedAdditions.change({...finalizedAdditions.value,prescription})}:undefined}
        scopeKey={String(consultationScope.current.epoch)} appointmentId={appointmentId}
        patientId={load.context.patient.patientId} sheet={sheet} history={history}
        available={load.context.prescriptionAvailable === true && load.context.patient.patientId !== null}
        disabled={busy !== null || recoveryBusy} printing={preparingPrint} printError={printError}
        ensureSheet={async () => {
          const epoch = consultationScope.current.epoch;
          if (!await autosaveRef.current.flush() || epoch !== consultationScope.current.epoch) return null;
          return ensureSheetForEvidence();
        }}
        onSaved={saved => {
          const current = sheetRef.current;
          if (load.consultationEpoch !== consultationScope.current.epoch || !current || current.id !== saved.id || current.patientId !== saved.patientId) return;
          if ((current.prescriptionRevision ?? 0) > (saved.prescriptionRevision ?? 0)) return;
          const merged = { ...current, ...prescriptionFields(saved) };
          sheetRef.current = merged; setSheet(merged);
        }}
        allergySubstances={intakeState.kind === 'ready' ? intakeState.view.answers.flatMap(answer =>
          answer.questionKey === 'allergies' && answer.details?.kind === 'allergies' ? answer.details.allergies.map(row => row.substance) : []) : []}
        onPrint={() => void prepareClinicalPrint('prescription')}
        onRegisterSave={registerPrescriptionSave} onRegisterRecovery={registerPrescriptionRecovery}
        onRecoveryChange={recoveryChanged}
      />}
      viewCaseSheet={{open:()=>void prepareClinicalPrint('internal'),busy:preparingPrint}}
      printoutsSlot={sheet !== null ? <section className="consult-v14g__card consult-v14g__prints" data-testid="consult-printouts" aria-label="Prints"><h3>Prints</h3><nav aria-label="Printouts">
        {(['internal','patient',...(sheet.prescription?.medicines?.length ? ['prescription'] : [])] as ConsultationPrintKind[]).map(kind => <AcButton key={kind} variant="secondary"
          disabled={preparingPrint || busy !== null || (kind === 'prescription' && load.context.prescriptionAvailable !== true)}
          onClick={() => void prepareClinicalPrint(kind)}>{CONSULTATION_PRINT_TITLES[kind]}</AcButton>)}
        <details className="consult-v14g__supplemental"><summary>Details</summary><AcButton variant="secondary" disabled={preparingPrint || busy !== null} onClick={() => void prepareClinicalPrint('blank')}>{CONSULTATION_PRINT_TITLES.blank}</AcButton></details>
        {preparingPrint ? <p role="status">Checking saved record…</p> : null}
        {printError ? <p role="alert">{printError}</p> : null}
        {sheet.planItems.length > 0 ? <AcButton variant="secondary" disabled={preparingPrint || busy !== null} onClick={() => void prepareClinicalPrint('estimate')}>Estimate</AcButton> : null}
      </nav></section> : null}
      onPrintEstimate={
        sheet !== null ? () => void prepareClinicalPrint('estimate') : undefined
      }
      onExplicitPickChange={setExplicitPick}
      onNotConvertedReasonChange={setNotConvertedReason}
      onClose={onClose}
      onBackToQueue={() => void leaveVisit('/dashboard/doctor')}
      clinicalProfile={profileOverride}
      consentChip={consentHeaderChip(sheet?.planItems ?? [], consentsWire)}
      // R3c: the Go door's per-field target -- the first unanswered VISIBLE
      // question over the block's own reason-first order, tracked from the
      // block's LIVE answer state (lifted joined-key string).
      nextIntakeTargetKey={
        intakeState.kind === 'ready'
          ? consultFirstUnansweredKey(
              intakeState.view.questions,
              new Set(
                (answeredIntakeKeys ?? '').split(',').filter((k) => k !== ''),
              ),
            )
          : null
      }
      startBlocked={startGate.kind === 'blocked' ? startGate : null}
      convertedBanner={
        startGate.kind === 'converted' ? { umr: startGate.umr } : null
      }
      onDismissConverted={() => setStartGate({ kind: 'none' })}
      startTrouble={
        startGate.kind === 'failed' ||
        startGate.kind === 'unresolved' ||
        startGate.kind === 'not_actionable'
          ? startGate
          : null
      }
      startRetryPending={startPending}
      onRetryStart={() => fireConsultStart('retry')}
      // C4: a patient-reported allergy answer exists on the page's ONE
      // intake read -- the banner chip reads pending-verification while the
      // durable record is still empty (the banner derives that side).
      allergyPendingReview={patientReportedAllergyLine(intakeState) !== null}
      intakeReadKind={intakeState.kind}
      // C7: the consent-owed count from the page's ONE consents read (the
      // same wire the masthead chip + consent card header already consume).
      evidenceOwedKinds={evidenceOwedKinds}
      consentOwedCount={
        consentsWire !== null &&
        consentsWire.available &&
        consentsWire.requiredForProcedure
          ? consentsWire.uncoveredAcceptedItemIds.length
          : null
      }
      intakeSlot={additionalDetails =>
        /* REGISTRATION-CONTRACT-AND-WALK-CLOSURE-V1 (D5) -- THE SINGLE
           DOCTOR-SIDE INSERTION POINT for the relocated intake questions.
           CONSULT-INTAKE-RENDER-HEAL-V1 (W-17): the intakeSlot is now the
           FIRST working block of the main column (ConsultWorkspaceContent
           renders it above the review, the clinical leaves, and evidence),
           so the questions the desk used to ask are literally the first thing
           the doctor works -- the consult opens where the paper opens. The
           block still costs ONE mount and no second render site. */
        /* DOCTOR-COCKPIT-VISUAL-CONFORM-V1 (defect 2): the questions block
           and the durable Allergies-and-alerts band render as ONE visual
           intake card (the candidate-b intake handoff: patient-reported
           prefills as provenance, the doctor confirms in the durable block
           -- never re-asked blank). The wrapper is presentation only; the
           2a write seam (one flow writing both stores) stays the
           STOP-reported seam from #526, restated in this run record. */
        <div className="consult-intake-card">
          {/* CONSULT-START-TRUTH-V1 (W-32): the block CONSUMES the page's one
              questionnaire read (PreconsultIntakePanel's fetch, mirrored into
              intakeState). Acknowledged saves and recovery refresh its projection
              through the same read API, without reseeding the current editor. */}
          <IntakeBand
            onRegisterSave={registerProfileSave}
            scopeKey={String(consultationScope.current.epoch)}
            recoveryBusy={recoveryBusy}
            onRegisterRecovery={registerProfileRecovery}
            onRegisterBeforeLeave={registerProfileBeforeLeave}
            onRecoveryChange={recoveryChanged}
            readProfile={async () => {
              const epoch = consultationScope.current.epoch;
              const before = contextRef.current;
              if (!before) throw new Error('Visit context unavailable.');
              const current = await fetchDoctorConsultContext(before.appointment.id);
              if (epoch !== consultationScope.current.epoch || current.appointment.id !== before.appointment.id ||
                  current.appointment.clinicId !== before.appointment.clinicId || current.patient.patientId !== before.patient.patientId ||
                  !current.clinicalProfileAvailable || !current.clinicalProfile) throw new Error('Could not verify the current patient profile.');
              return current.clinicalProfile;
            }}
            patientId={load.context.patient.patientId}
            caseSheetId={sheet?.id ?? null}
            profile={
              profileOverride ??
              load.context.clinicalProfile ??
              EMPTY_PROFILE_VIEW
            }
            available={load.context.clinicalProfileAvailable === true}
            locked={sheet !== null && sheet.status === 'finalized'}
            // ONE-TRUTH INTAKE (law 2a): the patient-reported allergy answer
            // from the page's ONE lifted intake read, as provenance context
            // the doctor confirms into the durable record -- allergies are
            // ASKED once (the questions block above); the durable band
            // CONFIRMS, it never re-asks blind.
            patientReported={patientReportedAllergyLine(intakeState)}
            onProfileChange={(profile) => {
              profileWriteRevision.current += 1;
              setProfileOverride(profile);
            }}
          >{profileControls => <>
          <ConsultIntakeQuestionsBlock
            key={`${load.consultationEpoch}:${finalizedAdditions.restoreEpoch}:${finalizedAdditions.questionnaire?.available===true}`}
            v14gLayout
            profileControls={{...profileControls, details:<>{profileControls.details}{additionalDetails}</>}}
            onPresentationChange={registerQuestionsPresentation}
            returningPlan={{available:previousPlansRead.kind==='ready'&&!previousPlansRead.failed,labels:[...(sheet?.planItems??[]).map(item=>({owningSheetId:sheet!.id,item})),...previousPlanRows].map(({owningSheetId,item})=>{const wire=previousPlanWork.wires[owningSheetId],fact=wire&&item.status==='accepted'&&!item.completedAt?latestTodayFacts(wire).find(row=>row.planItemId===item.id&&row.owningCaseSheetId===owningSheetId):undefined;return `${item.toothRefs?.map(ref=>ref.toothCode).join(', ')||item.toothArea||'Area not recorded'} ${item.procedureName} · ${planItemStatusLabel(item.status)}${item.completedAt?' · Completed':fact&&fact.status!=='not_today'?` · ${fact.status==='started'?'Started':'Work recorded'} ${formatIstShortDate(fact.visitDate)}`:''}`;})}}
            appointmentId={load.context.appointment.id}
            scopeKey={String(consultationScope.current.epoch)}
            read={finalizedAdditions.editable?finalizedQuestionnairePanel(intakeState,finalizedAdditions.questionnaire):intakeState}
            addition={finalizedAdditions.editable&&finalizedAdditions.questionnaire?.available?{
              original:intakeState,missingKeys:finalizedAdditions.questionnaire.missingKeys,detailOnlyKeys:finalizedAdditions.questionnaire.detailOnlyKeys,
              pending:finalizedAdditions.boundary.pending(),saveState:finalizedAdditions.saveState,
              onChange:answers=>{const owner=additionsRef.current;if(owner.questionnaire?.available)owner.change(stageFinalizedQuestionnaire(owner.value,owner.questionnaire,answers));},
              flush:()=>additionsRef.current.flush(),
            }:undefined}
            // R3a ONE OWNER: the first question IS the chief complaint --
            // typing there routes into the sheet form (the sheet's own
            // autosave persists it; the Doctor's record rail mirrors it
            // read-only). The questionnaire store saves through the block's
            // own autosave (R2) -- one input, both existing writers.
            onReasonChange={(text) => {
              // Recovery can restore an empty questionnaire while retaining a
              // saved clinical complaint. Re-entering that same value must not
              // mark the unchanged clinical writer dirty.
              if (text !== formRef.current.chiefComplaint) {
                onFormChange({ ...formRef.current, chiefComplaint: text });
              }
            }}
            onRegisterBeforeLeave={registerIntakeBeforeLeave}
            onRegisterRecovery={registerIntakeRecovery}
            onRecoveryChange={recoveryChanged}
            onVerifiedRead={view => {
              if (load.consultationEpoch === consultationScope.current.epoch &&
                  view.audience === 'clinical' && !view.underIdentityReview &&
                  view.appointmentId === consultationScope.current.appointmentId) setIntakeState({ kind: 'ready', view });
            }}
            onDiscard={() => askRecovery('discard')}
            onCheckAll={checkWriters}
            recoveryBusy={recoveryBusy}
            canDiscard={!autosave.boundary.pending() && !autosave.boundary.uncertain()}
            hasUnsavedRecord={!structuredFormsEqual(formRef.current, lastSavedFormRef.current) || profileRecoveryRef.current?.dirty?.() === true || prescriptionRecoveryRef.current?.dirty?.() === true}
            // Closing intake must await BOTH existing writers. Captured visit
            // identity prevents an old questionnaire completion flushing a new form.
            onFlushRecord={async () => {
              const expectedEpoch = load.consultationEpoch;
              if (consultationScope.current.epoch !== expectedEpoch) return false;
              const saved = await autosaveRef.current.flush();
              return saved && consultationScope.current.epoch === expectedEpoch;
            }}
            reasonSeed={form.chiefComplaint}
            // R3c: lift the LIVE answered-key set for the Go door's
            // first-unanswered target (joined-string primitive; setState
            // self-dedupes on identical values).
            onAnsweredKeysChange={setAnsweredIntakeKeys}
            // C3 (TRUTH-AND-GATE corrective): the lock propagates to EVERY
            // panel -- a finalized visit renders the intake answers read-only
            // (no active chips, no Save, no confirm).
            locked={sheet !== null && sheet.status === 'finalized'&&!(finalizedAdditions.editable&&finalizedAdditions.questionnaire?.available)}
          />
          {finalizedAdditions.enabled?<SavedClinicalAdditions additions={finalizedAdditions.additions} section="questionnaire"/>:null}
          {finalizedAdditions.enabled&&finalizedAdditions.questionnaire?.available!==true?<p role="status">Saved questionnaire answers could not be verified. Check again before adding answers.</p>:null}
          {autosave.recoveryMessage && autosave.saveState.kind === 'error' ? <div role="status" data-testid="consult-record-recovery">
            <p className="pim-error">{autosave.recoveryMessage}</p>
            <AcButton variant="secondary" disabled={recoveryBusy || autosave.boundary.pending()} onClick={() => void checkWriters()}>Check saved values</AcButton>
          </div> : null}

          <ClinicalConsentCapture key={String(consultationScope.current.epoch)} purpose="consultation" caseSheetId={sheet?.id ?? null}
            clinicId={load.context.appointment.clinicId} patientLabel={load.context.patient.patientName ?? undefined}
            wire={consentsWire} enabled={evidenceEnabled} ensureSheet={ensureSheetForEvidence} draftOwner={planDraftOwner} onRecorded={() => { if(load.consultationEpoch === consultationScope.current.epoch) setConsentRefreshKey(value => value + 1); }}
            onRetry={() => setConsentRefreshKey(value => value + 1)}/>
          </>}</IntakeBand>
        </div>
      }
      consentSlot={
        <ConsentPanel
          key={String(consultationScope.current.epoch)}
          presentation="v14g"
          embedded
          appointmentId={load.context.appointment.id}
          clinicId={load.context.appointment.clinicId}
          refreshKey={consentRefreshKey}
          draftOwner={planDraftOwner}
          caseSheetId={sheet?.id ?? null}
          sheetStatus={sheet?.status ?? null}
          planItems={sheet?.planItems ?? []}
          clinicDoctors={load.context.clinicDoctors??[]}
          toothDisplay={load.context.toothNotationDisplay??'fdi'}
          evidenceEnabled={evidenceEnabled}
          patient={load.context.patient}
          onWireChange={wire => { if (load.consultationEpoch === consultationScope.current.epoch) setConsentsWire(wire); }}
          // ROUND 2 (C26/C28) + ROUND-3 copy: the card head wears the
          // reference's COUNT grammar ("n owed" / "Signed") derived from the
          // SAME mirrored wire the masthead chip reads (one read, two
          // renders; the count is the wire's own uncovered set -- never
          // re-derived client-side).
          headerChip={(() => {
            const base = consentHeaderChip(sheet?.planItems ?? [], consentsWire);
            if (base === null) return null;
            const owedCount = consentsWire?.uncoveredAcceptedItemIds.length ?? 0;
            return base.label === 'Consent owed' && owedCount > 0
              ? { label: `${owedCount} owed`, tone: base.tone }
              : { label: 'Signed', tone: base.tone };
          })()}
        />
      }
      shellSearchSlot={lensEnabled && accessDenied?.epoch !== consultationEpoch ? <>
        <RoleHomeSearchPortal><form className="consult-v14g__header-search" role="search" onSubmit={event => {
          event.preventDefault();
          if (headerQuery.trim().length < 2 || headerSearchPending) return;
          const epoch = consultationScope.current.epoch;
          setHeaderSearchPending(true);
          void flushBeforeLeave().then(saved => {
            if (epoch === consultationScope.current.epoch && accessDeniedRef.current?.epoch !== epoch && saved) setHeaderSearchOpen(true);
          }).finally(() => { if (epoch === consultationScope.current.epoch) setHeaderSearchPending(false); });
        }}>
          <input type="search" aria-label="Search patients by name, mobile or UMR" placeholder="Name, mobile or UMR" autoComplete="off"
            data-testid="consult-header-search" value={headerQuery} onChange={event => setHeaderQuery(event.target.value)} />
          <AcButton type="submit" variant="ghost" disabled={headerSearchPending || headerQuery.trim().length < 2}>{headerSearchPending ? 'Saving…' : 'Search'}</AcButton>
        </form></RoleHomeSearchPortal>
        {headerSearchOpen ? <GlobalPatientSearchModal initialQuery={headerQuery} audience="doctor" onClose={() => {
          setHeaderSearchOpen(false);requestAnimationFrame(() => document.querySelector<HTMLElement>('[data-testid="consult-header-search"]')?.focus());
        }} /> : null}
      </> : null}
      earlierEstimatesSlot={<EarlierEstimates key={`${load.context.patient.patientId}:${load.context.appointment.id}`} patientId={load.context.patient.patientId} history={history} read={previousPlansRead} disabled={busy!==null}/> }
      previousRecords={previousPlansRead}
      previousPlanSlot={history.kind === 'ready' && history.history.entries.length === 0 ? null : <PreviousToothPlans key={`${load.context.patient.patientId}:${load.context.appointment.id}`} patientId={load.context.patient.patientId} currentAppointmentId={load.context.appointment.id} read={previousPlansRead} teeth={form.toothRefs} display={toothEntryContextFrom(load.context)?.display??'fdi'}/> }
      railSlot={
        <>
          <CaseHistoryRail
            patientId={load.context.patient.patientId}
            currentAppointmentId={load.context.appointment.id}
            history={history}
          />
          {/* C7: the running treatment-done ledger BELOW the rail -- the
              SAME lifted read, second render. */}
          <TreatmentLedgerRail
            patientId={load.context.patient.patientId}
            history={history}
          />
          {/* ROUND 2 (C38-C40): the candidate-b RELATED index rows close
              the rail -- appointments (lens-composed), payments (the same
              all-visits derivation as the rollup), intake (untappable
              index; the answers live in the intake card). */}
          <ConsultRelatedRail
            onNavigate={path => void leaveVisit(path)}
            appointments={lensRelated}
            lensHref={
              lensEnabled && load.context.patient.patientId !== null
                ? // BUILD 3 (L-09): stamp the door travelled, so the record's
                  // Back returns HERE instead of dumping the doctor on search.
                  `${doctorLensHref(load.context.patient.patientId, 'consult')}&fromId=${load.context.appointment.id}`
                : null
            }
            paidAllVisitsMinorUnits={paidAllVisits}
            intakeAnswerCount={intakeAnswerCount}
          />
        </>
      }
      onEarlierPlanAccepted={onEarlierPlanAccepted}
      onTodayWorkSaved={onTodayWorkSaved}
      onTodayWorkRead={onTodayWorkRead}
      todayWork={todayWorkRead.epoch===consultationScope.current.epoch&&todayWorkRead.value?.caseSheetId===sheet?.id?todayWorkRead.value:null}
      todayWorkPending={[...planControlDrafts.current].some(([key,draft])=>key.startsWith('today-work-')&&draft.dirty())}
      onPendingSaved={()=>{
        if(load.consultationEpoch!==consultationScope.current.epoch)return;
        setConsentRefreshKey(value=>value+1);
        setInvestigationRefreshKey(value=>value+1);
        if(evidenceSource?.caseSheetId===sheet?.id)void evidenceSource?.refresh();
      }}
      investigationWorkspace={{refreshKey:investigationRefreshKey,identity:`${load.consultationEpoch}:${load.context.appointment.id}:${load.context.patient.patientId??''}`,caseSheetId:sheet?.id??null,clinicId:load.context.appointment.clinicId,ensureSheet:ensureSheetForEvidence,draftOwner:planDraftOwner,attachmentsEnabled:evidenceEnabled,evidenceSource}}
      attachmentsEnabled={evidenceEnabled}
      evidenceImagingCount={evidenceEnabled&&evidenceImagingRead?.epoch===load.consultationEpoch&&evidenceImagingRead.sheetId===(sheet?.id??null)?evidenceImagingRead.count:null}
      evidenceSlot={
        evidenceEnabled ? (
          <ClinicalEvidencePanel
            presentation="v14g"
            selectedToothRefs={form.toothRefs}
            patientLabel={[load.context.patient.patientName, load.context.patient.umr ? `MR No. ${load.context.patient.umr}` : null].filter(Boolean).join(' · ')}
            captureConfig={load.context.evidenceCaptureConfig}
            key={`${load.consultationEpoch}:${load.context.appointment.clinicId}:${load.context.appointment.id}:${load.context.patient.patientId ?? 'unknown'}`}
            embedded
            clinicId={load.context.appointment.clinicId}
            sheet={
              sheet !== null ? { id: sheet.id, status: sheet.status } : null
            }
            ensureSheet={ensureSheetForEvidence}
            // C28 moved to the frozen masthead; Examination keeps this ONE
            // list reader and gallery. Patient/authority epochs fence the mirror.
            onEvidenceSource={setEvidenceSource}
            onImagingCount={onImagingCount}
            onPaperCapture={registerPaperCapture}
            onOwedKinds={setEvidenceOwedKinds}
          />
        ) : undefined
      }
      safetySlot={<PreconsultSafetyStrip state={intakeState} />}
      preconsultSlot={
        <PreconsultIntakePanel
          appointmentId={load.context.appointment.id}
          onStateChange={setIntakeState}
        />
      }
      journeySlot={
        sheet !== null ? (
          <TreatmentJourneyPanel
            compact
            sheet={sheet}
            journey={journeyWire}
            journeyState={journeyLoad}
            // C2 (TRUTH-AND-GATE corrective): the header counters read the
            // LIVE course truth -- the earlier-visit ledger rows plus THIS
            // sheet's live plan items (the same composition the teeth strip
            // uses) through THE ONE accepted-state truth owner. The stale
            // wire snapshot can no longer say "0 accepted" while the line
            // chip says Accepted -- and the counters live-refresh on add.
            liveProgress={deriveAcceptedTruth([
              ...courseRows.map((r) => r.item),
              ...sheet.planItems,
            ])}
            onSheetRefresh={(v) => {
              setSheet(v);
              setItemEdits((prev) =>
                syncItemEdits(prev, v.planItems, sheet.planItems),
              );
            }}
            onReload={loadJourney}
          />
        ) : null
      }
    />
    </fieldset>
    </div>
    </ConsultationPresentationContext.Provider>
  );
}
